import { GPSActivityApprovalStatus, GPSActivityPhoto } from './../../../classes/store-check/photo';
import { SamplesMaterialsSubTab, resolveDefaultSubTab } from './samples-materials-section.helpers';
import { SampleDeliveryRequest, SdrStatus, getSdrStatusColor, getSdrInlinePillColor, sdrDisplayTitle } from '../../../classes/sample/sample-delivery-request.class';
import { SampleDeliveryRequestService } from '../../../services/sample/sample-delivery-request.service';
import { SampleDeliveryRequestDataService, DraftSdrPayload } from '../../../data-services/sample/sample-delivery-request.data.service';
import { InlineSampleDeliveryRequestComponent } from '../inline-sample-delivery-request/inline-sample-delivery-request';
import { AccountPlansSelectionPageModel } from "@omni/models/account-plans-selection-page-model";
import { MainCardViewDataModel } from '@omni/models/MainCardViewDataModel';
import { AssetSelectionViewDataModel } from './../../../models/meeting-assets-selection-model';
import { CustomerAsset } from './../../../classes/field-materials/customer-asset.class';
import { FieldMaterialManagementService } from '@omni/services/field-materials/field-material-management.service';
import { AccountPlan } from "@omni/classes/account-management/account-plan.class";
import {
  MAXIMUM_NOTE_ATTACHMENT_SIZE,
  NOTE_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX,
  Utility,
  shortMonthArray, toBase64
} from '@omni/utility/util';
import { EventsToolService } from '@omni/services/events-tool/events-tool.service';
import { debounceTime, distinctUntilChanged, filter, first, map, skip, takeUntil } from 'rxjs/operators';
import {
  ApplicationRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Injector,
  Input,
  KeyValueDiffer,
  KeyValueDiffers,
  Output,
  ViewChild
} from '@angular/core';
import { AccountOfflineService, AccountSelectedFor } from '../../../services/account/account.offline.service';
import { FeatureProfiler } from '../../../services/logging/feature-profiler.service';
import { MeetingExpenseService } from '@omni/services/meeting-expense/meeting-expense.service';
import { MEETING_EXPENSE_INLINE_ACTIVITY_KEY } from '@omni/classes/meeting-expense/meeting-expense.constants';
import { FormatChangeExpenseAction } from '@omni/services/meeting-expense/meeting-expense.rules';
import { ActivityService } from '../../../services/activity/activity.service';
import { AlertController, IonContent, IonNav, LoadingController, ModalController, NavParams, PopoverController } from '@ionic/angular';
import { ConfiguredFields,hcpInteractionDefaultField } from '../../../classes/authentication/configured.field.class';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

import { ActivityDataService } from '../../../data-services/activity/activity.service';
import {
  Activity,
  ActivityOutcome,
  ActivityOutcomeType,
  ActivityType,
  ActivityTypeCodeRaw,
  ConfigFieldOptionValue,
  FormatType,
  MeetingActivityState,
  MeetingActivityType,
  MeetingActivityTypeCode,
  MeetingSubActivityType
} from '../../../classes/activity/activity.class';
import { ContactOfflineService } from '../../../services/contact/contact.service';
import { ComponentViewMode, PresentationView, UIService } from '../../../services/ui/ui.service';
import { DEVICE_ORIENTATION, DeviceService } from '../../../services/device/device.service';
import { LogService } from '../../../services/logging/log-service';
import { PopoverComponent, SelectListData } from '../../popover/popover';
import { MeetingDataService, UpdateMeetingPayload, UpdateTypeAndSubTypeActivityPayLoad } from '../../../data-services/meeting/meeting.data.service';
import { MeetingLocationCaptureService } from '../../../data-services/meeting/meeting-location-capture.service';
import { MeetingStatus } from '../../../classes/meeting/meeting.class';
import { AppointmentActivity, CHECKOUT_OPTIONS, CovisitorAccess, InStorePhoto } from '../../../classes/activity/appointment.activity.class';
import { FooterService, FooterViews } from '../../../services/footer/footer.service';
import { Clipboard } from '@awesome-cordova-plugins/clipboard/ngx';
import { PresentationService } from '../../../services/presentation/presentation.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { WebsocketDataService } from '../../../data-services/websocket/websocket.data.service';
import { NotificationService, ToastStyle } from '../../../services/notification/notification.service';
import { VOICE_NOTE_CAPTURE_MODAL_CLASS_NAME } from '../../../config/shared.config';
import { DictationFlowService } from '../../../services/voice-note/dictation-flow.service';
import { combineNoteTranscripts, detectionForReview } from '@omni/services/voice-note/note-dictation-seed';
import { TrackingEventNames, TrackService } from '../../../services/logging/tracking.service';
import { ChildNavNames, NavigationService, PageName } from '../../../services/navigation/navigation.service';
import { InboundMeetingControllerService } from '../../../services/meeting/inbound-meeting.controller.service';
import { EmailTemplateServices } from '../../../data-services/email-templates/email-template.service';
import { RepServices } from '../../../data-services/rep/rep.services';
import { AccompainedUser } from '../../../classes/activity/accompained-user.class';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { IoUserSelection } from '../../../services/io-userselection/io-userselection.service';
import { COACHING_VIEW_TYPE, CoachingReportService } from '../../../services/coaching/coaching.report.service';
import { Report } from '../../../classes/coaching/report.class';
import { FeatureActionsMap, IoConfigurationFeatureCodes, MeetingProximityActionOption } from '../../../classes/authentication/user.class';
import { SampleService, SamplingDetailsViewMode } from '../../../services/sample/sample.service';
import { SampleDataService } from '../../../data-services/sample/sample.data.service';
import { EventName, EventsService } from '../../../services/events/events.service';
import { CallPlanOfflineService } from '../../../services/call-plan/call-plan.offline.service';
import { SampleActivity, CreateSampleDropRequestBody } from '../../../classes/activity/sample.activity.class';
import { InMeetingAllocationComponent } from '../../in-meeting-allocation/in-meeting-allocation';
import { ContentMatchingService } from '../../../services/content-matching/content-matching.service';
import { cloneDeep, differenceBy, filter as lodashFilter, groupBy, includes, intersection, intersectionBy, isArray, isEmpty, isEqual as lodashIsEqual, orderBy, pick, range, sortBy, uniqBy } from 'lodash-es';
import { EmailTemplateType } from '../../../classes/email-templates/email-template.class';
import { EmailActivityChannelDetails } from '../../../classes/consent/channel.class';
import { DirectMessagingService } from '../../../services/direct-messaging/direct-messaging.service';
import { TherapeuticArea } from '../../../classes/therapeutic-area/therapeutic-area.class';
import { TherapeuticAreaDataService } from '../../../data-services/therapeutic-area/therapeutic-area.data.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalUtilityService } from '../../../services/global-utility.service';
import { DateTimeFormatsService } from '../../../services/date-time-formats/date-time-formats.service';
import { FormFieldType, IndFormFieldViewDataModel } from '../../../models/indFormFieldDataModel';
import { IndPageTitleViewDataModel } from '../../../models/indPageTitleDataModel';
import { MeetingStructureService } from '../../../services/meeting-structure/meeting-structure.service';
import { MeetingMandatoryActivitiesValidationService } from '@omni/services/meeting/meeting-mandatory-activities-validation.service';
import { MeetingMandatoryActivitiesConfigService } from '@omni/services/meeting/meeting-mandatory-activities-config.service';
import { REP_STATUS } from '../../../models/rep-status-model';
import { IndDropdownListComponent } from '../../../components/shared/ind-dropdown-list/ind-dropdown-list';
import { IndDropdownListDetailModel } from '../../../models/indDropdownListModel';
import { EmailService } from '../../../services/email-templates/email.service';
import { Contact, ContactAddress } from '../../../classes/contact/contact.class';
import { FooterToolbarComponent } from '../../footer-toolbar/footer-toolbar';
import { AccesingMode, CaseManagementService } from '../../../services/case-management/case-management.service';
import { AlertService } from '@omni/services/alert/alert.service';
import { BusinessProcessViewDataModel } from '@omni/models/business-process-view-data.model';
import { AgendaFooterService } from '@omni/services/footer/agenda-footer.service';
import { NextCallObjectiveComponent } from '@omni/components/next-call-objective/next-call-objective';
import { EmailViewType } from '@omni/classes/activity/email.activity.class';
import { DatePipe } from '@angular/common';
import { IndDateTimeFormViewDataModel } from '@omni/models/indDateTimeFormDataModel';
import {
  CurViewPageType,
  DateTimeFieldType,
  IndDatetimeFormComponent
} from './../../shared/ind-datetime-form/ind-datetime-form';
import { SurgeryOrderActivityDataService } from '@omni/data-services/surgery-order-activity/surgery-order-activity.data.service';
import { PollService } from '@omni/services/poll/poll.service';
import {
  checkTimeConflictWithOtherActivities,
  removeConflictIdFromOtherActivities,
  startRecursiveActivityCloseByActivityFlagging
} from '../../../utility/activity.utility';
import { CheckboxCustomEvent } from '../../../interfaces/shared/shared.interface';
import { DynamicsClientService } from '@omni/data-services/dynamics-client/dynamics-client.service';
import { fetchQueries } from '@omni/config/dynamics-fetchQueries';
import { configFieldSortFn, getConfigFormFieldIsReadOnly, getConfigFormFieldType, getConfigFormFieldViewDataModelId } from '../../../utility/common.utility';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { OpportunityManagementService } from '@omni/services/opportunity-management/opportunity-management.service';
import { OpportunitySelectionViewDataModel } from '@omni/models/opportunities-selection-page-model';
import { Opportunity } from '@omni/classes/opportunity-management/opportunity.class';
import { OpportunityManagementDataService } from '@omni/data-services/opportunity-management/opportunity-management.data.service';
import { EventsSelectionViewDataModel } from '@omni/models/events-selection-page-model';
import { EventActivity } from '@omni/classes/events-tool/event.class';
import { IoFileService } from '@omni/services/io-file-service/io-file-service';
import { IONote } from '@omni/classes/io/io-note.class';
import { AccountManagementOfflineService } from '@omni/services/account-management/account-management.service';
import { electronApi } from "@omni/services/electron-api";
import { Brand } from "@omni/classes/brand/brand.class";
import { MainToolTemplateDetail, MainToolTemplateListSelectionType } from "@omni/models/mainToolTemplateDetail.model";
import { GPS_STATUS, LocationOfflineService } from '@omni/services/location/location.service';
import { GeolocationService } from '@omni/services/location/gelolocation';
import { calculateDistance, convertAddressToCoords } from '@omni/services/location/utils';
import { DiskService, OFFLINE_DB_LINKED_ENTITY_NAME } from '@omni/services/disk/disk.service';
import { SelectListComponent } from '@omni/components/shared/select-list/select-list';
import { AlertWithInput } from '@omni/components/shared/alert-with-input/alert-with-input';
import { ReorderItemsViewDataModel } from "@omni/models/reorderItemsViewDataModel";
import { DB_KEY_PREFIXES } from "@omni/config/pouch-db.config";
import { BrandOfflineService } from "@omni/services/brand/brand.service";
import { MarketingPlansManagementOfflineService } from "@omni/services/marketing-management/marketing-management.service";
import { MarketingPlanSelectionViewDataModel } from "@omni/models/marketing-plan-selection-page-model";
import { MarketingPlan } from "@omni/classes/marketing-management/marketing-plan.class";
import { UserTypes } from "@omni/classes/activity/procedure-tracker.activity.class";
import { ProcedureTrackerActivityDataService } from "@omni/data-services/procedure-tracker-activity/procedure-tracker-activity.data.service";
import { CoachingPlan } from "@omni/classes/coaching/coaching-plan.class";
import { IndPhotoCaptureViewerDataModel } from "@omni/models/indPhotoCaptureViewerDataModel";
import { GPSActivity, Photo, PhotoOrigin, PhotoResponse } from '@omni/classes/store-check/photo';
import { IndPhotoViewerDataModel } from "@omni/models/indPhotoViewerDataModel";
import { PhotoAttachmentDto } from '@omni/classes/store-check/photo-attachment';
import { AppealService } from '@omni/services/appeal/appeal.service';
import { MedicalInquiryService } from '@omni/services/medical-inquiry/medical-inquiry.service';
import { SecInfoConfigDataService } from '@omni/data-services/sec-info-config/sec-info-config-data-service';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';
import { SetBookingActivity, SetBookingStatus } from '@omni/classes/activity/set-booking.activity.class';
import { SetBookingDataService } from '@omni/data-services/set-booking/set-booking.data.service';
import { CallPlanDataService } from '@omni/data-services/call-plan/call-plan.data.service';
import { FeatureActionsService } from '@omni/services/feature-actions/feature-actions.service';
import { AlertInfoTypes, OmniInfoAlertComponent } from '@omni/components/shared/omni-info-alert/omni-info-alert.component';
import { Task } from '@omni/classes/shared/task.class';
import { EntityNameForTranslation, LocalizationService } from '@omni/services/localization/localization.service';
import { MeetingFeatureFlags, MeetingFeatureFlagsService } from '@omni/services/meeting/meeting-feature-flags.service';
import { ReasonForLocationCaptureFailure } from '@omni/enums/presentation/gps-data.enum';
import { AllocationOrderType } from '@omni/enums/allocation/allocation.enum';
import { DistanceUnits } from '@omni/classes/my-assistant/my-assistant.class';
import { Guid } from 'typescript-guid';
declare var event;


/**
 * Generated class for the ActivitiesDetailsPaneComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// OnPush deferred — reads activityService, uiService, authService, footerService, and many other services directly in template
@Component({
  selector: "activities-details-pane",
  templateUrl: "activities-details-pane.html",
  styleUrls: ['activities-details-pane.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class ActivitiesDetailsPaneComponent {
  // Modern Angular 17+ Dependency Injection
  // Services used in template - public access
  readonly activityService = inject(ActivityService);
  readonly activityDataService = inject(ActivityDataService);
  readonly emailtemplateService = inject(EmailTemplateServices);
  readonly contactService = inject(ContactOfflineService);
  readonly accountService = inject(AccountOfflineService);
  readonly popoverCtrl = inject(PopoverController);
  readonly modalCtrl = inject(ModalController);
  private readonly injector = inject(Injector);
  readonly device = inject(DeviceService);
  readonly uiService = inject(UIService);
  readonly footerService = inject(FooterService);
  readonly authService = inject(AuthenticationService);
  readonly trackingService = inject(TrackService);
  readonly repService = inject(RepServices);
  readonly appRef = inject(ApplicationRef);
  readonly cdRef = inject(ChangeDetectorRef);
  readonly coachingReportService = inject(CoachingReportService);
  readonly translate = inject(TranslateService);
  readonly utilityService = inject(GlobalUtilityService);
  readonly dateTimeFormatsService = inject(DateTimeFormatsService);
  readonly loadingController = inject(LoadingController);
  readonly accountManagementService = inject(AccountManagementOfflineService);
  readonly fieldMaterialManagementService = inject(FieldMaterialManagementService);
  readonly marketingPlansManagementOfflineService = inject(MarketingPlansManagementOfflineService);
  readonly opportunityService = inject(OpportunityManagementService);
  readonly navCtrl = inject(IonNav);

  // Private services - internal use only
  private readonly emailService = inject(EmailService);
  private readonly logService = inject(LogService);
  private readonly meetingDataService = inject(MeetingDataService);
  private readonly events = inject(EventsService);
  private readonly clipboard = inject(Clipboard);
  private readonly presentationService = inject(PresentationService);
  private readonly websocket = inject(WebsocketDataService);
  private readonly notificationService = inject(NotificationService);
  private readonly authenticationOfflineService = inject(AuthenticationService);
  private readonly navService = inject(NavigationService);
  private readonly ioUserSelection = inject(IoUserSelection);
  private readonly sampleService = inject(SampleService);
  private readonly contentMatchService = inject(ContentMatchingService);
  private readonly callplanService = inject(CallPlanOfflineService);
  private readonly callplanDataService = inject(CallPlanDataService);
  private readonly dms = inject(DirectMessagingService);
  private readonly theraputicService = inject(TherapeuticAreaDataService);
  private readonly meetingStructureService = inject(MeetingStructureService);
  private readonly meetingMandatoryValidation = inject(MeetingMandatoryActivitiesValidationService);
  private readonly meetingMandatoryConfig = inject(MeetingMandatoryActivitiesConfigService);
  private readonly differs = inject(KeyValueDiffers);
  private readonly alertService = inject(AlertService);
  private readonly agendaFooterService = inject(AgendaFooterService);
  private readonly caseManagementService = inject(CaseManagementService);
  private readonly surgeryOrderDataService = inject(SurgeryOrderActivityDataService);
  private readonly datePipe = inject(DatePipe);
  private readonly pollService = inject(PollService);
  private readonly eventsService = inject(EventsService);
  private readonly inAppBrowser = inject(InAppBrowser);
  private readonly eventsToolService = inject(EventsToolService);
  private readonly dynamics = inject(DynamicsClientService);
  private readonly opportunityDataService = inject(OpportunityManagementDataService);
  private readonly fileService = inject(IoFileService);
  private readonly disk = inject(DiskService);
  private readonly locationService = inject(LocationOfflineService);
  private readonly geolocationService = inject(GeolocationService);
  private readonly alertCtrl = inject(AlertController);
  private readonly brandService = inject(BrandOfflineService);
  private readonly procedureTrackerDataService = inject(ProcedureTrackerActivityDataService);
  private readonly appealService = inject(AppealService);
  private readonly medicalInquiryService = inject(MedicalInquiryService);
  private readonly secondaryInfoService = inject(SecInfoConfigDataService);
  private readonly navParams = inject(NavParams);
  private readonly faService = inject(FeatureActionsService);
  private readonly localisationService = inject(LocalizationService);
  private readonly setBookingDataService = inject(SetBookingDataService);
  private readonly featuresFlagsService = inject(MeetingFeatureFlagsService);
  private readonly meetingLocationCaptureService = inject(MeetingLocationCaptureService);
  private readonly sampleDataService = inject(SampleDataService);
  private readonly sdrService = inject(SampleDeliveryRequestService);
  private readonly sdrDataService = inject(SampleDeliveryRequestDataService);
  private readonly featureProfiler = inject(FeatureProfiler);
  private readonly meetingExpenseService = inject(MeetingExpenseService);
  private readonly profiler = this.featureProfiler.for('activities');

  // ─── Sample Drop inline state ───────────────────────────────────────────────
  selectedAllocationId: string = null;
  scrappingAllocationId: string | null = null;

  textInput: any;

  @Input() showBackButton: boolean = false;
  private _isNewlyCreatedActivity: boolean = false;
  get isNewlyCreatedActivity(): boolean {
    return this._isNewlyCreatedActivity;
  }
  get novaMeetingActivity(): AppointmentActivity | null {
    return this.activityService.selectedActivity instanceof AppointmentActivity
      ? this.activityService.selectedActivity
      : null;
  }
  @Input() set isNewlyCreatedActivity(newValue: boolean) {
    this._isNewlyCreatedActivity = newValue;
  }
  @ViewChild('notesInput', { static: true }) notesInput: ElementRef;
  @ViewChild('footer', { read: ElementRef }) footerEl: ElementRef;

  @ViewChild('attachInput') attachInput: ElementRef;
  public annotationId: string = '';
  public attachmentTitle: string = '';
  public isAttachmentAdded: boolean = false;
  private attachmentFile: any;
  private base64str;

  /**
   * We require products, participants & accounts
   * @memberof ActivitiesDetailsPaneComponent
   */
  public activityDetails: Activity;
  public activityType = ActivityType;
  public meetingState = MeetingActivityState;
  public meetingActivityTypeCode = MeetingActivityTypeCode;
  public previouslySelectedLocation: string;
  public notesModal: string;
  public preSavedNotes: string;
  public firstLevelFormFields:Array<IndFormFieldViewDataModel> = [];
  public secondLevelFormFields:Array<IndFormFieldViewDataModel> = [];
  public meetingTypeFormField:IndFormFieldViewDataModel;
  public accountFormField:IndFormFieldViewDataModel;
  public contactFormField:IndFormFieldViewDataModel;
  nearMeContacts: Contact[] = [];
  nearMeEnabled = true;
  nearMePillsLoader = async (): Promise<{ id: string; label: string; onClick: () => void }[]> => {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    this.nearMeContacts = await this.contactService.loadNearMeContacts(meeting);
    return this.nearMeContacts.map(c => ({
      id: c.ID,
      label: c.fullName || `${c.firstName || ''} ${c.lastName || ''}`.trim(),
      onClick: () => {
        const currentMeeting = this.activityService.selectedActivity as AppointmentActivity;
        const isAlreadyAdded = currentMeeting?.contacts?.some(mc => mc.ID === c.ID);
        if (!isAlreadyAdded) {
          this.addContact({ id: c.ID, title: c.fullName || `${c.firstName || ''} ${c.lastName || ''}`.trim(), refObject: c });
        }
      },
    }));
  };
  sharedLocationPillsLoader = async (): Promise<{ id: string; label: string; onClick: () => void }[]> => {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const meetingContactIds = (meeting?.contacts || []).map(c => c.ID);
    if (!meetingContactIds.length) return [];
    const excludeIds = new Set([...meetingContactIds, ...this.nearMeContacts.map(c => c.ID)]);
    const meetingLocation = (meeting.location || '').trim();
    const contacts = await this.contactService.loadSharedLocationContacts(meetingContactIds, excludeIds, undefined, meetingLocation);
    return contacts.map(c => ({
      id: c.ID,
      label: c.fullName || `${c.firstName || ''} ${c.lastName || ''}`.trim(),
      onClick: () => {
        const currentMeeting = this.activityService.selectedActivity as AppointmentActivity;
        const isAlreadyAdded = currentMeeting?.contacts?.some(mc => mc.ID === c.ID);
        if (!isAlreadyAdded) {
          this.addContact({ id: c.ID, title: c.fullName || `${c.firstName || ''} ${c.lastName || ''}`.trim(), refObject: c });
        }
      },
    }));
  };
  public ownerFormField:IndFormFieldViewDataModel;
  public activityTypeFormField:IndFormFieldViewDataModel;
  public activitySubTypeFormField:IndFormFieldViewDataModel;
  public meetingLocationFormField:IndFormFieldViewDataModel;
  public meetingSubjectFormField: IndFormFieldViewDataModel;
  public presentationDurationFormField: IndFormFieldViewDataModel;
  public meetingstate: MeetingStatus;
  public isNotesDirty: boolean = false;
  public blockUI: boolean = false;
  private markCompleteInProgress: boolean = false;
  public isRemoteEnabled: boolean = false;
  private selectedActivityDiffer: KeyValueDiffer<string, any>;
  private _screenOrientation$;
  public meetingActivityTypes: MeetingActivityType[] = [];
  isGpsEnabled = false;
  isContentRequiredForRemoteChannelEnabled = false;
  isLiveTimeFieldEnabledForF2FMeetings =false;

  //Config Fields
  private appConfigInputText: string;
  private appConfigInputBoolValue: string;
  private appConfigProcessValue: string;
  private appConfigIntegervalue: string;
  private appConfigDecimalvalue: string;
  private appConfigMemovalue: string;
  private appConfigLookupValue: string;
  private appConfigPickValue: ConfigFieldOptionValue;
  private appConfigCurrencyValue: string;
  private formattedDate: string;
  private appConfigDateValue: number;
  private dateEvent: any;
  private dateFieldName: string;
  private isValueUpdated: boolean = false;
  public isCovisitor: boolean = false;

  // configMandatoryFields
  private configMandatoryField: string;
  tooltipEvent: string;
  showArrow: boolean = true;
  duration: number = 1000;
  private configFieldsSubscription: Subscription;
  private coachingActivitySubscription: Subscription;
  public isReadOnlyJointMeeting: boolean = false;
  private isReadOnlyRecommendedMeeting: boolean = false;
  private eventSubscriptions: { unsubscribe: Function }[] = [];
  private ngdestroy$$: any = new Subject<boolean>();
  public isInStoreMeeting: boolean = false;
  public isInStoreChildMeeting: boolean = false;


  @ViewChild(IonContent, { static: true }) content: IonContent;
  @ViewChild(FooterToolbarComponent) footerCmp: FooterToolbarComponent;
  @ViewChild(NextCallObjectiveComponent) nextCallObj: NextCallObjectiveComponent;
  /** The currently-mounted inline SDR editor instance (New draft, or an
   *  existing Active/Draft SDR resumed for editing) — bound in the template
   *  so the "+New" button's [disabled] can also gate on isBusy (a
   *  save-on-click operation in flight on the CURRENTLY visible instance). */
  @ViewChild(InlineSampleDeliveryRequestComponent) activeInlineSdr?: InlineSampleDeliveryRequestComponent;
  @Output() fullPageSelection = new EventEmitter<string>(null);

  public navPageName = PageName;
  private isLayoverPushView: boolean = false;
  private layoverViewPushedFrom: any;
  public currentAllocationsInMeeting: SampleActivity[];
  isProcedureSectionEnabled: boolean = false;
  public isSupportingMaterialsEnabled: boolean = false;

  @Input()
  callbackEvent;

  public diseaseAreaSectionViewData:ReorderItemsViewDataModel;
  public productIndicationSectionViewData:ReorderItemsViewDataModel;
  public therapeuticAreas: TherapeuticArea[] = [];
  activitiesDetailsPanePageTitle: IndPageTitleViewDataModel;
  private activitiesDetailsPanePageTitleText: string;
  private newActivitySubscription: Subscription;
  @Input() from: any
  selectedContacts: Contact[] = [];
  @Input() childFrom: PageName;
  /**
   * Set when the pane was pushed onto a tool's existing right-pane stack rather than
   * set as its root. Closing must pop back to whatever the rep had open underneath;
   * every other close path re-roots to NothingSelectedView and would discard it.
   */
  @Input() returnToUnderlyingPage: boolean = false;
  /** Paired with returnToUnderlyingPage: what the host tool's right pane was showing before. */
  @Input() restoreOnClose: { activeView?: string; activity?: any; showRightPane?: boolean; childNavRightPane?: boolean };
  public appointmentConfigFields: ConfiguredFields[] = [];
  @ViewChild('appConfigFieldDatePicker', { static: true }) appConfigFieldDatePicker;
  appConfigFieldDate: Date;
  public maxDate: string = this.dateTimeFormatsService.getEndOfMonth(new Date()).toISOString();
  ngUnsubscribe$ = new Subject<boolean>();
  shortMonth: string[] = shortMonthArray;
  public meetingProcessView:Array<BusinessProcessViewDataModel> = [];
  public detailsSectionId:string = 'details';
  public objectiveSectionId:string = 'meetingnotes';
  public gpsActivityPhotosSectionId:string = 'gpsActivityPhotos';
  public meetingStSectionId:string = 'meetingstructure';
  private _hideMeetingStructureTypes: string[] = [];
  private _singleAoInMeetingTypes: string[] = [];
  get hideMeetingStructure(): boolean {
    if (!this._hideMeetingStructureTypes.length) return false;
    const activity = this.activityService.selectedActivity as AppointmentActivity;
    const typeId = (activity?.indskr_activitytype || '').toLowerCase();
    return !!typeId && this._hideMeetingStructureTypes.includes(typeId);
  }
  get isSingleAoMeeting(): boolean {
    if (!this._singleAoInMeetingTypes.length) return false;
    const activity = this.activityService.selectedActivity as AppointmentActivity;
    const typeId = (activity?.indskr_activitytype || '').toLowerCase();
    return !!typeId && this._singleAoInMeetingTypes.includes(typeId);
  }
  public sharedResourcesSectionId:string = 'sharedresources';
  public keyMessagesSectionId:string = 'keymessages';
  public procedureSectionId: string = 'procedures';
  public supportingMaterialsSectionId: string = 'supportingmaterials';
  public therapeuticSectionId:string = 'therapeuticarea';
  public meetingNotesSectionId:string = 'meetingnotes';
  public meetingEventsSectionId:string = 'meetingevents';
  public coachingDetailsSectionId:string = 'coachingdetails';
  public callObjectiveSectionId:string = 'callobjective';
  public meetingOpportunitiesSectionId:string='meetingOpportunitiesSectionId'
  public meetingAssetsSectionId:string='meetingAssetsSectionId'
  public diseaseAreaSectionId:string='diseaseAreaSectionId';
  public productIndicationSectionId:string='productIndicationSectionId';
  public photosSectionId: string = 'photos';
  public samplesMaterialsSectionId: string = 'samplesmaterials';
  public expensesSectionId: string = 'meetingexpenses';
  public isSolicitatedMeetingComplianceCheckEnabled:boolean = false;
  private detectChangesOnActivityDetails$: Subject<boolean> = new Subject<boolean>();
  private calendarInviteModalHandle: any;
  private activityReopenedFromTimeline: boolean = false;
  public meetingStartDateField: IndDateTimeFormViewDataModel;
  public meetingStartTimeField: IndDateTimeFormViewDataModel;
  public meetingEndDateField: IndDateTimeFormViewDataModel;
  public meetingEndTimeField: IndDateTimeFormViewDataModel;
  public meetingDurationField: IndDateTimeFormViewDataModel;
  public opportunitiesSectionTitle: IndSectionHeaderViewDataModel;
  public assetsSectionTitle: IndSectionHeaderViewDataModel;
  public objectiveSectionHeader: IndSectionHeaderViewDataModel;
  public gpsActivityPhotosSectionHeader: IndSectionHeaderViewDataModel;
  public meetingStartDateTime: string;
  public meetingStartDate: string;
  public meetingStartTime: string;
  public meetingEndDateTime: string;
  public meetingEndDate: string;
  public meetingEndTime: string;
  public meetingDuration: string;
  dateFormatSubscription: Subscription;
  public backgroundUploadInProgress: boolean = false;
  public isTARequired: boolean = false;
  public requiredFields: any;
  public displayConflictMsg: boolean = false;
  private isClickedContacts: boolean = false;
  private isClickedAccounts:boolean = false;
  private isClickedFormat: boolean = false;
  private isClickedFormatDetails: boolean = false;
  private isClickedMeetingTypes: boolean = false;
  private isAccountClicked : boolean = false;
  private teamsMeetingStatus: { status: string, appointmentId: string } = null;
  private shouldCheckConflict: boolean = false;
  private covisitorComplianceAck$: Subject<boolean> = new Subject();

  public checkInField:IndFormFieldViewDataModel;
  public checkOutField:IndFormFieldViewDataModel;

  public isTimeRecommendationEnabled: boolean = false;
  public dictionaryDayOfWeek: { [key: number]: string };
  public dictionaryTimeSlot: { [key: number]: string };
  private timeSlotsFilteredByCurrentTime = [];
  private meetingsFilteredByCurrentTime = [];
  public recommendedByCurrentTime: any = [];
  isSelectedContactsCheck: boolean = false;
  public showTimeRecommendations: boolean = false;
  public hasMeetingEventsFA: boolean = false;
  public hasCoachingPlan: boolean = false;
  public notesSectionHeader: IndSectionHeaderViewDataModel;
  public eventsSectionHeader: IndSectionHeaderViewDataModel;
  public proceduresSectionHeader: IndSectionHeaderViewDataModel;
  public supportingMaterialsSectionHeader: IndSectionHeaderViewDataModel;
  public photosSectionHeader: IndSectionHeaderViewDataModel;
  public applicableOpportunities: Opportunity[] = [];
  public applicableAssets: any[] = [];
  public applicableAssetsModel: MainCardViewDataModel[] = [];
  public applicableEvents: EventActivity[] = [];
  public applicableAccountPlans: AccountPlan[] = [];
  public isOppSectionEnabled:boolean=false;
  public conflictMsg: string;
  // New Meeting Notes & Attachments Section
  public meetingNotesSectionHeader: IndSectionHeaderViewDataModel;
  public meetingNotesAndAttachmentsSectionId:string = 'meetingnotes';
  public isSaveNotesEnabled = false;
  public isNewNoteOffLabel = false;
  public tempNoteText: string;
  public isMeetingAttachmentAdded: boolean = false;
  public meetingNoteAttachmentTitle: string = '';
  public isMeetingAssetsEnabled:boolean = false;

  private _lookupPopover: HTMLIonPopoverElement;

  public isAccountVisitEnabled = false;
  public isAccountVisitRecord = false;
  public isAccountVisitNestedMeeting = false;
  public selectedDiseaseAreas=[];
  public selectedProductIndications=[];

  private activityOutcomeOptions:Array<ActivityOutcome> = [];
  private activityOutcomeisMandatory:boolean = false;
  private activityOutcomePopover:any;
  private locationPopover:any;
  public meetinglinkedtoamarketingbusinessplanField : IndFormFieldViewDataModel;
  public marketingBusinessPlanField : IndFormFieldViewDataModel;
  public locationField: IndFormFieldViewDataModel;
  public coachingPlanField : IndFormFieldViewDataModel;
  private allCompetitorProducts:Array<Brand> = [];
  private allCoachingPlans:Array<CoachingPlan> = [];

  public isCheckoutAndComplete = false;
  checkinFieldsEmpty = false; // this will be true when user tries to complete meeting without checkin  && mandatory flag true
  checkOutFieldsEmpty = false;
  checkinProcess = false;
  private isCompetitorProductsEnabled:boolean = false;

  isManualCheckinProcess = false;

  public checkInPhotoAttachments: PhotoAttachmentDto[] = [];
  public checkOutPhotoAttachments: PhotoAttachmentDto[] = [];
  public GPSActivity = GPSActivity;
  appealStatusFormField: IndFormFieldViewDataModel;
  public disableGPSCheckInFlowForHCPMeeting: boolean = false;

  public hasSecondaryInfo: boolean = false;
  private lookupConfigFieldsData;
  public isFromChat: boolean = false;
  public notesPlaceholder:string = '';

  private autoSavedNote:IONote;

  public testFormField:IndFormFieldViewDataModel;
  selectedData = [];

  accountSourceData:any = [];
  contactSourceData:any = [];
  public features: MeetingFeatureFlags;

  constructor() {
    this.features = this.featuresFlagsService.getMeetingFeatureFlags(this.activityService.selectedActivity as AppointmentActivity);

    this.initializeheaderTitle();
    this.events.unsubscribe('ContactsSelected');
    this.events.observe('ContactsSelected').pipe(takeUntil(this.ngdestroy$$)).subscribe(async (data) => {
      if (data && this.navService.getCurrentPageName() !== PageName.PresentationMeetingComponent) {
        if (this.activityService.selectedActivity && this.activityService.selectedActivity instanceof AppointmentActivity) {
          // # # # View Contacts in sequence the way they were selected during meeting creation # # # //
          if (!isEmpty(this.activityService.selectedActivity.contacts)) {
            for (let i = 0; i < this.activityService.selectedActivity.contacts.length; i++) {
              this.activityService.selectedActivity.contacts[i].indskr_sequence = i + 1;
            }
          }
          // # # # View Contacts in sequence the way they were selected during meeting creation # # # //
          const success = await this.meetingDataService.addContactsToMeeting(this.activityService.selectedActivity, true);

          await this.meetingDataService.addActivityAccountsAndContactAttendiesToMeeting(this.activityService.selectedActivity);

          this.meetingStructureService.addFilteredContentToMeeting();
          this.events.publish('contentIsAdded', this.activityService.selectedActivity.presentations);
          if (success) {
            this.activityService.notifyCalendarInviteUpdate(this.activityService.selectedActivity);
          }

          //Calc Best time on Contacts change
          this.calculateBestRecommendedTime();
        }
      }
    });

    this.eventSubscriptions.push(...this.events.subscribe('updateTherapeuticarea', () => {
      this.initTherapeuticAreas();
    }));
    this.events.observe('device:deviceIsOffline').pipe(takeUntil(this.ngdestroy$$)).subscribe((status) => {
      if (this.navService.getCurrentPageName() === PageName.PresentationMeetingComponent) {
        return;
      }
      this.initFooterAndHeaderForCompletedMeeting();
      this.initDieseaseAreaSectionData();
      this.initProductIndicationsSectionData();
      this.initActivitiesDetailsPageTitle();
      this._checkPageAndInitActivitiesFooterButtons()
    });
    this.events.observe('updateMeetingDateFields').pipe(takeUntil(this.ngdestroy$$)).subscribe(() => {
      this.meetingEndTimeField.isHidden = true;
      setTimeout(() => {
        this.initMeetingDateFormFields();
      }, 50);
      this.updateUIWithLatestTime();
      this.cdRef.detectChanges(); // Must be synchronous — date fields need immediate render
    });
    this.events.observe("sync:completed").pipe(takeUntil(this.ngdestroy$$)).subscribe(async (status) => {
      this.initFooterAndHeaderForCompletedMeeting();

      if (this.activityService.selectedActivity instanceof AppointmentActivity) {
        const activityAccounts: any = await this.meetingDataService.fetchActivityAccountsByMeetingId(this.activityService.selectedActivity.ID);
        if (activityAccounts) {
          (this.activityService.selectedActivity as AppointmentActivity)._raw_activityAccounts = activityAccounts;
        }

        const activityContacts: any = await this.meetingDataService.fetchActivityContactAttendiesByMeetingId(this.activityService.selectedActivity.ID);
        if (activityContacts) {
          (this.activityService.selectedActivity as AppointmentActivity)._raw_contactAttendees = activityContacts;
        }
      }
  });
    this.events.observe('device:deviceIsOnline').pipe(takeUntil(this.ngdestroy$$)).subscribe((status) =>{
      if (this.navService.getCurrentPageName() === PageName.PresentationMeetingComponent) {
        return;
      }
      this.initFooterAndHeaderForCompletedMeeting();
      this.initDieseaseAreaSectionData();
      this.initProductIndicationsSectionData();
      this.initActivitiesDetailsPageTitle();
      this._checkPageAndInitActivitiesFooterButtons()
    });
    this.events.observe('userStateChanged').pipe(takeUntil(this.ngdestroy$$)).subscribe((status) => this.initFooterAndHeaderForCompletedMeeting());
    this.events.observe('activityproductkeymessagesupdated').pipe(takeUntil(this.ngdestroy$$)).subscribe((event)=> {
      if(this.features.productIndicationEnabled){
        this.initProductIndicationsSectionData();
      }
    });
    this.events.observe('activity-detail:fieldRefreshRequired').pipe(takeUntil(this.ngdestroy$$)).subscribe(() => this.refreshFormFields());
    this.events.observe('AccountSelected').pipe(takeUntil(this.ngdestroy$$)).subscribe((data) => {
      if (data) {
        if (this.activityService.selectedActivity && this.activityService.selectedActivity instanceof AppointmentActivity) {
          this.meetingDataService.addAccountsToMeeting(this.activityService.selectedActivity).then(async() => {
            if (this.activityService.selectedActivity instanceof AppointmentActivity) {
              await this.meetingDataService.addActivityAccountsAndContactAttendiesToMeeting(this.activityService.selectedActivity);
              // Fix: the account attached here (manual account pick on an open meeting) was
              // never folded into the secondary-info subject, so the server kept whatever
              // subject was computed before this account existed on the meeting. Same defect
              // class as the auto-populate paths fixed in new-activity.ts.
              await this.meetingDataService.recomputeSecInfoSubjectAfterAttach(this.activityService.selectedActivity);
            }
          });
        }
      }
    });

    this.events.observe('refreshAccountFieldsInMeetingOfflineMode').pipe(takeUntil(this.ngdestroy$$)).subscribe(() => {
      this.setAccountFormField();
    });
    
    this.activityService.teamsMeetingStatus$.subscribe(data => {
      if (data) this.teamsMeetingStatus = data;
    });
    this.events.observe('completeMeeting').pipe(takeUntil(this.ngdestroy$$)).subscribe(() => {
      this.markComplete();
      this.initDieseaseAreaSectionData();
      this.initProductIndicationsSectionData();
    });

    this.events.subscribe('scrollToTop', () => {
      this.scrollToTop();
    });

    this.events.subscribe('remote_meeting_participant_Joined_left',(data)=> {
      this.detectChangesOnActivityDetails(true);
    });

    this.eventsService.observe('detectChangesOnActivityDetails').pipe(takeUntil(this.ngdestroy$$)).subscribe((initButtons: boolean = false) => {
      this.detectChangesOnActivityDetails$.next(initButtons);
    });

    this.detectChangesOnActivityDetails$.pipe(debounceTime(100)).subscribe((initButtons: boolean) => this.detectChangesOnActivityDetails(initButtons, false));

    this.events.observe('updateSelectedActivityDetails').pipe(takeUntil(this.ngdestroy$$)).subscribe(async () => {
      if (!this.activityService.selectedActivity) {
        if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent) {
          this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.GoAppActivitiesPageComponent);
          this.uiService.showRightPane = false;
        }
      } else {
        this.activityDataService.updateActivityDetails(this.activityService.selectedActivity, false);
        await this.initFormFields(false);
      }
    })

    this.events.subscribe('updateMandatoryField', async (field) => {
      if(field == PageName.ContactPageComponent) {
        if(this.activityService.selectedActivity instanceof AppointmentActivity){
          this.isClickedContacts = true;
          await this.initFormFields(false);
          this.appointmentConfigFields.forEach((conField) => {
            if(conField.fieldName == 'indskr_hcpinteraction' && (this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0 && this.isSolicitatedMeetingComplianceCheckEnabled) conField.isEmptyRequiredField = false;
          })
        }
      }
      else if(field == PageName.PresentationMeetingComponent) {
        await this.initFormFields(false);
      }
    })
    this.eventsService.observe('updateMandatoryField_footer').pipe(takeUntil(this.ngdestroy$$)).subscribe((button) => {
      if(button == 'contacts')  this.isClickedContacts = true;
    });

    this.newActivitySubscription = this.uiService.activityRequestObserver.subscribe(value => {
      this.uiService.showNewActivity = value;
    });
    // open issue on github where the tooltip is not destroyed when you navigate to another page
    // Solution dont put the directive in the elements top parent wrapper  Reference: https://github.com/zyra/ionic-tooltips/issues/34
    this.tooltipEvent = this.device.isNativeApp || this.device.isMobileDevice ? 'click' : 'hover';
    this.meetingStructureService.accessedFrom = AccesingMode.MEETING_DETAIL;

    this.events.subscribe('activities:appConfigFields', (message) => {
      if(message == 'indskr_hcpinteraction') {
        let meetingConfig = this.appointmentConfigFields.find((field) => field.fieldName == 'indskr_hcpinteraction')
        if(meetingConfig){
          meetingConfig.isEmptyRequiredField = false;
        }
      }
      else {
        this.updateAppConfigFieldsOnActivityChanges();
        if (this.device.isOffline) {
          this.setOfflineDataForConfigFields();
        }
      }
    });
    this.events.observe('contentmatching:refresh').pipe(takeUntil(this.ngdestroy$$)).subscribe(() => {
      this.meetingStructureService.addFilteredContentToMeeting();
      this.contentMatchService.isNewContactAddedToMeeting = false;
    });

    this.isCovisitor = !isEmpty(this.activityService.selectedActivity['accompaniedUserList']) ? this.activityService.selectedActivity['accompaniedUserList'].some(user => user.id === this.authService.user.systemUserID) : false;

    this.eventsService.observe('updateMeetingCaptureSignature').pipe(takeUntil(this.ngdestroy$$)).subscribe(() => {
      this.initMeetingFormatField();
    });
   
  }

  private footerSetDate = null;
  private allowedToCallFooterMethod(): boolean {
    if (this.footerSetDate) {
      const millisecondBetweenTwoDate = Math.abs((new Date().getTime() - this.footerSetDate.getTime()));
      // To avoid repeated calls for the footer init.
      if (millisecondBetweenTwoDate > 500) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  private initMeetingAssets() {
    this.applicableAssets = [];
    if (!isEmpty(this.fieldMaterialManagementService.meetingAssets)) {
      this.fieldMaterialManagementService.meetingAssets.filter(a => a.appointmentid == this.activityService.selectedActivity.ID && a.statecode == 0).forEach(ma => {
        const asset = this.fieldMaterialManagementService.customerAssets.find(cs => cs.msdyn_customerassetid == ma.msdyn_customerassetid);
        if (asset) {
          this.applicableAssets.push(asset);
        } else {
          this.applicableAssets.push({ ...ma, productName: ma.indskr_product, categoryName: ma.indskr_category });
        }
      });
      this.isMeetingAssetsEnabled = (this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings) ? !isEmpty(this.applicableAssets) : this.features.hasMeetingAssetsEnabled;
      this.getApplicableAssetsHeirarchyModel();
    }
  }

  private detectChangesOnActivityDetails(initButtons: boolean, updateBusinessProcess: boolean = true) {
    if (this.allowedToCallFooterMethod()) {
      if (this.activityService.selectedActivity instanceof AppointmentActivity) {
        this.initGpsFields();
        this.initGpsActivityPhotos();
        this.initGpsActivityPhotosSectionHeader();

        this.meetingStructureService.createEmbeddedInteractions(<AppointmentActivity>this.activityService.selectedActivity);
        if (initButtons) {
          if (this.uiService.activeView == 'Meeting') {
            this.footerService.initButtons(FooterViews.PreviewMeeting)
          }
          if ((this.uiService.activeView == 'activityTimelineDetails' || this.uiService.activeView == 'Appointment') &&
            (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent)) {
            this._checkPageAndInitActivitiesFooterButtons()
          }
        }
        this.initActivitiesDetailsPageTitle();
        this.opportunitiesSectionHeader();
        this.initObjectivesSectionHeader();
        this.initEventsSectionHeader();
        this.initProceduresSectionHeader();
        this.initSupportingMaterialsSectionHeader();
        this.initPhotosSectionHeader();
        if (this.features.allocationEnabled) {
          this._initSamplesMaterialsSectionHeader();
        }
        if (this.activityService.selectedActivity) {
          if (this.activityService.selectedActivity.associatedAttachments.length) {
            this.annotationId = this.activityService.selectedActivity.associatedAttachments[0].annotationId;
            this.attachmentTitle = this.activityService.selectedActivity.associatedAttachments[0].attachmentName;
            this.isAttachmentAdded = true;
          }
          this.applicableOpportunities = [];
          this.activityService.selectedActivity.associatedOpportunities.forEach(opp => {
            let foundOpportunity = this.opportunityService.getOpportunityDetailsbyId(opp.opportunityId);
            if (foundOpportunity) {
              this.applicableOpportunities.push(foundOpportunity);
            }
            else {
              const oppObj = {
                opportunityid: opp.opportunityId,
                name: opp.opportunityName
              }
              this.applicableOpportunities.push(new Opportunity(oppObj as any));
            }
          });
          this.applicableAccountPlans = [];
          this.activityService.selectedActivity.associatedAccountPlans.forEach(ap => {
            let foundAccountPlan = this.accountManagementService.getAccountPlanByPlanId(ap.accountPlanId);
            if(foundAccountPlan){
              this.applicableAccountPlans.push(foundAccountPlan);
            } else {
              const evObj = {
                indskr_accountplanid: ap.accountPlanId,
                indskr_name: ap.accountPlanName
              }
              this.applicableAccountPlans.push(new AccountPlan(evObj as any));
            }
          })
          this.applicableEvents = [];
          this.activityService.selectedActivity.associatedEvents.forEach(ev => {
            let foundEv = this.eventsToolService.getEventDetailsbyId(ev.eventId);
            if (foundEv) {
              this.applicableEvents.push(foundEv)
            } else {
              const evObj = {
                msevtmgt_eventid: ev.eventId,
                msevtmgt_name: ev.name
              }
              this.applicableEvents.push(new EventActivity(evObj));
            }
          });
          this.initMeetingAssets();
          this.isCovisitor = !isEmpty(this.activityService.selectedActivity['accompaniedUserList']) ? this.activityService.selectedActivity['accompaniedUserList'].some(user => user.id === this.authService.user.systemUserID) : false;

        }
        this.cdRef.markForCheck();
        this.footerSetDate = new Date();
      }
    }
  }

  private initializeheaderTitle() {
    switch (this.activityService.selectedActivity?.subject) {
      case 'Meeting':
        this.activitiesDetailsPanePageTitleText = this.translate.instant('MEETING');
        break;
      case 'Visit':
        this.activitiesDetailsPanePageTitleText = this.translate.instant('VISIT');
        break;
      default:
        this.activitiesDetailsPanePageTitleText = this.activityService.selectedActivity.subject;
        break;
    }
    return this.activitiesDetailsPanePageTitleText;
  }

  public get meetingStatusString(): string {
    let status: string = this.activityService.selectedActivity.getStatusString;
    switch (this.activityService.selectedActivity.getStatusString) {
      case 'Open':
        status = this.translate.instant('OPEN');
        break;
      case 'Completed':
        status = this.translate.instant('COMPLETED');
        break;
      case 'Canceled':
        status = this.translate.instant('CANCELLED');
        break;
      case 'Scheduled':
        status = this.translate.instant('SCHEDULED');
        break;
      default:
        status = this.translate.instant('N_A');
        break;
    }
    return status;
  }

  public get detailsSectionHeaderViewData(): IndSectionHeaderViewDataModel {
    const isStatusEnabled = this.features?.statusEnabled;
    return {
      id: 'meeting-details',
      title: this.translate.instant('DETAILS'),
      rightLabelTxt: isStatusEnabled ? this.meetingStatusString : undefined,
      customRightLabelClass: isStatusEnabled ? this.getMeetingStatusClassForHeader() : undefined,
      controls: []
    };
  }

  private getMeetingStatusClassForHeader(): string {
    const currentStatus = this.activityService?.selectedActivity?.state;
    if (currentStatus === MeetingActivityState.Canceled) {
      return 'details-status-badge details-status-cancelled';
    }
    if (currentStatus === MeetingActivityState.Completed) {
      return 'details-status-badge details-status-completed';
    }
    return 'details-status-badge details-status-open';
  }

  public get sharedResources() {
    return (this.activityService.selectedActivity as AppointmentActivity)?.sharedResources || []
  }


  ngAfterContentChecked() {
    if (
      !this.features.teamsMeetingEnabled
      && this.features.remoteFeatureEnabled
      && !(this.isAccountVisitRecord || this.isAccountVisitNestedMeeting)
    ) {
      this.isRemoteEnabled = true;
    }
    this.isProcedureSectionEnabled = this.features.procedureSectionEnabled || (this.activityService.selectedActivity && !isEmpty((this.activityService.selectedActivity as AppointmentActivity).activityProcedures) && this.activityService.selectedActivity.isCompleted)
    this.isSupportingMaterialsEnabled = this.features.supportingMaterialsEnabled || (this.activityService.selectedActivity && !isEmpty((this.activityService.selectedActivity as AppointmentActivity).activitySupportingMaterials) && this.activityService.selectedActivity.isCompleted)
    if (this.features.meetingContentReasonEnabled && this.activityService.isContentRequiredForRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype)) {
      this.isContentRequiredForRemoteChannelEnabled = true;
    } else {
      this.isContentRequiredForRemoteChannelEnabled = false;
    }
    this.isReadOnlyJointMeeting = this.jointMeetingStatus;
    this.isReadOnlyRecommendedMeeting = this.activityService.selectedActivity && this.activityService.selectedActivity['indskr_suggest'];
    this.assetsSectionTitle = { id: 'assets', title: this.translate.instant('ASSETS'), controls: [] };

    this.disableGPSCheckInFlowForHCPMeeting = !(this.isAccountVisitRecord || this.isAccountVisitNestedMeeting) && this.features.disableGPSCheckInFlowForHCPMeeting;
  }

  async ngOnInit() {
    this.profiler.mark('activities_detail_init');
    this.setAccountVisitFlags();

    if (this.activityService.selectedActivity instanceof AppointmentActivity &&
      this.activityService.selectedActivity.indskr_suggest &&
      !this.activityService.selectedActivity.meetingURL && !this.device.isOffline) {
      this.generateMeetingUrl(this.activityService.selectedActivity.ID)
    }

    if (this.activityService.selectedActivity instanceof AppointmentActivity &&
      this.activityService.selectedActivity.indskr_suggest &&
      !this.activityService.selectedActivity.meetingURL && !this.device.isOffline) {
      this.generateMeetingUrl(this.activityService.selectedActivity.ID)
    }

    this.initNotesSectionHeader();
    this.isFromChat = (this.navParams && this.navParams.data && this.navParams.data.viewData && this.navParams.data.viewData.from == 'openChat') || false;
    if(this.features.meetingNotesEnabled || this.features.meetingAttachmentEnabled) {
      this.initMeetingNotesSectionHeader();
      this._sortMeetingNotes();
    }

    this.activityService.isNewActivityFlow = false;
    this.displayConflictMsg = this.checkConflictMsgDisplay();
    this.activityService.signalRefreshConflictAlertMsg$.asObservable()
    .pipe(takeUntil(this.ngdestroy$$)).subscribe(() => {
      this.displayConflictMsg = this.checkConflictMsgDisplay();
    });

    if (this.from) {
      this.isLayoverPushView = true;
      if (this.from == 'AccountManagementTool') {
        this.layoverViewPushedFrom = 'AccountManagementTool';
      } else if (this.from == 'AccountTool') {
        this.layoverViewPushedFrom = 'AccountTool';
      } else if (this.from == 'AccountTimeline') {
        this.layoverViewPushedFrom = 'AccountTimeline';
      } else if (this.from == 'ScientificActivityPage') {
        this.layoverViewPushedFrom = 'ScientificActivityPage';
      } else if (this.from == 'PresentationToolsPage') {
        this.layoverViewPushedFrom = 'PresentationToolsPage';
      } else if (this.from == 'OpportunityManagementTool') {
        this.layoverViewPushedFrom = 'OpportunityManagementTool';
      } else if (this.from == 'ProcedureLogFrom') {
        this.layoverViewPushedFrom = 'ProcedureLogFrom';
      } else if(this.from === PageName.AccountPlanActivities){
        this.activityService.teamViewActive = true;
      } else if(this.from === PageName.SetBookingActivityDetailsComponent) {
        this.layoverViewPushedFrom = PageName.SetBookingActivityDetailsComponent;
      }
    }

    this.uiService.isFlipButtonClicked = false;

    this.configFieldsSubscription = this.ioUserSelection.additionalConfigObserver.subscribe(data => {
      if (data != undefined) {
        if (data[0].type != undefined) {
          this.updateAdditionalFields(data);
        }
        this.initConfigFieldsSetup();
      }
    });

    this.opportunitiesSectionHeader();
    this.initEventsSectionHeader();
    this.initGpsActivityPhotosSectionHeader();
    this.initObjectivesSectionHeader();
    this.initProceduresSectionHeader();
    this.initSupportingMaterialsSectionHeader();
    this.initPhotosSectionHeader();

    // Opportunities section visibility on meeting details
    this.applicableOpportunities = [];
    (this.activityService.selectedActivity as AppointmentActivity).associatedOpportunities.forEach(opp=> {
      let foundOpportunity = this.opportunityService.getOpportunityDetailsbyId(opp.opportunityId);
      if(foundOpportunity){
        this.applicableOpportunities.push(foundOpportunity);
      }else {
        const oppObj = {
          opportunityid: opp.opportunityId,
          name: opp.opportunityName
        }
        this.applicableOpportunities.push(new Opportunity(oppObj as any));
      }
    });
    this.applicableAccountPlans = [];
    (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans.forEach(ap=> {
      let foundAccountPlan = this.accountManagementService.getAccountPlanByPlanId(ap.accountPlanId);
      if(foundAccountPlan){
        this.applicableAccountPlans.push(foundAccountPlan);
      } else {
        const evObj = {
          indskr_accountplanid: ap.accountPlanId,
          indskr_name: ap.accountPlanName
        }
        this.applicableAccountPlans.push(new AccountPlan(evObj as any));
      }
    });
    if (this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings) {
      this.isOppSectionEnabled = !!(this.activityService.selectedActivity as AppointmentActivity).associatedOpportunities.length;
    }else if (!this.activityService.selectedActivity.isCompleted && !this.enableReadonlyViewForMeetings && this.features.opportunitySelectionEnabled) {
      this.isOppSectionEnabled = true;
    }
    this.initMeetingAssets();
    if (this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings) {
      this.hasMeetingEventsFA = !!(this.activityService.selectedActivity as AppointmentActivity).associatedEvents.length;
    }else if (!this.activityService.selectedActivity.isCompleted && !this.enableReadonlyViewForMeetings && this.features.eventsEnabled) {
      this.hasMeetingEventsFA = true;
    }

    // Event section visibility on meeting details
    this.applicableEvents = [];
    (this.activityService.selectedActivity as AppointmentActivity).associatedEvents.forEach(ev=> {
      let foundEvent = this.eventsToolService.getEventDetailsbyId(ev.eventId);
      if(foundEvent){
        this.applicableEvents.push(foundEvent);
      } else {
        const evObj = {
          msevtmgt_eventid: ev.eventId,
          msevtmgt_name: ev.name
        }
        this.applicableEvents.push(new EventActivity(evObj));
      }
    });

    // Attachment in Meeting Notes
    let attachments = (this.activityService.selectedActivity as AppointmentActivity).associatedAttachments;
    if (attachments.length) {
      this.annotationId = attachments[0].annotationId;
      this.attachmentTitle = attachments[0].attachmentName;
      this.isAttachmentAdded = true;
    }

    if (this.features.therapeuticAreaEnabled) {
      this.initTherapeuticAreas();
    }
    if (this.features.meetingNotesRelabelEnabled) {
      this.initNotesSectionHeader();
    }
    if (this.features.productIndicationEnabled) {
      this.initProductIndicationsSectionData();
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_SOLICITATION_COMPLIANCE)) {
      this.isSolicitatedMeetingComplianceCheckEnabled = true;
    }
    this.setCoachings();

    // Parse IO configs for allocation-related features
    const hideMsConfig = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_APPOINTMENT_GA_HIDE_MEETING_STRUCTURE);
    this._hideMeetingStructureTypes = typeof hideMsConfig === 'string'
      ? hideMsConfig.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
      : [];
    const singleAoConfig = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.SINGLE_AO_IN_MEETING);
    this._singleAoInMeetingTypes = typeof singleAoConfig === 'string'
      ? singleAoConfig.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
      : [];

    if (this.features.allocationEnabled) {
      let allocationInSelectedMeeting = this.activityService.activities.filter((o) => {
        return o instanceof SampleActivity && this._isAllocationForSelectedMeeting(o as SampleActivity)
      })
      this.allocationInSelectedMeeting = this._mergeContactTimelineAllocations(
        this.activityService.selectedActivity.ID,
        allocationInSelectedMeeting.map((p) => {
          return p as SampleActivity
        }),
      );
      // Pre-warm: sync lot details + allocations in background so IAO has fresh data when opened
      this._prefetchAllocationDataForIAO();
    }
    else this.allocationInSelectedMeeting = [];

    // Load the SDRs raised from this meeting (Request tab). Async — seeds the
    // cache-slice immediately and reconciles with the server when online.
    if (this.features.sampleDeliveryRequestEnabled) {
      this._refreshSdrsInMeeting();
      // Also react to sdrService.allSdrs$ directly, unlike Allocation Order's
      // equivalent init above (line ~1145) which reads activityService.
      // activities synchronously — that array is guaranteed already loaded by
      // the time this pane can even mount (core agenda data, loaded earlier
      // in app boot). sdrService.allSdrs is populated by its OWN async
      // syncRepSdrs() call, one task among many in the master sync pipeline,
      // with no such ordering guarantee relative to this pane's ngOnInit. The
      // one-shot _refreshSdrsInMeeting() call above can therefore run BEFORE
      // allSdrs has finished loading — offline, fetchSdrsForMeeting has
      // nothing else to fall back to, so the Request tab silently shows
      // nothing (or an empty count) and — since that call is never re-run on
      // its own — never corrects itself unless something else happens to
      // trigger a refresh later, which is exactly the "not listing" /
      // "takes some time to show" behavior reported (OMNI-61497 follow-up).
      // Subscribing here re-derives the meeting's SDR list on every emission
      // regardless of load order, matching Allocation Order's effectively-
      // always-correct-on-first-paint behavor without needing to touch the
      // shared sync pipeline's task ordering.
      this.sdrService.allSdrs$.pipe(takeUntil(this.ngdestroy$$)).subscribe((allSdrs) => {
        const apptId = this.activityService.selectedActivity?.ID;
        if (!apptId) return;
        this.sdrsInSelectedMeeting = (allSdrs || []).filter((s) => s.appointmentId === apptId);
      });
    } else {
      this.currentSdrsInMeeting = [];
    }

    // Default the Samples & Materials section to the first tab that's
    // actually visible for this meeting's format, in tab-bar order (Drops,
    // Materials, Request) — never based on which one has content.
    this.activeSamplesMaterialsSubTab = resolveDefaultSubTab({
      dropsVisible: this.features.sampleDropEnabled && this.isSampleDropSectionVisible,
      materialsVisible: this.features.promoMaterialEnabled && this.isPromoMaterialSectionVisible,
      requestVisible: this.features.sampleDeliveryRequestEnabled && this.isSdrSectionVisible,
    });

    if (this.contentMatchService.isNewContactAddedToMeeting) {
      this.meetingStructureService.addFilteredContentToMeeting();
      this.contentMatchService.isNewContactAddedToMeeting = false;
    }

    this.device.screenOrientation.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((newOrientation) => {
      if (newOrientation && this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent
        && this.navService.getCurrentPageName() === PageName.ActivitiesDetailsPaneComponent
        && this.uiService.activitiesPageTab !== 'plans')
        this._checkPageAndInitActivitiesFooterButtons()
    });

    //taking appointment appConfigFields from current user service
    const record = this.activityService.accountVisitRecordCheck(this.activityService.selectedActivity as AppointmentActivity);
    const formatType = record.isAccountVisitRecord || record.isAccountVisitNestedMeeting ? FormatType.ACCOUNT_VISIT : FormatType.HCP_MEETING;
    this.meetingActivityTypes = this.activityService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, formatType);
    this.initConfigFieldsSetup();
    this.initConfigFieldsLookupData();
    if (this.device.isOffline) {
      this.setOfflineDataForConfigFields();
    }
    this.uiService.setnewActivityRequest(false);
    this.initActivitiesDetailsPageTitle();

    this.selectedActivityDiffer = this.differs.find(this.activityService.selectedActivity).create();

    await this.initFormFields();

    this.translate.onLangChange.subscribe(async data => {
      this.initializeheaderTitle();
      await this.initFormFields();
    });
    this.dateFormatSubscription = this.dateTimeFormatsService.dateFormat.subscribe(async df => {
      if (df) {
        await this.initFormFields();
      }
    });

    this.device.isBackgroundUploadInProgressObservable.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(inProgress => {
      if (this.activityService.selectedActivity && this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent) {
        this.backgroundUploadInProgress = inProgress && this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID);
        this.initActivitiesDetailsPageTitle();
        this._checkPageAndInitActivitiesFooterButtons()
        if (!isEmpty(this.firstLevelFormFields)) {
          const subjField = this.firstLevelFormFields.find(field => field.id === 'subject-field');
          if (subjField) {
            subjField.isDisabled = this.backgroundUploadInProgress ? true : subjField.isDisabled;
          }
        }
      }
    });

    this.device.isOfflineObservable.pipe(
      skip(1),
      takeUntil(this.ngdestroy$$)
    )
    .subscribe(isOffline => {
      this.updateCovisitorInputEnableDisable();
      this.initActivitiesDetailsPageTitle();
      this.initMeetingFormatField();
    });

    if(this.authenticationOfflineService.impersonatedUser){
      this.detectChangesOnActivityDetails(false);
    }

    this.eventSubscriptions.push(
      this.covisitorComplianceAck$.asObservable()
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter((checked: boolean) =>
          checked !== null
          && this.activityService.selectedActivity.state !== MeetingActivityState.Completed
          // Adding this filter to
          && (this.activityService.selectedActivity as AppointmentActivity).covisitorComplianceAcked !== checked
        )
      )
      .subscribe(async (checked: boolean) => {
        try {
          await this.meetingDataService.updateCovisitorComplianceAck(
            this.activityService.selectedActivity as AppointmentActivity,
            checked,
            this.authService.user.covisitorComplianceDescription,
          );

          this.requiredFields['covisitor-compliance']['isAdded'] = checked;
        } catch (error) {
          console.error('activities-details-pane: covisitorComplianceAck$: ', error);
          // Set to null so that distinctUntilChanged doesn't filter out next attempt
          this.covisitorComplianceAck$.next(null);

          // Revert checkbox if needed
          const formField = this.secondLevelFormFields.find(field => field.id === 'covisitor-compliance');
          if (formField) {
            formField.inputValue = !!((this.activityService.selectedActivity as AppointmentActivity).covisitorComplianceAcked);
          }
          this.cdRef.markForCheck();

          // Display error message
          this.notificationService.notify(
            error?.message ?? 'Error',
            'Meeting Details',
            'top',
            ToastStyle.DANGER,
            3500,
            true,
          );
          return;
        }
      })
    );

    this.dateTimeFormatsService.updateSelectedAppointment$.pipe(takeUntil(this.ngdestroy$$)).subscribe((timeData) => {
      if (timeData) {
       setTimeout(() => {
        // Nullify fields first to force complete re-render because time-picker is not updating the fields with previous values
        this.meetingStartTimeField = null;
        this.meetingEndTimeField = null;
        this.cdRef.detectChanges(); // Must be synchronous — DOM must clear before re-init

        // Use requestAnimationFrame to ensure DOM updates before reinitializing
        requestAnimationFrame(() => {
          // Reinitialize with fresh data
          this.initMeetingDateFormFields();
          // Force change detection to ensure UI updates
          this.cdRef.detectChanges(); // Must be synchronous — date picker needs immediate render
          this.cdRef.detectChanges();
        });
       }, 0);
      }
    });

    this.isTimeRecommendationEnabled = this.authService.hasFeatureAction(FeatureActionsMap.TIME_RECOMMENDATION);
    //Calc Best time on init
    this.calculateBestRecommendedTime();

    this.isGpsEnabled = this.features.GPSCheckInEnabled && !this.activityService.isRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype)
    this.isLiveTimeFieldEnabledForF2FMeetings = this.authService.hasFeatureAction(FeatureActionsMap.HIDE_LIVETIME_FOR_F2F_MEETINGS) && !this.activityService.isRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype)
    this.profiler.measure('activities_detail_init', 'activities_detail_init', { activityType: this.activityService.selectedActivity?.type });
    // Cross-component: mark was set in activities-pane openActivityDetails
    this.profiler.measure('activities_open_detail', 'activities_open_detail', { activityType: this.activityService.selectedActivity?.type });
    // Not awaited: the pane owns the meeting, and what the rep dictated about it is
    // reviewed alongside rather than holding the meeting shut until it is read.
    this.reviewNotesAwaitingThisMeeting();
  }

  /**
   * Everything the rep dictated about this meeting, reviewed as one. Online, the
   * notes filed against the meeting in Dynamics are pulled first, so notes dictated
   * elsewhere since the last sync are included.
   *
   * A call is dictated in more than one sitting and each arrives as its own note.
   * Read separately they are partial accounts of the same call, so they are combined
   * and analysed once, and the whole set is confirmed in a single review. Every note
   * that contributed is converted together, so none is left behind to be reviewed a
   * second time.
   */
  private async reviewNotesAwaitingThisMeeting(): Promise<void> {
    const activity = this.activityService.selectedActivity;
    if (!(activity instanceof AppointmentActivity)) {
      return;
    }
    try {
      const [
        { VoiceNoteService },
        { VoiceNoteMeetingService },
        { VoiceNoteDetectionFeature },
        { isEmptyDetection },
      ] = await Promise.all([
        import('@omni/services/voice-note/voice-note.service'),
        import('@omni/services/voice-note/voice-note-meeting.service'),
        import('@omni/ai/features/voice-note-detection.feature'),
        import('@omni/ai/features/detected-mentions'),
      ]);
      const voiceNoteService = this.injector.get(VoiceNoteService);
      if (!this.device.isOffline) {
        await voiceNoteService.refreshNotesForMeeting(activity.ID)
          .catch(error => console.warn('ActivitiesDetailsPane: fetching the meeting\'s notes failed', error));
      }
      const waiting = await voiceNoteService.notesAwaitingMeeting(activity.ID);
      const transcript = combineNoteTranscripts(waiting);
      if (!transcript || this.activityService.selectedActivity?.ID !== activity.ID) {
        return;
      }

      const detection = this.injector.get(VoiceNoteDetectionFeature);
      let detected: Awaited<ReturnType<InstanceType<typeof VoiceNoteDetectionFeature>['detect']>> = null;
      let failed = false;
      if (detection.isAvailable()) {
        await this.displayLoader({ message: this.translate.instant('DETECTING_DETAILS') });
        try {
          detected = await detection.detect(transcript);
        } catch (error) {
          console.warn('ActivitiesDetailsPane: detecting the meeting\'s notes failed', error);
          failed = true;
        } finally {
          await this.uiService.dismissLoader();
        }
      }
      if (detected && isEmptyDetection(detected)) {
        detected = null;
      }
      if (failed) {
        this.notificationService.notify(
          this.translate.instant('DICTATE_DETECTION_FAILED_MERGE'), 'Meeting Details', 'top', ToastStyle.INFO,
        );
      }

      const meetingService = this.injector.get(VoiceNoteMeetingService);
      const confirmed = await this.injector.get(DictationFlowService).reviewAndConfirm(
        detectionForReview(detected, { transcript }),
        { targetMeeting: meetingService.describeMeeting(activity), transcript },
      );
      if (!confirmed) {
        return; // the notes stay as they are, to be reviewed another time
      }

      const applied = await meetingService.applyDictationToMeeting(activity, confirmed, transcript);
      await Promise.all(waiting.map(note => voiceNoteService.markConverted(note.id, activity.ID)
        .catch(error => console.error('ActivitiesDetailsPane: markConverted failed', error))));
      this.preSavedNotes = activity.notes;
      const addedAnything =
        applied.contacts + applied.accounts + applied.products + applied.keyMessages + applied.objectives > 0
        || applied.notesUpdated || applied.locationSet;
      this.notificationService.notify(
        this.translate.instant(addedAnything ? 'DICTATE_ADDED_TO_MEETING' : 'DICTATE_NOTHING_ADDED'),
        'Meeting Details',
        'top',
        addedAnything ? ToastStyle.INFO : ToastStyle.DANGER,
      );
    } catch (error) {
      console.error('ActivitiesDetailsPane: reviewing the meeting notes failed', error);
    }
  }

  private setAccountVisitFlags() {
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT)
      && this.activityService.selectedActivity.type === ActivityType.Appointment) {
      this.isAccountVisitEnabled = true;
      this.isAccountVisitRecord = !!((this.activityService.selectedActivity as AppointmentActivity).indskr_isparentcall);
      this.isAccountVisitNestedMeeting = !!((this.activityService.selectedActivity as AppointmentActivity).indskr_parentcallid);
    }
  }

  private setCoachings() {
    if (this.features.coachingEnabled) {
      this.coachingReportService.setActivityCoaching(this.activityService.selectedActivity);
      this.coachingActivitySubscription = this.coachingReportService.activityCoachingObserver.subscribe(data => {
        this.coachingReportService.coachingReports = data;
      });
    }
  }

  async ngDoCheck() {
    if(this.activityService.selectedActivity && this.activityService.selectedActivity instanceof AppointmentActivity) {
      if (this.selectedActivityDiffer) {
        const changes = this.selectedActivityDiffer.diff(this.activityService.selectedActivity);
        if (changes) {
          await this.initFormFields(false);
        }
      }
    }
  }


  private shouldDisableCovisitorComplianceInput(): boolean {
    return !(
      !this.enableReadonlyViewForMeetings
      && this.activityService.selectedActivity?.state !== MeetingActivityState.Completed
      && this.activityService.selectedActivity?.state !== MeetingActivityState.Canceled
      && !(this.jointMeetingStatus && this.device.isOffline)
      && !this.isEffectiveDiffPosition
    );
  }

  private async initFormFields(updateBusinessProcess:boolean = true) {
    this.setAccountVisitFlags();
    this.firstLevelFormFields = [];
    this.secondLevelFormFields = [];
    this.ngAfterContentChecked();
 
    this.requiredFields = this.activityService.getRequiredData(this.activityService.selectedActivity as AppointmentActivity);
    let meeting = this.activityService.selectedActivity as AppointmentActivity;

    this.activityOutcomeOptions = this.surgeryOrderDataService.activityOutcomes.filter(a=> a.indskr_omnipresenceactivity == ActivityOutcomeType.Meeting);
    this.activityOutcomeisMandatory = this.activityOutcomeOptions.some(a=> a.indskr_mandatory);
    this.isCompetitorProductsEnabled = this.authService.user.buConfigs['indskr_competitorproduct'];
    this.isCovisitor = !isEmpty(this.activityService.selectedActivity['accompaniedUserList']) ? this.activityService.selectedActivity['accompaniedUserList'].some(user => user.id === this.authService.user.systemUserID) : false;
    this.hasCoachingPlan = this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN);
    if(this.isCompetitorProductsEnabled){
      this.allCompetitorProducts = this.caseManagementService.caseProductSKU.filter(p => p.isCompetitorProduct && p.isCompetitorProduct == 'true');
    }

    const activityTypeFieldText = this.activityService.selectedActivity.activityTypeName
      || this.meetingActivityTypes?.find(t => t.indskr_activitytypeid === this.activityService.selectedActivity.indskr_activitytype)?.indskr_name;
    this.isInStoreMeeting = this.isAccountVisitRecord && !this.isAccountVisitNestedMeeting && activityTypeFieldText === this.translate.instant("INSTORE");
    this.isInStoreChildMeeting = this.isAccountVisitNestedMeeting && activityTypeFieldText === this.translate.instant("INSTORE");

    if (this.hasCoachingPlan) {
      this.allCoachingPlans = this.coachingReportService.coachingPlans;
    }
    this.initGpsFields();
    this.initGpsActivityPhotos();
    this.setAccountFormField();
    this.setContactFormField();

    if(!this.therapeuticAreas || (this.therapeuticAreas && this.therapeuticAreas.length<1) ) {
      this.requiredFields['therapeutic-area']['isRequired'] = false;
    }

    this.firstLevelFormFields.push({
      isHidden: !this.isReadOnlyJointMeeting,
      label: this.translate.instant('ACTIVITY_DETAILS_SCHEDULED_BY'),
      inputText: ((this.activityService.selectedActivity && this.activityService.selectedActivity.meetingOwnerName) ? this.activityService.selectedActivity.meetingOwnerName:''),
      id: 'scheduled-by-field',
      isReadOnly: true,
      isDisabled: true,
      showArrow: false,
    });

    this.firstLevelFormFields.push({
      isHidden: !this.activityService.selectedActivity.cancellationreason && !this.activityService.selectedActivity.indskr_reasonforcancellationname,
      label: this.translate.instant('CANCELLATION_REASON'),
      inputText: this.activityService.selectedActivity.cancellationreason || this.activityService.selectedActivity.indskr_reasonforcancellationname,
      id: 'cancellation-field',
      isReadOnly: true,
      isDisabled: true,
      showArrow: false,
    });

    this.firstLevelFormFields.push({
      isHidden: !this.activityService.selectedActivity.indskr_cancellationreasonother,
      label: this.translate.instant('CANCELLATION_REASON_OTHER'),
      inputText: this.activityService.selectedActivity.indskr_cancellationreasonother,
      id: 'cancellation-other-field',
      isReadOnly: true,
      isDisabled: true,
      showArrow: false,
    });

    const isSubjectNotEditable = this.features.meetingAutoSubjectEnabled ? this.secondaryInfoService.isAppointmentSecInfoConfigured : this.features.meetingAutoSubjectEnabled;
    const isSubjectReadOnly = this.isReadOnlyJointMeeting
      || this.enableReadonlyViewForMeetings
      || isSubjectNotEditable
      || this.activityService.selectedActivity.state == MeetingActivityState.Completed
      || this.isEffectiveDiffPosition;

    let viewDataField = {
      label: this.translate.instant('SUBJECT'),
      inputText: ((this.activityService.selectedActivity && this.activityService.selectedActivity.subject) ? (this.activityService.selectedActivity.subject == 'Meeting' ? this.translate.instant('MEETING') : (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT) && this.activityService.selectedActivity.subject == 'Visit') ? this.translate.instant('VISIT') : this.activityService.selectedActivity.subject) + '' : ''),
      inputValue: ((this.activityService.selectedActivity && this.activityService.selectedActivity.subject) ? (this.activityService.selectedActivity.subject == 'Meeting' ? this.translate.instant('MEETING') : (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT) && this.activityService.selectedActivity.subject == 'Visit') ? this.translate.instant('VISIT') : this.activityService.selectedActivity.subject) + '' : ''),
      id: 'subject-field',
      isHidden: isSubjectNotEditable,
      isReadOnly: isSubjectReadOnly,
      isDisabled: this.backgroundUploadInProgress || this.isReadOnlyRecommendedMeeting || this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings || isSubjectNotEditable || this.activityService.selectedActivity.state == MeetingActivityState.Completed || this.isEffectiveDiffPosition ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled,
      placeholderLabel: this.translate.instant('SUBJECT'),
      showArrow: !(this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings || this.features.meetingAutoSubjectEnabled || this.activityService.selectedActivity.state == MeetingActivityState.Completed ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.isEffectiveDiffPosition),
      formFieldType: FormFieldType.INLINE_INPUT,
      isRequired: !(this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings || this.features.meetingAutoSubjectEnabled || this.activityService.selectedActivity.state == MeetingActivityState.Completed ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.isEffectiveDiffPosition),
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      dropdown: undefined,
      displayInfoText: this.activityService.selectedActivity['indskr_suggest'],
      infoText: this.activityService.selectedActivity && this.activityService.selectedActivity['indskr_suggest'] ? (this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype && this.activityService.isRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype) ? this.translate.instant('SUGGESTED_REMOTE_MEETING') : this.translate.instant('SUGGESTED_F2F_MEETING') : '',
      infoTextCSSClass: 'orange-info-message-text',
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    if (this.activityService.meetingSubjects?.length && !viewDataField.isReadOnly) {
      viewDataField.showArrow = false;
      viewDataField.dropdown = {
        values: this.activityService.meetingSubjects.map((option, i) => ({ title: option, id: option }))
      };
    }
    this.firstLevelFormFields.push(viewDataField);

    let suggestReasonField: IndFormFieldViewDataModel = {
      label: this.translate.instant('SUGGEST_REASON'),
      inputText: this.activityService.selectedActivity['indskr_reason'],
      inputValue: this.activityService.selectedActivity['indskr_reason'],
      id: 'suggest-reason-field',
      isReadOnly: true,
      isDisabled: true,
      placeholderLabel: this.translate.instant('SUGGEST_REASON'),
      showArrow: false,
      isHidden: !this.activityService.selectedActivity['indskr_suggest'],
      isFieldNextIcon: true,
      imgSrc: 'assets/imgs/field_star.svg',
      formFieldType: FormFieldType.DATA_SUBMITTED
    };
    this.firstLevelFormFields.push(suggestReasonField);

    this.activitiesDetailsPanePageTitle =  {...this.activitiesDetailsPanePageTitle, title: viewDataField.inputValue};

    this.initMeetingDateFormFields();

    this.meetingDurationField = {
      isDurationField: true,
      isNewActivityView: true,
      label: this.translate.instant('DURATION'),
      inputText: this.meetingDuration,
      id: DateTimeFieldType.TimeDurationField,
      isReadOnly: true,
      isDisabled: false,
      showArrow: true,
      isHidden: !this.features.meetingDurationEnabled,
      isRequired: this.features.meetingDurationRequired || ((location) => location?.toLowerCase()?.includes('Chicago') || location?.includes('Oregon'))(this.activityService?.selectedActivity?.location),
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };

    if((!this.features.liveMeet && this.features.isMeetingTypeFAEnabled) && !this.isAccountVisitRecord && !this.isAccountVisitNestedMeeting && !isEmpty(this.meetingActivityTypes)){
      this.meetingTypeFormField = {
        label: this.translate.instant('MEETING_TYPE'),
        inputText: this.activityService.getMeetingType((this.activityService.selectedActivity as AppointmentActivity).indskr_meetingtype),
        placeholderLabel: (this.activityService.meetingTypes.length > 0 && !(!this.isNotReadOnly && !((this.activityService.selectedActivity as AppointmentActivity).indskr_meetingtype)) ? "" : this.translate.instant("NO") + " ") + this.translate.instant("MEETING_TYPE"),
        id: 'meeting-type-field',
        isReadOnly: true,
        isDisabled: !(this.isNotReadOnly),
        showArrow: (this.isNotReadOnly && this.activityService.meetingTypes.length > 0),
        formFieldType: FormFieldType.POPOVER_SELECT,
        isRequired: this.isNotReadOnly && this.activityService.meetingTypes.length > 0 && this.requiredFields['meeting-type-field']['isRequired'],
        errorMessage: this.activityService.getErrorMessageRequiredField(),
        isEmptyRequiredField: this.isNotReadOnly && this.activityService.meetingTypes.length > 0 && this.requiredFields['meeting-type-field']['isRequired'] && this.isClickedMeetingTypes && isEmpty(this.activityService.getMeetingType((this.activityService.selectedActivity as AppointmentActivity).indskr_meetingtype)),
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
      };
    }

    const isLoggedInUserMeetingOwner =
      (this.activityService.selectedActivity['meetingOwnerId'] || '').toString().toLowerCase() ===
      (this.authService.user.systemUserID || '').toString().toLowerCase();

    this.ownerFormField = {
      label: this.translate.instant('OM_OWNER'),
      inputText: this.activityService.selectedActivity.meetingOwnerName,
      id: 'created-by-field',
      isHidden: isLoggedInUserMeetingOwner,
      isReadOnly: true,
      isDisabled: false,
      showArrow: false,
    };

    this.initMeetingFormatField();

    this.initAllPresentationPlayDurationField();

    if(!this.isAccountVisitRecord && (!isEmpty(this.meetingActivityTypes) || !isEmpty(this.activityService.selectedActivity.indskr_activitysubtype))){
      const formatDetailShowArrow = (
        this.isNotReadOnly
        && !isEmpty(this.activityService.configuredActivitySubTypes(MeetingActivityTypeCode.MEETING))
      );
      this.activitySubTypeFormField = {
        label: this.translate.instant('FORMAT_DETAILS'),
        isHidden: this.authService.hasFeatureAction(FeatureActionsMap.MEETING_HIDE_SUBTYPE) ||  isEmpty(this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, this.activityService.selectedActivity.indskr_activitytype)),
        inputText: this.localisationService.getTranslatedString(this.activityService.selectedActivity.activitySubTypeName, EntityNameForTranslation.ActivityType),
        inputValue: this.localisationService.getTranslatedString(this.activityService.selectedActivity.activitySubTypeName, EntityNameForTranslation.ActivityType),
        customPlaceholderLabel: this.isNotReadOnly ? this.translate.instant('SELECT_FORMAT_DETAILS'):this.translate.instant('NO_FORMAT_DETAILS'),
        id: 'meeting-activitySubType-field',
        isReadOnly: true,
        isDisabled: !(this.isNotReadOnly),
        showArrow: formatDetailShowArrow,
        formFieldType: FormFieldType.POPOVER_SELECT,
        isRequired: formatDetailShowArrow && this.requiredFields['meeting-activitySubType-field']['isRequired'],
        errorMessage: this.activityService.getErrorMessageRequiredField(),
        isEmptyRequiredField: (this.isNotReadOnly && !isEmpty(this.activityService.configuredActivitySubTypes(MeetingActivityTypeCode.MEETING)) && this.requiredFields['meeting-activitySubType-field']['isRequired']) && this.isClickedFormatDetails && isEmpty(this.activityService.selectedActivity.activitySubTypeName),
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
      };
    }

    if(this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_meetinglinkedtomarketingbusinessplan']){
      if((this.activityService.selectedActivity as AppointmentActivity).hasLinkedToMarketingBusinessPlan == null) {
        (this.activityService.selectedActivity as AppointmentActivity).hasLinkedToMarketingBusinessPlan = false;
      }
      this.meetinglinkedtoamarketingbusinessplanField = {
        label: this.translate.instant('IS_MEETING_LINKED_MBP'),
        inputText:  this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).hasLinkedToMarketingBusinessPlan ?  this.translate.instant("YES") : this.translate.instant("NO"),
        placeholderLabel: this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).accounts.length === 0 ? this.translate.instant('IS_MEETING_LINKED_MBP') : this.translate.instant('IS_MEETING_LINKED_MBP'),
        id:'is-meeting-linked-mbp-field',
        isReadOnly:true,
        isDisabled: (this.activityService.selectedActivity as AppointmentActivity).state !== 0 || !(this.isNotReadOnly),
        showArrow: (this.activityService.selectedActivity as AppointmentActivity).state === 0 && this.isNotReadOnly ,
        isRequired: false,
        formFieldType: FormFieldType.POPOVER_SELECT,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id,event,eventName),
      }
    }

    if(this.authService.hasFeatureAction(FeatureActionsMap.MARKETING_BUSINESS_PLAN)){
      this.marketingBusinessPlanField = {
        label: this.translate.instant('MARKETING_BUSINESS_PLAN'),
        inputText:  this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).marketingBusinessPlanName ?  (this.activityService.selectedActivity as AppointmentActivity).marketingBusinessPlanName : '',
        placeholderLabel: this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).accounts.length === 0 ? this.translate.instant('MARKETING_BUSINESS_PLAN') : this.translate.instant('MARKETING_BUSINESS_PLAN'),
        id:'marketing-business-plan-field',
        isReadOnly:true,
        isDisabled: (this.activityService.selectedActivity as AppointmentActivity).state !== 0 || !(this.isNotReadOnly),
        showArrow: (this.activityService.selectedActivity as AppointmentActivity).state === 0 && this.isNotReadOnly,
        isRequired: this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).hasLinkedToMarketingBusinessPlan,
        isHidden: !((this.activityService.selectedActivity as AppointmentActivity).hasLinkedToMarketingBusinessPlan && this.authService.user.buConfigs['indskr_meetinglinkedtomarketingbusinessplan']) ,
        formFieldType: FormFieldType.NEW_PAGE_SELECT,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id,event,eventName),
      }
    }

    if(this.hasCoachingPlan){
      this.coachingPlanField = {
        label: this.translate.instant('COACHING_PLAN'),
        inputText:  this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).indskr_coachingplanname ?  (this.activityService.selectedActivity as AppointmentActivity).indskr_coachingplanname : '',
        placeholderLabel: this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).accounts.length === 0 ? this.translate.instant('COACHING_PLAN') : this.translate.instant('COACHING_PLAN'),
        id:'coaching-plan-field',
        isReadOnly:true,
        isDisabled: (this.activityService.selectedActivity as AppointmentActivity).state !== 0 || this.isReadOnlyJointMeeting ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled,
        showArrow: (this.activityService.selectedActivity as AppointmentActivity).state === 0  || !this.isReadOnlyJointMeeting ||  this.activityService.selectedActivity.state != MeetingActivityState.Canceled,
        formFieldType: FormFieldType.NEW_PAGE_SELECT,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id,event,eventName),
      }
    }


    // Form Field for Account Plan for Meetings
    this.secondLevelFormFields.push({
      isHidden: !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ACCOUNT_PLANS_FOR_MEETING),
      label: this.translate.instant('ACCOUNT_PLANS'),
      inputText: this.displayText(
        (this.activityService.selectedActivity as AppointmentActivity)
          .associatedAccountPlans,
        'accountPlanName'
      ),
      customPlaceholderLabel:
        this.activityService.selectedActivity &&
        !this.isReadOnlyJointMeeting &&
        !this.enableReadonlyViewForMeetings &&
        this.activityService.selectedActivity.state !=
        MeetingActivityState.Completed && this.checkIfAccountPlansAssociated()
          ? this.translate.instant('SELECT_ACCOUNT_PLANS')
          : this.translate.instant('ACCOUNTS_CALL_NO_ACCOUNT_PLANS'),
      id: 'account-plans-field',
      isReadOnly: true,
      isDisabled: !(this.isNotReadOnly && this.checkIfAccountPlansAssociated() || (this.activityService.selectedActivity && (this.activityService.selectedActivity.state == MeetingActivityState.Completed && (this.activityService.selectedActivity as AppointmentActivity).accounts.length !== 0 || (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans.length !== 0))),
      showArrow: this.isNotReadOnly && this.checkIfAccountPlansAssociated() || (this.activityService.selectedActivity && (this.activityService.selectedActivity.state == MeetingActivityState.Completed && (this.activityService.selectedActivity as AppointmentActivity).accounts.length !== 0 || (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans.length !== 0)),
      formFieldType: FormFieldType.NEW_PAGE_SELECT,
      eventHandler: (id: string, event, eventName) =>
        this.handleFormFieldEvent(id, event, eventName),
    });

    const isContactFormDisabled = (this.enableReadonlyViewForMeetings && (this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0)
      || (this.isAccountVisitRecord && (this.activityService.selectedActivity as AppointmentActivity).accounts.length === 0) || this.from === PageName.AccountPlanActivities || this.isFromChat;

    let contactString = '';
    if(this.contactService.isMeetingContactSequenceEnabled) {
      contactString =  (this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).contacts.length != 0) ? this.getMeetingContactsSequenceString() : '';
    }
    else{
      contactString =  (this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).contacts.length != 0) ? (this.activityService.selectedActivity as AppointmentActivity).contactString : '';
    }
    this.locationField = {
      isHidden: !this.features.locationEnabled,
      label: this.translate.instant('ACTIVITY_DETAILS_LOCATION'),
      inputText: (this.activityService.selectedActivity && this.activityService.selectedActivity.location && this.activityService.selectedActivity.location != 'No Location' && this.activityService.selectedActivity.location != this.translate.instant('NO_LOCATION')) ? this.activityService.selectedActivity.location : '',
      id: 'location-field',
      customCssClass: 'location-no-wrap',
      isReadOnly: true,
      customPlaceholderLabel: this.isNotReadOnly ? this.translate.instant('SELECT_ACTIVITY_DETAILS_LOCATION'):this.translate.instant('NO_LOCATION'),
      isDisabled:  (this.features.GPSCheckInEnabled && (this.activityService.selectedActivity as AppointmentActivity).gpsCheckInDetails.indskr_checkinstatus != null) || !(this.activityService.selectedActivity && !this.isReadOnlyRecommendedMeeting && !this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings && this.activityService.selectedActivity.state != MeetingActivityState.Completed || this.activityService.selectedActivity.state == MeetingActivityState.Completed) ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled,
      showArrow: (this.activityService.selectedActivity && !this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings && this.activityService.selectedActivity.state != MeetingActivityState.Completed  &&  this.activityService.selectedActivity.state != MeetingActivityState.Canceled && !this.features.GPSCheckInEnabled || (this.features.GPSCheckInEnabled && (this.activityService.selectedActivity as AppointmentActivity).gpsCheckInDetails.indskr_checkinstatus == null)),
      isRequired: this.isLocationMandatory && this.activityService.selectedActivity.state != MeetingActivityState.Completed && this.activityService.selectedActivity.state != MeetingActivityState.Canceled,
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      formFieldType: FormFieldType.POPOVER_SELECT,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };

    const isCoVisitoFieldDisabled = (this.activityService.teamViewActive || !this.activityService.isMeetingOwner || (this.activityService.selectedActivity.isCompleted && this.activityService.selectedActivity['accompaniedUserList'].length === 0) || this.isEffectiveDiffPosition)
    this.secondLevelFormFields.push({
      isHidden: (this.activityService.selectedActivity.isCompleted && (!this.activityService.selectedActivity['accompaniedUserList'])) || !(this.features.jointMeetingEnabled || (this.activityService.selectedActivity['accompaniedUserList'] && this.activityService.selectedActivity['accompaniedUserList'].length >0)),
      label: this.translate.instant('ACTIVITY_DETAILS_COVISITORS'),
      inputText: (this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).accompaniedUserList.length != 0) ? (this.activityService.selectedActivity as AppointmentActivity).accompaniedUserString : '',
      customPlaceholderLabel: ((this.activityService.selectedActivity && !this.enableReadonlyViewForMeetings && this.activityService.selectedActivity.state != MeetingActivityState.Completed) && !this.isEffectiveDiffPosition)? this.translate.instant('ACTIVITY_DETAILS_SELECT_COVISITORS'):this.translate.instant('ACTIVITY_DETAILS_NO_COVISITORS'),
      id: 'covisitor-field',
      isReadOnly: true,
      isDisabled: (this.enableReadonlyViewForMeetings || (this.activityService.selectedActivity.isCompleted &&  this.activityService.selectedActivity.state == MeetingActivityState.Canceled && this.activityService.selectedActivity['accompaniedUserList'].length === 0) || this.isEffectiveDiffPosition && this.isNotReadOnly),
      showArrow: !(this.enableReadonlyViewForMeetings || (this.activityService.selectedActivity.isCompleted &&  this.activityService.selectedActivity.state == MeetingActivityState.Canceled && this.activityService.selectedActivity['accompaniedUserList'].length === 0) || this.isEffectiveDiffPosition && this.isNotReadOnly) ,
      formFieldType: FormFieldType.NEW_PAGE_SELECT,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    });
    this.secondLevelFormFields.push({
      isHidden: !this.activityService.shouldShowCovisitorComplianceForm(this.activityService.selectedActivity),
      label: this.translate.instant('COVISITOR_COMPLIANCE'),
      inputText: (this.activityService.selectedActivity as AppointmentActivity).covisitorComplianceDescription
                  ? (this.activityService.selectedActivity as AppointmentActivity).covisitorComplianceDescription
                  : this.authService.user.covisitorComplianceDescription,
      inputValue: !!((this.activityService.selectedActivity as AppointmentActivity).covisitorComplianceAcked),
      isRequired: this.activityService.selectedActivity.state !== MeetingActivityState.Completed
                  ? this.authService.user.isCovisitorComplianceMandatory
                  : false,
      isEmptyRequiredField: this.activityService.selectedActivity.state !== MeetingActivityState.Completed
                            ? this.authService.user.isCovisitorComplianceMandatory
                              && this.requiredFields['covisitor-compliance']['isEvaluated'] === true
                              && !this.requiredFields['covisitor-compliance']['isAdded']
                            : false,
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      id: 'covisitor-compliance',
      isReadOnly: true,
      isDisabled: this.shouldDisableCovisitorComplianceInput(),
      formFieldType: FormFieldType.DESCRIPTION_AND_CONFIRM,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName)
    });
    const enableEdaField = this.authService.hasFeatureAction(FeatureActionsMap.CAPTURE_REMOTE_DETAILING_DURATION) && this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype);
    if (enableEdaField) {
      this.secondLevelFormFields.push({
        label: this.translate.instant('REMOTE_DETAILING_DURATION'),
        inputText: this.activityService.formattedDuration,
        id: 'edd-field',
        isReadOnly: true
      });
    }

    let isViewReadOnly = (this.enableReadonlyViewForMeetings || (this.activityService.selectedActivity.isCompleted) || this.isEffectiveDiffPosition ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled);
    if( (isViewReadOnly && (this.activityService.selectedActivity as AppointmentActivity).meetingOutcomeId) || (!isViewReadOnly && this.activityOutcomeOptions.length > 0) ){
      let meetingOutcomeFieldViewData: IndFormFieldViewDataModel;
      meetingOutcomeFieldViewData = {
        label: this.translate.instant('ACTIVITY_OUTCOME'),
        inputText: (this.activityService.selectedActivity as AppointmentActivity).meetingOutcomeString,
        customPlaceholderLabel: this.activityOutcomeOptions.length == 0 ? this.translate.instant('NO_ACTIVITY_OUTCOME'):this.translate.instant('SELECT_ACTIVITY_OUTCOME'),
        id: 'meeting-outcome-field',
        isReadOnly: true,
        isDisabled: isViewReadOnly || (this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID && (this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS)),
        showArrow: !isViewReadOnly && (this.activityService.selectedActivity.ownerId == this.authService.user.systemUserID || (this.isCovisitor && this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS)),
        isRequired: this.activityOutcomeisMandatory,
        errorMessage: this.activityService.getErrorMessageRequiredField(),
        isHidden: ((!isViewReadOnly && this.activityOutcomeOptions.length == 0) || (isViewReadOnly && !(this.activityService.selectedActivity as AppointmentActivity).meetingOutcomeId)),
        formFieldType: FormFieldType.POPOVER_SELECT,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
      };
      this.secondLevelFormFields.push(meetingOutcomeFieldViewData);
    }
    if(this.isCompetitorProductsEnabled){
      this.secondLevelFormFields.push({
        label: this.translate.instant('COMPETITOR_PRODUCTS'),
        inputText: this._currentCompetitorProductsString,
        customPlaceholderLabel: !this.allCompetitorProducts ? this.translate.instant('NO_COMPETITOR_PRODUCTS') : this.translate.instant('SELECT_COMPETITOR_PRODUCTS'),
        id: 'competitor-products-field',
        isReadOnly: true,
        isDisabled: isViewReadOnly || !this.allCompetitorProducts.length ||  (this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID && (this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS)),
        showArrow: (!isViewReadOnly && !!this.allCompetitorProducts.length) && (this.activityService.selectedActivity.ownerId == this.authService.user.systemUserID || (this.isCovisitor && this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS)),
        formFieldType: FormFieldType.NEW_PAGE_SELECT,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
      });
    }
    if(this.authService.hasFeatureAction(FeatureActionsMap.KIT_BOOKING)) {
      let linkedKitBooking = this.activityService.getActivityByID(this.activityService.selectedActivity['indskr_kitbooking']) as SetBookingActivity;
      this.secondLevelFormFields.push({
        label: this.translate.instant('KIT_BOOKING'),
        inputText: linkedKitBooking ? linkedKitBooking['subject'] : '',
        id: 'kit-booking-field',
        customPlaceholderLabel: this.from !== PageName.SetBookingActivityDetailsComponent ? this.translate.instant('SELECT_KIT_BOOKING') :this.translate.instant('NO_KIT_BOOKING'),
        isReadOnly: true,
        isDisabled: this.from === PageName.SetBookingActivityDetailsComponent || this.isFromChat ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled,
        showArrow: (this.from !== PageName.SetBookingActivityDetailsComponent || !this.isFromChat ) &&  this.activityService.selectedActivity.state != MeetingActivityState.Canceled,
        formFieldType: FormFieldType.NEW_PAGE_SELECT,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName)
      });
    }

    this.selectedContacts = [...(this.activityService.selectedActivity as AppointmentActivity).contacts];

    /* To check foll.
      1.Feature Action is enabled
      2.showBestTimeRecommendation is enabled for this user
      3.Device should be online
    */
    if (this.isTimeRecommendationEnabled && this.authService.user.showBestTimeRecommendation && !this.device.isOffline)
    {
      if (this.isSelectedContactsCheck === false && this.selectedContacts.length > 0) {
          this.isSelectedContactsCheck = true;
          //Calc Best time if selected Contact length is only one on Form init
          await this.calculateBestRecommendedTime();
        } else {
          //To check for scheduledStart.isAfter(currentTimeStart) then hide else show
          const scheduledStart = new Date(this.activityService.selectedActivity.scheduledStart);
          const currentTimeStart: Date = new Date();

          if (this.dateTimeFormatsService.isAfterDate(scheduledStart, currentTimeStart)) {
            this.showTimeRecommendations = true;
          }
          else {
            this.showTimeRecommendations = false;
          }
        }
    }


    if (updateBusinessProcess) {
      this.meetingProcessView = [];
      if(this.activityService.selectedActivity && (this.activityService.selectedActivity.type == 'Appointment' || this.activityService.selectedActivity.type == 'LiveMeet' || this.activityService.selectedActivity.type == 'Joint Meeting' )){
        this.detailsSectionId = 'details'+Math.random().toString(36).substring(7);
        this.meetingProcessView.push({
          id: 'detailsprocess'+Math.random().toString(36).substring(7),
          title: this.translate.instant('DETAILS'),
          bindingElementId: this.detailsSectionId,
          isActive:true,
        });
        // InStore Meeting Check
        if (this.isInStoreMeeting) {
          this.photosSectionId = 'photos' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'photosprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('IN_STORE_PHOTOS'),
            bindingElementId: this.photosSectionId,
            isActive: false,
          });
        }
        // GPS Activity Photos Check
        if (this.features.manualGPSCheckinEnabled && !this.isAccountVisitNestedMeeting) {
          this.gpsActivityPhotosSectionId = 'gpsActivityPhotos' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'gpsActivityPhotosprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('CHECK_IN_CHECK_OUT_PHOTOS'),
            bindingElementId: this.gpsActivityPhotosSectionId,
            isActive: false,
          });
        }

        if (this.features.isMeetingObjectiveSelectionEnabled) {
          this.objectiveSectionId = 'objectives' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'objectives' + Math.random().toString(36).substring(7),
            title: this.translate.instant('OBJECTIVES'),
            bindingElementId: this.objectiveSectionId,
            isActive: false,
          });
        }

        // visibleSamplesMaterialsTabsCount mirrors the section's OWN template
        // gate: the section hides entirely once the selected format hides all
        // of Drops/Request/Materials. Gating the tab on allocationEnabled
        // alone left a business-process tab pointing at a section that is not
        // rendered — it highlighted and scrolled nowhere (OMNI-62166).
        if (this.features.allocationEnabled && this.visibleSamplesMaterialsTabsCount > 0) {
          this.samplesMaterialsSectionId = 'samplesmaterials' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'samplesmaterialsprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('SAMPLES_AND_MATERIALS'),
            bindingElementId: this.samplesMaterialsSectionId,
            isActive: false,
          });
        }

        if (!this.hideMeetingStructure) {
          this.meetingStSectionId = 'meetingstructure'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingstructureprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('MEETING_STRUCTURE_CAMEL_CASE'),
            bindingElementId: this.meetingStSectionId,
            isActive:false,
          });
        }

        if(this.sharedResources && this.sharedResources.length > 0){
          this.sharedResourcesSectionId = 'sharedresources'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'sharedresourcesprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('SHARED_RESOURCES'),
            bindingElementId: this.sharedResourcesSectionId,
            isActive:false,
          });
        }

        if (this.isProcedureSectionEnabled) {
          this.procedureSectionId = 'procedures' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'proceduresprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('PROCEDURES'),
            bindingElementId: this.procedureSectionId,
            isActive: false,
          });
        }

        if(this.features.keyMessageSelectionEnabled){
          this.keyMessagesSectionId = 'keymessages'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'keymessagesprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('PRODUCT_KEY_MESSGES_CAMEL_CASE'),
            bindingElementId: this.keyMessagesSectionId,
            isActive:false,
          });
        }

        if (this.isSupportingMaterialsEnabled) {
          this.supportingMaterialsSectionId = 'supportingmaterials' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'supportingmaterialsprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('SUPPORTING_MATERIALS'),
            bindingElementId: this.supportingMaterialsSectionId,
            isActive: false,
          });
        }

        if(this.features.therapeuticAreaEnabled){
          this.therapeuticSectionId = 'therapeuticarea'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'therapeuticareaprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('THERAPEUTIC_AREAS'),
            bindingElementId: this.therapeuticSectionId,
            isActive:false,
          });
        }

        if(this.features.diseaseAreaEnabled){
          this.diseaseAreaSectionId = 'diseasearea'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'diseasearea'+Math.random().toString(36).substring(7),
            title: this.translate.instant('DISEASE_AREA'),
            bindingElementId: this.diseaseAreaSectionId,
            isActive:false,
          });
        }

        if(this.features.productIndicationEnabled){
          this.productIndicationSectionId = 'productindication'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'productindication'+Math.random().toString(36).substring(7),
            title: this.translate.instant('PRODUCT_INDICATION'),
            bindingElementId: this.productIndicationSectionId,
            isActive:false,
          });
        }

        if(this.hasMeetingEventsFA){
          this.meetingEventsSectionId = 'meetingevents'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingeventsprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('EVENTS'),
            bindingElementId: this.meetingEventsSectionId,
            isActive:false,
          });
        }
        if (this.isOppSectionEnabled) {
          this.meetingOpportunitiesSectionId = 'meetingopportunities' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingopportunitiesprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('OPPORTUNITIES'),
            bindingElementId: this.meetingOpportunitiesSectionId,
            isActive: false,
          });
        }
        if (this.isMeetingAssetsEnabled) {
          this.meetingAssetsSectionId = 'meetingassets' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingassetsprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('ASSETS'),
            bindingElementId: this.meetingAssetsSectionId,
            isActive: false,
          });
        }

        if(this.features.notesEnabled){
          this.meetingNotesSectionId = 'meetingnotes'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingnotesprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('NOTES'),
            bindingElementId: this.meetingNotesSectionId,
            isActive:false,
          });
        }

        if(this.features.meetingNotesEnabled || this.features.meetingAttachmentEnabled){
          this.meetingNotesAndAttachmentsSectionId = 'meetingnotesandattachments'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingnotesandattachmentsprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('NOTES'),
            bindingElementId: this.meetingNotesAndAttachmentsSectionId,
            isActive:false,
          });
        }

        if(this.features.coachingEnabled && !this.enableReadonlyViewForMeetings){
          this.coachingDetailsSectionId = 'coachingdetails'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'coachingdetailsprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('COACHING'),
            bindingElementId: this.coachingDetailsSectionId,
            isActive:false,
          });
        }

        if(this.features.meetingObjectivesEnabled){
          this.callObjectiveSectionId = 'callobjective'+Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'callobjectiveprocess'+Math.random().toString(36).substring(7),
            title: this.translate.instant('NEXT_MEETING_OBJECTIVES_CAP'),
            bindingElementId: this.callObjectiveSectionId,
            isActive:false,
          });
        }

        if (this.isExpenseSectionVisible) {
          this.expensesSectionId = 'meetingexpenses' + Math.random().toString(36).substring(7);
          this.meetingProcessView.push({
            id: 'meetingexpensesprocess' + Math.random().toString(36).substring(7),
            title: this.translate.instant('EXPENSES'),
            bindingElementId: this.expensesSectionId,
            isActive: false,
          });
        }
      }
    }
  }

  /**
   * Builds meetingProcessView from a config array instead of 19 individual push blocks.
   * Each config entry maps to a section: condition determines visibility,
   * sectionIdProp is the class property name for template binding.
   */
  private _buildMeetingProcessView(): void {
    this.meetingProcessView = [];

    const randomSuffix = () => Math.random().toString(36).substring(7);

    const sectionConfigs: Array<{
      sectionIdProp: string;
      keyPrefix: string;
      idPrefix: string;
      titleKey: string;
      condition: boolean;
    }> = [
      { sectionIdProp: 'detailsSectionId', keyPrefix: 'details', idPrefix: 'detailsprocess', titleKey: 'DETAILS', condition: true },
      { sectionIdProp: 'photosSectionId', keyPrefix: 'photos', idPrefix: 'photosprocess', titleKey: 'IN_STORE_PHOTOS', condition: this.isInStoreMeeting },
      { sectionIdProp: 'gpsActivityPhotosSectionId', keyPrefix: 'gpsActivityPhotos', idPrefix: 'gpsActivityPhotosprocess', titleKey: 'CHECK_IN_CHECK_OUT_PHOTOS', condition: this.features.manualGPSCheckinEnabled && !this.isAccountVisitNestedMeeting },
      { sectionIdProp: 'objectiveSectionId', keyPrefix: 'objectives', idPrefix: 'objectives', titleKey: 'OBJECTIVES', condition: this.features.isMeetingObjectiveSelectionEnabled },
      { sectionIdProp: 'meetingStSectionId', keyPrefix: 'meetingstructure', idPrefix: 'meetingstructureprocess', titleKey: 'MEETING_STRUCTURE_CAMEL_CASE', condition: true },
      { sectionIdProp: 'sharedResourcesSectionId', keyPrefix: 'sharedresources', idPrefix: 'sharedresourcesprocess', titleKey: 'SHARED_RESOURCES', condition: this.sharedResources && this.sharedResources.length > 0 },
      { sectionIdProp: 'procedureSectionId', keyPrefix: 'procedures', idPrefix: 'proceduresprocess', titleKey: 'PROCEDURES', condition: this.isProcedureSectionEnabled },
      { sectionIdProp: 'keyMessagesSectionId', keyPrefix: 'keymessages', idPrefix: 'keymessagesprocess', titleKey: 'PRODUCT_KEY_MESSGES_CAMEL_CASE', condition: this.features.keyMessageSelectionEnabled },
      { sectionIdProp: 'supportingMaterialsSectionId', keyPrefix: 'supportingmaterials', idPrefix: 'supportingmaterialsprocess', titleKey: 'SUPPORTING_MATERIALS', condition: this.isSupportingMaterialsEnabled },
      { sectionIdProp: 'therapeuticSectionId', keyPrefix: 'therapeuticarea', idPrefix: 'therapeuticareaprocess', titleKey: 'THERAPEUTIC_AREAS', condition: this.features.therapeuticAreaEnabled },
      { sectionIdProp: 'diseaseAreaSectionId', keyPrefix: 'diseasearea', idPrefix: 'diseasearea', titleKey: 'DISEASE_AREA', condition: this.features.diseaseAreaEnabled },
      { sectionIdProp: 'productIndicationSectionId', keyPrefix: 'productindication', idPrefix: 'productindication', titleKey: 'PRODUCT_INDICATION', condition: this.features.productIndicationEnabled },
      { sectionIdProp: 'meetingEventsSectionId', keyPrefix: 'meetingevents', idPrefix: 'meetingeventsprocess', titleKey: 'EVENTS', condition: this.hasMeetingEventsFA },
      { sectionIdProp: 'meetingOpportunitiesSectionId', keyPrefix: 'meetingopportunities', idPrefix: 'meetingopportunitiesprocess', titleKey: 'OPPORTUNITIES', condition: this.isOppSectionEnabled },
      { sectionIdProp: 'meetingAssetsSectionId', keyPrefix: 'meetingassets', idPrefix: 'meetingassetsprocess', titleKey: 'ASSETS', condition: this.isMeetingAssetsEnabled },
      { sectionIdProp: 'meetingNotesSectionId', keyPrefix: 'meetingnotes', idPrefix: 'meetingnotesprocess', titleKey: 'NOTES', condition: this.features.notesEnabled },
      { sectionIdProp: 'meetingNotesAndAttachmentsSectionId', keyPrefix: 'meetingnotesandattachments', idPrefix: 'meetingnotesandattachmentsprocess', titleKey: 'NOTES', condition: this.features.meetingNotesEnabled || this.features.meetingAttachmentEnabled },
      { sectionIdProp: 'coachingDetailsSectionId', keyPrefix: 'coachingdetails', idPrefix: 'coachingdetailsprocess', titleKey: 'COACHING', condition: this.features.coachingEnabled && !this.enableReadonlyViewForMeetings },
      { sectionIdProp: 'callObjectiveSectionId', keyPrefix: 'callobjective', idPrefix: 'callobjectiveprocess', titleKey: 'NEXT_MEETING_OBJECTIVES_CAP', condition: this.features.meetingObjectivesEnabled },
    ];

    let isFirst = true;
    for (const config of sectionConfigs) {
      if (!config.condition) continue;
      this[config.sectionIdProp] = config.keyPrefix + randomSuffix();
      this.meetingProcessView.push({
        id: config.idPrefix + randomSuffix(),
        title: this.translate.instant(config.titleKey),
        bindingElementId: this[config.sectionIdProp],
        isActive: isFirst,
      });
      isFirst = false;
    }
  }

  private initMeetingDateFormFields() {
    let dateTimeValue = this.activityService.getFormattedDateTimeText();
    if (dateTimeValue) {
      this.meetingStartDateTime = dateTimeValue.startDateTime;
      this.meetingStartDate = dateTimeValue.startDate;
      this.meetingStartTime = dateTimeValue.startTime;
      this.meetingEndDateTime = dateTimeValue.endDateTime;
      this.meetingEndDate = dateTimeValue.endDate;
      this.meetingEndTime = dateTimeValue.endTime;
      this.meetingDuration = dateTimeValue.duration;
    }
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    const hideDateFields = this.meetingMandatoryConfig.shouldHideDateTimeFieldsForFormat(formatId);
    this.meetingStartDateField = {
      isDateField: true,
      label: this.translate.instant('START_DATE'),
      inputText: this.meetingStartDate,
      startDateTimeValue: this.meetingStartDateTime,
      endDateTimeValue: this.meetingEndDateTime,
      fromViewPage: CurViewPageType.Appointment,
      id: DateTimeFieldType.StartDateField,
      isHidden: hideDateFields,
      isReadOnly: true,
      isDisabled: !(this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly),
      showArrow: this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
      isRequired: this.activityService.selectedActivity && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };

    this.meetingStartTimeField = {
      isTimeField: true,
      label: this.translate.instant('START_TIME'),
      inputText: this.meetingStartTime,
      startDateTimeValue: this.meetingStartDateTime,
      endDateTimeValue: this.meetingEndDateTime,
      fromViewPage: CurViewPageType.Appointment,
      id: DateTimeFieldType.StartTimeField,
      isHidden: hideDateFields,
      isReadOnly: true,
      isDisabled: !(this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly),
      showArrow: this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
      isRequired: this.activityService.selectedActivity && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
    };
    this.meetingEndDateField = {
      isDateField: true,
      label: this.translate.instant('END_DATE'),
      inputText: this.meetingEndDate,
      startDateTimeValue: this.meetingStartDateTime,
      endDateTimeValue: this.meetingEndDateTime,
      fromViewPage: CurViewPageType.Appointment,
      id: DateTimeFieldType.EndDateField,
      isHidden: hideDateFields || !this.features.meetingEndDateEnabled,
      isReadOnly: true,
      isDisabled: !(this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly),
      showArrow: this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
      isRequired: this.activityService.selectedActivity && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    this.meetingEndTimeField = {
      isTimeField: true,
      label: this.translate.instant('END_TIME'),
      inputText: this.meetingEndTime,
      startDateTimeValue: this.meetingStartDateTime,
      endDateTimeValue: this.meetingEndDateTime,
      fromViewPage: CurViewPageType.Appointment,
      isHidden: hideDateFields || !this.features.meetingEndDateEnabled,
      id: DateTimeFieldType.EndTimeField,
      isReadOnly: true,
      isDisabled: !(this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly),
      showArrow: this.activityService.selectedActivity && !this.isDateEditable && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly,
      isRequired: this.activityService.selectedActivity && !this.activityService.selectedActivity.isFromXperiences && this.isNotReadOnly
    };
  }

  private initAllPresentationPlayDurationField() {
    this.presentationDurationFormField = undefined;
    if (this.features.showPresentationPlayDuration) {
      const currentActivity = this.activityService.selectedActivity as AppointmentActivity;
      if (currentActivity.isRemoteDetailing) return;

      const meetingFormats = this.activityService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, FormatType.HCP_MEETING);
      if (currentActivity.indskr_activitytype) {
        const existingFormat = meetingFormats.find(mf => mf.indskr_activitytypeid == currentActivity.indskr_activitytype);
        if (existingFormat?.indskr_remotechannel) return;
      }

      const formattedString = this.activityService.getAllPresentationPlayDuration(this.activityService.selectedActivity as AppointmentActivity);

      if (formattedString) {
        this.presentationDurationFormField = {
          label: this.translate.instant('ALL_PRESENTATION_PLAY_DURATION'),
          inputText: formattedString,
          id: 'all-presentation-play-duration-field',
          isReadOnly: true,
          isDisabled: false,
          showArrow: false,
        };
      }
    }
  }

  public openPhotoViewer(photoAttachment) {
    const activity = <AppointmentActivity> this.activityService.selectedActivity;
    const photoAttachments = activity.inStorePhotos;
    photoAttachments.forEach(photo => { photo.isSelected = photo.indskr_photoattachmentid == photoAttachment.indskr_photoattachmentid });
    const photoModel: IndPhotoViewerDataModel = {
      pageTitle: this.translate.instant("INSTORE") + ' - ' + activity.accountString,
      masterPhotos: photoAttachments,
      readOnly: true,
      callbackEvent: null
    };
    this.navService.pushWithPageTracking(PageName.IndPhotoViewerComponent, PageName.IndPhotoViewerComponent, { photoModel: photoModel }, PageName.IndPhotoViewerComponent);
  }

  initGpsFields(){
    if(isEmpty(this.activityService.selectedActivity)) return;
    let meeting = this.activityService.selectedActivity as AppointmentActivity;

    let checkinInput = '';
    if(this.features.manualGPSCheckinEnabled) {
      checkinInput= meeting.gpsCheckInDetails?.indskr_checkindatetime ? this.datePipe.transform(meeting.gpsCheckInDetails.indskr_checkindatetime, 'shortTime') +  ' | ' +  this.translate.instant(meeting.gpsCheckInDetails.indskr_checkinstatus === GPS_STATUS.VALID ? 'VALID' : 'MANUAL') : '';
    } else {
      checkinInput= meeting.gpsCheckInDetails?.indskr_checkindatetime ? this.datePipe.transform(meeting.gpsCheckInDetails.indskr_checkindatetime, 'shortTime') +  ' | ' +  this.translate.instant(meeting.gpsCheckInDetails.indskr_checkinstatus === GPS_STATUS.VALID ? 'VALID' : 'INVALID') : '';
    }

    this.checkInField = {
      isDateField: true,
      label: this.translate.instant('CHECK_IN_STATUS'),
      inputText:  checkinInput,
      customPlaceholderLabel: meeting.gpsCheckInDetails && !meeting.gpsCheckInDetails.indskr_checkindatetime ? this.translate.instant('START_CHECK_IN') : '',
      id: 'check-in-field',
      isReadOnly: true,
      isRequired : this.features.gpsFunctionalityEnabled && meeting.state != MeetingActivityState.Completed,
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      isEmptyRequiredField : this.checkinFieldsEmpty && this.features.gpsFunctionalityEnabled && meeting.gpsCheckInDetails.indskr_checkinstatus == null,
      isHidden :  !this.features.GPSCheckInEnabled ||this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype),
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    }

    let checkoutInput = '';
    if(this.features.manualGPSCheckinEnabled) {
      checkoutInput= checkinInput= meeting.gpsCheckInDetails?.indskr_checkoutdatetime ? this.datePipe.transform(meeting.gpsCheckInDetails.indskr_checkoutdatetime, 'shortTime') +  ' | ' +  this.translate.instant(meeting.gpsCheckInDetails.indskr_checkoutstatus === GPS_STATUS.VALID ? 'VALID' : 'MANUAL') : '';
    } else {
      checkoutInput= meeting.gpsCheckInDetails?.indskr_checkoutdatetime ? this.datePipe.transform(meeting.gpsCheckInDetails.indskr_checkoutdatetime, 'shortTime') +  ' | ' +  this.translate.instant(meeting.gpsCheckInDetails.indskr_checkoutstatus === GPS_STATUS.VALID ? 'VALID' : 'INVALID') : '';
    }

    this.checkOutField = {
      isDateField: true,
      label: this.translate.instant('CHECK_OUT_STATUS'),
      inputText: checkoutInput,
      customPlaceholderLabel: meeting.gpsCheckInDetails && !meeting.gpsCheckInDetails.indskr_checkoutdatetime ?  this.translate.instant('START_CHECK_OUT') : '',
      id: 'check-out-field',
      isReadOnly: true,
      isRequired : this.features.gpsCheckoutMandatory  && meeting.state != MeetingActivityState.Completed,
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      isEmptyRequiredField : this.checkOutFieldsEmpty && this.features.gpsCheckoutMandatory && meeting.gpsCheckInDetails.indskr_checkoutstatus == null,
      isHidden : !this.features.GPSCheckInEnabled ||this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype),
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    }
  }

  get isDateEditable() {
    if (this.activityService.selectedActivity && this.features.lockStartEndTimeIfContentPlayed) {
     return this.isContentPlayed;
    }
  }

  get isContentPlayed() {
    const appointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    if (!isEmpty(appointmentActivity.presentations)) {
      const playedContentIds = appointmentActivity.presentations.map(cont => cont.contentId);
      return ((!isEmpty(appointmentActivity.activityPresentations) && appointmentActivity.activityPresentations.some(pre => playedContentIds.includes(pre.presentationId)))
      || (!isEmpty(appointmentActivity.activityResources) && appointmentActivity.activityResources.some(res => playedContentIds.includes(res.indskr_ioresourceid) || playedContentIds.includes(res.indskr_iodocumentid))))
    }
  }

  isGPSStatusValid() {
    let isValid = false;

    const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;

    if(currentMeeting.gpsCheckInDetails
    && currentMeeting.gpsCheckInDetails.indskr_checkinstatus === GPS_STATUS.VALID
    && currentMeeting.gpsCheckInDetails.indskr_checkoutstatus === GPS_STATUS.VALID) {
        isValid = true;
      }

    return isValid;
  }

  checkIfAccountPlansAssociated(): boolean {
    let hasAccountPlans = false;
    if (this.isNotReadOnly) {
      const accountIds = (this.activityService
        .selectedActivity as AppointmentActivity).accounts.map(
        (el) => el.id
      );
      const accountPlanDataSet = [];
      if (accountIds.length) {
        this.accountManagementService.accountPlans.forEach((e) => {
          if (accountIds.includes(e.accountId)) {
            accountPlanDataSet.push(e)
          }
        });
      }
      if (!(this.activityService.selectedActivity as AppointmentActivity).accounts.length) {
        hasAccountPlans = true;
      }
      if (accountPlanDataSet.length) {
        hasAccountPlans = true;
      }
    }
    return hasAccountPlans;
  }

  public displayText(any, fieldName: string): string {
    if (isEmpty(any)) {
      return '';
    } else {
      any = this.sortListByFielName(any, fieldName);
      return any.length > 1
        ? any[0][fieldName].concat(' +').concat(any.length - 1)
        : any[0][fieldName];
    }
  }

  sortListByFielName(options, fieldName: string) {
    if (isEmpty(options)) return [];
    return options.sort((a, b) => {
      let nameA: string = a[fieldName];
      let nameB: string = b[fieldName];
      if (!nameA || !nameB) return 1;
      nameA = nameA.toLowerCase();
      nameB = nameB.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA >= nameB) return 1;
    });
  }

  private initNotesSectionHeader() {
    this.notesSectionHeader = {
      id: 'notes',
      title: this.features.meetingNotesRelabelEnabled ? this.translate.instant('MEDICAL_DISCUSSION'): this.translate.instant('ACTIVITY_DETAILS_NOTES'),
      controls: [
        {
          id: 'notes-attachment',
          text: this.translate.instant('ATTACH'),
          isVisible: this.features.meetingAttachmentFAEnabled,
          isDisabled: this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress || this.activityService.selectedActivity.state == MeetingActivityState.Canceled || !this.activityService.isMeetingOwner
        }
      ]
    }
    let isNotesOnBU = this.authService.user.buConfigs["indskr_notessectionhelptext"];
    this.notesPlaceholder = isNotesOnBU? isNotesOnBU : this.translate.instant('ENTER_NOTES');
  }

  public isNoteDisabled(): boolean {
    let isDisabled: boolean = false;
    isDisabled = this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.backgroundUploadInProgress || this.enableReadonlyViewForMeetings;
    if ((this.features.coVisitorAccess === CovisitorAccess.MINIMUM_ACCESS || this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS) && this.isCovisitor) {
      isDisabled = this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress || !this.isSaveNotesEnabled || (isEmpty(this.tempNoteText) && !this.isMeetingAttachmentAdded);
    } else {
      isDisabled = isDisabled ? isDisabled : this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID;
    }
    return isDisabled;
   }

  private initMeetingNotesSectionHeader() {
    let isNotesAttachmentDisabled = this.device.isOffline || this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled;
    let isNotesSaveDisabled = this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.backgroundUploadInProgress || this.enableReadonlyViewForMeetings || !this.isSaveNotesEnabled || (isEmpty(this.tempNoteText) && !this.isMeetingAttachmentAdded);
    if ((this.features.coVisitorAccess === CovisitorAccess.MINIMUM_ACCESS || this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS) && this.isCovisitor) {
      isNotesAttachmentDisabled = isNotesAttachmentDisabled ? isNotesAttachmentDisabled : false;
      isNotesSaveDisabled = this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress || !this.isSaveNotesEnabled || (isEmpty(this.tempNoteText) && !this.isMeetingAttachmentAdded);
    } else {
      isNotesAttachmentDisabled = isNotesAttachmentDisabled ? isNotesAttachmentDisabled : this.enableReadonlyViewForMeetings || this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID;
      isNotesSaveDisabled = isNotesSaveDisabled ? isNotesSaveDisabled : this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID;
    }
    this.meetingNotesSectionHeader = {
      id: 'notes-and-attachments',
      title: this.features.meetingNotesRelabelEnabled ? this.translate.instant('MEDICAL_DISCUSSION'):this.translate.instant('ACTIVITY_DETAILS_NOTES'),
      controls: [
        {
          id: 'notes-attachment',
          text: this.translate.instant('ATTACH'),
          isVisible: this.features.meetingAttachmentEnabled,
          isDisabled: isNotesAttachmentDisabled
        },
        {
          id: 'meeting-notes-save',
          text: this.translate.instant('ADD'),
          isDisabled: isNotesSaveDisabled,
          isVisible: true,
        }
      ]
    }
    let isNotesOnBU = this.authService.user.buConfigs["indskr_notessectionhelptext"];
    this.notesPlaceholder = isNotesOnBU? isNotesOnBU : this.translate.instant('ENTER_NOTES');
  }

  public onSectionHeaderControlClick(id: string) {
    // Prevent account visit offline request
    if (this.activityService.accountVisitOfflineCheck(
      {
        isAccountVisitEnabled: this.isAccountVisitEnabled,
        isAccountVisitRecord: this.isAccountVisitRecord,
        isAccountVisitNestedMeeting: this.isAccountVisitNestedMeeting,
      },
      true,
    )) {
      return;
    }

    switch (id) {
      case 'add-objectives':
        this.handleObjectivesAdd();
        break;
      case 'notes-attachment':
        this.handleNoteAttachment();
        break;
      case 'meeting-notes-save':
        this.addMeetingNote();
        break;
      case 'add-opportunities':
        this._handleAddOpportunities();
        break;
      case 'add-meetingevents':
        this._handleAddEvents();
        break;
      case 'add-assets':
        this._handleAddAssets();
        break;
      case 'appeal':
        this.sendForAppeal();
        break;
      case 'add-procedures':
        this.handleAddProcedures();
        break;
      case 'add-photos':
        this.openPhotoCaptureViewer();
        break;
      case 'add-supportingmaterials':
        this.handleAddSupportingMaterials();
      default:
        break;
    }
  }

  public async sendForAppeal() {
      if(this.authService.user.buConfigs['indskr_approvalsubmissionperiod'] !== null) {
        await this.alertService.showAlert(
          {
            title: this.translate.instant('SUBMIT_APPEAL_TITLE'),
            message: this.translate.instant('SUBMIT_APPEAL_MESSAGE'),
          }, this.translate.instant('SUBMIT')
        ).then(async res => {
          if (res.role === 'ok') {
            const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;

            let appealStatus = GPSActivityApprovalStatus.PENDING;
            let toastMsg = ``;

            //Calculate Approval submission period
            let approvalSubmissionPeriod  = +this.authService.user.buConfigs['indskr_approvalsubmissionperiod'];
            approvalSubmissionPeriod = approvalSubmissionPeriod - 1;

            if(approvalSubmissionPeriod === -1) {
              toastMsg = this.translate.instant('APPEAL_STATUS_SENT_FOR_REVIEW');
            }
            else {
              const dateCompleted = new Date(+this.activityService.selectedActivity.omnip_datecompleted);
              const currentdate = new Date();
              let calcApprovalSubmissionPeriod = this.dateTimeFormatsService.addMonthsToDate(dateCompleted, approvalSubmissionPeriod);
              calcApprovalSubmissionPeriod = this.dateTimeFormatsService.getLastDayOfMonth(calcApprovalSubmissionPeriod);
              calcApprovalSubmissionPeriod.setHours(23, 59, 59, 999);

              if(this.dateTimeFormatsService.isBeforeDate(currentdate, calcApprovalSubmissionPeriod)) {
                toastMsg = this.translate.instant('APPEAL_STATUS_SENT_FOR_REVIEW');
              } else {
                appealStatus = GPSActivityApprovalStatus.OUT_OF_SUBMISSION_WINDOW_PERIOD;
                toastMsg = this.translate.instant('APPEAL_STATUS_OUT_OF_SUBMISSION_WINDOW_PERIOD');
              }
            }

            let payload: any = {
              indskr_gpscheckindetailsid: currentMeeting.gpsCheckInDetails['indskr_gpscheckindetailsid'],
              statuscode: appealStatus
            }

            await this.displayLoader({duration: 30000});
            try {
              const existingStatus = await this.dynamics.retrieveAll('indskr_gpscheckindetailses', ['statuscode'],
                `indskr_gpscheckindetailsid eq ${payload.indskr_gpscheckindetailsid}`);
              if (!existingStatus || isEmpty(existingStatus['value']) || existingStatus['value'][0]['statuscode'] == 1) {
                await this.appealService.updateAppealStatus(currentMeeting.ID, payload);
              }
            } catch (error) {
              console.error('updateAppealStatus: ', error);
              await this.dismissLoader();
              return;
            }

            currentMeeting.gpsCheckInDetails['statuscode'] = appealStatus;
            await this.disk.updateOrInsertActivityToActivityDetailRawDocument(currentMeeting, true);
            await this.dismissLoader();
            this.notificationService.notify(toastMsg, "Meeting Details", "top", ToastStyle.INFO, 3000);
            this.detectChangesOnActivityDetails(true);
          }
        });
      } else {
        this.notificationService.notify(this.translate.instant('ERR_APPEAL_NO_SUBMISSION_WINDOW_PERIOD'), "Meeting Details", "top", ToastStyle.DANGER, 3000);
      }
  }

  private openPhotoCaptureViewer() {
    if (!this.device.isNativeApp) {
      this.notificationService.notify(this.translate.instant('INSTORE_PHOTOS_WEB_WARNING'), 'Meeting Details', 'top', ToastStyle.DANGER);
      return;
    }
    const activity: AppointmentActivity = <AppointmentActivity>this.activityService.selectedActivity;
    let accountName = '';
    let etmsCode = '';
    if (!isEmpty(activity.accounts)) {
      accountName = activity.accountString;
      const account = this.accountService.getAccountById(activity.accounts[0].id);
      if (account?.extendedDetails['externalId']) {
        etmsCode = account.extendedDetails['externalId']
      }
    }
    const photoModel: IndPhotoCaptureViewerDataModel = {
      pageTitle: this.translate.instant("ADD") + ' - ' + activity.subject,
      photosLimit: isEmpty(activity.inStorePhotos) ? 10 : (10 - (activity.inStorePhotos.length)),
      photoNameFormat: `${this.authService.user.displayName} ${accountName} ${etmsCode} {currentTimestamp} ${this.translate.instant('INSTORE')}.PNG`,
      photoOrigin: PhotoOrigin.INSTORE_MEETING,
      accountId: isEmpty(activity.accounts) ? '' : activity.accounts[0].id,
      errorMessage: this.translate.instant('MAX_PHOTO_NOTIFICATION', { limit: 10 }),
      callbackEvent: (data: []) => this._handlePhotoCaptureComponentCallback(data)
    };
    this.navService.pushWithPageTracking(PageName.IndPhotoCaptureViewerComponent, PageName.IndPhotoCaptureViewerComponent, { photoModel: photoModel }, PageName.IndPhotoCaptureViewerComponent);
  }

  private async _handlePhotoCaptureComponentCallback(data: Photo[]) {
    if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID) || this.backgroundUploadInProgress || isEmpty(data)) return;
    await this.displayLoader({ duration: 30000 });
    await this.meetingDataService.uploadPhotosToBlobStorgae(data);
    this.initPhotosSectionHeader();
    await this.dismissLoader();
  }

  async deletePhotoAttachments(event , photo: InStorePhoto) {
    event.stopPropagation();
    if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID) || this.backgroundUploadInProgress) return;
    const res = await this.alertService.showAlert(
      {
        title: this.translate.instant('DELETE_PHOTO_HEADER'),
        message: this.translate.instant('DELETE_PHOTO_NAME').replace('{{name}}', photo.name),
      },
      this.translate.instant('CONFIRM'),
    );
    if (res.role == 'ok') {
      if (this.backgroundUploadInProgress || this.device.isOffline
        || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)
        || this.activityService.selectedActivity.isCompleted
        || !this.activityService.isMeetingOwner) {
        return;
      }
      await this.displayLoader();
      await this.meetingDataService.updateInStorePhotos([{"photoAttachmentId": photo.indskr_photoattachmentid, deleted: true}]);
      this.initPhotosSectionHeader();
      await this.dismissLoader();
    }
  }

  private handleAddProcedures() {
    const isReadOnlyMode = this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings ;
    const selectedProcedures = (this.activityService.selectedActivity as AppointmentActivity).activityProcedures;
    if (isReadOnlyMode && isEmpty(selectedProcedures)) return;
    const listDetail: MainToolTemplateDetail = {
      title: this.translate.instant('PROCEDURES'),
      dividerTitle: this.translate.instant('ALL_PROCEDURES'),
      isSearchEnabled: !isReadOnlyMode,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: !isReadOnlyMode,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'primaryTextRight',
      searchTitle: this.translate.instant('PROCEDURES'),
      hideAllItemsList: isReadOnlyMode,
      isListSelectionEnabled: !isReadOnlyMode,
      listSelectionType: MainToolTemplateListSelectionType.MULTIPLESELECTION,
      navOptions: { animate: false },
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail) => this._handleProcedureComponentEvent(data, eventTarget, refData),
      data: this.getProceduresSelectionData(isReadOnlyMode, selectedProcedures),
    };
    this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, { viewData: listDetail, isHierarchyView: true }, PageName.MainToolTemplateComponent);
  }

  private getProceduresSelectionData(isReadOnlyMode, selectedProcedures) {
    let data: Array<MainCardViewDataModel> = [];
    let masterList = cloneDeep(this.surgeryOrderDataService.procedureTrackerProductHierarchies);
    masterList = masterList.sort((a, b): number => {
      if (a.surgeryName > b.surgeryName) return 1;
      if (a.surgeryName < b.surgeryName) return -1;
      return 0;
    });

    const selectedProcedureIds = selectedProcedures.map(procedure => procedure.ID);

    for (let i = 0; i < masterList.length; i++) {
      const item = masterList[i];
      const isSelected = selectedProcedureIds.includes(item.surgeryId);
      let obj = {
        id: item.surgeryId,
        primaryTextLeft: '',
        secondaryTextLeft: '',
        showEndIcon: !isReadOnlyMode,
        mainItemCssClass: 'selector-item',
        isItemSelectedForSelectionView: isSelected,
        endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
        endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
        primaryTextRight: item.surgeryName,
        showArrow: false,
        eventOwnerId: this.activityService.selectedActivity.ownerId
      };
      data.push(obj);
    }

    const mappedProcedureIds = this.surgeryOrderDataService.procedureTrackerProductHierarchies.filter(pro => pro.surgeryId);
    selectedProcedures.filter(procedure => mappedProcedureIds.includes(procedure['indskr_productid'])).forEach(procedure => {
      data.push({
        id: procedure.indskr_productid,
        primaryTextLeft: '',
        secondaryTextLeft: '',
        showEndIcon: !isReadOnlyMode,
        mainItemCssClass: 'selector-item',
        isItemSelectedForSelectionView: true,
        endIconType: 'indegene-selectors-checkmark-icon',
        endIconCssClass: 'checkmark-icon',
        primaryTextRight: procedure.productName,
        showArrow: false,
        arrowType: '',
        eventOwnerId: this.activityService.selectedActivity.ownerId
      })
    })
    return data;
  }

  private async _handleProcedureComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
      const appointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
      if (isEmpty(data.selectedItems)) {
        appointmentActivity.activityProcedures = [];
      } else {
        const selectedIds = appointmentActivity.activityProcedures ? appointmentActivity.activityProcedures.map(procedure => procedure.ID) : [];
        data.selectedItems.forEach(item => {
          if (!selectedIds.includes(item.id)) {
            const activityProcedure = new Brand({
              productid: item.id,
              name: item.primaryTextRight,
              productStructure: 3
            });
            appointmentActivity.activityProcedures.push(activityProcedure);
          }
        });
        if (!isEmpty(data.removedItems)) {
          data.removedItems.forEach(item => {
            const index = appointmentActivity.activityProcedures.findIndex(procedure => procedure.ID == item.id);
            if (index > -1) appointmentActivity.activityProcedures.splice(index, 1);
          });
        }
      }
      if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
        try { // I/O operations needs to be wrap in a try and catch block
          this.activityService.upsertMeetingsOfflineData(appointmentActivity); // offline saving
        } catch (e) {
          console.error("Failed to save procedures for apppointment in offlineDB ", e);
        }
      } else {
        const isSuccess = await this.meetingDataService.updateMeetingProcedures(appointmentActivity);
        if (!isSuccess) {
          this.activityService.upsertMeetingsOfflineData(appointmentActivity, false, true);
        }
      }
    }
  }

  private handleAddSupportingMaterials(){
    const isReadOnlyMode = this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings ;
    const selectedSupportedMaterials = (this.activityService.selectedActivity as AppointmentActivity).activitySupportingMaterials.map(a=> a.id);
    let supportingMaterialsList = this.brandService.supportingMaterials.length > 0 ? this.brandService.supportingMaterials.map(sm => {
      const isSelected = selectedSupportedMaterials.includes(sm.id);
      return {
        id: sm.id,
        primaryTextLeft: '',
        secondaryTextLeft: '',
        showEndIcon: !isReadOnlyMode,
        mainItemCssClass: 'selector-item',
        isItemSelectedForSelectionView: isSelected,
        endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
        endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
        primaryTextRight: sm.name,
        showArrow: false,
        eventOwnerId: this.activityService.selectedActivity.ownerId
      };
    }) : [];
    //
    if (isReadOnlyMode && isEmpty(selectedSupportedMaterials)) return;
    const listDetail: MainToolTemplateDetail = {
      title: this.translate.instant('SUPPORTING_MATERIALS'),
      dividerTitle: this.translate.instant('ALL_SUPPORTING_MATERIALS'),
      isSearchEnabled: !isReadOnlyMode,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: !isReadOnlyMode,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'primaryTextRight',
      searchTitle: this.translate.instant('SUPPORTING_MATERIALS'),
      hideAllItemsList: isReadOnlyMode,
      isListSelectionEnabled: !isReadOnlyMode,
      listSelectionType: MainToolTemplateListSelectionType.MULTIPLESELECTION,
      navOptions: { animate: false },
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail) => this._handleSupportingMaterialsComponentEvent(data, eventTarget, refData),
      data: supportingMaterialsList,
    };
    this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, { viewData: listDetail, isHierarchyView: true }, PageName.MainToolTemplateComponent);
  }

  private async _handleSupportingMaterialsComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
      const appointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
      if (isEmpty(data.selectedItems)) {
        appointmentActivity.activitySupportingMaterials = [];
      } else {
        const selectedIds = appointmentActivity.activitySupportingMaterials ? appointmentActivity.activitySupportingMaterials.map(material => material.id) : [];
        data.selectedItems.forEach(item => {
          if (!selectedIds.includes(item.id)) {
            const activitySupportingMaterial = {
              id: item.id,
              name: item.primaryTextRight,
            };
            appointmentActivity.activitySupportingMaterials.push(activitySupportingMaterial);
          }
        });
        if (!isEmpty(data.removedItems)) {
          data.removedItems.forEach(item => {
            const index = appointmentActivity.activitySupportingMaterials.findIndex(material => material.id == item.id);
            if (index > -1) appointmentActivity.activityProcedures.splice(index, 1);
          });
        }
      }
      if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
        try { // I/O operations needs to be wrap in a try and catch block
          this.activityService.upsertMeetingsOfflineData(appointmentActivity); // offline saving
        } catch (e) {
          console.error("Failed to save supporting materials for apppointment in offlineDB ", e);
        }
      } else {
        const isSuccess = await this.meetingDataService.updateMeetingSupportingMaterials(appointmentActivity);
        if (!isSuccess) {
          this.activityService.upsertMeetingsOfflineData(appointmentActivity, false, true);
        }
      }
    }
  }

  private async handleObjectivesAdd() {
    if(this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress) return;
    const selectedObjIds = (this.activityService.selectedActivity as AppointmentActivity).activityObjectives?.map(obj => obj.indskr_meetingobjectivesid);
    const options = this.meetingDataService.meetingObjectives.map(obj => {
      return {
        id: obj.indskr_meetingobjectivesid,
        title: obj.indskr_name,
        isSelected: selectedObjIds.includes(obj.indskr_meetingobjectivesid)
      }
    });
    const objectiveModal = await this.modalCtrl.create({
      component: SelectListComponent,
      componentProps: {
        viewData: {
          data: options,
          isMultipleSelectionEnabled: true,
          title: this.translate.instant('OBJECTIVES'),
          dividerTitle: this.translate.instant('ALL_OBJECTIVES'),
          isSearchEnabled: true,
        }
      },
      backdropDismiss: false
    });
    objectiveModal.present();
    objectiveModal.onDidDismiss().then(async (obj: any) => {
      const data = obj.data;
      if (data && data.isDone) {
        let selectedObjectives = [];
        const selectedIds = []
        data.selectedItems.forEach(selectedItem => {
          selectedIds.push(selectedItem.id);
          selectedObjectives.push({indskr_meetingobjectivesid: selectedItem.id, indskr_name: selectedItem.title});
        });
        (this.activityService.selectedActivity as AppointmentActivity).activityObjectives = orderBy(selectedObjectives, 'indskr_name');
        await this.displayLoader();
        await this.meetingDataService.saveMeetingObjectives(selectedIds);
        await this.dismissLoader();
      }
    });
  }

  private handleNoteAttachment(){
    if(this.features.meetingAttachmentFAEnabled || this.features.meetingAttachmentEnabled){
      try {
        this.attachInput.nativeElement.click();
      } catch (error) {
        console.error(error);
      }
    }
  }

  public async loadImageFromDevice(event) {
    if (this.device.isOffline) return;
    if (event && event.target && event.target.files) {
      try {
        const file = event.target.files[0];
        if ((file.size / 1000) < MAXIMUM_NOTE_ATTACHMENT_SIZE) {
          if (NOTE_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX.test(file.name)) {
            this.base64str = await toBase64(file);
            const dataURLPattern = /^data:[^;]+;base64,/;
            this.base64str = this.base64str.replace(dataURLPattern, '');
            this.attachmentFile = file;
            if(this.features.meetingAttachmentFAEnabled) {
              this.attachmentTitle = file.name;
              this.isAttachmentAdded = true;
              await this.saveAttachmentInDynamics();
              this.initNotesSectionHeader();
            } else if(this.features.meetingAttachmentEnabled) {
              this.meetingNoteAttachmentTitle = file.name;
              this.isMeetingAttachmentAdded = true;
              this.isSaveNotesEnabled = true;
              this.onMeetingNotesFocusOut();
              this.initMeetingNotesSectionHeader();
            }
          } else {
            this.notificationService.notify(this.translate.instant('NOTE_ATTACHMENT_MIME_TYPE_NOT_SUPPORTED_NOTIFICATION'), 'Account Info', 'top', 'info');
            this.removeAttachment(false);
          }
        } else {
          this.notificationService.notify(this.translate.instant('MAXIMUM_NOTE_ATTACHMENT_SIZE_NOTIFICATION', { size: MAXIMUM_NOTE_ATTACHMENT_SIZE }), 'Account Info', 'top', 'info');
          this.removeAttachment(false);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async saveAttachmentInDynamics() {
    let payload = {
      "documentbody": this.base64str,
      "filename": this.attachmentFile.name,
      "mimetype": this.attachmentFile.type,
      "objectid_appointment@odata.bind": "/appointments(" +this.activityService.selectedActivity.ID+ ")",
      "notetext": this.activityService.selectedActivity.notes
    };
    await this.meetingDataService.updateMeetingAttachments(payload);
  }

  public removeAttachment(event){
    if (this.device.isOffline || this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress) return;
    try {
      this.attachInput.nativeElement.value = null;
    } catch (error) {
      console.error(error);
    }
    this.attachmentTitle = '';
    if(this.features.meetingAttachmentFAEnabled) {
      this.isAttachmentAdded = false;
      this.removeAttachmentFromDynamics();
      this.initNotesSectionHeader();
    }
    this.attachmentFile = null;
    this.base64str = null;
  }

  public removeMeetingNoteAttachment(event){
    if (this.device.isOffline || !this.activityService.isMeetingOwner || this.activityService.selectedActivity.isCompleted
      || this.backgroundUploadInProgress || !this.features.meetingAttachmentEnabled || this.enableReadonlyViewForMeetings) return;
    try {
      this.attachInput.nativeElement.value = null;
    } catch (error) {
      console.error(error);
    }
    this.meetingNoteAttachmentTitle = '';
    this.isMeetingAttachmentAdded = false;
    this.initMeetingNotesSectionHeader();
    this.attachmentFile = null;
    this.base64str = null;
    if(this.autoSavedNote && this.autoSavedNote.hasDocument){
      let ev = {
        action: 'SAVE',
        noteId: this.autoSavedNote.noteId,
        updatedText: this.tempNoteText,
        isAttachmentRemoved: true,
      };
      this.updateNote(ev);
    }
  }

  public async downloadAttachment(event) {
    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant('ATTACHMENT_CAN_BE_DOWNLOADED_ONLY_WHEN_ONLINE_MSG'), 'Notes Attachment Down', 'top', 'info');
      return;
    }
    let response = await this.dynamics.retrieveAll('annotations', [],
      `annotationid eq  ${(this.activityService.selectedActivity as AppointmentActivity).associatedAttachments[0].annotationId}`)
      .then(res => res.value).catch(() => []);
    if (response) {
      if (response[0].filename) {
        if (response[0].documentbody) {
          try {
            if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
              this.fileService.downloadeBase64DataFileAndOpenInNativeApp(response[0].filename, response[0].documentbody, response[0].mimetype);
            } else {
              const linkSource = response[0].documentbody;
              const downloadLink = document.createElement("a");
              const fileName = response[0].filename;
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
              downloadLink.remove();
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          await this.displayLoader();
          try {
            let data = await this.fileService.getDocumentBody(response[0].annotationid);
            if (data['documentbody']) {
              if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
                this.fileService.downloadeBase64DataFileAndOpenInNativeApp(response[0].filename, response[0].documentbody, response[0].mimetype);
              } else {
                const linkSource = data['documentbody'];
                const downloadLink = document.createElement("a");
                const fileName = response[0].filename;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                downloadLink.remove();
              }
            }
            await this.dismissLoader();
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
  }


  private async removeAttachmentFromDynamics() {
    await this.meetingDataService.removeMeetingAttachment();
  }

  private initConfigFieldsSetup(fromOnActivityChanges: boolean = false) {
    this.appointmentConfigFields = [];
    const appConfigFields = new Map<string, {appFieldId: string, subTypeIds: string[]}>();
    if (!this.authService.hasFeatureAction(FeatureActionsMap.MEETING_HIDE_SUBTYPE)) {
      this.activityService.configuredActivitySubTypes(MeetingActivityTypeCode.MEETING).forEach(subType => {
        subType.appConfigFields.forEach(appFieldId => {
          if (appConfigFields.has(appFieldId)) {
            appConfigFields.get(appFieldId)!.subTypeIds.push(subType.indskr_activitysubtypeid);
          } else {
            appConfigFields.set(appFieldId, { appFieldId: appFieldId, subTypeIds: [subType.indskr_activitysubtypeid] });
          }
        });
      });
    }
     this.authService.user.getSupportedAppointmentConfiguredFields().forEach(field => {
      if(appConfigFields.has(field.appFieldId)) {
        //Separately display the config fields that are present in the meeting sub activity types
        field['subTypeIds'] = appConfigFields.get(field.appFieldId)!.subTypeIds;
      }
      this.appointmentConfigFields.push(field);

    });
    this.updateAppConfigFieldsOnActivityChanges(fromOnActivityChanges);
    this.setOrderToConfigFields();
  }

  private updateAppConfigFieldsOnActivityChanges(fromInitConfigFieldsSetup: boolean = false) {
    if (fromInitConfigFieldsSetup) {
      // Reset all the config fields value everything since this is a fresh activity.
      this.resetConfigFields(this.appointmentConfigFields);
      return;
    }

    const currentActivity = this.activityService.selectedActivity;
    if (!currentActivity?.appConfigFields?.length) {
      // Get the latest config fields from the service.
      this.initConfigFieldsSetup(true);
      return;
    }

    if (!this.appointmentConfigFields.length) {
      return;
    }

    const appConfigFieldsFromCurrentActivity = currentActivity.appConfigFields;
    const notReplacedFieldNames = new Set<string>();

    // Create a map for O(1) lookup of fields from current activity
    const activityFieldsMap = new Map<string, ConfiguredFields>();
    appConfigFieldsFromCurrentActivity.forEach(field => {
      if (field.fieldName) {
        activityFieldsMap.set(field.fieldName, field);
      }
    });

    // Update fields that exist in both service and current activity
    this.appointmentConfigFields.forEach((serviceField, index) => {
      if (!serviceField.fieldName) {
        return;
      }

      const activityField = activityFieldsMap.get(serviceField.fieldName);
      if (activityField) {
        // Preserve subTypeIds from service field
        activityField['subTypeIds'] = serviceField['subTypeIds'];
        this.appointmentConfigFields[index] = activityField;
      } else {
        notReplacedFieldNames.add(serviceField.fieldName);
      }
    });

    // Reset values for fields that weren't found in current activity
    if (notReplacedFieldNames.size > 0) {
      this.appointmentConfigFields.forEach(field => {
        if (field.fieldName && notReplacedFieldNames.has(field.fieldName)) {
          this.resetConfigField(field);
        }
      });
    }
  }

  /**
   * Resets a single config field to its default empty state
   */
  private resetConfigField(field: ConfiguredFields): void {
    field.value = '';
    field.stringValue = '';
    field.selectedValues = '';
    field.hasMultipleValues = false;
    field.multipleLabels = [];
    field.multipleValues = [];
    field.isEmptyRequiredField = false;
  }

  /**
   * Resets multiple config fields to their default empty state
   */
  private resetConfigFields(fields: ConfiguredFields[]): void {
    fields.forEach(field => this.resetConfigField(field));
  }

  private setOrderToConfigFields() {
    // sort the appConfigFields according to the order
    this.appointmentConfigFields.sort(configFieldSortFn)
  }

  initTherapeuticAreas() {
    this.therapeuticAreas = [];
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      if (!this.activityService.selectedActivity.isCompleted) {
        this.theraputicService.therapeuticAreas.forEach(ta => {
          let selectedTA = this.activityService.selectedActivity['activityTherapeuticAreas'].find(item => item.therapeuticareaId === ta.therapeuticareaId);
          if (selectedTA) {
            this.therapeuticAreas.push(selectedTA);
          } else {
            this.therapeuticAreas.push(new TherapeuticArea(ta.TherapeuticAreaDTO));
          }
        });
      } else {
        this.therapeuticAreas = cloneDeep(this.activityService.selectedActivity.activityTherapeuticAreas);
      }
    } else {
      this.therapeuticAreas = JSON.parse(JSON.stringify(this.theraputicService.therapeuticAreas));
    }
  }
  ngAfterViewChecked() {
    if (this.activityService.inboundMeetingFlagForActivitiesDetailsPane) {
      this.activityService.inboundMeetingFlagForActivitiesDetailsPane = false;
      if (this.footerCmp) {
        this.footerCmp.triggerPreviewButton();
      }
    }
  }

  ngOnDestroy() {
    this.events.unsubscribe('remote_meeting_participant_Joined_left');
    // this.events.unsubscribe('detectChangesOnActivityDetails');
    this.events.unsubscribe('scrollToTop');
    this.events.unsubscribe('updateMandatoryField');
    this.ngdestroy$$.next(true);
    this.ngdestroy$$.complete();
    if (this.newActivitySubscription) {
      this.newActivitySubscription.unsubscribe();
    }
    this.eventSubscriptions.forEach(sub => sub.unsubscribe());
    if (this.configFieldsSubscription) this.configFieldsSubscription.unsubscribe();
    if (this.coachingActivitySubscription) this.coachingActivitySubscription.unsubscribe();
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
    this.dateFormatSubscription.unsubscribe();
    this.presentationService.clearReferencesCache();
    this.activityService.isLayOverPushedMeetingFromOtherActivities = false;
  }

  ionViewDidEnter() {
    if (this.isLayoverPushView && this.layoverViewPushedFrom) {
      if (this.layoverViewPushedFrom == 'AccountManagementTool' ||
        this.layoverViewPushedFrom == 'AccountTool' ||
        this.layoverViewPushedFrom == 'ScientificActivityPage' ||
        this.layoverViewPushedFrom == 'PresentationToolsPage' ||
        this.layoverViewPushedFrom == 'OpportunityManagementTool'
        ||this.layoverViewPushedFrom == 'ProcedureLogFrom') {
        this.uiService.isFlipButtonClicked = false;
      }
    }
  }

  // Refresh form fields when required
  private refreshFormFields() {
    this.initAllPresentationPlayDurationField();
  }
  private async initFooterAndHeaderForCompletedMeeting() {
    if (!this.activityService.inboundMeetingFlagForActivitiesDetailsPane && isEmpty(document.getElementsByTagName('ion-modal'))
      && this.authService.hasFeatureAction(FeatureActionsMap.MEETING_REOPEN) && this.activityService.selectedActivity.isCompleted) {
      this._checkPageAndInitActivitiesFooterButtons()
      this.initActivitiesDetailsPageTitle();
    }
  }
  private updateCovisitorInputEnableDisable() {
    const formField = this.secondLevelFormFields.find(field => field.id === 'covisitor-compliance');
    if (formField) {
      formField.isDisabled = this.shouldDisableCovisitorComplianceInput();
    }
    this.cdRef.markForCheck();
  }

  ionViewWillEnter() {
    if (!this.activityService.inboundMeetingFlagForActivitiesDetailsPane) {
      if (this.sampleService.samplingDetailsViewMode != SamplingDetailsViewMode.CREATE_FROM_MEETING
        && this.caseManagementService.accessedFrom != AccesingMode.INMEETING
        && this.caseManagementService.accessedFrom != AccesingMode.IN_PHONE_CALL
        && this.emailService.viewType != EmailViewType.CREATE_FROM_MEETING
        && !this.surgeryOrderDataService.isInMeetingProcedureLogFlow
        && !this.medicalInquiryService.isCreatingFromMeeting) {
        if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent){
          this._checkPageAndInitActivitiesFooterButtons()
        }
      }
      this.uiService.isFlipButtonClicked = false;
      if (this.isLayoverPushView) {
        // Do Nothing
      } else if (!this.device.shouldBeMobileView) {
        // Pop out since it's split view now
      } else {
        if (!this._screenOrientation$) {
          this._screenOrientation$ = this.device.screenOrientation.subscribe((deviceOrientation: number) => {
            if (this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent
              && this.navService.getCurrentPageName() === PageName.ActivitiesDetailsPaneComponent) {
              if (deviceOrientation === DEVICE_ORIENTATION["landscape-primary"]
                || deviceOrientation === DEVICE_ORIENTATION["landscape-secondary"]) {
                this.navService.popWithPageTracking();
              }
            }
          });
        }
      }
    }
    // Refresh sample drop header on revisit so single-AO "+" state is up to date
    if (this.features.allocationEnabled) {
      this._refreshAllocationsInMeeting();
    }
    // Same on revisit for SDRs, which had no equivalent: _refreshSdrsInMeeting
    // ran only from ngOnInit and onSdrSaved, so reopening a meeting re-rendered
    // whatever the pane last held and depended on an allSdrs$ emission to
    // correct it — one that never comes when nothing changed (OMNI-61614).
    if (this.features.sampleDeliveryRequestEnabled) {
      void this._refreshSdrsInMeeting();
    }
  }

  handleMeetingScrap() {
    if (this.isScrapButtonEnabled) {
      this.events.publish('deleteMeeting');
    }
  }

  ionViewWillLeave() {
    if (this._screenOrientation$) {
      this._screenOrientation$.unsubscribe();
      this._screenOrientation$ = null;
    }
  }

  /**
   *  Called when a new activity is created from call plan details page
   * This should scrap the meeting.
   *
   * @private
   * @memberof ActivitiesDetailsPaneComponent
   */
  private scrapActivity() {
    this.events.publish('deleteMeetingNoConfirm');
    if (this.uiService.prevView == 'callPlanDetails') {
    }
    if (this.navService.getCurrentPageName() == PageName.GoAppActivitiesPageComponent && !this.footerService.isActivitiesButton) {
      this.events.publish("go-back-to-xperiences", PageName.ActivitiesDetailsPaneComponent);
    }
    if (this.uiService.activeView == "activityTimelineDetails" && this.navService.getCurrentPageName() == PageName.ContactPageComponent) {
      this.activityService.selectedActivity = undefined;
      this.uiService.showCancelDoneOnActivityDetails = false;
      this.uiService.showNewActivity = false;
      this.uiService.activeView = "contactDetails";
      this.footerService.initButtons(FooterViews.Contacts);
    }
  }

  public get isScrapButtonEnabled(): boolean {
    let flag: boolean = false;
    if (this.activityService.selectedActivity.state == this.meetingState.Open && !this.enableReadonlyViewForMeetings && (this.activityService.selectedActivity && (this.activityService.selectedActivity.ownerId == this.authService.user.systemUserID || (this.isCovisitor && this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS))) && !this.backgroundUploadInProgress) {
      flag = true;
    }
    return flag;
  }

  /**
   *  Called when a new activity is created from the call plan details page and the user hits done
   *
   * @private
   * @memberof ActivitiesDetailsPaneComponent
   */
  private markNewActivityOkay() {
    //hide buttons? do nothing?
    this.uiService.showCancelDoneOnActivityDetails = false;
    if (this.isLayoverPushView && this.layoverViewPushedFrom) {
      if (this.layoverViewPushedFrom == 'AccountManagementTool' || this.layoverViewPushedFrom == 'PresentationToolsPage') {
        if(this.uiService.activitiesPagePlanTabSelectedPlan === 'accountPlansTab'){
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        } else {
          this.uiService.activeView = "AccountManagement";
        }
        this.footerService.initButtons('');
        this.navService.popChildNavPageWithPageTracking();
      } else if (this.layoverViewPushedFrom == 'AccountTool') {
        this.navService.popChildNavPageWithPageTracking();
      } else if (this.layoverViewPushedFrom == 'ScientificActivityPage') {
        this.footerService.initButtons('');
        this.navService.popToRootChildNavPageWithPageTracking();
      }else if (this.layoverViewPushedFrom == 'OpportunityManagementTool'){
        this.navService.popChildNavPageWithPageTracking();
      }
      else if (this.layoverViewPushedFrom == 'ProcedureLogFrom') {
        this.navService.popChildNavPageWithPageTracking();
      }
    }
    else if ((this.uiService.prevView == 'callPlanDetails' || this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent || this.navService.getCurrentMasterPageName() == PageName.CustomerCallPlanPage) && this.uiService.activitiesPagePlanTabSelectedPlan !== 'goalsPlansTab') {
      this.uiService.activeView = 'callPlanDetails';
      this.uiService.showNewActivity = false;
      this.navService.popChildNavPageWithPageTracking();
      this.footerService.initButtons(FooterViews.Contacts);
      this.events.publish('call-plan-details:confirmedNewActivity');
    } else if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showRightPane = true;
      this.navService.popChildNavPageWithPageTracking();
    }
    else if (this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent &&
      !this.footerService.isActivitiesButton) {
      this.events.publish("go-back-to-xperiences", PageName.ActivitiesDetailsPaneComponent, this.activityService.selectedActivity);
    }
    if (this.uiService.activeView == "activityTimelineDetails" && this.navService.getCurrentPageName() == PageName.ContactPageComponent) {
      this.activityService.selectedActivity = undefined;
      this.uiService.showCancelDoneOnActivityDetails = false;
      this.uiService.showNewActivity = false;
      this.uiService.activeView = "contactDetails";
      this.uiService.showRightPane = false;
      this.footerService.initButtons(FooterViews.Contacts);
    }
  }

  async openStartDatePicker(myEvent) {
    if (this.activityService.selectedActivity.isFromXperiences) return;
    if (!this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings) {
      if (this.activityService.selectedActivity.state != MeetingActivityState.Completed) {
        this.activityService.dateTimePickerType = DateTimeFieldType.StartDateField;
        let popover = await this.popoverCtrl.create(
          {
            component: IndDatetimeFormComponent,
            componentProps: {
              currentViewPage: CurViewPageType.Appointment,
              startDateTimeValue: this.activityService.selectedActivity.scheduledStart,
              endDateTimeValue: this.activityService.selectedActivity.scheduledEnd
            },
            cssClass: "datetime-popover"
          }
        );
        popover.onDidDismiss().then((data: any) => {
          this.logService.logDebug(data);
          if (data !== null && !isEmpty(data.data) && data.data.startTime !='') {
            if(this.backgroundUploadInProgress) return;
            this.updateMeetingDate(data.data, true);
            this.activityService.selectedActivity.resetScheduledStartLocale();
            let dateTimeValue = this.activityService.getFormattedDateTimeText();
            if (dateTimeValue) {
              this.meetingStartDate = dateTimeValue.startDate;
              this.meetingEndDate = dateTimeValue.endDate;
            }
          }
        });
        popover.present();
      }
    }
  }
  async openEndDatePicker(myEvent) {
    if (this.activityService.selectedActivity.isFromXperiences) return;
    if (!this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings) {
      if (this.activityService.selectedActivity.state != MeetingActivityState.Completed) {
        this.activityService.dateTimePickerType = DateTimeFieldType.EndDateField;
        let popover = await this.popoverCtrl.create(
          {
            component: IndDatetimeFormComponent,
            componentProps: {
              currentViewPage: CurViewPageType.Appointment,
              startDateTimeValue: this.activityService.selectedActivity.scheduledStart,
              endDateTimeValue: this.activityService.selectedActivity.scheduledEnd
            },
            cssClass: "datetime-popover"
          }
        );
        popover.onDidDismiss().then((data: any) => {
          this.logService.logDebug(data);
          if (data !== null && !isEmpty(data.data) && data.data.endTime !='') {
            if (this.backgroundUploadInProgress) return;
            this.updateMeetingDate(data.data, false);
            this.activityService.selectedActivity.resetScheduledStartLocale();
            let dateTimeValue = this.activityService.getFormattedDateTimeText();
            if (dateTimeValue) {
              this.meetingEndTime = dateTimeValue.endTime;
            }
          }
        });
        popover.present();
      }
    }
  }

  async openSubjectPopover(myEvent) {
    if (!this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings && !this.backgroundUploadInProgress && !this.isReadOnlyRecommendedMeeting) {
      const isSubjectNotEditable = this.secondaryInfoService.isAppointmentSecInfoConfigured ? false : this.features.meetingAutoSubjectEnabled;
      if (isSubjectNotEditable) return;
      if (this.activityService.selectedActivity.state != MeetingActivityState.Completed) {
        let subject = (myEvent && myEvent.target && myEvent.target.value && myEvent.target.value.length != 0) ? myEvent.target.value : this.authService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT) ? 'Visit' : 'Meeting';
        if (subject != this.activityService.selectedActivity.subject) {
          await this.meetingSubjectUpdate(subject);
        }
      }
    }
  }

  async meetingSubjectUpdate(subject) {
    const payload = new UpdateMeetingPayload();
    payload.subject = subject;
    this.activityService.updateSelectedActivityProps({ subject });
    this.initActivitiesDetailsPageTitle();
    this.activityService.getActivityByID(this.activityService.selectedActivity.ID).subject = subject;
    this.refreshPlanToDO();

    if (!this.device.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
      await this.displayLoader();
      try {
        this.activityService.updateSelectedActivityProps({ modified: new Date() });
        const success = await this.meetingDataService.updateMeeting((this.activityService.selectedActivity as AppointmentActivity), payload);
        if (success) {
          this.activityService.notifyCalendarInviteUpdate(this.activityService.selectedActivity as AppointmentActivity);
        }
      } catch (error) {
        console.error('openSubjectPopover: ', error);
        // Create an offline record
        await this.activityService.upsertMeetingsOfflineData((this.activityService.selectedActivity as AppointmentActivity), false, true);
      } finally {
        await this.dismissLoader();
      }
    } else {
      await this.activityService.upsertMeetingsOfflineData((this.activityService.selectedActivity as AppointmentActivity));
    }
  }
  /**
   * Opens contacts component screen
   *
   * @returns
   * @memberof ActivitiesDetailsPaneComponent
   */
  openContacts(ev?:any) {
    this.trackingService.tracking('MeetingAddContact', TrackingEventNames.ACTIVITY);
    if (!this.contactService.loadedContacts) {
      return;
    }
    if((this.isReadOnlyRecommendedMeeting || this.backgroundUploadInProgress || this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings) && isEmpty(this.activityService.selectedActivity['contacts'])) {
      return;
    }
    
    const isSignatureRequiredFormat = this.isSignatureRequiredFormat();
    const isCapturedSignatureMeeting = this.activityService.selectedActivity?.hasCapturedSignature || false;

    if (
      this.enableReadonlyViewForMeetings
      || this.activityService.selectedActivity.isFromXperiences
      || (this.activityService.selectedActivity.isCompleted || this.isReadOnlyJointMeeting || this.isReadOnlyRecommendedMeeting)
      || this.backgroundUploadInProgress
      || (isSignatureRequiredFormat && isCapturedSignatureMeeting)
    ) {
      
      if (this.navService.getActiveChildNavViewPageName() ===  PageName.ActivitiesDetailsPaneComponent) {
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.activeView = '';
      }
      this.uiService.showNewActivity = false;
      this.contactService.contactPageMode = ComponentViewMode.READONLY;
      this.contactService.accessedContactListFrom = PageName.ActivitiesDetailsPaneComponent;
      this.navService.pushWithPageTracking(PageName.ContactPageComponent, PageName.ContactPageComponent, null, PageName.ContactPageComponent);
    } else {
      if (this.isLayoverPushView && (this.layoverViewPushedFrom == "AccountTool" || this.layoverViewPushedFrom == "AccountManagementTool")) {
        this.uiService.prevView = '';
        this.uiService.activeView = '';
      } else if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent) {
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.activeView = '';
      }
      this.uiService.showNewActivity = false;
      if (this.uiService.activitiesPagePlanTabSelectedPlan == 'goalsPlansTab' || this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent) {
        this.contactService.contactInformation = undefined;
        this.uiService.contactDetailsSegment = undefined;
      }
      this.contactService.contactPageMode = ComponentViewMode.ADDNEW;

      let searchText = '';
      let activateSearchOtherContacts = true;
      let overrideAutoFilteres = false;
      if (ev) {
        searchText = ev.text || '';
        if (ev.id === 'view-all' || ev.id === 'show-other') {
          activateSearchOtherContacts = !this.device.isOffline && this.features.showLessThanResultButtonForContact;
          overrideAutoFilteres = true;
        } 
      }

      this.contactService.accessedContactListFrom = PageName.ActivitiesDetailsPaneComponent;
      const params = { 
        'contactSearchText': searchText,
        activateSearchOtherContacts,
        overrideAutoFilteres,
        hidesearchSuggestionsDropDown : true,
        callbackEvent: (data: any) => this.onContactsUpdated(data) 
      }
      this.navService.pushWithPageTracking(PageName.ContactPageComponent, PageName.ContactPageComponent, { 
        'contactSearchText': searchText,
        activateSearchOtherContacts,
        overrideAutoFilteres,
        hidesearchSuggestionsDropDown : true,
        callbackEvent: (data: any) => this.onContactsUpdated(data) 
      }, PageName.ContactPageComponent);
    }
    this.isClickedContacts = true;
  }

  private async markCompleteAccountVisit(selfClaim: boolean = false) {
    let shouldThrowError = false;
    let errorToThrow;

    const payload: AppointmentActivity[] = [];
    if (!this.activityService.selectedActivity) {
      throw(new Error('markCompleteAccountVisit has no selected activity'));
    }
    const activity = this.activityService.selectedActivity as AppointmentActivity;
    const origState = this.activityService.selectedActivity.state;
    const dateCompleted = new Date().getTime().toString();
    const nestedMeetings = this.isAccountVisitRecord ? this.activityService.getAccountVisitNestedMeetings(activity.ID) : [];

    activity.state = 1;
    activity.omnip_datecompleted = dateCompleted;
    if (this.isAccountVisitNestedMeeting) {
      // This activity is a nested meeting
      if (selfClaim) {
        activity.indskr_selfclaimbyuseronappttimemodification = selfClaim;
      }

      const activityPresentationGpsData = await this.presentationService.getActivityPresentationGpsData(activity.offlineMeetingId);
      // Update GPS data for each nested meetings
      if (
        this.authService.user.buSettings
        && this.authService.user.buSettings['indskr_capturegpsdistanceaccountwhencontentplaye']
        && activityPresentationGpsData
      ) {
        const meetingDistancePayload = this.presentationService.getActivityPresentationGpsDataPayload(activity, activityPresentationGpsData);
        if (meetingDistancePayload) {
          if (meetingDistancePayload.indskr_meetingdistance) {
            activity.indskr_meetingdistance = meetingDistancePayload.indskr_meetingdistance;
          } else if (meetingDistancePayload.indskr_reasonforlocationcapturefailure) {
            activity.indskr_reasonforlocationcapturefailure = meetingDistancePayload.indskr_reasonforlocationcapturefailure;
          }
        }
      }
    }
    payload.push(activity);

    if (nestedMeetings.length > 0) {
      // Need to check if nested meetings are all complete-able
      const notCompletedNestedMeetings: AppointmentActivity[] = nestedMeetings.filter(m => m.state !== 1);
      if (!this.activityService.appointmentsCanComplete(notCompletedNestedMeetings)) {
        shouldThrowError = true;
        errorToThrow = new Error('markCompleteAccountVisit failed nested meeting complete check');
      } else {
        const activityPresentationGpsDataMap = await this.presentationService.getMultiActivityPresentationGpsData(notCompletedNestedMeetings.map(m => m.offlineMeetingId));
        for (let i = 0; i < notCompletedNestedMeetings.length; i++) {
          const nActivity = notCompletedNestedMeetings[i];
          nActivity.state = 1;
          nActivity.omnip_datecompleted = dateCompleted;

          // Update GPS data for each nested meetings
          if (
            this.authService.user.buSettings
            && this.authService.user.buSettings['indskr_capturegpsdistanceaccountwhencontentplaye']
            && activityPresentationGpsDataMap
          ) {
            const activityPresentationGpsData = activityPresentationGpsDataMap[nActivity.offlineMeetingId] ?? null;
            const meetingDistancePayload = this.presentationService.getActivityPresentationGpsDataPayload(nActivity, activityPresentationGpsData);
            if (meetingDistancePayload) {
              if (meetingDistancePayload.indskr_meetingdistance) {
                nActivity.indskr_meetingdistance = meetingDistancePayload.indskr_meetingdistance;
              } else if (meetingDistancePayload.indskr_reasonforlocationcapturefailure) {
                nActivity.indskr_reasonforlocationcapturefailure = meetingDistancePayload.indskr_reasonforlocationcapturefailure;
              }
            }
          }

          payload.push(nActivity);
        }
      }
    }


    try {
      if (!shouldThrowError) {
        const success = await this.meetingDataService.crudMeetingsOnlineWithOfflineUploadEndpoint(payload);
        shouldThrowError = !success;
      }
    } catch (error) {
      console.error('markCompleteAccountVisit: ', error);
      this.notificationService.notify(
        this.translate.instant('XPERIENCES_ERROR'),
        'Activity Detail',
        'top',
        ToastStyle.DANGER,
      );
      shouldThrowError = true;
      errorToThrow = error;
    }

    if (shouldThrowError) {
      // Revert
      activity.state = origState;
      activity.omnip_datecompleted = undefined;
      throw(errorToThrow);
    }
  }

  private async processMarkComplete(isFromActivityDetails: boolean, selfClaim: boolean = false) {
    if (isFromActivityDetails) this.trackingService.tracking('MeetingMarkComplete', TrackingEventNames.ACTIVITY, null, true)
    this.blockUI = true;
    const loader = await this.loadingController.create({});
    loader.present();
    this.activityService.updateSelectedActivityProps({ completed: new Date() });
    if (this.nextCallObj && this.nextCallObj.newObjectiveInput != '') await this.nextCallObj.saveObjective();
    const currentActivity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    if (currentActivity.isRemoteDetailing ||
      !isEmpty(currentActivity.activityattendeejoiningdetails)
      || (!isEmpty(currentActivity.contacts) && currentActivity.contacts.some(contact => contact.indskr_joineddate != null))) {
      await this.meetingDataService.convertToRemoteMeeting();
    }
    let meetingDistancePayload;
    try {
      await this.meetingDataService.updateContactJoinDetailsLeftDate(this.activityService.selectedActivity, true);
      if (this.isAccountVisitRecord || this.isAccountVisitNestedMeeting) {
        // Account visit & nested meetings will have a separate flow
        await this.markCompleteAccountVisit(selfClaim)
      } else {
        // Regular meetings
          if (
          this.authService.user.buSettings
          && this.authService.user.buSettings['indskr_capturegpsdistanceaccountwhencontentplaye']
        ) {
          const activityPresentationGpsData = await this.presentationService.getActivityPresentationGpsData(currentActivity.offlineMeetingId);
          meetingDistancePayload = this.presentationService.getActivityPresentationGpsDataPayload(currentActivity, activityPresentationGpsData);
          if (meetingDistancePayload) {
            if (meetingDistancePayload.indskr_meetingdistance) {
              currentActivity.indskr_meetingdistance = meetingDistancePayload.indskr_meetingdistance;
            } else if (meetingDistancePayload.indskr_reasonforlocationcapturefailure) {
              currentActivity.indskr_reasonforlocationcapturefailure = meetingDistancePayload.indskr_reasonforlocationcapturefailure;
            }
          }
        }

        await this.meetingDataService.updateMeetingStatus(<AppointmentActivity>this.activityService.selectedActivity, MeetingStatus.COMPLETED, new Date().getTime(), null, meetingDistancePayload ? meetingDistancePayload : null, selfClaim);
      }
    } catch (error) {
      console.error('markComplete: ', error);

        const errorInfo = (error?.hasOwnProperty('error')) ? error.error : error;
        // Revert completed date if completion limit has been passed
        if (errorInfo?.errorCode === "ERR_IO_ME13") {
          this.notificationService.notify(this.translate.instant('RETROACTIVE_MEETING_COMPLETION_LIMIT_DAYS',{N:this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays']}), 'Meeting Details', 'top', ToastStyle.DANGER);
          this.activityService.updateSelectedActivityProps({ completed: undefined });
        } else if (errorInfo?.errorCode === "ERR_IO_ME14") {
          this.notificationService.notify(this.translate.instant('RETROACTIVE_MEETING_COMPLETION_LIMIT_SAME_DATE'), 'Meeting Details', 'top', ToastStyle.DANGER);
          this.activityService.updateSelectedActivityProps({ completed: undefined });
        } else if (errorInfo?.errorCode === "ERR_IO_ME15") {
          this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'Meeting Details', 'top', ToastStyle.DANGER);
          this.activityService.updateSelectedActivityProps({ completed: undefined });
        } else if (errorInfo?.errorCode === "ERR_IO_ME16") {
          this.notificationService.notify(this.translate.instant('ACTIVITY_MEETING_SCHEDULED_IN_FUTURE'), 'Meeting Details', 'top', ToastStyle.DANGER);
          this.activityService.updateSelectedActivityProps({ completed: undefined });
        } else if (errorInfo?.errorCode === "ERR_IO_ME18") {
          this.notificationService.notify(this.translate.instant('RETROACTIVE_MEETING_COMPLETION_LIMIT',{N:this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimit']}), 'Meeting Details', 'top', ToastStyle.DANGER);
          this.activityService.updateSelectedActivityProps({ completed: undefined });
        } else if (errorInfo?.errorCode === "ERR_IO_ME19") {
          loader.dismiss();
          selfClaim = await this.selfClaimAlert();
          if (selfClaim) {
            loader.present();
            await this.meetingDataService.updateMeetingStatus(<AppointmentActivity>this.activityService.selectedActivity, MeetingStatus.COMPLETED, null, null, null, false);
            void this.sweepMeetingExpenses(currentActivity);
          } else
            this.activityService.updateSelectedActivityProps({ completed: undefined });
        }

        this.blockUI = false;
        removeConflictIdFromOtherActivities(
          this.activityService.selectedActivity,
          this.activityService.activities,
          this.eventsToolService.eventsToolData,
        );
        this.displayConflictMsg = this.checkConflictMsgDisplay(true);
        loader.dismiss();
        this.detectChangesOnActivityDetails(true);
        return false;
    }
    // Remove conflict ID from other activities
    removeConflictIdFromOtherActivities(
      this.activityService.selectedActivity,
      this.activityService.activities,
      this.eventsToolService.eventsToolData,
    );
    if(!this.device.isOffline && this.authService.hasFeatureAction(FeatureActionsMap.CALL_PLANS)) {
      this.callplanDataService.syncCallPlanActivities();
    }
    this.displayConflictMsg = this.checkConflictMsgDisplay(true);
    this.activityService.publishActivityEvent({ action: 'Update', activity: this.activityService.selectedActivity });
    this.meetingStructureService.setCurrentMeetingStructure(this.meetingStructureService.embeddedIntreactions);
    this.websocket.sendRemoteMeetingEnd(this.activityService.selectedActivity, true);
    this.websocket.removeSubscription(this.activityService.selectedActivity);
    void this.sweepMeetingExpenses(currentActivity);
    this.notificationService.notify(this.translate.instant("MEETNG_COMPLETED"), 'Meeting Details');
    this._checkPageAndInitActivitiesFooterButtons()
    this.blockUI = false;
    loader.dismiss();
    this.detectChangesOnActivityDetails(true);
    this.events.publish("updateTherapeuticarea");
    this.events.publish("initTodo");
    this.events.publish('meetingCompleted',this.activityService.selectedActivity);
    this.updateUnsolicitedMeetingData();
    this.initDieseaseAreaSectionData();
    this.initProductIndicationsSectionData();
    return true;
  }



  /**
   * Set activity status to complete
   *
   * @memberof ActivitiesDetailsPaneComponent
   */
  async markComplete(isFromActivityDetails?: boolean) {
    //TODO: Add code to updtae activity status.
    if (this.enableReadonlyViewForMeetings || this.activityService.selectedActivity.state == this.meetingState.Completed) return;
    if (this.markCompleteInProgress) return;
    this.markCompleteInProgress = true;
    if (this.activityService.productSaveInProgress) {
      // Cancel the debounce and flush the product save immediately, then wait for it to finish
      this.events.publish('activity:flushProductSave');
      try {
        await firstValueFrom(this.activityService.productSaveCompleted$);
      } catch {
        this.markCompleteInProgress = false;
        return;
      }
    }
    // Release re-entry guard — blockUI gates processMarkComplete from here
    this.markCompleteInProgress = false;

    const shouldReturn: boolean = this.handleMandatoryFieldNotification();
    if (shouldReturn) {
      return;
    }
    if (!this.device.isOffline && this.authService.hasFeatureAction(FeatureActionsMap.MEETING_CONSENT_CHECK) && this.activityService.selectedActivity instanceof AppointmentActivity
      && !isEmpty(this.activityService.selectedActivity.contacts)) {
      await this.displayLoader();
      const hasActiveConsent = await this.meetingDataService.getActiveGeneralConsent(this.activityService.selectedActivity.contacts[0].ID);
      if (!hasActiveConsent) {
        await this.dismissLoader();
        this.notificationService.notify(this.translate.instant('ACTIVE_GENERAL_CONSENT_NOT_FOUND'), 'Meeting Details', 'top', ToastStyle.DANGER);
        return;
      }
      await this.dismissLoader();
    }
    if ((this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimit']) > 0) {
      let minutesDifference = this.dateTimeFormatsService.getDifferenceInMinutes(new Date(), new Date(this.activityService.selectedActivity.scheduledStart))
      let hourDifference = minutesDifference / 60;
      if (hourDifference > (this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimit'])) {
        this.notificationService.notify(this.translate.instant('RETROACTIVE_MEETING_COMPLETION_LIMIT', {N: this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimit']}), 'Meeting Details', 'top', ToastStyle.DANGER);
        return;
      }
    }
    let currentActivity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity
    // Retroactive Meeting completion limit setting - By End of Meeting Day
    if (this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays'] != null) {
      let limitedDate = new Date(this.activityService.selectedActivity.scheduledStart);
      limitedDate.setHours(23);
      limitedDate.setMinutes(59);
      limitedDate.setSeconds(59);
      if ((this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays']) > 0) {
        limitedDate.setDate(limitedDate.getDate() + this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays']);
        if (new Date() > limitedDate) {
          this.notificationService.notify(this.translate.instant('RETROACTIVE_MEETING_COMPLETION_LIMIT_DAYS', {N: this.authService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays']}), 'Meeting Details', 'top', ToastStyle.DANGER);
          return;
        }
      } else {
        if (new Date() > limitedDate) {
          this.notificationService.notify(this.translate.instant('RETROACTIVE_MEETING_COMPLETION_LIMIT_SAME_DATE'), 'Meeting Details', 'top', ToastStyle.DANGER);
          return;
        }
      }
    }

    /* Meeting Proximity Action Check with completed meetings
      Warn: in-line text only
      BlockAndCancel: inline text, pop-up message, meeting is scrapped in the App and meeting staus is Cancelled in Dynamics
      BlockAndReopen: inline text, pop-up message, stay in the current meeting open status, the meeting cannot be completed */
    if (this.authService.user.meetingProximityWarningPeriod > 0) {
      const userId: string = this.authService.user.xSystemUserID;
      const hasAccountVisitEnabled = !!(this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT));
      const myMeetingsWithContacts: Activity[] = this.activityService.activities.filter(activity => activity instanceof AppointmentActivity && (activity.meetingOwnerId === userId ||
        (Array.isArray(activity.accompaniedUserList) && activity.accompaniedUserList.findIndex(a => a.id === userId) >= 0)) && !isEmpty(activity.contacts));
      //In case of the complete meeting from Account/Contact timeline, closeByActivityIds and closeByCompletedActivityIds should be updated
      if (!isEmpty(myMeetingsWithContacts)) {
        for (let i = 0; i < myMeetingsWithContacts.length; i++) {
          startRecursiveActivityCloseByActivityFlagging(myMeetingsWithContacts, i, userId, this.authService.user.meetingProximityWarningPeriod, hasAccountVisitEnabled);
        }
      }
      this.displayConflictMsg = this.checkConflictMsgDisplay(true);

      if (this.authService.user.buSettings && this.authService.user.buSettings['indskr_meetingproximityaction']
        && ((this.authService.user.buSettings['indskr_meetingproximityaction']) == MeetingProximityActionOption.BlockAndCancel
          || (this.authService.user.buSettings['indskr_meetingproximityaction']) == MeetingProximityActionOption.BlockAndReopen)) {

        const activity = this.activityService.activities.find(a => a.ID === this.activityService.selectedActivity.ID);
        const hasCompletedMeetingProximityWarning: boolean = activity?.closeByCompletedActivityIds?.size > 0 ? true : false;

        if (hasCompletedMeetingProximityWarning) {
          let messageString = this.translate.instant('MEETING_PROXIMITY_RESTRICTION_BLOCK_AND_REOPEN');

          if ((this.authService.user.buSettings['indskr_meetingproximityaction']) == MeetingProximityActionOption.BlockAndCancel) {
            this.events.publish('deleteMeetingNoConfirm');
            messageString = this.translate.instant('MEETING_PROXIMITY_RESTRICTION_BLOCK_AND_CANCEL');
          }

          this.notificationService.notify(messageString, 'Meeting Details', 'top', ToastStyle.DANGER, 3000);

          return;
        }
      }
    }
    // check eDA /uploaded picture
    if (this.isInStoreMeeting) {
      if (this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT_FORMAT_INSTORE_MR) || this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT_FORMAT_INSTORE_OSS)) {
        if (isEmpty(this.activityService.selectedActivity['presentations'])) {
          this.notificationService.notify(this.translate.instant('FA_INSTORE_CHECK_GPS_EDA', {N: this.activityService.selectedActivity.subject}), 'Meeting Details', 'top', ToastStyle.INFO);
          return;
        }
        const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;
        if (isEmpty(currentMeeting.inStorePhotos)) {
          this.notificationService.notify(this.translate.instant('FA_INSTORE_CHECK_GPS_PIC', {N: this.activityService.selectedActivity.subject}), 'Meeting Details', 'top', ToastStyle.INFO);
          return;
        }
      }
    }
    // Account visit mark complete confirm
    if (this.isAccountVisitRecord) {
      const res = await this.alertService.showAlert(
        {
          title: this.translate.instant('MARK_COMPLETE'),
          message: this.translate.instant('ACCOUNT_VISIT_NESTED_MARK_COMPLETE_CONFIRM'),
        },
        this.translate.instant('SUBMIT'),
      );
      if (res.role !== 'ok') {
        return;
      }
    }

    if (!this.isAccountVisitNestedMeeting &&
      this.isGpsEnabled && this.activityService.selectedActivity instanceof AppointmentActivity
      && (this.activityService.selectedActivity.gpsCheckInDetails?.indskr_checkinstatus == null &&
        this.activityService.selectedActivity.gpsCheckInDetails?.indskr_checkoutstatus == null)) {
      if (this.features.gpsFunctionalityEnabled) {
        this.checkinFieldsEmpty = true;
        this.notificationService.notify(this.translate.instant('GPS_CHECKIN_MANDATORY'), 'Meeting Details', 'top', ToastStyle.DANGER);
        await this.initFormFields();
        return;
      }

    }

    if (!this.isAccountVisitNestedMeeting &&
      this.isAccountVisitRecord && this.features.gpsCheckoutMandatory && currentActivity.gpsCheckInDetails?.indskr_checkoutstatus == null) {
      this.checkOutFieldsEmpty = true;
      this.notificationService.notify(this.translate.instant('GPS_CHECKOUT_MANDATORY'), 'Meeting Details', 'top', ToastStyle.DANGER);
      await this.initFormFields();
      return;
    }
    // check-in/out date verify
    if (this.isGpsEnabled) {
      if (this.isAccountVisitNestedMeeting) {
        let parentActivity = this.activityService.getActivityByID(currentActivity.indskr_parentcallid) as AppointmentActivity;
        currentActivity.gpsCheckInDetails = parentActivity.gpsCheckInDetails
      }
      if (this.validateGpsDetailsDates(currentActivity) == false) return
    }
    if (this.isMeetingLimitReached) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('MEETING_LIMIT_REACHED'),
        message: this.translate.instant('MEETING_LIMIT_REACHED_MSG').replace("{{DATE}}", this.meetingStartDate),
        buttons: [{
          text: this.translate.instant("CLOSE"),
          role: 'cancel',
          handler: () => {
          }
        }]
      });
      alert.present();
      alert.onDidDismiss().then(() => {
      });
      return;
    }

    if (this.pollService.isPollsToSubmit()) {
      const res = await this.alertService.showAlert({
        header: this.translate.instant('POP_SUBMIT_POLL'),
        message: this.translate.instant('POP_R_U_SURE_NOT_SUBMIT_POLL'), backdropDismiss: false
      }, "Yes", "No");

      if (res.role === "ok") {
        return;
      } else if (res.role === "cancel") {
        localStorage.setItem("polls", JSON.stringify([]));
      }
    }

    if (this.activityOutcomeisMandatory) {
      if (!(this.activityService.selectedActivity as AppointmentActivity).meetingOutcomeId) {
        this.notificationService.notify(this.translate.instant('MEETING_COMPLETE_FAIL_ALERT_MEETING_OUTCOME'), 'Meeting Details', 'top', ToastStyle.DANGER);
        return;
      }
    }
    if (this.isLocationMandatory && this._isMeetingLocationEmpty()) {
      this.notificationService.notify(this.translate.instant('MEETING_COMPLETE_FAIL_ALERT_LOCATION'), 'Meeting Details', 'top', ToastStyle.DANGER);
      return;
    }
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      const appt = this.activityService.selectedActivity as AppointmentActivity;
      if (!this.meetingMandatoryValidation.canCompleteMeeting(appt).ok) {
        this.notificationService.notify(
          this.translate.instant('MANDATORY_INLINE_ACTIVITIES_BEFORE_COMPLETE'),
          'Meeting Details',
          'top',
          ToastStyle.DANGER
        );
        return;
      }
    }
    if (this.activityService.activityCanComplete && this.activityService.selectedActivity instanceof AppointmentActivity && !this.blockUI) {

      const isRemoteDetailingReasonRequired = this.isCurrentContentNotPlayedByUser() || isEmpty(this.activityService.selectedActivity.presentations);

      if (this.isContentRequiredForRemoteChannelEnabled && isRemoteDetailingReasonRequired) {
        //Show warning for isContentRequiredForRemoteChannelEnabled
        this.notificationService.notify(this.translate.instant("NO_DETAILING_WARNING_REMOTE_MESSAGE"), 'Meeting Details', 'top', ToastStyle.DANGER);
      } else if (this.features.meetingContentReasonEnabled && isRemoteDetailingReasonRequired && !this.isAccountVisitRecord) {
        let selfClaim = false;
        if (this.features.selfClaimNeededIfStartEndTimeModified && !this.isContentPlayed && !this.isAccountVisitRecord) {
          const createdOnTime = this.activityService.selectedActivity.offlineId ? this.activityService.extractDateFromMeetingOfflineId(this.activityService.selectedActivity.offlineId) : new Date();
          if (!this.dateTimeFormatsService.isSameDayCheck(new Date(this.activityService.selectedActivity.scheduledStart), createdOnTime)
            || !this.dateTimeFormatsService.isSameDayCheck(new Date(this.activityService.selectedActivity.scheduledEnd), createdOnTime)
            || !this.isTimeBetween(
              this.dateTimeFormatsService.formatDate(new Date(this.activityService.selectedActivity.scheduledStart), 'HH:mm'),
              this.dateTimeFormatsService.formatDate(new Date(this.activityService.selectedActivity.scheduledEnd), 'HH:mm'),
              this.dateTimeFormatsService.formatDate(new Date(createdOnTime), 'HH:mm')
            )) {
            selfClaim = await this.selfClaimAlert();
            if (!selfClaim)
              return;
          }
        }
        //Show modal popup for selecting Meeting Content Reasons
        const fetchedMeetingContentReasons = this.fetchMeetingContentReasons();
        if (isEmpty(fetchedMeetingContentReasons)) {
          return this.notificationService.notify(this.translate.instant("NO_DETAILING_REASON_EMPTY_ERROR"), 'Meeting Details', 'top', ToastStyle.DANGER);
        }

        const selectedReason = await this.showReaonPopover(fetchedMeetingContentReasons);
        if (selectedReason) {
          //Assign selected reason value so that it could be used in payload
          this.activityService.updateSelectedActivityProps({ indskr_meetingcontentreasonsid: selectedReason.value });
          return await this.processMarkComplete(isFromActivityDetails, selfClaim);
        }
      } //end of if(isRemoteDetailingReasonRequired)
      // --------------------------------No Detailing in a Meeting-------------------------------- //

      else {
        if (this.isAccountVisitRecord) {
          return await this.processMarkComplete(isFromActivityDetails);
        }
        let selfClaim = false;
        if (this.features.selfClaimNeededIfStartEndTimeModified && !this.isContentPlayed && !this.isAccountVisitRecord) {
          const createdOnTime = this.activityService.selectedActivity.offlineId ? this.activityService.extractDateFromMeetingOfflineId(this.activityService.selectedActivity.offlineId) : new Date();
          if (!this.dateTimeFormatsService.isSameDayCheck(new Date(this.activityService.selectedActivity.scheduledStart), createdOnTime)
            || !this.dateTimeFormatsService.isSameDayCheck(new Date(this.activityService.selectedActivity.scheduledEnd), createdOnTime)
            || !this.isTimeBetween(
              this.dateTimeFormatsService.formatDate(new Date(this.activityService.selectedActivity.scheduledStart), 'HH:mm'),
              this.dateTimeFormatsService.formatDate(new Date(this.activityService.selectedActivity.scheduledEnd), 'HH:mm'),
              this.dateTimeFormatsService.formatDate(new Date(createdOnTime), 'HH:mm')
            )) {
            selfClaim = await this.selfClaimAlert();
            if (!selfClaim)
              return;
          }
        }
        const hasMeetingReopenFA = this.authService.hasFeatureAction(FeatureActionsMap.MEETING_REOPEN) && this.authService.user.pastMeetingReopenPeriod !== 0;
        if (hasMeetingReopenFA) {
          return await this.processMarkComplete(isFromActivityDetails, selfClaim);
        }
        const message = this.translate.instant(hasMeetingReopenFA ? 'MEETING_COMPLETE' : 'MEETING_NO_MODIFIED');
        const alertResponse = await this.alertService.showAlert(
          {
            title: this.translate.instant('MARK_COMPLETE'),
            message,
          }, this.translate.instant('SUBMIT')
        );
        if (alertResponse.role === 'ok') {
          return this.processMarkComplete(isFromActivityDetails, selfClaim);
        }
      }
    } else {
      return false;
    }
  }

  private validateGpsDetailsDates(appointment):boolean{
    let checkinDate = this.datePipe.transform(appointment.gpsCheckInDetails?.indskr_checkindatetime,'yyyy-MM-dd')
    let checkoutDate = this.datePipe.transform(appointment.gpsCheckInDetails?.indskr_checkoutdatetime,'yyyy-MM-dd')
    let scheduledStartDate = this.datePipe.transform(new Date(appointment.scheduledStart),'yyyy-MM-dd') ;
    let scheduledEndDate = this.datePipe.transform(new Date(appointment.scheduledEnd),'yyyy-MM-dd') ;
    if ((checkinDate != null && checkinDate != scheduledStartDate) || (checkoutDate != null && checkoutDate != scheduledEndDate)) {
      this.notificationService.notify(this.translate.instant(this.isAccountVisitRecord ? 'AC_DATE_AND_GPS_DATE' : 'MEETING_DATE_AND_GPS_DATE'), 'Meeting Details', 'top', ToastStyle.DANGER);
      return false;
    }
    return true;
  }
  private async showReaonPopover(fetchedMeetingContentReasons) {
    let popoverOptions = {
      header: this.translate.instant('NO_DETAILING_POPUP_HEADER'),
      inputs: fetchedMeetingContentReasons,
      cancelText: this.translate.instant('CANCEL'),
      confirmText: this.translate.instant('SUBMIT_AND_COMPLETE')
    };

    this._lookupPopover = await this.popoverCtrl.create({
      component: AlertWithInput,
      componentProps: popoverOptions,
      cssClass: 'alert-with-input-list-view-for-meeting-content-reason',
      backdropDismiss: true
    });
    this._lookupPopover.present();

    return await this._lookupPopover.onDidDismiss().then(async (res) => {
      if (res.data && res.data.role && res.data.role == 'ok' && res.data.inputs) {
        return res.data.inputs;
      }
      return false;
    });
  }

  private async selfClaimAlert() {
    const modal = await this.modalCtrl.create({
      component: OmniInfoAlertComponent,
      cssClass: 'omni-notification-modal',
      componentProps: {
        header: this.translate.instant('ARE_YOU_SURE_YOU_WANT_SELF_CLAIM'),
        alertType: AlertInfoTypes.NOTIFICATION_MESSAGE,
        notificationMessage: this.translate.instant("SELF_CLAIM_NOTIFICATION"),
        buttons: [{
          label: this.translate.instant("ACCEPT"),
          value: true
        }]
      }
    });
    await modal.present();

    return await modal.onDidDismiss().then(async ({ data }) => {
      const response = data?.value ? data.value : false;
      if(!response) {
        await this.displayLoader();
        const isShortCall = (this.activityService.selectedActivity as AppointmentActivity).indskr_shortcall;
        const createdOnTime = this.activityService.selectedActivity.offlineId ? this.activityService.extractDateFromMeetingOfflineId(this.activityService.selectedActivity.offlineId) : new Date();
        const startTime = this.dateTimeFormatsService.toISOString(createdOnTime);
        const endTime = this.dateTimeFormatsService.toISOString(this.dateTimeFormatsService.addMinutesToDate(createdOnTime, isShortCall ? 5 : this.authService.user?.meeting_duration || 30));
        const prevStartTime = startTime;
        const prevEndTime = endTime;

        await this.updateMeetingDate({
          startTime,
          endTime,
          prevStartTime,
          prevEndTime,
        }, true);
        this.initMeetingDateFormFields();
        this.activityService.selectedActivity.resetScheduledStartLocale();
        let dateTimeValue = this.activityService.getFormattedDateTimeText();
        if (dateTimeValue) {
          this.meetingStartTime = dateTimeValue.startTime;
          this.meetingEndTime = dateTimeValue.endTime;
        }
        this.cdRef.markForCheck();
        await this.dismissLoader();
      }
      return response;
    })
  }

  private get isMeetingLimitReached(): boolean {
    if (this.authService.user.meetingLimit > 0) {
      return this.activityService.activities.filter(activity =>
        activity.type == ActivityType.Appointment
        && this.activityService.isMeetingOwner
        && activity.state == MeetingActivityState.Completed
        && this.dateTimeFormatsService.formatDate(new Date(activity.scheduledStart), 'MM DD YYYY') === this.dateTimeFormatsService.formatDate(new Date(this.activityService.selectedActivity.scheduledStart), 'MM DD YYYY')
      ).length >= this.authService.user.meetingLimit;
    }
    return false;
  }

  private updateUnsolicitedMeetingData(reopen?: boolean) {
    let hcpInteractionField;
    if ((this.activityService.selectedActivity as AppointmentActivity).appConfigFields) {
      hcpInteractionField = (this.activityService.selectedActivity as AppointmentActivity).appConfigFields.find(a => a.fieldName == 'indskr_hcpinteraction');
    }
    if (this.isSolicitatedMeetingComplianceCheckEnabled && hcpInteractionField && hcpInteractionField.value == 548910001) {
      (this.activityService.selectedActivity as AppointmentActivity).contacts.forEach(c => {
        const solicDataIdx = this.activityService.unsolicitedMeetingsData.findIndex(a => a.contactid == c.ID);
        if (solicDataIdx >= 0) {
          if (reopen) {
            const filteredMeetings = this.activityService.unsolicitedMeetingsData[solicDataIdx].appointments.filter(a => a.activityid !== this.activityService.selectedActivity.ID);
            if (filteredMeetings.length == 0) {
              this.activityService.unsolicitedMeetingsData.splice(solicDataIdx, 1);
            } else {
              this.activityService.unsolicitedMeetingsData[solicDataIdx].appointments = filteredMeetings;
            }
          } else {
            this.activityService.unsolicitedMeetingsData[solicDataIdx].appointments.push({
              activityid: this.activityService.selectedActivity.ID,
              scheduledend: this.activityService.selectedActivity.scheduledEnd,
            });
          }
        }
        else {
          this.activityService.unsolicitedMeetingsData.push({
            contactid: c.ID,
            appointments: [{
              activityid: this.activityService.selectedActivity.ID,
              scheduledend: this.activityService.selectedActivity.scheduledEnd,
            }],
          });
        }
      });
      this.activityDataService.updateUnsolicitedMeetingDataOfflineDB();
    }
  }

  async reopenMeeting() {
    if (!this.isSelectedActivityReopenable) return;

    const title = this.isAccountVisitRecord
      ? this.translate.instant('ACCOUNT_VISIT_REOPEN')
      : this.translate.instant('REOPEN_MEETING');
    const message = this.isAccountVisitRecord
      ? this.translate.instant('ACCOUNT_VISIT_REOPEN_COMFIRM')
      : this.translate.instant('MEETING_REOPEN_CONFIRMATION')

    await this.alertService.showAlert({
      title,
      message,
    }, this.translate.instant('REOPEN')
    ).then(async res => {
      if (res.role === 'ok') {
        this.displayLoader();

        try {
          await this.meetingDataService.updateMeetingStatus(<AppointmentActivity>this.activityService.selectedActivity, MeetingStatus.OPEN);
           if(!this.device.isOffline && this.authService.hasFeatureAction(FeatureActionsMap.CALL_PLANS)) {
            this.callplanDataService.syncCallPlanActivities();
          }
        } catch (error) {
          console.error('reopenMeeting: ', error);
          this.dismissLoader();
          // Check conflicts
          checkTimeConflictWithOtherActivities(
            this.activityService.selectedActivity,
            this.activityService.activities,
            this.activityService.conflictCheckStartIdx,
            this.eventsToolService.eventsToolData,
            this.eventsToolService.conflictCheckLastIdx,
            this.authService.user.xSystemUserID,
          );
          this.displayConflictMsg = this.checkConflictMsgDisplay(true);
          this.detectChangesOnActivityDetails(true);
          return;
        }

        // Check conflicts
        checkTimeConflictWithOtherActivities(
          this.activityService.selectedActivity,
          this.activityService.activities,
          this.activityService.conflictCheckStartIdx,
          this.eventsToolService.eventsToolData,
          this.eventsToolService.conflictCheckLastIdx,
          this.authService.user.xSystemUserID,
        );
        this.displayConflictMsg = this.checkConflictMsgDisplay(true);
        this.activityService.publishActivityEvent({ action: 'Update', activity: this.activityService.selectedActivity });
        this.meetingStructureService.setCurrentMeetingStructure(this.meetingStructureService.embeddedIntreactions);
        this._checkPageAndInitActivitiesFooterButtons()
        this.dismissLoader();
        if (this.activityService.selectedActivity.accessedFrom == PageName.AccountTimelineComponent
          || this.activityService.selectedActivity.accessedFrom == PageName.ScientificActivityTimeline
          || this.activityService.selectedActivity.accessedFrom == PageName.ContactTimelineComponent) {
          this.activityReopenedFromTimeline = true;
        }
        this.events.publish('meetingReopened', this.activityService.selectedActivity);
        this.events.publish("updateTherapeuticarea");
        this.activityService.updateActivities(this.activityService.selectedActivity);
        this.updateUnsolicitedMeetingData(true);
        this.detectChangesOnActivityDetails(true);
        this.initDieseaseAreaSectionData();
        this.initProductIndicationsSectionData();
      }
    });
  }

  /**
   *
   *
   * @returns
   * @memberof ActivitiesDetailsPaneComponent
   * set mode of Account view 'addnew', readOnly, listviw
   */
  openAccounts(ev?:any) {
    this.trackingService.tracking('MeetingAccountsClick', TrackingEventNames.ACTIVITY);
    this.accountService.selectedFor = AccountSelectedFor.ADD_TO_MEETING;
    if (!this.accountService.loadedAccounts || this.enableReadonlyViewForMeetings ||
      ((this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress || this.isReadOnlyRecommendedMeeting)
      && this.activityService.selectedActivity['accounts'].length === 0)) return;
    if (this.activityService.selectedActivity.isCompleted || this.isReadOnlyJointMeeting || !this.activityService.isMeetingOwner || this.backgroundUploadInProgress || this.isReadOnlyRecommendedMeeting) {
      this.accountService.accessedAccountListFrom = PageName.ActivitiesDetailsPaneComponent;
      this.navService.pushWithPageTracking(PageName.AccountPageComponent, PageName.AccountPageComponent, { 'listMode': ComponentViewMode.READONLY }, PageName.AccountPageComponent).then(() => {
        if (this.accountService.selectedAccounts.length > 0 && !this.device.isMobileDevice) this.events.publish(EventName.OPEN_SELECTED_ACCOUNT_DETAILS, this.accountService.selectedAccounts[0]);
      });
    } else {
      if (this.isLayoverPushView && (this.layoverViewPushedFrom == "AccountTool" || this.layoverViewPushedFrom == "AccountManagementTool")) {
        this.uiService.prevView = '';
        this.uiService.activeView = '';
      } else if (this.navService.getActiveChildNavName() === ChildNavNames.ActivitiesPageNavigation) {
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.activeView = '';
      } else {
        this.uiService.prevView = 'Appointment';
        this.uiService.activeView = 'accountDetails';
      }
      this.uiService.showNewActivity = false;
      this.accountService.accessedAccountListFrom = PageName.ActivitiesDetailsPaneComponent;
      if (this.isAccountVisitRecord) {
        this.accountService.selectedFor = AccountSelectedFor.ACCOUNT_VISIT;
      }
      let viewMode = this.isGpsEnabled ? ComponentViewMode.SELECTION : ComponentViewMode.ADDNEW;
      if(this.isGpsEnabled && (this.activityService.selectedActivity as AppointmentActivity).gpsCheckInDetails?.indskr_checkinstatus != null){
        viewMode = ComponentViewMode.READONLY
      }

      let searchText = '';
      let activateSearchOtherAccounts = true;
      let overrideAutoFilteres = false;
      if (ev) {
        searchText = ev.text || '';
        if (ev.id === 'view-all' || ev.id === 'show-other') {
          activateSearchOtherAccounts = !this.device.isOffline && this.features.showLessThanResultButtonForAccount;
          overrideAutoFilteres = true;
        }
      }
      this.navService.pushWithPageTracking(PageName.AccountPageComponent, PageName.AccountPageComponent, {
        'listMode': viewMode,
        'accountSearchText': searchText,
        activateSearchOtherAccounts,
        overrideAutoFilteres,
        hidesearchSuggestionsDropDown : true
      }, PageName.AccountPageComponent).then(() => {
        if(!activateSearchOtherAccounts){
          if (this.accountService.selectedAccounts.length > 0 && !this.device.isMobileDevice) this.events.publish(EventName.OPEN_SELECTED_ACCOUNT_DETAILS, this.accountService.selectedAccounts[0]);
        }
      });
    }
    this.isClickedAccounts = true;
  }

  /*
    Open List of user for selection
  */
  openAccompainedUsers() {
    this.ioUserSelection.setCaseSelectorSource("Team Members");
    this.ioUserSelection.setSelectedInputSource(this.activityService.selectedActivity["accompaniedUserList"]);
    let userList = cloneDeep(this.activityService.repUserList);
    if(this.authService.hasFeatureAction(FeatureActionsMap.ASSIGN_MEETING)){
      userList.push({
        id : this.authService.user.xSystemUserID,
        name : this.authService.user.displayName,
        emailaddress : this.authService.user.mail,
        businessunitname : this.authService.user.businessUnitName
      })
    }
    this.ioUserSelection.setSelectionDataSource(userList);

    this.uiService.showNewActivity = false;

    setTimeout(() => {
      const onUserSelect = (data) => { if (data != undefined) {
        this.activityService.updateSelectedActivityProps({ modified: new Date() });
        this.updateAccompaniedUsers(data);
      }};
      this.navService.pushWithPageTracking(PageName.IOMultiSelect, PageName.IOMultiSelect, { remoteMeetingConnectionMapping: true, onSelectDone: onUserSelect }, PageName.IOMultiSelect);
    }, 10);
  }

  private _handleCancelDoneOnActivityDetails(): boolean {
    if (!this.uiService.showCancelDoneOnActivityDetails) {
      return false;
    }

    const curMasterPageName = this.navService.getCurrentMasterPageName();
    const isCallPlanContext = this.uiService.prevView == 'callPlanDetails' || 
                             curMasterPageName == PageName.CallPlanComponent || 
                             curMasterPageName == PageName.CustomerCallPlanPage ||
                             (curMasterPageName == PageName.GoAppActivitiesPageComponent && 
                              this.uiService.activitiesPageTab == 'plans' && 
                              this.uiService.activitiesPagePlanTabSelectedPlan == 'goalsPlansTab');

    if (isCallPlanContext) {
      this.events.publish('refresh-callplan-activity');
      this.markNewActivityOkay();
      return true;
    }

    this.uiService.showCancelDoneOnActivityDetails = false;
    return false;
  }

  private _handleTimelineActivityRefresh(): void {
    if (!this.activityService.selectedActivity) return;

    const accessedFrom = this.activityService.selectedActivity.accessedFrom;
    const isTimelineActivity = accessedFrom == PageName.AccountTimelineComponent ||
                              accessedFrom == PageName.ContactTimelineComponent ||
                              accessedFrom == PageName.ScientificActivityTimeline;

    if (!isTimelineActivity) return;

    this.uiService.agendaRefreshRequired = this.uiService.timelineRefreshRequired = this.activityReopenedFromTimeline;

    if (accessedFrom == PageName.AccountTimelineComponent) {
      if (isEmpty(this.accountService.selected)) {
        this.accountService.selected = this.accountService.tempSelected;
        this.accountService.tempSelected = null;
      }
    } else if (accessedFrom == PageName.ContactTimelineComponent) {
      this._handleContactTimelineRefresh();
    }
  }

  private _handleContactTimelineRefresh(): void {
    if (!this.activityService.prevSelectedActivityOnTimeline || !this.activityService.selectedActivity) {
      this.footerService.initButtons('');
      return;
    }

    const prevData = this.activityService.prevSelectedActivityOnTimeline;
    const currData = this.activityService.selectedActivity;

    const isDiffStatus = prevData.state != currData.state || prevData.status != currData.status;
    const isDiffTime = new Date(prevData.scheduledStart).getTime() !== new Date(currData.scheduledStart).getTime();
    const isDiffSubject = prevData.subject != currData.subject;
    const isDiffContact = this.isClickedContacts;
    const isDiffAccount = this.isClickedAccounts;
    const isDiffLocation = this._checkLocationDifference(prevData, currData);

    this.uiService.agendaRefreshRequired = this.uiService.timelineRefreshRequired = 
      isDiffStatus || isDiffTime || isDiffSubject || isDiffContact || isDiffLocation || isDiffAccount;

    if (this.uiService.agendaRefreshRequired && 
        !isEmpty(this.activityService.selectedActivityAtHome) && 
        !isEmpty(this.activityService.selectedActivity) &&
        this.activityService.selectedActivityAtHome.ID == this.activityService.selectedActivity.ID) {
      this.activityService.selectedActivityAtHome = this.activityService.selectedActivity;
    }

    this.footerService.initButtons('');
  }

  private _checkLocationDifference(prevData: any, currData: any): boolean {
    if (isEmpty(prevData.location) || 
        prevData.location == 'No Location' || 
        prevData.location == this.translate.instant('NO_LOCATION')) {
      return !(currData.location == 'No Location' || 
               isEmpty(currData.location) || 
               currData.location == this.translate.instant('NO_LOCATION'));
    }
    return prevData.location != currData.location;
  }

  private _handleUserStateAndAppealDetails(): void {
    if (this.repService.getCurrentUserState() !== REP_STATUS.IN_MEETING.userState) {
      if (this.from !== PageName.SetBookingActivityDetailsComponent) {
        this.activityService.selectedActivity = undefined;
      }

      if (this.navService.getActiveChildNavViewMasterPageName() === PageName.AppealDetailsComponent) {
        this.navService.popChildNavPageWithPageTracking();
        if (this.from == PageName.AppealDetailsComponent) {
          this.footerService.initButtons(FooterViews.APPEAL_DETAILS);
          if (this.callbackEvent) {
            this.callbackEvent();
          }
        }
      }
    }
  }

  private _handleLayoverPushView(): boolean {
    if (!this.isLayoverPushView || !this.layoverViewPushedFrom) {
      return false;
    }

    switch (this.layoverViewPushedFrom) {
      case 'AccountManagementTool':
        this.navService.popChildNavPageWithPageTracking().then(() => {
          this.footerService.initButtons(FooterViews.None);
        });
        break;
      case 'PresentationToolsPage':
        this.navService.popChildNavPageWithPageTracking();
        break;
      case 'AccountTool':
      case 'AccountTimeline':
        this.navService.popChildNavPageWithPageTracking();
        this.footerService.initButtons(FooterViews.None);
        break;
      case 'OpportunityManagementTool':
        this.navService.popChildNavPageWithPageTracking();
        break;
      case 'ProcedureLogFrom':
        this.navService.popChildNavPageWithPageTracking();
        break;
      case 'ScientificActivityPage':
        this._handleScientificActivityPageNavigation();
        break;
      default:
        if (this.from === PageName.SetBookingActivityDetailsComponent) {
          this.activityService.selectedActivity = this.activityService.prevSelectedActivity;
          this.navService.popChildNavPageWithPageTracking();
          this.activityService.isLayOverPushedMeetingFromOtherActivities = false;
          this.events.publish('refresh-kit-booking-activities');
        }
        break;
    }

    return true;
  }

  private _handleScientificActivityPageNavigation(): void {
    this.footerService.initButtons('');
    if (this.childFrom === PageName.ContactDetailsComponent) {
      this.navService.popChildNavPageWithPageTracking();
    } else if (this.uiService.activitiesPagePlanTabSelectedPlan === 'scientificPlans') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.navService.popChildNavPageWithPageTracking();
    } else {
      this.navService.popToRootChildNavPageWithPageTracking();
    }
  }

  private _handlePageSpecificNavigation(): boolean {
    const curMasterPageName = this.navService.getCurrentMasterPageName();
    const curPageName = this.navService.getCurrentPageName();

    if (curPageName == PageName.ContactPageComponent) {
      this._handleContactPageNavigation();
      return true;
    } else if (curMasterPageName == PageName.CallPlanComponent || 
               curMasterPageName == PageName.CustomerCallPlanPage ||
               (curMasterPageName == PageName.GoAppActivitiesPageComponent && 
                this.uiService.activitiesPagePlanTabSelectedPlan == 'goalsPlansTab' && 
                this.callplanService.selectedCallPlan)) {
      this._handleCallPlanNavigation();
      return false; // No return, continue execution
    } else if (curMasterPageName == PageName.AccountPageComponent) {
      this.uiService.showNewActivity = false;
      this.uiService.activeView = 'accountDetails';
      return false; // No return, continue execution
    } else if (curMasterPageName == PageName.CoachingActivitiesComponent || 
               curPageName == PageName.AccountPlanActivities) {
      this.activityService.selectedActivity = undefined;
      this.coachingReportService.activityClick = false;
      this.navService.setChildNavRightPaneView(false);
      this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, curMasterPageName);
      return true;
    } else if (curMasterPageName === PageName.GoAppActivitiesPageComponent && 
               this.uiService.activitiesPageTab === 'plans') {
      this.activityService.selectedActivity = undefined;
      this.uiService.showRightPane = false;
      return false; // No return, continue execution
    } else if (curMasterPageName === PageName.GoAppActivitiesPageComponent &&
               !this.footerService.isActivitiesButton && 
               this.uiService.activitiesPageTab !== 'plans') {
      this.events.publish("go-back-to-xperiences", PageName.ActivitiesDetailsPaneComponent);
      return true;
    } else if (this.from === PageName.AccountPlanActivities) {
      this.activityService.teamViewActive = false;
      return false; // No return, continue execution
    } else if (curMasterPageName == PageName.MarketingPlanManagementPageComponent) {
      this.activityService.selectedActivity = undefined;
      this.navService.popChildNavPageWithPageTracking();
      this.footerService.initButtons(FooterViews.AccountPlanObjectives);
      return true; // No return, continue execution
    } else if (this.from === PageName.SetBookingActivityDetailsComponent) {
      this._handleSetBookingNavigation();
      return false; // No return, continue execution
    } else if (curMasterPageName === PageName.VoiceNotesPageComponent) {
      // A meeting opened in the My Notes right pane (created from a voice note):
      // clear the pane and return to nothing-selected so the note list re-roots.
      this.activityService.selectedActivity = undefined;
      this.navService.setChildNavRightPaneView(false);
      this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, curMasterPageName);
      // Nudge the OnPush My Notes page to re-render so mobile reveals the note list.
      // Keep the topic in sync with VOICE_NOTES_MEETING_PANE_CLOSED in voice-notes-page.ts.
      this.events.publish('voicenotes:meeting-pane-closed');
      return true;
    }

    return false;
  }

  private _handleContactPageNavigation(): void {
    if (this.activityService.isNewMeetingFlow && 
        this.activityService.prevSelectedActivity && 
        this.activityService.prevSelectedActivity.type == ActivityType.Appointment) {
      this.activityService.isNewMeetingFlow = false;
      this.uiService.timelineRefreshRequired = true;
    }
    if (this.navService.getPreviousPageName() == PageName.GoAppActivitiesPageComponent) {
      if (!this.activityService.selectedActivity) {
        if (this.activityService.trackSelectedActivityId) {
          const trackSelectedActivity = this.activityService.getActivityByID(this.activityService.trackSelectedActivityId);
          if (trackSelectedActivity) {
            this.activityService.selectedActivity = trackSelectedActivity;
          }
        }
      }
    }
    this.navService.popChildNavPageWithPageTracking();
    this.events.publish('refreshContactDetailPageTitleOnly');
    this.uiService.showNewActivity = false;
    this.footerService.initButtons(FooterViews.Contacts);
  }

  private _handleCallPlanNavigation(): void {
    this.activityService.selectedActivity = undefined;
    this.uiService.showNewActivity = false;
    this.uiService.activeView = 'callPlanDetails';
    this.callplanService.callPlanPageView = 'CallPlanDetail';
    this.events.publish('activity-scrapped-created-from-call-plan');
    this.navService.popChildNavPageWithPageTracking();
  }

  private _handleSetBookingNavigation(): void {
    this.activityService.selectedActivity = this.activityService.prevSelectedActivity;
    this.navService.popChildNavPageWithPageTracking();
    this.events.publish('refresh-kit-booking-activities');
    
    if (this.activityService.selectedActivity && 
        this.activityService.selectedActivity.type === ActivityType.SetBooking) {
      const setBooking = this.activityService.selectedActivity as SetBookingActivity;
      if (setBooking.indskr_status === SetBookingStatus.PENDINGSYNC || 
          setBooking.indskr_status === SetBookingStatus.PENDINGCANCEL) {
        this.setBookingDataService.startPollingForKitBookingStatus(setBooking);
      }
    }
  }

  private _handleMobileNavigation(): void {
    if ((this.device.isMobileDevice || 
         this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent) && 
        this.uiService.activitiesPageTab !== 'plans') {
      this.activityService.selectedActivity = undefined;
      this.uiService.showRightPane = false;
      this.navService.setChildNavRightPaneView(false);
      this.activityService.shouldScrollToPrevSelectedActivity = !this.activityService.didOpenDetailPageFromAgendaPage;
      
      if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent) {
        this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView);
      }
      
      if (this.agendaFooterService.actSegment === "week" || 
          this.activityService.newHomeView == 'calendarView') {
        this.events.publish('weekview:RefreshUI');
      }
      
      this.events.publish('scrollToDate');
    }
  }

  public closepage() {
    this.events.publish('initTodo');
    
    // Handle cancel done on activity details
    if (this._handleCancelDoneOnActivityDetails()) {
      return;
    }
    
    // Handle timeline activity refresh
    this._handleTimelineActivityRefresh();
    
    // Handle user state and appeal details
    this._handleUserStateAndAppealDetails();

    if (this.returnToUnderlyingPage) {
      const restore = this.restoreOnClose || {};
      this.activityService.selectedActivity = restore.activity;
      if (restore.activeView !== undefined) {
        this.uiService.activeView = restore.activeView;
      }
      if (restore.showRightPane !== undefined) {
        this.uiService.showRightPane = restore.showRightPane;
      }
      if (restore.childNavRightPane !== undefined) {
        this.navService.setChildNavRightPaneView(restore.childNavRightPane);
      }
      this.navService.popChildNavPageWithPageTracking();
      return;
    }

    // Handle layover push view
    if (this._handleLayoverPushView()) {
      return;
    }
    
    // Handle page specific navigation
    if (this._handlePageSpecificNavigation()) {
      return;
    }
    
    // Handle mobile navigation
    this._handleMobileNavigation();
    
    this.activityService.didOpenDetailPageFromAgendaPage = false;
  }

  private async showSelectList<Tid, Ttitle>(data: { id: Tid, title: Ttitle }[], orderOption?: { orderBy: 'title' | 'id' | '$', ascending?: boolean }) {

    let selectListPopoverModel: IndDropdownListDetailModel = {
      id: 'select-list-popover',
      data: data as any
    };

    const target = event?.currentTarget ?? event?.target;

    let ev: any = target ? { target } : undefined;
    // Handling popover launch from more options popover scenario
    if (!ev || ev instanceof CustomEvent) {
      ev = this.footerService.getFakeMouseEventForPopoverDerivedFromMoreOptionsButton(this.footerEl.nativeElement);
    }

    let popover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: selectListPopoverModel },
      cssClass: 'dropdown-list-view',
      event: ev
    });
    await popover.present();
    let dismissFn = await popover.onDidDismiss()
    const result = dismissFn.data;
    if (result) {
      result.selectedItem = result.selectedItem || result.selectedItems?.[0];
    }
    return result;
  }
  async sendMeetingURL(ev) {
    if (ev) ev.stopPropagation();
    if (this.activityService.selectedActivity.isCompleted || this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings) return;
    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant('NO_INTERNET_CONNECTION'), 'Meeting Details', 'top', ToastStyle.DANGER);
      return;
    }

    const hasRemoteFeature = this.features.remoteFeatureEnabled || this.features.teamsMeetingEnabled;
    const hasCalendarInviteFeature = this.authService.hasFeatureAction(FeatureActionsMap.MEETING_CALENDAR_INVITE);

    if (hasCalendarInviteFeature && !hasRemoteFeature) {
      await this.createCalendarInviteModal();
    } else {
    const channelPopoverData = await this.dms.channelList.pipe(map(channels => channels.map(channel => (channel))), first(),).toPromise();
    let channelPopoverDataWithoutExternalChannel: any[] = [];

    if (hasCalendarInviteFeature) {
      this.insertCalendarInviteAsChannel(channelPopoverData);
    }

    channelPopoverData.forEach(value => {
      let translatedChannel = this.emailService.translateChannelType(value.title)
      value.title = translatedChannel;
      if (!value.indskr_externalchannel) {
        channelPopoverDataWithoutExternalChannel.push(value);
      }
    });
    const selectedChannel: any = !channelPopoverData || channelPopoverData.length == 0 ? undefined : channelPopoverData.length == 1 ? {selectedItem: channelPopoverData[0]} : await this.showSelectList(channelPopoverDataWithoutExternalChannel);
    if (selectedChannel && selectedChannel.selectedItem) {
      if (selectedChannel.selectedItem.channelType === 'Calendar Invite') {
        await this.createCalendarInviteModal();
      } else {
      this.emailService.isRemoteEmail = true;
      this.createEmailInMeeting(selectedChannel?.selectedItem, EmailTemplateType.RemoteURL);
      }
    }
    }
    return;
  }
  private insertCalendarInviteAsChannel(channelPopoverData: any[]) {
    if (Array.isArray(channelPopoverData)) {
      channelPopoverData.unshift({
        activityType: 0,
        channelType: 'Calendar Invite',
        id: 'calendar-invite',
        title: this.translate.instant('CALENDAR_INVITE')
      });
    }
  }
  private async createCalendarInviteModal() {
    if (!this.calendarInviteModalHandle) {
      // iOS safari is not displaying the modal randomly and couldn't find the root cause.
      // As a workaround, forced no animation & added CSS rules (by appending calendar-invite-modal class)
      // so that functionality isn't broken.
      const cssClass = this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent && !this.device.isMobileDevice? ['inMeetingAllocation', 'calendar-invite-modal', 'HomeScreen'] : ['inMeetingAllocation', 'calendar-invite-modal'];
      this.calendarInviteModalHandle = await this.modalCtrl.create({ animated: false, component: InMeetingAllocationComponent, componentProps: { type: 'Calendar Invite' }, backdropDismiss: false, cssClass: cssClass })
      await this.calendarInviteModalHandle.present();
      this.calendarInviteModalHandle.onDidDismiss().then((data) => {
        this.calendarInviteModalHandle = undefined;
      });
    }
  }

  sendMeetingURL_old(ev) {
    if (ev) ev.stopPropagation();
    if (this.activityService.selectedActivity.isCompleted || this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings) return;
    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant("NO_INTERNET_CONNECTION"), 'Meeting Details', 'top', ToastStyle.DANGER);
      return;
    }
    if (this.activityService.selectedActivity) {
      this.emailtemplateService.emailContacts = (this.activityService.selectedActivity['contacts']) ? this.activityService.selectedActivity['contacts'].slice() : [];
    }
    if (this.isLayoverPushView && this.layoverViewPushedFrom) {
      if (this.layoverViewPushedFrom == 'AccountManagementTool') {
        this.navService.pushChildNavPageWithPageTracking(PageName.RemoteURLEmailTemplate, PageName.RemoteURLEmailTemplate, PageName.AccountManagementPageComponent, { from: 'AccountManagementTool' });
        return;
      }
    }
    this.uiService.prevView = 'Appointment';
    this.uiService.showNewActivity = false;
    this.uiService.activeView = 'EmailTemplate';


    if (this.device.isMobileDevice) {
      this.navService.pushWithPageTracking(PageName.RemoteURLEmailTemplate, PageName.RemoteURLEmailTemplate);
    }
  }

  get isLocationMandatory(): boolean {
    return this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_APPOINTMENT_GA_LOCATIONMANDATORY) === true;
  }

  private _isMeetingLocationEmpty(): boolean {
    const location = this.activityService.selectedActivity?.location;
    return !location || location == 'No Location' || location == this.translate.instant('NO_LOCATION');
  }

  async handleLocationField(myEvent) {
    if (this._blockIfSingleAoHasLocation()) return;
    if (this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings || this.isReadOnlyRecommendedMeeting) return;
    if (!(this.activityService.selectedActivity instanceof AppointmentActivity)) return;
    const meeting = this.activityService.selectedActivity;
    if (meeting.state == MeetingActivityState.Completed) return;

    this.uiService.showNewActivity = false;

    const LIVE_TIME_ID = 'location-live-time';
    const addresses = await this._getMeetingLocationAddresses();
    const liveTimeUrl = this._hasLiveTimeOption() ? this._liveTimeUrl() : null;
    if (isEmpty(addresses) && !liveTimeUrl) {
      this.notificationService.notify(this.translate.instant('NO_ADDRESS_FOUND'), 'Meeting Details', 'top', ToastStyle.INFO);
      return;
    }

    const listData = addresses.map(address => ({
      title: address.compositeAdd,
      id: address.addressId || address.compositeAdd,
      isSelected: address.compositeAdd == meeting.location,
    }));
    if (liveTimeUrl) {
      listData.unshift({
        title: this.translate.instant('ACTIVITY_DETAILS_LIVE_TIME'),
        id: LIVE_TIME_ID,
        isSelected: meeting.location == liveTimeUrl,
      });
    }
    const dropdownListDetail: IndDropdownListDetailModel = {
      id: 'location-select',
      isMultipleSelectionEnabled: false,
      data: listData,
    };

    this.locationPopover = await this.popoverCtrl.create({ component: IndDropdownListComponent, componentProps: { viewData: dropdownListDetail }, cssClass: 'account-plan-select', event: myEvent });
    await this.locationPopover.present();
    await this.locationPopover.onDidDismiss().then(async (data) => {
      if (data && data.data && data.data.selectedItems && data.data.selectedItems.length == 1) {
        const selectedId = data.data.selectedItems[0].id;
        if (liveTimeUrl && selectedId == LIVE_TIME_ID) {
          // Live Time stores the meeting URL as the location; pass it as an object so
          // _handleLocationComponentCallback skips the address-to-coords lookup.
          if (meeting.location != liveTimeUrl) {
            await this._handleLocationComponentCallback({ compositeAdd: liveTimeUrl });
          }
        } else {
          const selectedAddress = addresses.find(a => (a.addressId || a.compositeAdd) == selectedId);
          if (selectedAddress && selectedAddress.compositeAdd != meeting.location) {
            await this._handleLocationComponentCallback(selectedAddress);
          }
        }
      }
      this.locationPopover = undefined;
    });
  }

  // Mirrors LocationComponent.hasMeetingURL(): the "Live Time" option lets the rep set
  // the remote/Teams meeting URL as the location.
  private _hasLiveTimeOption(): boolean {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const useAccountAddressesOnly = this.isGpsEnabled || !!(this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress']);
    const hasRemoteFeature = this.authService.hasFeatureAction(FeatureActionsMap.REMOTE_FEATURE) || this.authService.hasFeatureAction(FeatureActionsMap.TEAMS_MEETING);
    return hasRemoteFeature && this.from != 'EventsToolPage'
      && ((!isEmpty(meeting.meetingURL) && !useAccountAddressesOnly) || !isEmpty(meeting['indskr_teamslink']));
  }

  private _liveTimeUrl(): string {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    return !isEmpty(meeting['indskr_teamslink']) ? meeting['indskr_teamslink'] : meeting.meetingURL;
  }

  // Mirrors LocationComponent's address sourcing: account-only when GPS or the
  // indskr_populateaccountaddress BU config is on, otherwise the meeting's HCP
  // contact addresses plus account addresses.
  private async _getMeetingLocationAddresses(): Promise<Array<{ addressId: string; compositeAdd: string; customerAddressID: string; latitude: string; longitude: string }>> {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const useAccountAddressesOnly = this.isGpsEnabled || !!(this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress']);
    const addresses: Array<{ addressId: string; compositeAdd: string; customerAddressID: string; latitude: string; longitude: string }> = [];
    const addAddress = (addressId: string, item: any) => {
      if (isEmpty(addressId) || addresses.some(a => a.addressId === addressId)) return;
      addresses.push({
        addressId,
        compositeAdd: item['indskr_address.indskr_composite'] || '',
        customerAddressID: item['indskr_indskr_customeraddress_v2.indskr_indskr_customeraddress_v2id'] || '',
        latitude: item['indskr_address.indskr_latitude'] || '',
        longitude: item['indskr_address.indskr_longitude'] || '',
      });
    };

    const accountIds = meeting.accounts.map(account => account.id);
    if (accountIds.length) {
      let rawAccountsData = await this.disk.retrieveFromChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
      if (!rawAccountsData) {
        const temp = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
        rawAccountsData = temp?.raw;
      }
      if (Array.isArray(rawAccountsData)) {
        rawAccountsData.forEach(item => {
          if (item.hasOwnProperty('accountid') && accountIds.some(id => id == item['accountid'])) {
            addAddress(item['indskr_indskr_customeraddress_v2.indskr_address'] || '', item);
          }
        });
      }
    }

    if (!useAccountAddressesOnly) {
      const contactIds = meeting.contacts.map(contact => contact.ID);
      if (contactIds.length) {
        const rawData = await this.disk.retrieve(OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
        if (rawData && rawData.raw && Array.isArray(rawData.raw)) {
          rawData.raw.forEach(item => {
            if (item.hasOwnProperty('contactid') && contactIds.some(id => id == item['contactid'])) {
              addAddress(item['indskr_indskr_customeraddress_v2.indskr_address'] || '', item);
            }
          });
        }
      }
    }

    return uniqBy(addresses.filter(a => !isEmpty(a.compositeAdd)), 'compositeAdd');
  }

  openPresentations() {
    if (!this.isReadOnlyJointMeeting) {
      this.trackingService.tracking('MeetingAddPresentation', TrackingEventNames.ACTIVITY)
      this.uiService.prevView = 'Appointment';
      this.presentationService.viewMode = PresentationView.ADDTOMEETING;
      this.navService.pushWithPageTracking(PageName.PresentationPageComponent, PageName.PresentationPageComponent, null, PageName.PresentationPageComponent);
    }
  }

  /**
   *
   *
   * @returns
   * @memberof ActivitiesDetailsPaneComponent
   * updates the meeting notes for a selected activity
   */
  public async saveNotes() {
    const currentNotes = this.activityService.selectedActivity.notes;

    if (this.preSavedNotes == currentNotes || (currentNotes && currentNotes.trim().length == 0)) return;
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      this.trackingService.tracking('MeetingNotesUpdate', TrackingEventNames.ACTIVITY)
      let currentAppointmentActivity: AppointmentActivity = this.activityService.selectedActivity;

      const payload = new UpdateMeetingPayload();
      payload.notes = this.activityService.selectedActivity.notes;

      this.activityService.getActivityByID(this.activityService.selectedActivity.ID).notes = this.activityService.selectedActivity.notes;

      this.activityService.getDisplayctivityByID(this.activityService.selectedActivity.ID).notes = this.activityService.selectedActivity.notes;

      this.meetingDataService.updateMeeting(this.activityService.selectedActivity, payload);

      this.preSavedNotes = this.activityService.selectedActivity.notes;
    }
    this.isNotesDirty = false;
  }

  cancelNotes() {
    if (this.preSavedNotes) {
      this.activityService.updateSelectedActivityProps({ notes: this.preSavedNotes });
    } else {
      this.activityService.updateSelectedActivityProps({ notes: '' });
    }
    this.isNotesDirty = false
  }

  onNotesFocus() {
    this.preSavedNotes = this.activityService.selectedActivity.notes;
  }

  iconClick(id, event) {

    if (id === '') {
      this.openURLPopover(event);
    } else if (id === 'x') {
      this.onLiveMeetingLinkCopyClick(event);
    }

  }

  async onTeamsLinkCopy(ev) {
    if (ev) ev.stopPropagation();
    this.copyTeamsLinkToClipboard();
  }

  async openURLPopover(ev) {
    let popover = await this.popoverCtrl.create({
      component: PopoverComponent, componentProps: { field: 'LiveTimeURL' },
      cssClass: "livetimeURL-popover", event: ev
    })
    popover.present();
  }
  async openTeamsURLPopover(ev) {
    let popover = await this.popoverCtrl.create({
      component: PopoverComponent, componentProps: { field: 'TeamsMeetingUrl' },
      cssClass: "livetimeURL-popover", event: ev
    })
    popover.present();
  }
  async onLiveMeetingLinkCopyClick(ev) {
    if (ev) ev.stopPropagation();
    if (this.activityService.selectedActivity.isCompleted || this.activityService.selectedActivity.isReopened || this.isEffectiveDiffPosition) return;

    const listData = [
      {
        id: 'participants',
        title: this.translate.instant(this.nativeShareAvailable ? 'SHARE_PARTICIPANTS_LINK' : 'COPY_PARTICIPANTS_LINK')
      },
      {
        id: 'coVisitors',
        title: this.translate.instant(this.nativeShareAvailable ? 'SHARE_COVISITORS_LINK' : 'COPY_COVISITORS_LINK')
      }
    ];
    const data: any = await this.showSelectList(listData, { orderBy: '$' }); // '$' makes pipe to not sort at all.
    if (data && data.selectedItem.id === 'participants') {
      this.copyToClipboard();
    } else if (data && data.selectedItem.id === 'coVisitors') {
      this.copyToClipboard(true);
    }
  }

  copyTeamsLinkToClipboard() {
    this.trackingService.tracking('MeetingCopyURL', TrackingEventNames.ACTIVITY)
    if (this.activityService.selectedActivity['indskr_teamslink']) {
      const url = this.activityService.selectedActivity['indskr_teamslink'];
      if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
        this.clipboard.copy(url);
        this.notificationService.notify(this.translate.instant('LINK_COPIED_TO_CLIPBOARD'), "activity-details", "top", "", 3000, true);
      } else {
        this.copyTextToClipboard(url);
      }
    }
  }

  copyToClipboard(isForCoVisitor = false) {
    this.trackingService.tracking('MeetingCopyURL', TrackingEventNames.ACTIVITY)
    if (this.activityService.selectedActivity['meetingURL']) {
      const url = !isForCoVisitor ? this.activityService.selectedActivity['meetingURL'] : this.activityService.selectedActivity['meetingURL'] + '/covisitor';
      const shareData = { url, title: this.activityService.selectedActivity.subject, text: this.translate.instant("INVITE_YOU_TO_CONNECT_REMOTELY") };
      try {
        if (this.nativeShareAvailable && (!(navigator as any).canShare || (navigator as any).canShare(shareData))) {
          navigator.share(shareData)
        } else {
          if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
            this.clipboard.copy(url);
            this.notificationService.notify(this.translate.instant('LINK_COPIED_TO_CLIPBOARD'), "activity-details", "top", "", 3000, true);
          } else {
            this.copyTextToClipboard(url);
          }
        }
      } catch (err) {
        console.error('Oops, unable to copy', err);
      }
    }
  }
  // tslint:disable-next-line:prefer-function-over-method
  copyTextToClipboard(text) {
    let txtArea = document.createElement("textarea");

    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = text;
    document.body.appendChild(txtArea);
    txtArea.focus();
    txtArea.select();
    try {
      let successful = document.execCommand('copy');
      let msg = successful ? 'successful' : 'unsuccessful';
      if (successful) {
        document.body.removeChild(txtArea);

        this.notificationService.notify(this.translate.instant('LINK_COPIED_TO_CLIPBOARD'), "activity-details", "top", "", 3000, true);
        return true;
      }
    } catch (err) {
      console.error('Oops, unable to copy');
    }
    document.body.removeChild(txtArea);

    return false;
  }

  scrollToTop() {
    let scrollIntoViewOptions: object = {
      behaviour: "smooth"
    };
    let ele = document.getElementById('listScroll');
    if (ele) {
      ele.scrollIntoView(scrollIntoViewOptions);
    }
  }

  get meetingURL(): string {
    //Local testing purposes
    if (this.authService.userConfig.activeInstance.friendlyName === "Dev-Cystine") {
      let vanityURL: string = this.activityService.selectedActivity.meetingURL;
      return vanityURL
    } else {
      return this.activityService.selectedActivity.meetingURL;
    }
  }

  get teamsLink(): string {
      return isEmpty(this.activityService.selectedActivity['indskr_teamslink']) ? null : this.activityService.selectedActivity['indskr_teamslink'];
  }
  private async updateAccompaniedUsers(raw: AccompainedUser[]) {
    if(!this.device.isOffline){
      await this.displayLoader();
    }
    await this.meetingDataService.addRemoveAccompaniedUsers(raw).then(e => {
      this.ioUserSelection.setUserSelectedData(undefined);
    });
    this.resetCovisitorComplianceAck();
    if(!this.device.isOffline){
      this.dismissLoader();
      // To dismiss the loader after certain delay
      setTimeout(() => {
        this.dismissLoader();
      }, 5000);
    }
  }

  private async updateAdditionalFields(raw: any[]) {
    this.appConfigLookupValue = raw[0].name;
    this.ioUserSelection.setAdditionalConfigData(undefined);
    var appConfigFields: ConfiguredFields = {
      fieldName: raw[0].fieldName,
      datatype: 'Lookup',
      value: raw[0].id,
      stringValue: raw[0].name,
      fieldType: 'Lookup'
    };
    this.saveAdditionalConfigFields(appConfigFields);
  }

  public get jointMeetingStatus(): boolean {
    if (this.activityService.selectedActivity != undefined && this.activityService.selectedActivity != null) {
      //If the meeting has been marked as joint meeting
      //Handle case where joint meeting flag is set as undefined.
      if (this.activityService.selectedActivity['isJointmeeting'] || (this.activityService.selectedActivity['accompaniedUserList'] && this.activityService.selectedActivity['accompaniedUserList'].length > 0)) {
        let meetingOwnerId = this.activityService.selectedActivity['meetingOwnerId'];
        let userId = this.authService.user.systemUserID;
        //owner
        if (this.activityService.isMeetingOwner || (this.isCovisitor &&  this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS)) {
          return false;
        }
        else
          return true;
      }
      //owner is the meeting creator
      else {
        return false;
      }
    }
    else
      return false;
  }

  openCoachingReportDetails(report: Report) {
    if (this.enableCoachingView) return;
    this.trackingService.tracking('CoachingMeetingDetails', TrackingEventNames.COACHING);
    let selectedReport: Report = JSON.parse(JSON.stringify(report));
    this.coachingReportService.selectedReport.next(selectedReport);
    this.coachingReportService.coachingViewtype = COACHING_VIEW_TYPE.FROM_MEETING;
    this.coachingReportService.activeTab = "teamCoaching";
    this.uiService.prevView = this.uiService.activeView;
    if(this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent) {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
    } else if(this.navService.getCurrentMasterPageName() === PageName.ContactPageComponent) {
      this.uiService.activeView = 'ContactPageRightPaneNav';
    } else if(this.navService.getCurrentMasterPageName() === PageName.AccountPageComponent) {
      this.uiService.activeView = 'AccountPageRightPaneNav';
    }
    this.navService.pushChildNavPageWithPageTracking(PageName.CoachingDetailsComponent, PageName.CoachingDetailsComponent, PageName.ActivitiesDetailsPaneComponent);
    this.activityService.lastActivity = this.activityService.selectedActivity.ID;
    this.uiService.showFieldCoaching = true;
    this.footerService.initButtons(FooterViews.CoachingDetails);
    if ((report.statuscode === 548910001 || report.statuscode === 548910002 || report.statuscode === 548910003) && !this.coachingReportService.isOffline(report)) {
      this.coachingReportService.checkCoachingOnline(report).then(() => {
        this.setCoachings();// Reset status in coachings list
      });
    }
  }

  public get enableCoachingView() {
    return this.navService.getPreviousPageName() === PageName.CoachingComponent ||
      this.navService.getPreviousPageName() === PageName.CoachingActivitiesComponent;
  }

  public saveUserNotes() {
    alert(this.translate.instant('NOTES_SAVED'));
  }

  // ─── Samples & Materials (Drops / Request / Materials sub-tabs) ────────────
  // NOTE (OMNI-61002, Task 5 — UI shell only): this section is being restructured
  // from a standalone "Sample Drop" section into a unified "Samples & Materials"
  // section with an internal sub-tab bar. The Drops tab below is the EXACT same
  // Sample Drop content/logic as before — only its container and header changed.
  // The Request tab is a static placeholder in this task; real SDR wiring lands
  // in Task 6, once the SDR data layer + inline component exist (Tasks 1-4).
  // Materials is a permanent visual-only stub — no backing feature (see plan).

  samplesMaterialsSectionHeader: IndSectionHeaderViewDataModel;
  activeSamplesMaterialsSubTab: SamplesMaterialsSubTab = 'drops';

  /**
   * Returns `true` when the Sample Drop (Drops tab) content should be shown.
   * Visible by default; hidden only when the selected meeting format lists `SampleDrop`
   * in `hideInlineActivities` AND it is NOT covered by `mandatoryInlineActivities`
   * (mandatory rules take precedence).
   */
  get isSampleDropSectionVisible(): boolean {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    return !this.meetingMandatoryConfig.shouldHideInlineActivityForFormat(formatId, 'SampleDrop');
  }

  /**
   * Returns `true` when the Sample Delivery Request (Request tab) content should be shown.
   * Same precedence rule as `isSampleDropSectionVisible`: hidden only when the selected
   * meeting format lists `SampleDeliveryRequest` in `hideInlineActivities` AND it is NOT
   * covered by `mandatoryInlineActivities`.
   */
  get isSdrSectionVisible(): boolean {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    return !this.meetingMandatoryConfig.shouldHideInlineActivityForFormat(formatId, 'SampleDeliveryRequest');
  }

  /**
   * Returns `true` when the Materials tab (Promotional Material) content
   * should be shown. Same precedence rule as the other two tabs: hidden only
   * when the selected meeting format lists `PromotionalMaterial` in
   * `hideInlineActivities` AND it is NOT covered by `mandatoryInlineActivities`.
   * NOTE: this key must match `MandatoryInlineActivityRule.activityType`'s
   * documented value exactly (`PromotionalMaterial`, not `PromoMaterial`) —
   * BU config compares by this string, and a mismatch here silently no-ops
   * the whole hide mechanism for this format.
   */
  get isPromoMaterialSectionVisible(): boolean {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    if (this.activityService.isRemoteChannelEnabled(formatId)) return false;
    return !this.meetingMandatoryConfig.shouldHideInlineActivityForFormat(formatId, 'PromotionalMaterial');
  }

  get isExpenseSectionVisible(): boolean {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    return this.meetingExpenseService.isSectionVisibleForFormat(formatId);
  }

  get isSelectedMeetingCanceled(): boolean {
    return Number(this.activityService.selectedActivity?.state) === MeetingActivityState.Canceled;
  }

  get isExpenseSectionRequired(): boolean {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const isOpen = meeting?.state !== MeetingActivityState.Completed && meeting?.state !== MeetingActivityState.Canceled;
    return isOpen && !this.isExpenseSectionReadOnly
      && this.meetingMandatoryConfig.getMandatoryRulesForFormat(meeting?.indskr_activitytype)
        .some(rule => rule.activityType === MEETING_EXPENSE_INLINE_ACTIVITY_KEY && rule.mandatory !== false);
  }

  get expenseGracePeriodDays(): number {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    return this.meetingExpenseService.gracePeriodDays(formatId);
  }

  // Null means the rep was blocked or backed out; the format must not change.
  private async resolveFormatChangeForExpenses(newFormatId: string): Promise<FormatChangeExpenseAction | null> {
    const meetingId = this.activityService.selectedActivity?.ID;
    const action = await this.meetingExpenseService.formatChangeAction(meetingId, newFormatId, !this.device.isOffline);
    if (action === 'block') {
      this.notificationService.notify(this.translate.instant('MEETING_EXPENSE_FORMAT_CHANGE_BLOCKED'), 'Meeting Details');
      return null;
    }
    if (action === 'confirmScrap') {
      const res = await this.alertService.showAlert(
        {
          title: this.translate.instant('MEETING_EXPENSE_FORMAT_CHANGE_TITLE'),
          message: this.translate.instant('DRAFT_MEETING_HAS_OPEN_EXPENSES_POPUP_MESSAGE'),
        },
        this.translate.instant('CONFIRM'),
      );
      if (res?.role !== 'ok') return null;
    }
    return action;
  }

  // Fire-and-forget: completion must never wait on, or fail because of, the expense sweep.
  private async sweepMeetingExpenses(meeting: AppointmentActivity): Promise<void> {
    if (!meeting?.ID || !this.activityService.isMeetingOwner) return;
    if (!this.meetingExpenseService.isSectionVisibleForFormat(meeting.indskr_activitytype)) return;
    try {
      const result = await this.meetingExpenseService.submitCompleteDrafts(meeting.ID, !this.device.isOffline);
      if (result.incomplete > 0) {
        this.notificationService.notify(
          this.translate.instant('MEETING_EXPENSE_INCOMPLETE_NOT_SUBMITTED', { count: result.incomplete }),
          'Meeting Details', 'top', ToastStyle.INFO,
        );
      }
      if (result.failed > 0) {
        this.notificationService.notify(
          this.translate.instant('MEETING_EXPENSE_SWEEP_FAILED'),
          'Meeting Details', 'top', ToastStyle.DANGER,
        );
      }
    } catch (err) {
      console.error('ActivitiesDetailsPane.sweepMeetingExpenses failed', err);
      this.notificationService.notify(
        this.translate.instant('MEETING_EXPENSE_SWEEP_FAILED'),
        'Meeting Details', 'top', ToastStyle.DANGER,
      );
    }
  }

  // Only the owner creates expenses; co-visitors (any access level) and managers see them read-only.
  get isExpenseSectionReadOnly(): boolean {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    return !this.activityService.isMeetingOwner
      || this.enableReadonlyViewForMeetings
      || this.backgroundUploadInProgress
      || this.isReadOnlyJointMeeting
      || !!meeting?.isDiffPosition;
  }

  /** How many of Drops/Request/Materials are actually visible for the selected format. */
  get visibleSamplesMaterialsTabsCount(): number {
    return (this.features.sampleDropEnabled && this.isSampleDropSectionVisible ? 1 : 0)
      + (this.features.sampleDeliveryRequestEnabled && this.isSdrSectionVisible ? 1 : 0)
      + (this.features.promoMaterialEnabled && this.isPromoMaterialSectionVisible ? 1 : 0);
  }

  /**
   * Translate key for the sole visible tab's name when
   * `visibleSamplesMaterialsTabsCount === 1` — a tab bar with a single option
   * is never useful, so this becomes the section header's own title instead
   * of the generic "Samples & Materials" (see _initSamplesMaterialsSectionHeader),
   * rather than rendering as a separate subtitle line underneath it.
   */
  get singleVisibleSamplesMaterialsTabLabelKey(): string {
    if (this.features.sampleDropEnabled && this.isSampleDropSectionVisible) return 'SAMPLE_DROP';
    if (this.features.sampleDeliveryRequestEnabled && this.isSdrSectionVisible) return 'SAMPLE_DELIVERY_REQUESTS';
    return 'PROMOTIONAL_MATERIAL';
  }

  /**
   * Single header for the unified Samples & Materials section. No "+" control
   * here — each tab owns its own "+ New" affordance inline in its content
   * (the Drops tab's allocation-tab-bar; Materials reuses the same pattern,
   * scoped to isPromoMaterial allocations; the Request tab's own tab-bar).
   */
  private _initSamplesMaterialsSectionHeader() {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    // A format change can hide whichever tab is currently active (its button
    // disappears), or un-hide one that was previously forced to 'materials' —
    // activeSamplesMaterialsSubTab doesn't correct itself either way. Re-validate
    // it against the CURRENT format on every call: if it no longer matches a
    // visible tab, fall back to the first visible one in tab-bar order (Drops,
    // Materials, Request — see resolveDefaultSubTab).
    const isSampleDropVisible = this.features.sampleDropEnabled && this.isSampleDropSectionVisible;
    const isSdrVisible = this.features.sampleDeliveryRequestEnabled && this.isSdrSectionVisible;
    const isMaterialsVisible = this.features.promoMaterialEnabled && this.isPromoMaterialSectionVisible;
    const isActiveTabStillValid =
      (this.activeSamplesMaterialsSubTab === 'drops' && isSampleDropVisible)
      || (this.activeSamplesMaterialsSubTab === 'request' && isSdrVisible)
      || (this.activeSamplesMaterialsSubTab === 'materials' && isMaterialsVisible);
    if (!isActiveTabStillValid) {
      this.activeSamplesMaterialsSubTab = resolveDefaultSubTab({
        dropsVisible: isSampleDropVisible,
        materialsVisible: isMaterialsVisible,
        requestVisible: isSdrVisible,
      });
    }
    const isSectionContentGateOpen = !this.enableReadonlyViewForMeetings
      && this.activityService.selectedActivity.state !== MeetingActivityState.Completed
      && this.activityService.selectedActivity.state !== MeetingActivityState.Canceled
      && !this.isEffectiveDiffPosition;
    const mandatoryRules = this.meetingMandatoryConfig.getMandatoryRulesForFormat(formatId);
    const isSampleDropRequired = isSectionContentGateOpen
      && mandatoryRules.some(r => r.activityType === 'SampleDrop' && r.mandatory !== false);
    const isSdrRequired = isSectionContentGateOpen
      && mandatoryRules.some(r => r.activityType === 'SampleDeliveryRequest' && r.mandatory !== false);
    const isMaterialsRequired = isSectionContentGateOpen
      && mandatoryRules.some(r => r.activityType === 'PromotionalMaterial' && r.mandatory !== false);
    // A single visible tab shows its own specific name as the section title
    // (e.g. "Sample Drop", "Sample Delivery Requests") instead of the generic
    // "Samples & Materials" — collapses what used to be a title + separate
    // subtitle line into just the one header.
    const sectionTitleKey = this.visibleSamplesMaterialsTabsCount === 1
      ? this.singleVisibleSamplesMaterialsTabLabelKey
      : 'SAMPLES_AND_MATERIALS';
    this.samplesMaterialsSectionHeader = {
      id: 'samples-materials-section-header',
      title: this.translate.instant(sectionTitleKey),
      isRequired:
        (this.activeSamplesMaterialsSubTab === 'drops' && isSampleDropRequired)
        || (this.activeSamplesMaterialsSubTab === 'request' && isSdrRequired)
        || (this.activeSamplesMaterialsSubTab === 'materials' && isMaterialsRequired),
      controls: [],
    };

    this._updateMeetingContactsRef();
  }

  /**
   * KNOWN LIMITATION: switching away from an in-progress Draft SDR (to
   * another sub-tab here, or to an existing SDR tab via onSdrTabChange
   * below) and back destroys and recreates InlineSampleDeliveryRequestComponent
   * (it sits behind this pane's @if), and create-on-New always creates a
   * FRESH Draft header on remount — there is no "resume the already-open
   * Draft for this meeting" check. This silently orphans the abandoned
   * Draft (its data is still safely persisted server-side/locally, just
   * unreachable in this pane until the meeting is closed and reopened) and
   * creates a new one in its place. Not fixed here — would need
   * create-on-New to check hasOpenSdrForMeeting and re-fetch/resume the
   * existing Draft instead of always creating fresh. Tracked as a
   * follow-up, not silently inherited.
   */
  onSamplesMaterialsSubTabChange(tab: SamplesMaterialsSubTab) {
    this.activeSamplesMaterialsSubTab = tab;
    this._initSamplesMaterialsSectionHeader();
  }

  // ──────────────── Sample Delivery Requests (Request sub-tab, OMNI-61002) ────────────────

  currentSdrsInMeeting: SampleDeliveryRequest[] = [];
  selectedSdrId: string | null = null;
  isCreatingSdr = false;
  /** id of the SDR currently being scrapped — mirrors scrappingAllocationId:
   *  disables its tab and hides its own close icon while the scrap call is
   *  in flight (see onSdrScrapFromTab). */
  scrappingSdrId: string | null = null;
  /** Bound for template use — colours the tab-bar dot by the SDR's business status.
   *  2-color variant, matching Sample Drop's own tab-dot exactly (blue = open,
   *  green = done) — see getSdrInlinePillColor's own doc comment for why this
   *  is a separate function from getSdrStatusColor, which the standalone
   *  detail view's status badge still uses unchanged. */
  getSdrStatusColor = getSdrInlinePillColor;
  /** Tab-pill label: the dedicated SDR business number (indskr_sdrnumber) when
   *  present, else the same "generic label + contact name" fallback the
   *  standalone detail view/customer360 tile use via sdrDisplayTitle — never
   *  item.title (indskr_name), which is a different autonumber this pill
   *  doesn't display. */
  sdrPillLabel(item: SampleDeliveryRequest): string {
    return sdrDisplayTitle(item.sdrNumber, this.translate.instant('SAMPLE_DELIVERY_REQUEST'), item.contactName);
  }
  /** Exposed so the template can compare item.statusCode against it — an
   *  imported enum member can't be referenced directly from the template. */
  readonly sdrStatusActive = SdrStatus.Active;
  /** Set by onSdrTabChange when switching to an Active (Draft, resumable)
   *  SDR tab — the fully-hydrated record (fetched via fetchSdrById, which
   *  includes notes) that gets bound to the editable
   *  InlineSampleDeliveryRequestComponent instead of the slim list-row
   *  object, which never carries notes (the Request-tab list query has no
   *  note join at all). Null while switching TO a Submitted/read-only item
   *  (which hydrates its own notes lazily, unaffected by this), or before
   *  any resume fetch has completed. */
  resumingSdr: SampleDeliveryRequest | null = null;

  /** SDRs to render in the Request tab (fetchSdrsForMeeting already excludes inactive). */
  get activeSdrsInMeeting(): SampleDeliveryRequest[] {
    return this.currentSdrsInMeeting || [];
  }

  get sdrsInSelectedMeeting(): SampleDeliveryRequest[] {
    return this.currentSdrsInMeeting;
  }
  set sdrsInSelectedMeeting(list: SampleDeliveryRequest[]) {
    this.currentSdrsInMeeting = list || [];
    this._initSamplesMaterialsSectionHeader();
    // Drop a selection left over from a DIFFERENT meeting. This pane instance
    // survives switching between activities (the allSdrs$ subscription re-reads
    // selectedActivity on every emission precisely because of that), but
    // `selectedSdrId` was only ever assigned, never cleared. Once it held any
    // id, the auto-select below could not fire again — and the detail body only
    // renders `@if (selectedSdrId === item.id)` — so the next meeting's SDRs
    // showed a tab strip with no selected tab and no data behind it, which
    // reads as "the Active SDR is gone" (OMNI-61614). Skipped while a create is
    // in flight: createNewInlineSdr sets selectedSdrId to a draft it has not
    // finished adding to this list yet, same window onSdrTabChange guards.
    if (!this.isCreatingSdr && this.selectedSdrId
        && !this.currentSdrsInMeeting.some((s) => s.id === this.selectedSdrId)) {
      this.selectedSdrId = null;
      this.resumingSdr = null;
    }
    // Route the initial auto-select through onSdrTabChange (fire-and-forget,
    // same as the template's own (click) binding) rather than assigning
    // selectedSdrId directly — a direct assignment here bypassed the
    // Active-SDR hydration fetch entirely, so a meeting whose FIRST/only
    // existing SDR tab is a resumable Draft would auto-select it with
    // resumingSdr still null, rendering the editable form against the slim
    // list-row object (notes always []) exactly like the tab-click bug this
    // fix is otherwise addressing.
    if (!this.selectedSdrId && this.activeSdrsInMeeting.length) {
      void this.onSdrTabChange(this.activeSdrsInMeeting[0].id);
    }
    this.cdRef.markForCheck();
  }

  /**
   * Switching to an existing SDR tab. A Submitted (or otherwise non-Active)
   * item is rendered read-only from the slim list-row object as before — its
   * notes are hydrated lazily by the read-only branch's own
   * _hydrateNotesIfNeeded, which is safe there. An Active (Draft, resumable)
   * item is rendered EDITABLE instead, and must be handed the FULLY hydrated
   * record (fetchSdrById, which includes notes) — InlineSampleDeliveryRequest-
   * Component's resume path seeds its notes composer synchronously, once, at
   * creation, so a later async patch would be silently ignored (see that
   * component's _initResumeState doc comment). Hence the fetch happens here,
   * BEFORE the editable component mounts, rather than fetch-then-patch-after.
   */
  async onSdrTabChange(sdrId: string): Promise<void> {
    // Re-clicking the already-selected tab is a no-op, not a refresh
    // affordance — without this guard, a resumed Active draft would re-run
    // the whole hydrate flow on every click, and once the child component
    // actually renders editable (see inline-sample-delivery-request.html's
    // isReadOnly-gated blocks), that would resurrect _initResumeState(),
    // rebuild brand-new StagedSdrNote objects, and repopulate noteServerIds
    // keyed to them — while SdrNotesSectionComponent, already initialized
    // once per its one-shot initialStagedNotes contract, still holds the
    // ORIGINAL objects. A later note removal would then look up
    // noteServerIds with the wrong keys, silently mis-treating an
    // already-persisted note as never-synced (or vice versa).
    if (sdrId === this.selectedSdrId) return;
    // Also bail while createNewInlineSdr's own create-on-New call is still in
    // flight: unconditionally clearing isCreatingSdr here would let the "+New"
    // pill/button flip back before that call resolves, and whichever of the
    // two async chains (this hydrate fetch vs. that create call) finishes
    // last would silently stomp the other's resumingSdr/selectedSdrId — up to
    // and including binding the wrong SDR's full record to the new draft's
    // tab. The tab buttons are also disabled in the template for the same
    // window; this is the defense-in-depth backstop.
    if (this.isCreatingSdr) return;
    await this._hydrateResumingSdr(sdrId);
    this.selectedSdrId = sdrId;
  }

  /** Shared by onSdrTabChange (user-driven tab click) and onSdrScrapped
   *  (falling back to the next remaining tab after a scrap) — both need an
   *  Active (Draft, resumable) SDR handed the FULLY hydrated record before
   *  the editable component mounts, per onSdrTabChange's own doc comment
   *  above. Leaving this out of the scrap fallback (as an earlier version
   *  did) left resumingSdr null, so the [sdr] binding fell back to the slim
   *  currentSdrsInMeeting snapshot — which is never updated by inline
   *  product/qty edits — making an untouched, already-autosaved draft look
   *  like its data had vanished the instant a sibling draft was scrapped
   *  (OMNI-61545). */
  /** Last-resort read of the lazy detail cache, for when the primary hydrate
   *  returned nothing or threw. Never rejects — a failure here just means we
   *  fall through to the slim row, which is where we were headed anyway. */
  private async _cachedSdrOrNull(sdrId: string): Promise<SampleDeliveryRequest | null> {
    try {
      return (await this.sdrDataService.getCachedSdrRecord(sdrId)) ?? null;
    } catch {
      return null;
    }
  }

  private async _hydrateResumingSdr(sdrId: string): Promise<void> {
    const item = this.activeSdrsInMeeting?.find((s) => s.id === sdrId);
    if (item?.statusCode !== SdrStatus.Active) {
      this.resumingSdr = null;
      return;
    }
    this.resumingSdr = null;
    this.cdRef.markForCheck();
    try {
      const full = this.device.isOffline
        ? await this.sdrDataService.getCachedSdrRecord(sdrId)
        : await this.sdrDataService.fetchSdrById(sdrId);
      this.resumingSdr = full ?? (await this._cachedSdrOrNull(sdrId)) ?? item;
    } catch (err) {
      console.error('_hydrateResumingSdr: failed to hydrate resumed SDR', err);
      this.resumingSdr = (await this._cachedSdrOrNull(sdrId)) ?? item;
    }
    this.cdRef.markForCheck();
  }

  /**
   * Open a fresh inline SDR draft — mirrors createNewInlineAllocation: the
   * header record is created directly here (create-on-New), the tab bar
   * shows a skeleton pill while that call is in flight, and the editable
   * detail view only mounts once the record actually exists (rendered by
   * the same "Selected saved SDR" loop a resumed Active draft uses — a
   * freshly-created Draft is not a special case, just another Active SDR).
   * Deliberately does NOT clear resumingSdr/selectedSdrId up front (unlike
   * an earlier version of this method) — Allocation's equivalent never
   * resets selectedAllocationId either, so an already-open SDR just stays
   * visible, undisturbed, for the whole create call instead of the pane
   * going blank until the new draft exists.
   */
  async createNewInlineSdr(): Promise<void> {
    if (this.isCreatingSdr) return;
    // Defense-in-depth: the "+ New" button should already be hidden without
    // SAMPLE_DELIVERY_REQUESTS mapped (see the Request tab body's *ngIf), but a stale
    // activeSamplesMaterialsSubTab default (resolveDefaultSubTab picks 'request' by SDR
    // count alone, with no feature-action awareness) could still render it. Refuse the
    // actual create call regardless of how the button became reachable.
    if (!this.features.sampleDeliveryRequestEnabled) {
      console.log('[SDR-ACCESS] createNewInlineSdr blocked — SAMPLE_DELIVERY_REQUESTS feature action not mapped for this user/role.');
      return;
    }
    // Defense-in-depth: same reasoning as the feature-action check above — the
    // "+ New" button's own *ngIf already excludes a Cancelled meeting, but that
    // guard only covers isCompleted, not Canceled (a separate MeetingActivityState
    // value), so a stale render of the button must not be trusted either.
    if (this.activityService.selectedActivity?.state === MeetingActivityState.Canceled) {
      console.log('[SDR-ACCESS] createNewInlineSdr blocked — meeting is cancelled.');
      return;
    }
    this.isCreatingSdr = true;
    this._initSamplesMaterialsSectionHeader();
    this.cdRef.markForCheck();
    try {
      const meeting = this.activityService.selectedActivity;
      const contacts = this.getMeetingContacts();
      const singleContact = contacts?.length === 1 ? contacts[0] : null;
      // Also prefill the single contact's PRIMARY address/email, same as the
      // old child-owned blank-init branch used to (formerly _initState's
      // dead blank branch) — createNewInlineAllocation's own single-contact
      // prefill only sets the contact id, but SDR's create payload accepts
      // address/email up front too, so there's no reason to leave them
      // blank and make the rep re-pick something that's already on file.
      const primaryAddress = singleContact?.primaryAddress;
      const primaryEmail = singleContact?.emailAddressList?.find((e) => e.isPrimary);
      const payload: DraftSdrPayload = {
        sdrId: Guid.create().toString(),
        contactId: singleContact?.ID,
        contactName: singleContact?.fullName || undefined,
        deliveryAddress: primaryAddress?.addressId || undefined,
        // Display labels, not just ids — createSdrDraft (online) doesn't need
        // these, Dynamics' create response resolves and returns the lookups'
        // formatted display names automatically. createSdrDraftOffline has no
        // such round-trip, so without passing these through explicitly, the
        // address/email fields render blank in the UI despite the underlying
        // id being correctly set (matches how new-sample-delivery-request.
        // component.ts already derives these: primaryAddress.compositeAdd /
        // primaryEmail.emailAddress).
        deliveryAddressLabel: primaryAddress?.compositeAdd || undefined,
        email: primaryEmail?.emailAddressId || undefined,
        emailLabel: primaryEmail?.emailAddress || undefined,
        appointmentId: meeting?.ID || undefined,
      };
      const draft = this.device.isOffline
        ? this.sdrDataService.createSdrDraftOffline(payload)
        : await this.sdrDataService.createSdrDraft(payload);
      // Seed sdrService's own allSdrs cache right at creation, same as
      // Allocation Order's initiateSampleOrder calling activityService.
      // addActivity() immediately in both its online/offline branches — this
      // draft goes straight through sdrDataService, never through
      // sdrService.submit()/submitOffline(), so without this allSdrs would
      // stay unaware of it until (if ever) finalize seeds the cache. A pane
      // reload (or any other _refreshSdrsInMeeting call) before submit would
      // otherwise fully replace currentSdrsInMeeting with fetchSdrsForMeeting's
      // offline result — which reads only from allSdrs — silently dropping
      // this not-yet-submitted draft tab. Best-effort: a cache-seed failure
      // must not block draft creation, the tab already shows it locally below.
      try {
        await this.sdrService.cacheCreatedSdr(draft);
      } catch (err) {
        console.error('createNewInlineSdr: failed to seed allSdrs cache', err);
      }
      const current = (this.currentSdrsInMeeting || []).filter((s) => s.id !== draft.id);
      this.currentSdrsInMeeting = [...current, draft];
      this.selectedSdrId = draft.id;
      // Clear any stale resumingSdr left over from a PREVIOUSLY open SDR — the
      // [sdr] binding falls back to `resumingSdr ?? item`, so leaving it set
      // here would make the new draft's tab incorrectly render the old SDR's
      // data instead of the just-created one.
      this.resumingSdr = null;
    } catch (err) {
      console.error('createNewInlineSdr: create-on-New failed', err);
      this.notificationService.notify(
        this.translate.instant('ERROR_SDR_DRAFT_CREATE_FAILED'),
        'Meeting Details',
        'top',
        ToastStyle.DANGER,
        3000,
      );
    } finally {
      this.isCreatingSdr = false;
      this.cdRef.markForCheck();
    }
  }

  async onSdrSaved(saved: SampleDeliveryRequest) {
    this.isCreatingSdr = false;
    this.resumingSdr = null;
    await this._refreshSdrsInMeeting();
    this.selectedSdrId = saved?.id ?? this.selectedSdrId;
    this.cdRef.markForCheck();
  }

  /**
   * Scrap (cancel) a Draft SDR tab — mirrors onAllocationScrapFromTab.
   * Only ever reachable for an Active (Draft) item; the template's close
   * icon is gated the same way Sample Drop gates its own (not currently
   * scrapping, meeting not completed/read-only/team-view) plus
   * item.statusCode === sdrStatusActive, since a Submitted-or-later SDR is
   * a "completed order" equivalent and not scrappable via this path.
   */
  async onSdrScrapFromTab(event: MouseEvent, item: SampleDeliveryRequest): Promise<void> {
    event.stopPropagation(); // prevent tab selection
    if (item.statusCode !== SdrStatus.Active) return;
    // Defense-in-depth: mirrors createNewInlineSdr's own Cancelled guard — the scrap icon's
    // own *ngIf already excludes a Cancelled meeting, but a stale render must not be trusted.
    if (this.activityService.selectedActivity?.state === MeetingActivityState.Canceled) {
      console.log('[SDR-ACCESS] onSdrScrapFromTab blocked — meeting is cancelled.');
      return;
    }
    const confirmed = await this.alertService.showAlert(
      {
        title: this.translate.instant('SCRAP_SAMPLE_DELIVERY_REQUEST'),
        message: this.translate.instant('CONFIRM_SCRAP_SAMPLE_DELIVERY_REQUEST'),
      },
      this.translate.instant('SCRAP'),
    );
    if (confirmed?.role !== 'ok') return;
    this.scrappingSdrId = item.id;
    this.cdRef.markForCheck();
    try {
      await this.sdrService.scrapSdr(item);
      await this.onSdrScrapped(item);
    } catch (err) {
      console.error('Scrap SDR from tab failed', err);
      this.notificationService.notify(
        this.translate.instant('ERROR_SDR_SCRAP_FAILED'),
        'Meeting Details',
        'top',
        ToastStyle.DANGER,
        3000,
      );
    } finally {
      this.scrappingSdrId = null;
      this.cdRef.markForCheck();
    }
  }

  /** Mirrors onAllocationScrapped: drop the scrapped tab from the local
   *  list immediately (sdrService.scrapSdr already dropped it from its own
   *  allSdrs cache — this is the component's OWN parallel array) and
   *  reassign selectedSdrId to whatever tab (if any) is left. Unlike
   *  Allocation (whose own tab-switch has no hydration step), a fallback to
   *  a remaining Active SDR tab must go through the same
   *  _hydrateResumingSdr as a manual click — see that method's doc comment
   *  (OMNI-61545). */
  private async onSdrScrapped(scrapped: SampleDeliveryRequest): Promise<void> {
    this.currentSdrsInMeeting = (this.currentSdrsInMeeting || []).filter((s) => s.id !== scrapped.id);
    if (this.selectedSdrId === scrapped.id) {
      const remaining = this.activeSdrsInMeeting;
      const nextId = remaining.length ? remaining[0].id : null;
      if (nextId) {
        await this._hydrateResumingSdr(nextId);
      } else {
        this.resumingSdr = null;
      }
      this.selectedSdrId = nextId;
    }
    this._initSamplesMaterialsSectionHeader();
    this.cdRef.markForCheck();
  }

  private async _refreshSdrsInMeeting(): Promise<void> {
    const meeting = this.activityService.selectedActivity;
    const apptId = meeting?.ID;
    if (!apptId) {
      this.sdrsInSelectedMeeting = [];
      return;
    }
    try {
      this.sdrsInSelectedMeeting = await this.sdrService.fetchSdrsForMeeting(apptId);
    } catch (err) {
      console.error('_refreshSdrsInMeeting failed', err);
    }
  }

  /**
   * A customer was chosen in the inline SDR editor — add it to the meeting (same
   * as the allocation flow, minus the allocation-specific location sync) so the
   * SDR's customer is a meeting participant and the subject reflects it.
   */
  async onSdrContactSelected(event: { contact: Contact }) {
    const meeting = this.activityService.selectedActivity;
    if (!meeting || !(meeting instanceof AppointmentActivity) || !event?.contact) return;

    // A contact chosen for the SDR is very often ALREADY a meeting attendee
    // (e.g. the customer auto-populated from the meeting, cleared, then
    // re-selected) — only add-to-meeting when they genuinely aren't one yet.
    // Calling addContactsToMeeting unconditionally re-submitted an
    // already-mapped attendee and Dynamics rejected it with ERR_IO_500
    // "Duplicate Detected: This Appointment/Attendee has already been
    // mapped." (OMNI-61272).
    const isAlreadyMeetingContact = !!meeting.contacts?.find(c => c.ID === event.contact.ID);
    if (!isAlreadyMeetingContact) {
      this.contactService.moveContactToSelected(event.contact);
    }

    const previousSubject = meeting.subject;
    this.meetingDataService.setMeetingSubjectFromContact(meeting, meeting.meetingOwnerName);

    if (!isAlreadyMeetingContact && !this.device.isOffline && !this.activityService.hasOfflineMeetingData(meeting.ID)) {
      await this.meetingDataService.addContactsToMeeting(meeting).catch(err => {
        console.error('onSdrContactSelected: addContactsToMeeting error:', err);
        this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity, false, true);
      });
      if (meeting.subject !== previousSubject) {
        const payload = new UpdateMeetingPayload();
        payload.subject = meeting.subject;
        await this.meetingDataService.updateMeeting(meeting as AppointmentActivity, payload).catch(err => {
          console.error('onSdrContactSelected: updateMeeting error:', err);
          this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity, false, true);
        });
      }
    }
    await this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity);
    this._updateMeetingContactsRef();
    await this.initFormFields(false);
    this.detectChangesOnActivityDetails(true);
    this.cdRef.markForCheck();
  }

  get activeAllocationsInMeeting(): SampleActivity[] {
    return (this.allocationInSelectedMeeting || []).filter(a => a.state !== 2);
  }

  /** Drops tab content: same as activeAllocationsInMeeting minus Promotional Material. */
  get activeSampleDropsInMeeting(): SampleActivity[] {
    return this.activeAllocationsInMeeting.filter(a => !a.isPromoMaterial);
  }

  /** Materials tab content: Promotional Material allocations only. */
  get activePromoMaterialsInMeeting(): SampleActivity[] {
    return this.activeAllocationsInMeeting.filter(a => !!a.isPromoMaterial);
  }

  // OMNI-62429: an AO created before its parent offline meeting synced still carries the old
  // offline meeting id, so match on both the meeting's current id and its offlineMeetingId.
  private _isAllocationForSelectedMeeting(alloc: SampleActivity): boolean {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    if (!meeting || !alloc) return false;
    const offlineId = meeting.offlineMeetingId;
    return alloc.appointmentID === meeting.ID || (!!offlineId && alloc.appointmentID === offlineId);
  }

  /** Blocks only removal of the customer linked to the active IAO (sample drop) in single-AO meetings. */
  private _blockIfRemovingIaoLinkedCustomer(contact: Contact): boolean {
    if (!this.isSingleAoMeeting) return false;
    const isIaoCustomer = this.activeAllocationsInMeeting.some(
      a => !!a.contactID && a.contactID === contact.ID,
    );
    if (isIaoCustomer) {
      const isPromo = this.activeAllocationsInMeeting.some(
        a => !!a.contactID && a.contactID === contact.ID && a.isPromoMaterial,
      );
      this.notificationService.notify(
        this.translate.instant(isPromo ? 'CANNOT_CHANGE_CUSTOMER_ASSOCIATED_PROMO_MAT' : 'CANNOT_CHANGE_CUSTOMER_ASSOCIATED_SAMPLE_DROP'),
        '', 'top', ToastStyle.INFO,
      );
      return true;
    }
    return false;
  }

  /** Blocks removal of a customer that has an SDR raised from this meeting (single-AO meetings). */
  private _blockIfRemovingSdrLinkedCustomer(contact: Contact): boolean {
    const meeting = this.activityService.selectedActivity;
    if (!(meeting instanceof AppointmentActivity)) return false;
    if (!this.activityService.isContactLinkedToSdrOnMeeting(meeting, contact?.ID, this.sdrService.allSdrs)) {
      return false;
    }
    this.notificationService.notify(
      this.translate.instant('CANNOT_CHANGE_CUSTOMER_ASSOCIATED_SDR'),
      '', 'top', ToastStyle.INFO,
    );
    return true;
  }

  /** Returns true (and shows toast) if single-AO mode has an active allocation with location — blocks location change */
  private _blockIfSingleAoHasLocation(): boolean {
    if (!this.isSingleAoMeeting) return false;
    const hasAllocWithLocation = this.activeAllocationsInMeeting.some(a => !!a.location);
    if (hasAllocWithLocation) {
      this.notificationService.notify(
        this.translate.instant('CANNOT_CHANGE_LOCATION_ASSOCIATED_SAMPLE_DROP'),
        '', 'top', ToastStyle.INFO,
      );
      return true;
    }
    return false;
  }

  meetingContactsRef: Contact[] = [];

  getMeetingContacts(): Contact[] {
    const meeting = this.activityService.selectedActivity as any;
    return meeting?.contacts || [];
  }

  private readonly noMeetingContacts: Contact[] = [];

  // Stable reference when the meeting has none, so the expense form's [contacts] input does not change every cycle.
  get expenseContacts(): Contact[] {
    return (this.activityService.selectedActivity as any)?.contacts ?? this.noMeetingContacts;
  }

  /** Update cached reference — call whenever meeting contacts may have changed */
  private _updateMeetingContactsRef() {
    this.meetingContactsRef = this.getMeetingContacts();
  }

  onAllocationTabChange(allocId: string) {
    this.selectedAllocationId = allocId;
  }

  isCreatingAllocation = false;

  async createNewInlineAllocation(isPromoMaterial = false) {
    if (this.isCreatingAllocation) return;
    // Defense-in-depth: mirrors createNewInlineSdr's own Cancelled guard — the "+ New"
    // button's own *ngIf already excludes a Cancelled meeting, but a stale render of the
    // button must not be trusted either.
    if (this.activityService.selectedActivity?.state === MeetingActivityState.Canceled) {
      console.log('[SAMPLE-DROP] createNewInlineAllocation blocked — meeting is cancelled.');
      return;
    }
    // OMNI-62429: hard stop a second sample-drop AO on single-AO meetings even if the button's
    // disabled state lagged (async create window, stale appointmentID, or non-inline entry point).
    if (!isPromoMaterial && this.isSingleAoMeeting && this.activeSampleDropsInMeeting.length >= 1) return;
    this.isCreatingAllocation = true;
    try {
      const meeting = this.activityService.selectedActivity as any;
      const now = new Date();
      const contacts = this.getMeetingContacts();
      const singleContact = contacts?.length === 1 ? contacts[0] : null;
      const allocationSubject = isPromoMaterial
        ? this.translate.instant('PROMOTIONAL_MATERIAL')
        : singleContact
          ? `Allocation Order with ${singleContact.fullName}`
          : (meeting?.subject || '');
      const payload = new CreateSampleDropRequestBody({
        subject: allocationSubject,
        scheduledStart: now,
        scheduledEnd: now,
        ID: '',
        state: 0,
        status: 1,
        indskr_appointmentid: meeting?.ID || '',
        appointmentID: meeting?.ID || '',
        offlineActivityId: '',
        samples: [],
        ownerId: this.authenticationOfflineService.user?.systemUserID || '',
      });
      payload.indskr_appointmentid = meeting?.ID || '';
      if (isPromoMaterial) payload.indskr_allocationordertype = AllocationOrderType.PromotionalMaterial;

      // Pre-fill contact if meeting has exactly one contact
      if (singleContact) {
        payload.indskr_contactid = singleContact.ID;
      }

      console.log(`[SAMPLE-DROP] createNewInlineAllocation: isPromoMaterial=${isPromoMaterial} indskr_allocationordertype=${payload.indskr_allocationordertype} appointmentId=${payload.indskr_appointmentid}`);
      const newAllocation = await this.sampleDataService.initiateSampleOrder(payload);
      console.log(`[SAMPLE-DROP] createNewInlineAllocation: result ID=${newAllocation?.ID} offlineActivityId=${newAllocation?.offlineActivityId} indskr_allocationordertype=${newAllocation?.indskr_allocationordertype}`);
      if (newAllocation) {
        // Belt-and-suspenders: force indskr_allocationordertype to match the user's own choice
        // regardless of what the POST response echoes back (omitted, defaulted, or just wrong) —
        // the caller already knows definitively whether this is a promo-material allocation, so
        // that intent must win over the server value. A falsy-only guard here previously let a
        // truthy-but-wrong response value slip through, leaving alloc.isPromoMaterial false and
        // causing the unrestricted global SKU list to leak into the Promotional Material picker.
        if (isPromoMaterial) {
          newAllocation.indskr_allocationordertype = AllocationOrderType.PromotionalMaterial;
        }
        // Directly push the new allocation so the UI refreshes immediately
        // (activityService.activities may not contain it yet when _refreshAllocationsInMeeting runs)
        const current = (this.currentAllocationsInMeeting || []).filter(a => a.ID !== newAllocation.ID && a.offlineActivityId !== newAllocation.offlineActivityId);
        this.allocationInSelectedMeeting = [...current, newAllocation];
        this.selectedAllocationId = newAllocation.ID || newAllocation.offlineActivityId;
      }
    } finally {
      this.isCreatingAllocation = false;
    }
  }

  onAllocationSaved(allocation: SampleActivity) {
    this._refreshAllocationsInMeeting();
    // Publish event so todo/agenda lists update (matches new-sample-activity intermediate save flow)
    this.events.publish('allocationOrderActivityIsUpdated', allocation);
    // In single-AO mode, sync allocation location to meeting if meeting has no location or same single contact
    this._syncAllocationToMeetingIfSingleAo(allocation);
  }

  onAllocationCompleted(allocation: SampleActivity) {
    this._refreshAllocationsInMeeting();
    this._initSamplesMaterialsSectionHeader();
    // Publish event so todo/agenda lists update (matches new-sample-activity complete flow)
    this.events.publish('allocationOrderActivityCompleted', allocation);
    // Clean up meeting<->sampling mapping if needed
    if (allocation?.ID && this.activityService.selectedActivity?.ID) {
      if (this.activityService.samplingToInMeetingActivityMapping?.get(this.activityService.selectedActivity.ID) === allocation.ID) {
        this.activityService.samplingToInMeetingActivityMapping.delete(this.activityService.selectedActivity.ID);
      }
    }
  }

  async onAllocationScrapFromTab(event: MouseEvent, allocation: SampleActivity) {
    event.stopPropagation(); // prevent tab selection
    if (allocation.state === 1) return; // completed
    // Defense-in-depth: mirrors createNewInlineAllocation's own Cancelled guard — the scrap
    // icon's own *ngIf already excludes a Cancelled meeting, but a stale render must not be
    // trusted either.
    if (this.activityService.selectedActivity?.state === MeetingActivityState.Canceled) {
      console.log('[SAMPLE-DROP] onAllocationScrapFromTab blocked — meeting is cancelled.');
      return;
    }
    const isPromo = allocation.isPromoMaterial;
    const confirmed = await this.alertService.showAlert(
      {
        title: this.translate.instant(isPromo ? 'SCRAP_PROMOTIONAL_MATERIAL' : 'SCRAP_ALLOCATION_ORDER'),
        message: this.translate.instant(isPromo ? 'CONFIRM_SCRAP_PROMOTIONAL_MATERIAL' : 'CONFIRM_SCRAP_ALLOCATION'),
      },
      this.translate.instant('SCRAP'),
    );
    if (confirmed?.role !== 'ok') return;
    this.scrappingAllocationId = allocation.ID;
    this.cdRef.markForCheck(); // render overlay on IAO before the async API call
    try {
      const payload = new CreateSampleDropRequestBody(allocation);
      payload.statecode = 2;
      payload.statuscode = 3;
      await this.sampleDataService.updateSampleActivity(payload, allocation);
      allocation.state = 2;
      allocation.status = 3;
      this.onAllocationScrapped(allocation);
    } catch (e) {
      console.error('Scrap allocation from tab failed', e);
    } finally {
      this.scrappingAllocationId = null;
    }
  }

  onAllocationScrapped(allocation: SampleActivity) {
    this.allocationInSelectedMeeting = (this.allocationInSelectedMeeting || []).filter(a => a.ID !== allocation.ID);
    // Always land on the first remaining pill after scrap
    const remaining = this.activeAllocationsInMeeting;
    this.selectedAllocationId = remaining.length ? remaining[0].ID : null;

    this._initSamplesMaterialsSectionHeader();
    // Publish event so todo/agenda lists update (matches new-sample-activity scrap flow)
    this.events.publish('allocationOrderActivityDeleted', allocation);
    this.activityService.finalizeAgendaRefresh();
    // Clean up in-meeting mapping
    if (allocation?.ID && this.activityService.selectedActivity?.ID) {
      if (this.activityService.samplingToInMeetingActivityMapping?.get(this.activityService.selectedActivity.ID) === allocation.ID) {
        this.activityService.samplingToInMeetingActivityMapping.delete(this.activityService.selectedActivity.ID);
      }
    }
  }

  openContactsForAllocation() {
    if (!this.contactService.loadedContacts) return;
    const alloc = this.activeAllocationsInMeeting.find(a => a.ID === this.selectedAllocationId);
    if (!alloc) return;

    // Point contact-list at our inline allocation so it sets contactID/contactName directly on it
    this.sampleService.inMeetingAllocationActivity = alloc;
    this.sampleService.samplingDetailsViewMode = SamplingDetailsViewMode.CREATE_FROM_MEETING;
    this.uiService.showNewActivity = false;
    this.contactService.contactPageMode = ComponentViewMode.SELECTION;
    this.contactService.accessedContactListFrom = PageName.NewSampleActivityComponent;
    if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent) {
      this.uiService.prevView = this.uiService.activeView;
      this.uiService.activeView = 'contactDetails';
    }
    this.navService.pushWithPageTracking(PageName.ContactPageComponent, PageName.ContactPageComponent, null, PageName.ContactPageComponent);
  }

  async onAllocationContactSelected(event: { allocation: SampleActivity; contact: Contact; address?: ContactAddress }) {
    const meeting = this.activityService.selectedActivity;
    if (!meeting || !(meeting instanceof AppointmentActivity)) return;
    const isAlreadyMeetingContact = !!meeting.contacts?.find(c => c.ID === event.contact.ID);
    // In single-AO mode: always override meeting contact with IAO contact
    if (this.isSingleAoMeeting) {
      // Remove all existing meeting contacts that differ from the new one
      const existingContacts = [...(meeting.contacts || [])];
      existingContacts
        .filter(c => c.ID !== event.contact.ID)
        .forEach(c => this.contactService.removeContactFromSelected(c));
      // Add the new contact if not already present
      if (!meeting.contacts?.find(c => c.ID === event.contact.ID)) {
        this.contactService.moveContactToSelected(event.contact);
      }
    } else {
      // Default: add contact to meeting's contacts array (same as contact-list flow)
      if (!meeting.contacts?.find(c => c.ID === event.contact.ID)) {
        this.contactService.moveContactToSelected(event.contact);
      }
    }
    const previousLocation = meeting.location;
    // Sync allocation location and lat/lng to meeting before subject calculation
    if (this.isSingleAoMeeting) {
      meeting.location = event.allocation.location || '';
    }
    meeting.indskr_meetinglocationlatitude = event.address?.latitude ? Number(event.address.latitude) : null;
    meeting.indskr_meetinglocationlongitude = event.address?.longitude ? Number(event.address.longitude) : null;

    // Recalculate meeting subject to reflect the new contact
    const previousSubject = meeting.subject;
    this.meetingDataService.setMeetingSubjectFromContact(meeting, meeting.meetingOwnerName);

    if (!isAlreadyMeetingContact && !this.device.isOffline && !this.activityService.hasOfflineMeetingData(meeting.ID)) {
      await this.meetingDataService.addContactsToMeeting(meeting).catch(err => {
        console.error('onAllocationContactSelected: addContactsToMeeting error:', err);
        this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity, false, true);
      });
      if (meeting.subject !== previousSubject || meeting.location !== previousLocation) {
        const payload = new UpdateMeetingPayload();
        if (meeting.subject !== previousSubject) payload.subject = meeting.subject;
        if (meeting.location !== previousLocation) {
          payload.location = meeting.location;
          payload.indskr_meetinglocationlatitude = meeting.indskr_meetinglocationlatitude;
          payload.indskr_meetinglocationlongitude = meeting.indskr_meetinglocationlongitude;
        }
        await this.meetingDataService.updateMeeting(meeting as AppointmentActivity, payload).catch(err => {
          console.error('onAllocationContactSelected: updateMeeting error:', err);
          this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity, false, true);
        });
      }
    }
    await this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity);
    this._updateMeetingContactsRef();
    await this.initFormFields(false);
    this.detectChangesOnActivityDetails(true);
    this.cdRef.markForCheck();
  }

  /** In single-AO mode, always override meeting location with allocation's location */
  private async _syncAllocationToMeetingIfSingleAo(allocation: SampleActivity) {
    if (!this.isSingleAoMeeting) return;
    const meeting = this.activityService.selectedActivity;
    if (!meeting || !(meeting instanceof AppointmentActivity)) return;

    const allocLocation = allocation.location || '';
    if (allocLocation === (meeting.location || '')) return;

    meeting.location = allocLocation;
    // Sync lat/lng from the allocation's selected address
    const contact = this.contactService.getContactByID(allocation.contactID);
    const address = contact?.addressesList?.find(a => (a.customerAddressID || a.addressId) === allocation.addressID);
    meeting.indskr_meetinglocationlatitude = address?.latitude ? Number(address.latitude) : null;
    meeting.indskr_meetinglocationlongitude = address?.longitude ? Number(address.longitude) : null;
    const payload = new UpdateMeetingPayload();
    payload.location = allocLocation;
    payload.indskr_meetinglocationlatitude = meeting.indskr_meetinglocationlatitude;
    payload.indskr_meetinglocationlongitude = meeting.indskr_meetinglocationlongitude;
    if (!this.device.isOffline && !this.activityService.hasOfflineMeetingData(meeting.ID)) {
      await this.meetingDataService.updateMeeting(meeting as AppointmentActivity, payload).catch(err => {
        console.error('_syncAllocationToMeetingIfSingleAo: updateMeeting error:', err);
        this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity, false, true);
      });
    } else {
      await this.activityService.upsertMeetingsOfflineData(meeting as AppointmentActivity);
    }
    this.cdRef.markForCheck();
  }

  /** Fire-and-forget: sync lot details + max order quantities so IAO has fresh data when opened */
  private _prefetchAllocationDataForIAO() {
    if (this.device.isOffline || this.device.isUserStateOffline) return;
    const dataRange = this.authService.getFromToDateRangeInUTCMiliSec(undefined);
    // Sync lots and max order quantities in parallel — non-blocking
    Promise.all([
      this.sampleDataService.syncLots(dataRange).catch(e => console.error('ADP lot prefetch failed', e)),
      this.authService.hasFeatureAction(FeatureActionsMap.ALLOCATION_ORDERS_UNRESTRICTED)
        ? this.sampleDataService.fetchAllocationsMaxOrderQuantity(undefined, true).catch(e => console.error('ADP max order qty prefetch failed', e))
        : Promise.resolve(),
    ]).then(() => {
      // Ensure lots are in memory for IAO
      if (!this.sampleService.lots?.length) {
        this.sampleService.loadAllLotsFromDBAndMap(true);
      }
    });
  }

  private _refreshAllocationsInMeeting() {
    if (!this.features.allocationEnabled || !this.activityService.selectedActivity) return;
    const allocations = this.activityService.activities.filter(
      o => o instanceof SampleActivity && this._isAllocationForSelectedMeeting(o as SampleActivity)
    ) as SampleActivity[];
    this.allocationInSelectedMeeting = this._mergeContactTimelineAllocations(this.activityService.selectedActivity.ID, allocations);
    // Auto-select first active allocation if none selected
    if (!this.selectedAllocationId && this.activeAllocationsInMeeting.length) {
      this.selectedAllocationId = this.activeAllocationsInMeeting[0].ID;
    }
  }

  /**
   * Fallback for a non-owner viewer opening a meeting via the shared-contact
   * timeline (e.g. two reps mapped to the same contact — see contact-timeline.ts's
   * displayActivityDetails): Sample Drop / Promotional Material (SampleActivity)
   * records for a meeting the viewer doesn't own never land in
   * activityService.activities — that array is populated only by each rep's own
   * "self", position-scoped allocation sync (syncAllocationOrders,
   * activity.service.ts). They DO reach the device via the broader, purely
   * contact-scoped GET_CONTACT_ACTIVITIES fetch that also brings the meeting
   * itself for a shared/non-owned view (contactService.mapTimelineActivities) —
   * but that response lands in contact.activitesTimeline, a side array
   * allocationInSelectedMeeting never reads. Without this, a non-owner sees an
   * empty Samples & Materials section even though the data already reached
   * their device (it's a display-wiring gap, not a sync-scoping one).
   * Merged and deduped by ID rather than a straight fallback, since an owned
   * meeting can have both sources populated (e.g. self-sync plus a contact
   * timeline visit) and must not double-render the same allocation.
   */
  private _mergeContactTimelineAllocations(meetingId: string, ownActivities: SampleActivity[]): SampleActivity[] {
    const timelineAllocations = (this.contactService.contactInformation?.activitesTimeline ?? []).filter(
      (a) => a instanceof SampleActivity && (a as SampleActivity).appointmentID === meetingId,
    ) as SampleActivity[];
    if (!timelineAllocations.length) return ownActivities;
    const seen = new Set(ownActivities.map((a) => a.ID));
    const merged = [...ownActivities];
    for (const a of timelineAllocations) {
      if (!seen.has(a.ID)) {
        seen.add(a.ID);
        merged.push(a);
      }
    }
    return merged;
  }

  get allocationInSelectedMeeting() {
    return this.currentAllocationsInMeeting;
  }
  set allocationInSelectedMeeting(allocations: SampleActivity[]) {
    this.currentAllocationsInMeeting = allocations;
    this._initSamplesMaterialsSectionHeader();
    // Auto-select first active allocation if none selected
    const active = (allocations || []).filter(a => a.state !== 2);
    if (!this.selectedAllocationId && active.length) {
      this.selectedAllocationId = active[0].ID;
    }
  }

  getFormattedDate(value) {
    return this.dateTimeFormatsService.formatDate(value, 'MMM DD')
  }

  openNewActivityPage() {
    this.uiService.showNewActivity = true;
    if (this.navService.getActiveChildNavViewMasterPageName() === PageName.CallPlanComponent) {
      this.navService.pushChildNavPageWithPageTracking(PageName.NewActivityComponent, PageName.NewActivityComponent, PageName.CallPlanComponent, { from: PageName.PhoneCallDetailsComponent });
    }
  }

  async openAllocationoder(allocationOrder: SampleActivity) {
    this.sampleService.samplingDetailsViewMode = SamplingDetailsViewMode.CREATE_FROM_MEETING;
    this.sampleService.inMeetingAllocationActivity = allocationOrder
    this.activityService.activityDetailsLoaded = true;
    this.uiService.showNewActivity = false;
    const cssClass = this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent && this.device.isMobileDevice? ['inMeetingAllocation', 'HomeScreen'] : ['inMeetingAllocation'];
    let modal = await this.modalCtrl.create({ component: InMeetingAllocationComponent, componentProps: { type: ActivityType.Sample }, backdropDismiss: false, cssClass: cssClass })
    modal.present();
    modal.onDidDismiss().then((data?: any) => {
      this.sampleService.samplingDetailsViewMode = undefined;
      this.footerService.initButtons(FooterViews.Activities)
      if (data && data.isCompleted) {
        if (this.activityService.samplingToInMeetingActivityMapping.has(this.activityService.selectedActivity.ID)
          && this.activityService.samplingToInMeetingActivityMapping.get(this.activityService.selectedActivity.ID) == allocationOrder.ID) {
          this.activityService.samplingToInMeetingActivityMapping.delete(this.activityService.selectedActivity.ID)
        }
      }
    })
    return;
  }

  public get enableBackButton() {
    if (this.navService.getCurrentPageName() === PageName.GoAppNotificationPageComponent) return this.device.isMobileDevice;
    return this.from === PageName.AppealDetailsComponent ||
    this.from === PageName.NotificationDetailsComponent ||
    this.from === PageName.ContactTimelineComponent ||
    this.from === PageName.GoAppHomeComponent ||
    this.navService.getCurrentMasterPageName() !== PageName.GoAppActivitiesPageComponent &&
    this.navService.getCurrentPageName() !== PageName.AccountPlanActivities &&
    this.navService.getCurrentMasterPageName() !== PageName.CoachingActivitiesComponent &&
    !this.uiService.showCancelDoneOnActivityDetails;
  }


  private async createEmailInMeeting(channelDetails: EmailActivityChannelDetails, type: EmailTemplateType) {
    this.events.publish('activities-details-pane:createEmail', channelDetails, type);
  }

  onSaveTA(ta) {
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      this.activityService.selectedActivity.activityTherapeuticAreas = ta.filter(item => item.isSelected || item.isAutoSelected);
      this.theraputicService.updateMeetingTherapeuticArea(this.activityService.selectedActivity).then(response => {
      }).catch(err => {
        console.error(err);
        this.notificationService.notify(this.translate.instant('UPDATING_THERAPEUTIC_AREA_FAILED'), 'Meeting Details', 'top', ToastStyle.DANGER);
      })
    }
  }

  get isNotReadOnly(): boolean {
    return this.activityService.selectedActivity && !this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings && this.activityService.selectedActivity.state != MeetingActivityState.Completed && this.activityService.selectedActivity.state != MeetingActivityState.Canceled && !this.isEffectiveDiffPosition && this.from !== PageName.AccountPlanActivities;
  }

  public getLivetimeFormField(): IndFormFieldViewDataModel {
    const activity = <AppointmentActivity>this.activityService.selectedActivity;
    let viewData: IndFormFieldViewDataModel;
    viewData = {
      label: this.features.liveMeet ? this.translate.instant('LIVE_MEETING') : this.translate.instant('ACTIVITY_DETAILS_LIVE_TIME'),
      inputText: this.meetingURL?.substring((this.meetingURL?.length - 4), this.meetingURL?.length),
      placeholderLabel: (this.activityService.meetingTypes.length > 0 && !(!this.isNotReadOnly && !(activity.indskr_meetingtype)) ? "" : this.translate.instant("NO") + " ") + this.translate.instant("MEETING_TYPE"),
      id: 'meeting-live-time-field',
      isReadOnly: true,
      isDisabled: false,
      showArrow: false,
      formFieldType: FormFieldType.INLINE_INPUT,
      additionalcontrols: [{
        id: 'live-time-copy',
        src: 'assets/imgs/link.svg',
      },
      {
        id: 'live-time-mail',
        src: 'assets/imgs/Live_meet_icon.svg',
      }]
    };
    return viewData;
  }

  private async updateAppConfigInputValuesForMultiOptionSet(fieldName, dataType, multipleLabels, multipleValues) {
    let appConfigFieldsfromService: ConfiguredFields[] = this.appointmentConfigFields.filter(reqField => reqField.fieldName === fieldName);
    let currentConfigField = appConfigFieldsfromService[0];

    var appConfigFields: ConfiguredFields = {
      fieldName: currentConfigField.fieldName,
      datatype: dataType,
      value: multipleValues,
      fieldType: currentConfigField.fieldType,
      fieldLabel: currentConfigField.fieldLabel,
      order: currentConfigField.order,
      mandatory: currentConfigField.mandatory,
      readOnly: currentConfigField.readOnly
    };

    appConfigFields.selectedValues = multipleLabels;
    appConfigFields.multipleLabels = multipleLabels.split(', ')
    appConfigFields.multipleValues = multipleValues.split(', ')
    appConfigFields.hasMultipleValues = true;

    currentConfigField.selectedValues = multipleLabels;
    currentConfigField.value = multipleValues;
    currentConfigField.multipleLabels = multipleLabels.split(', ')
    currentConfigField.multipleValues = multipleValues.split(', ')
    currentConfigField.hasMultipleValues = true;

    this.appointmentConfigFields.map(obj => appConfigFieldsfromService.find(o => o.fieldName == obj.fieldName) || obj);

    this.saveAdditionalConfigFields(appConfigFields);
  }

  public async updateAppConfigInputValues(myEvent, fieldName, dataType, inputValue?, isOptionSet: boolean = false,stringValue:string = '') {
    let appConfigFieldsfromService: ConfiguredFields[] = this.appointmentConfigFields.filter(reqField => reqField.fieldName === fieldName);
    let currentConfigField = appConfigFieldsfromService[0];
    var appConfigFields: ConfiguredFields = {
      fieldName: currentConfigField.fieldName,
      datatype: dataType,
      value: inputValue != undefined && inputValue != null ? inputValue : (myEvent && myEvent.target && myEvent.target.value && myEvent.target.value.length != 0) ? myEvent.target.value : '',
      stringValue: stringValue,
      fieldType: currentConfigField.fieldType,
      fieldLabel: currentConfigField.fieldLabel,
      order: currentConfigField.order,
      mandatory: currentConfigField.mandatory,
      readOnly: currentConfigField.readOnly,
      isEmptyRequiredField: false,
      indskr_optionsetdefaultext: currentConfigField.indskr_optionsetdefaultext,
      indskr_optionsetdefaultvalue: currentConfigField.indskr_optionsetdefaultvalue,
    };

    if(currentConfigField.datatype == 'Lookup' || currentConfigField.fieldType == 'Lookup'){
      appConfigFields['indskr_lookupentitysetname'] = currentConfigField.indskr_lookupentitysetname;
      appConfigFields['indskr_referencingentitynavigationpropertyname'] = currentConfigField.indskr_referencingentitynavigationpropertyname;
      appConfigFields['indskr_lookupentityprimaryidattribute'] = currentConfigField.indskr_lookupentityprimaryidattribute;
      appConfigFields['indskr_lookupentityprimarynameattribute'] = currentConfigField.indskr_lookupentityprimarynameattribute;
      appConfigFields['indskr_lookupquery'] = currentConfigField.indskr_lookupquery;
      appConfigFields['indskr_lookupentityname'] = currentConfigField.indskr_lookupentityname;
    }

    if (isOptionSet) {
      appConfigFields.selectedValues = (this.appConfigPickValue && this.appConfigPickValue.label) ?? '';
      currentConfigField.selectedValues = (this.appConfigPickValue && this.appConfigPickValue.label) ?? '';
    } else {
      appConfigFields.selectedValues = appConfigFields.value;
      currentConfigField.selectedValues = appConfigFields.value;
    }

    if(isEmpty(appConfigFields.selectedValues)) this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = true;
    else this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = false;

    appConfigFields.multipleLabels = [];
    appConfigFields.multipleValues = [];
    appConfigFields.hasMultipleValues = false;

    currentConfigField.multipleLabels = [];
    currentConfigField.multipleValues = [];
    currentConfigField.hasMultipleValues = false;

    currentConfigField.value = appConfigFields.value;
    this.appointmentConfigFields.map(obj => appConfigFieldsfromService.find(o => o.fieldName == obj.fieldName) || obj);
    this.saveAdditionalConfigFields(appConfigFields);
  }

  public async updateAppConfigBoolValues(fieldName, dataType, inputValue?) {
    const appConfigFieldsfromService: ConfiguredFields[] = this.appointmentConfigFields.filter(reqField => reqField.fieldName === fieldName);
    const currentConfigField = appConfigFieldsfromService[0];
    var appConfigFields: ConfiguredFields[] = [{
      fieldName: currentConfigField.fieldName,
      datatype: dataType,
      value: inputValue ? inputValue : false,
      fieldType: currentConfigField.fieldType,
      fieldLabel: currentConfigField.fieldLabel,
      order: currentConfigField.order,
      mandatory: currentConfigField.mandatory,
      readOnly: currentConfigField.readOnly
    }];
    currentConfigField.value = appConfigFields[0].value;
    this.appointmentConfigFields.map(obj => appConfigFieldsfromService.find(o => o.fieldName == obj.fieldName) || obj);
    this.saveAdditionalConfigFields(appConfigFields);
  }

  public async updateConfigDate(myEvent, fieldName, dateValue) {
    let appConfigFieldsfromService: ConfiguredFields[] = this.appointmentConfigFields.filter(reqField => reqField.fieldName === fieldName);
    let currentConfigField = appConfigFieldsfromService[0];
    var appConfigFields: ConfiguredFields = {
      fieldName: currentConfigField.fieldName,
      datatype: 'Date',
      value: dateValue,
      fieldType: currentConfigField.fieldType,
      fieldLabel: currentConfigField.fieldLabel,
      order: currentConfigField.order,
      mandatory: currentConfigField.mandatory,
      readOnly: currentConfigField.readOnly
    };
    currentConfigField.value = appConfigFields.value;
    this.appointmentConfigFields.map(obj => appConfigFieldsfromService.find(o => o.fieldName == obj.fieldName) || obj);
    this.saveAdditionalConfigFields(appConfigFields);
  }

  public async saveAdditionalConfigFields(appConfigFields: ConfiguredFields | ConfiguredFields[]) {
    const configFieldsArray = Array.isArray(appConfigFields) ? appConfigFields : [appConfigFields];

    for (const configField of configFieldsArray) {
      if (!configField.entityName) {
        // For later use.
        configField['entityName'] = 'appointment';
      }
      if (configField.fieldName && configField.fieldName.length) {
        // API requires this key (fieldname).
        let fieldName = configField.fieldName;
        configField['fieldname'] = fieldName;
      }
      this.pushAdditionalConfigOffline(configField);
      /**Note conflict(indskr_notes): Notes in App configured fields and Notes in Section with the FA(isNotesEnabled)
     * Note in App configured is override the Notes in Section
    */
      if (configField['fieldName'] == 'indskr_notes') this.activityService.selectedActivity.notes = configField['value'] || '';
    }
    if (!this.device.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
      await this.displayLoader();
      try {
        await this.meetingDataService.updateappConfigFields((this.activityService.selectedActivity as AppointmentActivity), configFieldsArray, true);
      } catch (error) {
        console.error('saveAdditionalConfigFields: ', error);
        this.activityService.upsertMeetingsOfflineData((this.activityService.selectedActivity as AppointmentActivity), false, true);
      } finally {
        await this.dismissLoader();
      }
    } else {
      this.activityService.upsertMeetingsOfflineData((this.activityService.selectedActivity as AppointmentActivity));
    }
  }

  public async openBooleanPopover(event, fieldName) {
    let appConfigBooleanValues = ['Yes', 'No'];
    const prevSelectedValue = this.appConfigInputBoolValue;
    let dropdownListDetail: IndDropdownListDetailModel = {
      id: 'appConfigBooleanValues-select',
      data: appConfigBooleanValues.map(value => {
        let obj = {
          title: value,
          id: value,
          isSelected: false,
        };
        if (prevSelectedValue === value) {
          obj['isSelected'] = true;
        }
        return obj;
      }),
    };
    let popover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event
    });
    await popover.present();
    await popover.onDidDismiss().then(async (obj: any) => {
      const field = this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName);
      if (!field) return;

      if (obj?.data?.selectedItems) {
        if (this.backgroundUploadInProgress) return;
        const value = obj.data.selectedItems[0].title;
        const requestValue = value === 'Yes';
        this.appConfigInputBoolValue = value;
        field.isEmptyRequiredField = false;
        this.updateAppConfigBoolValues(fieldName, 'boolean', requestValue);
      } else {
        if (!field.value) {
          field.isEmptyRequiredField = true;
        }
      }
    });
  }

  public async openLookup(event,fieldName) {
    const configField = this.appointmentConfigFields.find(a=> a.fieldName == fieldName);
    if(configField){
      if (fieldName === 'indskr_activitytype' || fieldName === 'indskr_activitysubtype') {
        this.ioUserSelection.setCaseSelectorSource(configField.fieldLabel);
        let dataSource: any = this.lookupData(configField.fieldLabel, fieldName);
        // Guard: if the backend config maps a known fieldName to an unexpected fieldLabel
        // (or lookupData has no matching case), dataSource will be undefined/null, which
        // crashes IOMultiSelect's BehaviorSubject subscriber via JSON.parse(JSON.stringify(undefined)).
        // Bail out early with a console warning instead of crashing.
        if (!dataSource) {
          console.warn(`openLookup: lookupData returned undefined for fieldName="${fieldName}", fieldLabel="${configField.fieldLabel}". Check backend config for this meeting configured field.`);
          return;
        }
        this.ioUserSelection.setSelectionDataSource(dataSource);
        this.uiService.showNewActivity = false;
        setTimeout(() => {
          this.navService.pushWithPageTracking(PageName.IOMultiSelect, PageName.IOMultiSelect, { remoteMeetingConnectionMapping: true }, PageName.IOMultiSelect);
        }, 10);
      }else {

        let results = [];
        if(this.device.isOffline){
          if(this.lookupConfigFieldsData && this.lookupConfigFieldsData[configField.fieldName]){
            results = this.lookupConfigFieldsData[configField.fieldName]
          }
        }else{
          results = await this.activityDataService.getConfigFieldLookupResults(configField,null);
        }
        let currentSelectedValue:string;
        if(this.activityService.selectedActivity instanceof AppointmentActivity && this.activityService.selectedActivity.appConfigFields && this.activityService.selectedActivity.appConfigFields.length > 0){
          const currentConfigField = this.activityService.selectedActivity.appConfigFields.find(a=> a.fieldName == fieldName);
          if(currentConfigField && currentConfigField.value){
            currentSelectedValue = currentConfigField.value;
          }
        }
        let lookupPopoverModel:IndDropdownListDetailModel = {
          id: 'config-fields-lookup-select',
          isSearchEnabled:true,
          searchInputPlaceholder: this.translate.instant('SEARCH'),
          data: results.map(item=> {
            let data:SelectListData = {
              title: item[configField.indskr_lookupentityprimarynameattribute],
              id: item[configField.indskr_lookupentityprimaryidattribute],
              isSelected: currentSelectedValue == item[configField.indskr_lookupentityprimaryidattribute] ? true : false,
            }
            return data;
          })
        };
        this._lookupPopover = await this.popoverCtrl.create({
          component: IndDropdownListComponent,
          componentProps: { viewData: lookupPopoverModel },
          cssClass: 'dropdown-list-view',
          event: event
        });
        this._lookupPopover.onDidDismiss().then(async (data: any) => {
          data = data.data;
          if (data && data.selectedItems && data.selectedItems.length == 1) {
            let selectedPopOverValue = data.selectedItems[0].id;
            let selectedPopOverStringValue = data.selectedItems[0].title;
            this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = false;
            this.updateAppConfigInputValues(event, fieldName, 'Lookup', selectedPopOverValue, false,selectedPopOverStringValue);
          } else if (data && data.selectedItems && data.selectedItems.length == 0) {
            let fieldValue = this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).value;
            if(!fieldValue) this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = true;
          }
          this._lookupPopover = undefined;
        });
        this._lookupPopover.present();
      }
    }
  }

  private lookupData(fieldLabel, fieldName): any[] {
    switch (fieldLabel) {
      case 'Activity Type':
        let typesArray = this.activityService.meetingActivityTypes.filter(at => at.indskr_omnipresenceactivity === this.meetingActivityTypeCode.MEETING);
        let activityTypeSource: any = typesArray.map((obj) => {
          let values = {
            "name": obj.indskr_name,
            "id": obj.indskr_activitytypeid,
            "type": "activity",
            'fieldName': fieldName
          }
          return values
        })
        return activityTypeSource;
      case 'Activity Sub Type':
        let SubTypesArray = this.activityService.meetingSubActivityTypes.filter(at => at.indskr_omnipresenceactivity === this.meetingActivityTypeCode.MEETING);
        let subActivityTypeSource: any = SubTypesArray.map((obj) => {
          let values = {
            "name": obj.indskr_name,
            "id": obj.indskr_activitysubtypeid,
            "type": "sub activity",
            'fieldName': fieldName
          }
          return values
        })
        return subActivityTypeSource;
    }
  }

  public async updateConfigFieldDate(isDone: boolean) {
    if (isDone) {
      const m = new Date(this.appConfigFieldDate);
      if (!this.dateTimeFormatsService.isValidDate(m)) {
        this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'appconfigfields', 'top', ToastStyle.DANGER);
        return;
      }
      this.appointmentConfigFields.find(reqField => reqField.fieldName === this.dateFieldName).isEmptyRequiredField = false;
      this.appConfigDateValue = new Date(this.appConfigFieldDate).getTime();
      this.formattedDate = this.dateTimeFormatsService.formatDate(new Date(parseInt(this.appConfigDateValue.toString())), this.dateTimeFormatsService.dateTimeToUpper);
      if (this.appConfigDateValue && this.formattedDate) {
        this.updateDateField();
      }
    } else {
      let fieldValue = this.appointmentConfigFields.find(reqField => reqField.fieldName === this.dateFieldName).value;
      if(!fieldValue) this.appointmentConfigFields.find(reqField => reqField.fieldName === this.dateFieldName).isEmptyRequiredField = true;

    }
  }

  private selectedCFOValues: ConfigFieldOptionValue[] = [];

  private handleMultiOptionSelectPopoverDismiss(data: any) {
    if (data && data.selectedItems && data.selectedItems.length && data.isDone) {
      let firstSelectedPopOverOptionValue = data.selectedItems[0].value;
      let optionsLabels = data.selectedItems.map(each => { return each.title });
      let optionsValues = data.selectedItems.map(each => { return each.value });
      let multipleLabels = optionsLabels.join(', ');
      let multipleValues = optionsValues.join(', ');
      let selectedValue = this.selectedCFOValues.filter(option => { return option.value === firstSelectedPopOverOptionValue });
      let fieldName = selectedValue.length ? selectedValue[0].fieldName : '';
      this.selectedCFOValues = [];
      this.updateAppConfigInputValuesForMultiOptionSet(fieldName, 'String', multipleLabels, multipleValues);
    }
  }

  public getPicklistForRecommendedEngagementPeriod() {
    let entityName = 'indskr_rec_engagement_period';
    let fieldName = 'indskr_day_of_week';

    let optionValuesForDayOfWeek = this.activityService.getConfigFieldsValuesByActivityName(entityName, fieldName);
    if (!optionValuesForDayOfWeek.length) {
      console.error(`No options available for ${fieldName} in ${entityName}.`);
      return;
    }
    else {
      //To create dictionary
      let tempArr = [];
      optionValuesForDayOfWeek.forEach((element) => {
        tempArr.push(pick(element, ['label', 'value']));
      });
      this.dictionaryDayOfWeek = Object.assign(
        {},
        ...tempArr.map((x) => ({ [x.value]: x.label }))
      );
    }

    fieldName = 'indskr_time_slot';
    let optionValuesForTimeSlot = this.activityService.getConfigFieldsValuesByActivityName(entityName, fieldName);
    if (!optionValuesForTimeSlot.length) {
      console.error(`No options available for ${fieldName} in ${entityName}.`);
      return;
    } else {
      //To create dictionary
      let tempArr = [];
      optionValuesForTimeSlot.forEach((element) => {
        tempArr.push(pick(element, ['label', 'value']));
      });
      this.dictionaryTimeSlot = Object.assign(
        {},
        ...tempArr.map((x) => ({ [x.value]: x.label }))
      );
    }
  }

  public async getRecommendedEngagementPeriodByContactId(contactId:string) {
    let fetchXML = fetchQueries.recommendedEngagementPeriodByContactId;
    fetchXML = fetchXML.replace('{contactId}', `${contactId}`);

    try {
      await this.displayLoader();

      let response = await this.dynamics.executeFetchQuery('indskr_rec_engagement_periods', fetchXML);

      if (!isEmpty(response) && this.dictionaryTimeSlot && this.dictionaryDayOfWeek) {
        // --------------------------------Time Slot-------------------------------- //
        let arr = response;

        // Add three properties labelTimeSlot, labelDayOfWeek and responseRate for storing value
        arr = arr.map((obj) => ({
        ...obj,
        labelTimeSlot: this.dictionaryTimeSlot[obj.indskr_time_slot],
        labelDayOfWeek: this.dictionaryDayOfWeek[obj.indskr_day_of_week],
        responseRate: obj.indskr_score ? obj.indskr_score : 0,
        }));

        // Sort based on response rate descending
        arr = orderBy(arr, ['responseRate'], ['desc']);


        let currentDayNum = this.dateTimeFormatsService.getDayOfWeek(new Date());
        currentDayNum = 100000000 + currentDayNum;
        const currentTimeStart: Date = new Date();

        // Calc. dates for scheduledStart/scheduledEnd based on daysDifference from current day
        arr.forEach((slot, index) => {
          let daysDifference = 0;

          if (slot['indskr_day_of_week'] >= currentDayNum) {
            daysDifference = slot['indskr_day_of_week'] - currentDayNum;
          } else {
            daysDifference = 7 - (currentDayNum - slot['indskr_day_of_week']);
          }

          arr[index]['scheduledStart'] = this.dateTimeFormatsService.addDaysToDate(currentTimeStart, daysDifference);
          arr[index]['scheduledEnd'] = this.dateTimeFormatsService.addDaysToDate(currentTimeStart, daysDifference);
       });


        // To check for current Date and then check for time
        arr = arr.filter((item) => {
          if (item['indskr_day_of_week'] === currentDayNum) {
            let startTime = item['labelTimeSlot'].toUpperCase().substring(0, 5);
            let parsedStartTime: Date = this.parseTimeFormat(startTime, 'hh A');
            parsedStartTime.setMinutes(0);

            let endTime = item['labelTimeSlot'].toUpperCase().substring(8, 13);
            let parsedEndTime: Date = this.parseTimeFormat(endTime, 'hh A');

            if (this.dateTimeFormatsService.formatDate(parsedEndTime, 'hh:mm A') === '12:00 AM') {
              // Midnight case: set to 23:55 next day to represent end of period
              parsedEndTime = this.dateTimeFormatsService.addDaysToDate(parsedEndTime, 1);
              parsedEndTime.setMinutes(-5);
            } else {
              parsedEndTime.setMinutes(0);
            }

            return (
              this.dateTimeFormatsService.isAfterDate(parsedEndTime, currentTimeStart) &&
              !(currentTimeStart >= parsedStartTime && currentTimeStart <= parsedEndTime)
            );
          } else return true;
        });

        this.timeSlotsFilteredByCurrentTime = Object.assign([], arr);

        // --------------------------------Time Slot-------------------------------- //

        // --------------------------------Meetings-------------------------------- //
        const appointments = this.activityService.displayActivities.filter((activity) => {
              return activity.type === ActivityType.Appointment;
        });

        //To create dictionary
        let tempArr = [];
        appointments.forEach((element) => {
          tempArr.push(pick(element, ['ID', 'scheduledEnd', 'scheduledStart']));
        });

        // Add extra property dayNum for storing value
        tempArr = tempArr.map((obj) => ({
          ...obj,
          momentScheduledStart: new Date(obj.scheduledStart),
          momentScheduledEnd: new Date(obj.scheduledEnd),
          dayOfWeek: 100000000 + this.dateTimeFormatsService.getDayOfWeek(new Date(obj.scheduledStart)),
        }));

        // Sort based on momentScheduledStart asc
        tempArr = orderBy(tempArr, ['momentScheduledStart'], ['asc']);


        // Filter out the days of the week that have passed
        tempArr = tempArr.filter((obj) => obj['momentScheduledStart'] >= new Date());


        // Filter out the timeslots of today that have passed current Time
        tempArr = tempArr.filter((item) => {
          // To check for current Date and then check for time
          if (item['dayOfWeek'] === currentDayNum) {
            let parsedStartTime: Date = new Date(item['scheduledStart']);
            let parsedEndTime: Date = new Date(item['scheduledEnd']);

            return (
              this.dateTimeFormatsService.isAfterDate(parsedEndTime, currentTimeStart) &&
              !(currentTimeStart >= parsedStartTime && currentTimeStart <= parsedEndTime)
            );
          } else return true;
        });


        this.meetingsFilteredByCurrentTime = Object.assign([], tempArr);
        // --------------------------------Meetings-------------------------------- //

        // // --------------------------------Recommended-------------------------------- //

        // //To check for slotStartTime between Booking Start and End Time
        this.recommendedByCurrentTime = Object.assign([], this.timeSlotsFilteredByCurrentTime);

        this.timeSlotsFilteredByCurrentTime.forEach((slot, index) => {
          this.meetingsFilteredByCurrentTime.forEach((booking, index1) => {
            if (slot['indskr_day_of_week'] === booking['dayOfWeek']) {

              let slotStartTime = slot['labelTimeSlot'].toUpperCase().substring(0, 5);
              let parsedSlotStartTime: Date = this.parseTimeFormat(slotStartTime, 'hh A');
              parsedSlotStartTime.setMinutes(0);

              let slotEndTime = slot['labelTimeSlot'].toUpperCase().substring(8, 13);
              let parsedSlotEndTime: Date = this.parseTimeFormat(slotEndTime, 'hh A');
              parsedSlotEndTime.setMinutes(0);


              let parsedBookingStartTime: Date = new Date(booking['scheduledStart']);

              let parsedBookingEndTime: Date = new Date(booking['scheduledEnd']);


              if (
                this.isTimeBetween(
                  this.dateTimeFormatsService.formatDate(parsedSlotStartTime, 'HH:mm'),
                  this.dateTimeFormatsService.formatDate(parsedSlotEndTime, 'HH:mm'),
                  this.dateTimeFormatsService.formatDate(parsedBookingStartTime, 'HH:mm')
                ) ||
                this.isTimeBetween(
                  this.dateTimeFormatsService.formatDate(parsedSlotStartTime, 'HH:mm'),
                  this.dateTimeFormatsService.formatDate(parsedSlotEndTime, 'HH:mm'),
                  this.dateTimeFormatsService.formatDate(parsedBookingEndTime, 'HH:mm')
                )
              ) {
                delete this.recommendedByCurrentTime[index];
              }

            } // end of if (slot['dayNum'] === booking['dayNum'])
          });
        });

        //To remove undefined
        this.recommendedByCurrentTime = this.recommendedByCurrentTime.filter(function (element) {
          return element !== undefined;
        });

        // Sort based on response rate descending
        this.recommendedByCurrentTime = orderBy(this.recommendedByCurrentTime, ['responseRate'], ['desc']);


        this.recommendedByCurrentTime = this.recommendedByCurrentTime.slice(0, 3);


       // Sort based on day of week ascending
       this.recommendedByCurrentTime = orderBy(this.recommendedByCurrentTime, ['indskr_day_of_week'], ['asc']);


        // Add extra property dayNum for storing value
        this.recommendedByCurrentTime = this.recommendedByCurrentTime.map((obj) => ({
          ...obj,
          timeSlot: obj.labelTimeSlot.split(':')[0],
        }));

        //To remove group by Days of Week
        this.recommendedByCurrentTime = groupBy(
          this.recommendedByCurrentTime, "labelDayOfWeek"
        );

        //To convert Object to Array
        this.recommendedByCurrentTime = Object.keys(this.recommendedByCurrentTime).map((key) => [
          String(key),
          orderBy(
            this.recommendedByCurrentTime[key],
            ['indskr_time_slot'],
            ['asc']
          ),
        ]);

        // --------------------------------Recommended-------------------------------- //
      }
      else { // To clear when response is empty from FetchXML
        this.recommendedByCurrentTime = [];
      }
      this.dismissLoader();
    } catch (error) {
      console.error('getRecommendedEngagementPeriodByContactId: error:', error);
    }
    finally {
      await this.dismissLoader();
    }
    return;
  }

  public isTimeBetween(startTime, endTime, serverTime) {
    let start = this.parseTimeFormat(startTime, 'H:mm');
    let end = this.parseTimeFormat(endTime, 'H:mm');
    let server = this.parseTimeFormat(serverTime, 'H:mm');
    if (end < start) {
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 0);
      const startOfDay = new Date();
      startOfDay.setHours(0, 0, 0, 0);
      return (
        (server >= start && server <= endOfDay) ||
        (server >= startOfDay && server < end)
      );
    }
    return server >= start && server < end;
  }

  private parseTimeFormat(timeStr: string, formatStr: string): Date {
    const d = new Date();
    d.setSeconds(0, 0);
    if (formatStr === 'hh A' || formatStr === 'h A') {
      const match = timeStr.match(/(\d+)\s*(AM|PM)/i);
      if (match) {
        let hour = parseInt(match[1]);
        if (match[2].toUpperCase() === 'PM' && hour !== 12) hour += 12;
        if (match[2].toUpperCase() === 'AM' && hour === 12) hour = 0;
        d.setHours(hour, 0);
      }
    } else if (formatStr === 'H:mm') {
      const parts = timeStr.split(':');
      d.setHours(parseInt(parts[0]), parseInt(parts[1]));
    }
    return d;
  }


  public async setRecommendedDateTime(slot) {
    let scheduledStart = new Date(slot['scheduledStart']);
    let scheduledEnd = new Date(slot['scheduledEnd']);

    const slotStartTime = slot['timeSlot'].split('-')[0].trim();
    const slotEndTime = slot['timeSlot'].split('-')[1].trim();

    let hours = this.dateTimeFormatsService.formatDate(this.parseTimeFormat(slotStartTime, 'hh A'), 'HH:mm');
    hours = '' + hours.split(':')[0];
    scheduledStart.setHours(+hours, 0);

    hours = this.dateTimeFormatsService.formatDate(this.parseTimeFormat(slotEndTime, 'hh A'), 'HH:mm');
    hours = '' + hours.split(':')[0];
    scheduledEnd.setHours(+hours, 0);

    this.activityService.updateSelectedActivityProps({ scheduledStart, scheduledEnd });

    this.events.publish("initTimePickerLimitedMinTime");

    let dateTimeValue = this.activityService.getFormattedDateTimeText();
    if (dateTimeValue) {
      this.meetingStartDateTime = dateTimeValue.startDateTime;
      this.meetingStartDate = dateTimeValue.startDate;
      this.meetingStartTime = dateTimeValue.startTime;
      this.meetingEndDateTime = dateTimeValue.endDateTime;
      this.meetingEndDate = dateTimeValue.endDate;
      this.meetingEndTime = dateTimeValue.endTime;
      this.meetingDuration = dateTimeValue.duration;
    }

    this.meetingStartDateField.inputText = this.meetingStartDate;
    this.meetingStartDateField.startDateTimeValue = this.meetingStartDateTime;
    this.meetingStartDateField.endDateTimeValue = this.meetingEndDateTime;

    this.meetingStartTimeField.inputText = this.meetingStartTime;
    this.meetingStartTimeField.startDateTimeValue = this.meetingStartDateTime;
    this.meetingStartTimeField.endDateTimeValue = this.meetingEndDateTime;

    this.meetingEndDateField.inputText = this.meetingEndDate;
    this.meetingEndDateField.startDateTimeValue = this.meetingStartDateTime;
    this.meetingEndDateField.endDateTimeValue = this.meetingEndDateTime;

    this.meetingEndTimeField.inputText = this.meetingEndTime;
    this.meetingEndTimeField.startDateTimeValue = this.meetingStartDateTime;
    this.meetingEndTimeField.endDateTimeValue = this.meetingEndDateTime;

    //-----------------API call - Update Meeting with Recommended DateTime-----------------//
    this.trackingService.tracking('MeetingTimeUpdate', TrackingEventNames.ACTIVITY)
    this.activityService.updateSelectedActivityProps({ scheduledStart: new Date(this.meetingStartTime), scheduledEnd: new Date(this.meetingEndTime) });
    this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledStart = new Date(scheduledStart);
    this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledEnd = new Date(scheduledEnd);
    let currentAppointmentActivity = this.activityService.selectedActivity;
    const payload = new UpdateMeetingPayload();
    payload.scheduledStart = currentAppointmentActivity.scheduledStart;
    payload.scheduledEnd = currentAppointmentActivity.scheduledEnd;
    payload.isBestTime = true;
    await this.displayLoader();

    await this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity);
    if (this.activityService.selectedActivity instanceof AppointmentActivity && (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID))) {

      this.activityService.finalizeAgendaRefresh();
      this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
    }
    this.meetingDataService.updateMeeting(this.activityService.selectedActivity as AppointmentActivity, payload, false, true)
      .then(() => {
        this.dismissLoader();
        this.activityService.finalizeAgendaRefresh();
        this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
      })
      .catch(e => {
        this.dismissLoader();

        console.error('ActivitiesDetailsPaneComponent: onDismiss: ', e);
        this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity, false, true);
      });
    //-----------------API call - Update Meeting with Recommended DateTime-----------------//

  }

  public async openPicklist(event, fieldName, id) {
    const selectedConfigField = this.getOptionSetField(fieldName);
    const prevSelectedValue = this.getOptionSetValue(fieldName);
    const isMultipleSelectionCase = (id === 'appConfig-MultiSelectPicklist-field');
    let optionValues = this.activityService.getConfigFieldsValues(ActivityType.Appointment, fieldName);
    if (!optionValues.length) {
      console.error('No options available for this custom field in appointment.');
      return;
    }

    optionValues.sort((a,b) => (a.label && a.label.toLowerCase()) > (b.label && b.label.toLowerCase()) ? 1 : -1);

    this.selectedCFOValues = optionValues;
    let objects = optionValues.map(option => {
      let obj = {
        title: option.label,
        id: option.label,
        isSelected: false,
        value: option.value
      };
      if (isMultipleSelectionCase) {
        if (selectedConfigField && selectedConfigField.multipleLabels && selectedConfigField.multipleLabels.includes(option.label)) {
          obj['isSelected'] = true;
        } else if (prevSelectedValue && prevSelectedValue === option.label) {
          obj['isSelected'] = true;
        }
      } else {
        if (prevSelectedValue && prevSelectedValue === option.label) {
          obj['isSelected'] = true;
        }
      }
      return obj;
    });
    let dropdownListDetail: IndDropdownListDetailModel = {
      id: 'appConfigPickValues-select',
      data: objects,
      isMultipleSelectionEnabled: isMultipleSelectionCase,
      showCancelandDoneBtn: isMultipleSelectionCase
    };
    let popover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event
    })
    await popover.present();
    await popover.onDidDismiss().then(async (data: any) => {
      if (this.backgroundUploadInProgress) return;
      if (isMultipleSelectionCase) {
        if (data && data.data) {
          this.handleMultiOptionSelectPopoverDismiss(data.data);
        }
      } else if(this.authService.user.unsolicitedMeetingLimitPeriod && this.authService.user.unsolicitedMeetingLimitTotal && this.isSolicitatedMeetingComplianceCheckEnabled && fieldName == 'indskr_hcpinteraction' && data && data.data && data.data.selectedItems && data.data.selectedItems[0].value == 548910001){
        this.displayUnsolicitedMeetingConfirmation(data);
        this.appointmentConfigFields.find(conField => conField.fieldName == 'indskr_hcpinteraction').isEmptyRequiredField = false;
      } else if (data && data.data && data.data.selectedItems) {
          // This is for single selection.
          let selectedPopOverValue = data.data.selectedItems[0].value;
          let selectedValue = this.selectedCFOValues.filter(option => { return option.value === selectedPopOverValue });
          if (selectedValue && selectedValue.length) {
            this.appConfigPickValue = selectedValue[0];
          }
          this.selectedCFOValues = [];
          this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = false;
          this.updateAppConfigInputValues(event, fieldName, 'String', selectedPopOverValue, true);
        } else {
          let fieldValue = this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).value;
          if(!fieldValue) this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = true;
        }
    });
  }

   private _getFormattedAndLocalisedDate(value: any) {
    return this.datePipe.transform(value, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
  }

  private async displayUnsolicitedMeetingConfirmation(data){
    let count = 0;
    (this.activityService.selectedActivity as AppointmentActivity).contacts.filter(a=> !a.isguest).forEach( async contact=>{
      let contactData = this.activityService.unsolicitedMeetingsData.find(a=> a.contactid == contact.ID);
      let remainingCalls:any = this.authService.user.unsolicitedMeetingLimitTotal - 1;
      let dateAfterAdjustment = this.dateTimeFormatsService.addDaysToDate(new Date(),this.authService.user.unsolicitedMeetingLimitPeriod)
      let formattedDate:string = this._getFormattedAndLocalisedDate(dateAfterAdjustment);
      if(contactData){
        let count = 0;
        for(var i=0;i< contactData.appointments.length;i++){
          const appoint = contactData.appointments[i];
          if(this.dateTimeFormatsService.isBeforeDate(this.dateTimeFormatsService.addDaysToDate(appoint.scheduledend,this.authenticationOfflineService.user.unsolicitedMeetingLimitPeriod),new Date().setHours(23,59,59))){
            count++;
          }else{
            break;
          }
        }
        if(count > 0){
          contactData.appointments.splice(0,count);
          await this.activityDataService.updateUnsolicitedMeetingDataOfflineDB();
        }
        remainingCalls = this.authService.user.unsolicitedMeetingLimitTotal - contactData.appointments.length - 1;

        let dateAfterAdjustment = this.dateTimeFormatsService.addDaysToDate(new Date(contactData.appointments[0].scheduledend),this.authService.user.unsolicitedMeetingLimitPeriod);

        formattedDate = this._getFormattedAndLocalisedDate(dateAfterAdjustment);
      }else {
        let dateAfterAdjustment = this.dateTimeFormatsService.addDaysToDate(new Date((this.activityService.selectedActivity as AppointmentActivity).scheduledEnd),this.authService.user.unsolicitedMeetingLimitPeriod);
        formattedDate = this._getFormattedAndLocalisedDate(dateAfterAdjustment);
      }
      if(remainingCalls == 0){
        remainingCalls = 'no';
      }
      let msg = this.translate.instant('REMAINING_UNSOLICITATED_CALLS_MESSAGE',{number:remainingCalls,customerName:contact.fullName,date:formattedDate});
      if(remainingCalls < 0){
        msg = this.translate.instant('OVER_LIMIT_UNSOLICITATED_CALLS_MESSAGE',{customerName:contact.fullName,date:formattedDate});
      }
      await this.alertService.showAlert({
        title: this.translate.instant('SOLICITATION_COMPLIANCE'),
        message: this.translate.instant(msg),
        buttons: [{ text:this.translate.instant('OK'), role: 'ok' }],
        backdropDismiss : false,
      }, this.translate.instant('OK')
      ).then(async res => {
        if (res.role === 'ok') {
          count++;
        }
        if (count == (this.activityService.selectedActivity as AppointmentActivity).contacts.filter(a=> !a.isguest).length) {
          let selectedPopOverValue = data.data.selectedItems[0].value;
          let selectedValue = this.selectedCFOValues.filter(option => { return option.value === selectedPopOverValue });
          if (selectedValue && selectedValue.length) {
            this.appConfigPickValue = selectedValue[0];
          }
          this.selectedCFOValues = [];
          this.updateAppConfigInputValues(event, 'indskr_hcpinteraction', 'String', selectedPopOverValue, true);
        }
      });
    });
    if ((this.activityService.selectedActivity as AppointmentActivity).contacts.filter(a => !a.isguest).length == 0) {
      let selectedPopOverValue = data.data.selectedItems[0].value;
      let selectedValue = this.selectedCFOValues.filter(option => { return option.value === selectedPopOverValue });
      if (selectedValue && selectedValue.length) {
        this.appConfigPickValue = selectedValue[0];
      }
      this.selectedCFOValues = [];
      this.updateAppConfigInputValues(event, 'indskr_hcpinteraction', 'String', selectedPopOverValue, true);
    }
  }

  public openOwner(event, fieldName) {
    if (event && event == 'input_value_confirm') {
      this.appConfigInputText = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
      if (this.appConfigInputText != '') {
        this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = false;
        this.updateAppConfigInputValues(event, fieldName, 'String');
      } else {
        this.appointmentConfigFields.find(reqField => reqField.fieldName === fieldName).isEmptyRequiredField = true;
      }
    }
  }

  onPeriodEndDateFieldClick(event, fieldName) {
    this.appConfigFieldDatePicker.open();
    this.dateEvent = event;
    this.dateFieldName = fieldName;
  }

  private updateDateField() {
    if (this.appConfigDateValue && this.formattedDate) {
      this.updateConfigDate(this.dateEvent, this.dateFieldName, this.appConfigDateValue);
    }
  }

  public getAppontmentsFormField(appConfigField: any, withFormatDetail: boolean = false): IndFormFieldViewDataModel {
    let viewData: IndFormFieldViewDataModel;
    const subTypeIds = appConfigField.subTypeIds || [];
    const currentSubType = this.activityService.selectedActivity.indskr_activitysubtype;
    
    if (withFormatDetail && !subTypeIds.includes(currentSubType)) {
      return null;
    }
    if (!withFormatDetail && subTypeIds.length > 0) {
      return null;
    }
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      viewData = {
        label: appConfigField.fieldLabel,
        inputText: this.getInputText(appConfigField.fieldType, appConfigField.value, appConfigField.fieldName),
        inputValue: this.getInputText(appConfigField.fieldType, appConfigField.value, appConfigField.fieldName),
        placeholderLabel: this.activityService.selectedActivity.state != MeetingActivityState.Completed ? this.getplaceholderLabel(appConfigField.fieldType, appConfigField.fieldLabel) : this.getPlaceHolderForCompletedAct(appConfigField.fieldType, appConfigField.fieldLabel),
        id: getConfigFormFieldViewDataModelId(appConfigField.fieldType),
        isReadOnly: getConfigFormFieldIsReadOnly(appConfigField.fieldType, appConfigField.readOnly),
        isDisabled: this.backgroundUploadInProgress || !(this.isNotReadOnly) || (this.isSolicitatedMeetingComplianceCheckEnabled && appConfigField.fieldName == 'indskr_hcpinteraction' && ( this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0),
        showArrow: this.isNotReadOnly && !(this.isSolicitatedMeetingComplianceCheckEnabled && appConfigField.fieldName == 'indskr_hcpinteraction' && (this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0),
        formFieldType: ((appConfigField.fieldName === 'indskr_activitytype' || appConfigField.fieldName === 'indskr_activitysubtype')) ? FormFieldType.NEW_PAGE_SELECT : getConfigFormFieldType(appConfigField.fieldType),
        isRequired: (this.isNotReadOnly && appConfigField.mandatory == "true" && !this.backgroundUploadInProgress && !(this.isSolicitatedMeetingComplianceCheckEnabled && appConfigField.fieldName == 'indskr_hcpinteraction' && ( this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0)) ? true : false,
        errorMessage: appConfigField.mandatory == "true" && !(this.isSolicitatedMeetingComplianceCheckEnabled && appConfigField.fieldName == 'indskr_hcpinteraction' && ( this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0)? this.activityService.getErrorMessageRequiredField() : undefined,
        isEmptyRequiredField: appConfigField.isEmptyRequiredField,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName, appConfigField.fieldName, appConfigField.fieldLabel),
      };
    }
    return viewData;
  }

  private setOfflineDataForConfigFields() {
    if (this.appointmentConfigFields.length > 0 && this.activityService.selectedActivity.appConfigFields.length > 0) {
      this.activityService.selectedActivity.appConfigFields.forEach(o => {
        let fieldName = o.fieldName
        this.appointmentConfigFields.map(obj => {
          if (obj.fieldName === fieldName) {
            if (o.value !== undefined || o.value !== "") {
              obj.value = o.value;
              this.isValueUpdated = true;
            }
            if (o.selectedValues !== undefined || o.selectedValues !== "") {
              obj.selectedValues = o.selectedValues;
              obj.hasMultipleValues = o.hasMultipleValues;
              obj.multipleLabels = o.multipleLabels;
              obj.multipleValues = o.multipleValues;
              this.isValueUpdated = true;
            }
          }
        })
      })
    } else {
      this.isValueUpdated = false;
      this.initConfigFieldsSetup();
    }
  }


  private getOptionSetValue(fieldName: string): string {
    if (fieldName && this.activityService.selectedActivity) {
      let activity = this.activityService.selectedActivity;
      if (activity.appConfigFields && activity.appConfigFields.length) {
        let fieldFilter = activity.appConfigFields.filter(o => { return o.fieldName === fieldName });
        if (fieldFilter && fieldFilter.length) {
          let field = fieldFilter[0];
          if (field.hasMultipleValues) {
            let count = (field.multipleLabels && field.multipleLabels.length) ?? 0;
            if (count > 1) {
              return (field.multipleLabels[0] + ' +' + (count-1));
            } else {
              return field.selectedValues;
            }
          } else {
            return field.selectedValues;
          }
        }
      }
    }
    return '';
  }

  private getLookupValue(fieldName: string): string {
    if (fieldName && this.activityService.selectedActivity) {
      let activity = this.activityService.selectedActivity;
      if (activity.appConfigFields && activity.appConfigFields.length) {
        let fieldFilter = activity.appConfigFields.filter(o => { return o.fieldName === fieldName });
        if (fieldFilter && fieldFilter.length) {
          let field = fieldFilter[0];
          if (field.stringValue) {
            return field.stringValue;
          }
        }
      }
    }
    return '';
  }

  private getOptionSetField(fieldName: string): ConfiguredFields {
    if (fieldName && this.activityService.selectedActivity) {
      let activity = this.activityService.selectedActivity;
      if (activity.appConfigFields && activity.appConfigFields.length) {
        let fieldFilter = activity.appConfigFields.filter(o => { return o.fieldName === fieldName });
        if (fieldFilter && fieldFilter.length) {
          let field = fieldFilter[0];
          return field;
        }
      }
    }
    return null;
  }

  private getInputText(fieldType, fieldValue, fieldName?) {
    switch (fieldType) {
      case 'String':
        this.updateInputStringValue(fieldName, fieldValue);
        return this.appConfigInputText;
      case 'Uniqueidentifier':
        this.appConfigProcessValue = fieldValue;
        return this.appConfigProcessValue;
      case 'Boolean':
        if (fieldValue === undefined) {
          this.appConfigInputBoolValue = "";
        } else {
          this.appConfigInputBoolValue = (fieldValue === true || String(fieldValue).toLowerCase() === 'true') ? 'Yes' : 'No';
        }
        return this.appConfigInputBoolValue;
      case 'DateTime':
        if (fieldValue != undefined) {
          this.formattedDate = fieldValue ? this.dateTimeFormatsService.formatDate(new Date(parseInt(fieldValue.toString())), this.dateTimeFormatsService.dateTimeToUpper) : this.formattedDate;
        }
        return this.formattedDate;
      case 'Lookup':
        return this.getLookupValue(fieldName);
      case 'Picklist':
        return this.getOptionSetValue(fieldName);
      case 'Virtual':
        return this.getOptionSetValue(fieldName);
      case 'Owner':
        return this.activityService.selectedActivity.meetingOwnerName;
      case 'Currency':
        this.appConfigCurrencyValue = fieldValue;
        return this.appConfigCurrencyValue;
      case 'Integer':
        this.appConfigIntegervalue = fieldValue;
        return this.appConfigIntegervalue;
      case 'Decimal':
        this.appConfigDecimalvalue = fieldValue;
        return this.appConfigDecimalvalue;
      case 'Memo':
        if (fieldValue !== undefined) {
          this.appConfigMemovalue = fieldValue;
        } else {
          this.appConfigMemovalue = '';
        }
        return this.appConfigMemovalue;
      default:
        break;
    }
  }

  private updateInputStringValue(fieldName, fieldValue) {
    this.appConfigInputText = fieldValue;
  }

  public isCheckMandatoryFieldValidationIsFailed(): boolean {
    let fieldNames: string[] = [];
    let count = 0;
    let inputValues: any[] = [];
    const currentSubType = this.activityService.selectedActivity?.indskr_activitysubtype;
    let appConfigFields: ConfiguredFields[] = this.appointmentConfigFields.filter(reqField => {
      if (reqField.mandatory !== 'true' || reqField.readOnly !== false) return false;
      // Only validate fields applicable to the currently selected sub-type.
      // Fields with subTypeIds are sub-type-specific (shown in format detail section);
      // they should not block completion when a different sub-type is active.
      const subTypeIds: string[] = reqField['subTypeIds'] || [];
      if (subTypeIds.length > 0 && !subTypeIds.includes(currentSubType)) return false;
      return true;
    });

    if (this.activityService.selectedActivity && this.activityService.selectedActivity.appConfigFields) {
      let inActivityAppConfigFields = this.activityService.selectedActivity.appConfigFields.filter(reqField => { return (reqField.mandatory === 'true' && reqField.readOnly === false) });
      if (inActivityAppConfigFields && inActivityAppConfigFields.length) {
        appConfigFields.forEach(cf => {
          let key = cf.fieldName;
          if (key) {
            let inActivityAppConfigFieldValue = inActivityAppConfigFields.filter(cf => { return cf.fieldName === key });
            if (inActivityAppConfigFieldValue && inActivityAppConfigFieldValue.length) {
              let first = inActivityAppConfigFieldValue[0];
              if (first.value && first.value !== '') {
                inputValues.push({
                  'key': key,
                  'value': first.value
                });
              } else if (first.selectedValues && first.selectedValues !== '') {
                inputValues.push({
                  'key': key,
                  'value': first.selectedValues
                });
              }
            }
          }
        });
      }
    }
    if (appConfigFields.length) {
      appConfigFields.forEach(configuredField => {
        let key = configuredField.fieldName;
        if (key) {
          let result = inputValues.filter(r => { return r.key === key });
          if (!result.length) {
            fieldNames.push(configuredField.fieldLabel.toLowerCase());
            count = count + 1;
          }
        }
      });
    }
    if (count > 0) {
      this.configMandatoryField = fieldNames.join(', ');
      return true;
    } else {
      return false;
    }
  }


  private getplaceholderLabel(fieldType, fieldLabel) {
    let appConfigInputText
    switch (fieldType) {
      case 'String':
        appConfigInputText = fieldLabel;
        break;
      case 'Uniqueidentifier':
        appConfigInputText = fieldLabel;
        break;
      case 'Boolean':
        appConfigInputText = fieldLabel;
        break;
      case 'DateTime':
        appConfigInputText = fieldLabel
        break;
      case 'Lookup':
        appConfigInputText = fieldLabel
        break;
      case 'Picklist':
        appConfigInputText = fieldLabel
        break;
      case 'Virtual':
        appConfigInputText = fieldLabel
        break;
      case 'Owner':
        appConfigInputText = fieldLabel
        break;
      case 'Currency':
        appConfigInputText = fieldLabel
        break;
      case 'Integer':
        appConfigInputText = fieldLabel
        break;
      case 'Memo':
        appConfigInputText = fieldLabel
        break;
      case 'EntityName':
        appConfigInputText = fieldLabel
        break;
      case 'Decimal':
        appConfigInputText = fieldLabel
      default:
        break;
    }
    return appConfigInputText;
  }

  getPlaceHolderForCompletedAct(fieldType, fieldLabel) {
    let appConfigInputText
    switch (fieldType) {
      case 'String':
        appConfigInputText = `${this.translate.instant('NO_EXIST')}${fieldLabel}`;
        break;
      case 'Uniqueidentifier':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`;
        break;
      case 'Boolean':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`;
        break;
      case 'DateTime':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'Lookup':
        appConfigInputText = `${this.translate.instant('NO_EXIST')} ${fieldLabel}`
        break;
      case 'Picklist':
        appConfigInputText = `${this.translate.instant('NO_EXIST')} ${fieldLabel}`
        break;
      case 'Virtual':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'Owner':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'Currency':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'Integer':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'Memo':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'EntityName':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
        break;
      case 'Decimal':
        appConfigInputText = `${this.translate.instant('NO')} ${fieldLabel}`
      default:
        break;
    }
    return appConfigInputText;
  }

  private handleFormFieldEvent(id, event, eventName, fieldName?, fieldLabel?) {
    if (id) {
      //during background upload, allow account/contact in read only
      if (id !== 'account-field' && id !== 'contact-field' && (this.backgroundUploadInProgress)) return;
      // Prevent account visit offline request
      if (this.activityService.accountVisitOfflineCheck(
        {
          isAccountVisitEnabled: this.isAccountVisitEnabled,
          isAccountVisitRecord: this.isAccountVisitRecord,
          isAccountVisitNestedMeeting: this.isAccountVisitNestedMeeting,
        },
        true,
      )) {
        return;
      }

      this.events.publish(EventName.ACTIVITY_DETAILS_INTERACTION);
      switch (id) {
        case 'subject-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.openSubjectPopover(event);
          }
          break;
        case 'start-date-field':
          this.openStartDatePicker(event);
          break;
        case 'end-date-field':
          this.openEndDatePicker(event);
          break;
        case 'location-field':
          this.handleLocationField(event);
          break;
        case 'account-field':
          this.openAccounts();
          break;
        case 'account-plans-field':
          this._handleAddAccountPlans(event);
          break;
        case 'contact-field':
          this.openContacts();
          break;
        case 'covisitor-field':
          this.openAccompainedUsers();
          break;
        case 'appConfig-text-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.appConfigInputText = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
            this.updateAppConfigInputValues(event, fieldName, 'String');
          }
          break;
        case 'appConfig-Lookup-field':
          this.openLookup(event,fieldName);
          break;
        case 'appConfig-Picklist-field':
          this.openPicklist(event, fieldName, id);
          break;
        case 'appConfig-MultiSelectPicklist-field':
          this.openPicklist(event, fieldName, id);
          break;
        case 'appConfig-Owner-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.openOwner(event, fieldName);
          }
          break;
        case 'appConfig-Currency-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.appConfigInputText = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
            this.updateAppConfigInputValues(event, fieldName, 'String');
          }
          break;
        case 'appConfig-Integer-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.appConfigIntegervalue = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
            this.updateAppConfigInputValues(event, fieldName, 'Int');
          }
          break;
        case 'appConfig-Memo-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.appConfigMemovalue = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
            this.updateAppConfigInputValues(event, fieldName, 'String');
          }
          break;
        case 'appConfig-EntityName-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.appConfigInputText = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
            this.updateAppConfigInputValues(event, fieldName, 'String');
          }
          break;
        case 'appConfig-Uniqueidentifier-field':
          if (eventName && eventName == 'input_value_confirm') {
            this.appConfigProcessValue = (event && event.target && event.target.value && event.target.value.length != 0) ? event.target.value : ''
            this.updateAppConfigInputValues(event, fieldName, 'Number');
          }
          break;
        case 'appConfig-Boolean-field':
          this.openBooleanPopover(event, fieldName);
          break;
        case 'appConfig-DateTime-field':
          this.onPeriodEndDateFieldClick(event, fieldName);
          break;
        case 'meeting-type-field':
          this.selectMeetingType(event);
          break;
        case 'meeting-activityType-field':
            if(event && eventName && eventName != undefined) {
              this.selectMeetingActivityType(event);
            }
          break;
        case 'meeting-activitySubType-field':
          this.selectMeetingSubActivityType(event);
          break;
        case 'covisitor-compliance':
          this.onCovisitorComplianceChange(event);
          break;
        case 'marketing-business-plan-field':
          this.openMarketingPlans();
          break;
        case 'coaching-plan-field':
          this.openCoachingPlans();
          break;
        case DateTimeFieldType.TimeDurationField:
          this.selectDuration(event);
          break;
        case 'meeting-outcome-field':
          this.handleMeetingOutcomeField(event);
          break;
        case 'competitor-products-field':
          this.handleCompetitorProductSelect();
          break;
        case 'is-meeting-linked-mbp-field':
          this.handleIsMeetingMBPSelect(event);
          break;
        case 'kit-booking-field':
          this.openKitBooking();
          break;
        default:
          break;
      }
    }
  }

  private async handleIsMeetingMBPSelect(event) {
    const activity = this.activityService.selectedActivity as AppointmentActivity;
    const isValueTrue = activity && activity.hasLinkedToMarketingBusinessPlan == true ? true : false;
    const viewData: IndDropdownListDetailModel = {
      id: 'is_mbp-select',
      data: [
        {
          id: 'yes',
          title: this.translate.instant('YES'),
          isSelected: isValueTrue,
        },
        {
          id: 'no',
          title: this.translate.instant('NO'),
          isSelected: !isValueTrue,
        }
      ],
      isMultipleSelectionEnabled: false,
    };
    const dropdownPopover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData },
      cssClass: 'dropdown-list-view',
      event,
    });
    await dropdownPopover.present();

    const selectionData = await dropdownPopover.onDidDismiss();
    if (
      Array.isArray(selectionData?.data?.selectedItems)
      && selectionData?.data?.selectedItems[0]
    ) {

      const selectedData = selectionData.data.selectedItems[0];
      const isSelectedValueTrue: boolean = selectedData.id === 'yes';
      let payload :any = { hasLinkedToMarketingBusinessPlan : isSelectedValueTrue };

      activity.hasLinkedToMarketingBusinessPlan = isSelectedValueTrue;
      this.meetinglinkedtoamarketingbusinessplanField.inputText = this.getIsMeetingMBPFormattedText(activity);

      if (this.device.isOffline || this.activityService.hasOfflineMeetingData(activity.ID)) {
        activity.hasLinkedToMarketingBusinessPlan = isSelectedValueTrue;
        if (!isSelectedValueTrue && activity.marketingBusinessPlanId) {
          this.updateMarketBusinessPlanInMeeting("", activity);
        }
        this.activityService.upsertMeetingsOfflineData(activity);
        return;
      }

      if (!isSelectedValueTrue && activity.marketingBusinessPlanId) {
        payload = {
          ...payload,
          indskr_marketingbusinessplan: ""
        }
      }

      const response = await this.meetingDataService.updateMeetingMarketingBusinessPlanOnline(
        'update', payload, activity.ID);
      if (!response) return;
      if (!isSelectedValueTrue && activity.marketingBusinessPlanId) {
        this.updateMarketBusinessPlanInMeeting("", activity);
      }
      this.activityService.upsertMeetingsOfflineData(activity);

    }
  }

  private getIsMeetingMBPFormattedText = (dataObj: AppointmentActivity): string => {
    let formattedText = this.translate.instant('NO');
    try {
      if (
        dataObj.hasLinkedToMarketingBusinessPlan === true
      ) {
        formattedText = this.translate.instant('YES');
      }
    } catch (error) {
      console.error('getIsMeetingMBPFormattedText')
    }
    return formattedText;
  }

  private async selectDuration(event) {
    const popover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: {
        viewData: {
          id: 'duration-field',
          data: range(1, 61).map(option => {
            return { title: option == 60 ? '1 Hour' : `${option} Minute${option > 1 ? 's' : ''}`, id: option.toString(), isSelected: lodashIsEqual(option, this.activityService.selectedActivity.durationInMinutes) }
          })
        }
      },
      event: event
    });
    await popover.present();
    const data = (await popover.onDidDismiss())?.data?.selectedItems[0];
    if (this.backgroundUploadInProgress) return;
    if (data) {
      let selectedDuration = parseInt(data.id);
      if (!lodashIsEqual(this.activityService.selectedActivity.durationInMinutes, selectedDuration)) {
        const startTime = new Date(this.activityService.selectedActivity.scheduledStart).toISOString();
        const endTime = this.dateTimeFormatsService.addMinutesToDate(this.activityService.selectedActivity.scheduledStart, selectedDuration).toISOString();
        const prevStartTime = startTime;
        const prevEndTime = endTime;

        this.updateMeetingDate({
          startTime,
          endTime,
          prevStartTime,
          prevEndTime,
        }, false);
        this.activityService.selectedActivity.resetScheduledStartLocale();
        let dateTimeValue = this.activityService.getFormattedDateTimeText();
        if (dateTimeValue) {
          this.meetingEndTime = dateTimeValue.endTime;
        }
      }
    } else {
      if(!this.meetingDurationField.inputValue) this.meetingDurationField.isEmptyRequiredField = true;
    }
  }

  private async selectMeetingSubActivityType(event) {
    if (isEmpty(this.activityService.selectedActivity.indskr_activitytype)) return;
    const activitySubTypes = this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, this.activityService.selectedActivity.indskr_activitytype);
    if (isEmpty(activitySubTypes)) {
      this.notificationService.notify(this.translate.instant("FORMAT_DETAILS_NOT_CONFIGURED"), 'Meeting Details');
      return;
    }
    const dropdownListDetail: IndDropdownListDetailModel = {
      id: 'meeting-activityType-field',
      data: activitySubTypes.map(option => {
        return { title: this.localisationService.getTranslatedString(option.indskr_name, EntityNameForTranslation.ActivityType), id: option.indskr_activitysubtypeid.toString(), isSelected: lodashIsEqual(option.indskr_activitysubtypeid, this.activityService.selectedActivity.indskr_activitysubtype) }
      })
    };
    const popover = await this.popoverCtrl.create({ component: IndDropdownListComponent, componentProps: { viewData: dropdownListDetail }, cssClass: 'subject-popover', event: event });
    await popover.present();
    await popover.onDidDismiss().then(async (data: any) => {
      this.isClickedFormatDetails = true;

      if (this.backgroundUploadInProgress) return;

      if (!isEmpty(data?.data?.selectedItems)) {
        const selectedActivitySubType = data.data.selectedItems[0];
        
        if (!lodashIsEqual(this.activityService.selectedActivity.indskr_activitysubtype, selectedActivitySubType.id)) {
          const selectedSubType = activitySubTypes.find(subType => subType.indskr_activitysubtypeid === selectedActivitySubType.id);
          const prevSelectedSubType = activitySubTypes.find(subType => subType.indskr_activitysubtypeid === this.activityService.selectedActivity.indskr_activitysubtype);
          if(prevSelectedSubType && !isEmpty(prevSelectedSubType.appConfigFields)) {
            await this.clearAppConfigFields(prevSelectedSubType.appConfigFields);
          }
          if (isEmpty(selectedSubType.appConfigFields) || this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
            if (!isEmpty(selectedSubType.appConfigFields))
              this.saveDefaultAppConfigFields(selectedSubType);
            await this.saveMeetingSubActivityType(selectedActivitySubType);
          } else {
            this.saveDefaultAppConfigFields(selectedSubType);
            await this.saveMeetingSubActivityType(selectedActivitySubType);
          }
          this.activityService.updateSelectedActivityProps({ modified: new Date() });
        }
      } else {
        if (!this.activitySubTypeFormField.inputValue) {
          this.activitySubTypeFormField.isEmptyRequiredField = true;
        }
      }
    });
  }

  private async clearAppConfigFields(appConfigFieldIds: string[]) {
    try {
      const notSupportedDataTypes = ['Boolean'];
      const appConfigFieldsToClearValue = cloneDeep(
        this.authService.user.configuredFields.filter(
          field => appConfigFieldIds.includes(field.appFieldId) 
        )
      );
      
      const configFieldsPayload = appConfigFieldsToClearValue.map(appfield => {
        //Cannot clear boolean value: false default
        if (notSupportedDataTypes.includes(appfield.fieldType)) {
          appfield.indskr_optionsetdefaultvalue = "false";
          appfield.indskr_optionsetdefaultext = "false";
        } else {
          appfield.indskr_optionsetdefaultvalue = null;
          appfield.indskr_optionsetdefaultext = null;
        }
        return this.activityService.createConfigFieldItem(appfield);
      });
      
      if (!isEmpty(configFieldsPayload)) {
        await this.saveAdditionalConfigFields(configFieldsPayload);
        configFieldsPayload.forEach(field => {
          const appfield = this.appointmentConfigFields.find(f => f.fieldName === field.fieldName);
          if (appfield) {
            appfield.value = field.value;
          }
        });
      }
    } catch (e) {
      console.error('clearAppConfigFields: ', e);
    }
  }

  private async saveMeetingSubActivityType(selectedActivitySubType: any) {
    const payload = {
      indskr_activitysubtype: selectedActivitySubType.id,
      activitySubTypeName: selectedActivitySubType.title
    };
    await this.meetingDataService.updateActivityTypeAndActivitySubType(
      this.activityService.selectedActivity as AppointmentActivity,
      payload,
      ActivityTypeCodeRaw.Appointment,
      "indskr_activitysubtype"
    );
  }

  private saveDefaultAppConfigFields(selectedSubType: MeetingSubActivityType) {
    if(this.authService.hasFeatureAction(FeatureActionsMap.MEETING_HIDE_SUBTYPE)) return;
    const configFieldsPayload = this.activityService.getDefaultIoConfigPayload(selectedSubType.indskr_activitysubtypeid);
    if (!isEmpty(configFieldsPayload)) {
      this.saveAdditionalConfigFields(configFieldsPayload).then(() => {
        configFieldsPayload.forEach(field => {
          const appfield = this.appointmentConfigFields.find(f => f.fieldName === field.fieldName);
          if(appfield) {
            appfield.value = field.value;
          }
        })
      });
    }
  }

  private async selectMeetingActivityType(event) {
    const data = this.meetingActivityTypes.map(option => {
      return { title: this.localisationService.getTranslatedString(option.indskr_name), id: option.indskr_activitytypeid.toString(), isSelected: lodashIsEqual(option.indskr_activitytypeid, this.activityService.selectedActivity.indskr_activitytype) }
    });
    const dropdownListDetail: IndDropdownListDetailModel = {
      id: 'meeting-activityType-field',
      data,
    };
    const popover = await this.popoverCtrl.create({ component: IndDropdownListComponent, componentProps: { viewData: dropdownListDetail }, cssClass: 'dropdown-list-view2', event: event });
    await popover.present();
    await popover.onDidDismiss().then(async (data: any) => {
      this.isClickedFormat = true;
      if (!isEmpty(data) && !isEmpty(data.data) && !isEmpty(data.data.selectedItems)) {
        if (this.backgroundUploadInProgress) return;
        const previousSelectedActivityType = this.activityService.selectedActivity.indskr_activitytype;
        const selectedActivityType = data.data.selectedItems[0];
        if (!lodashIsEqual(this.activityService.selectedActivity.indskr_activitytype, selectedActivityType.id)) {
          const expenseAction = await this.resolveFormatChangeForExpenses(selectedActivityType.id);
          if (!expenseAction) return;
          await this.meetingSubjectAutomateForAcino(selectedActivityType.title);
          const defaultActivitySubType = this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, selectedActivityType.id).find(ast => ast.indskr_default);
          const formattedDefaultActivitySubTypeName = defaultActivitySubType ? this.localisationService.getTranslatedString(defaultActivitySubType.indskr_name, EntityNameForTranslation.ActivityType) : '';
          let currentActivity:AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
          const arrayActivityToUpdate : AppointmentActivity[] = [];
          currentActivity.indskr_activitytype = selectedActivityType.id;
          currentActivity.activityTypeName = selectedActivityType.title;
          const prevSelectedSubTypeId = currentActivity.indskr_activitysubtype;
          currentActivity.indskr_activitysubtype = defaultActivitySubType ? defaultActivitySubType.indskr_activitysubtypeid : null;
          currentActivity.activitySubTypeName = defaultActivitySubType ? formattedDefaultActivitySubTypeName : null;
          if (!isEmpty(prevSelectedSubTypeId)) {
            const prevSelectedSubType = this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, previousSelectedActivityType)?.find(ast => ast.indskr_activitysubtypeid === prevSelectedSubTypeId);
            if (prevSelectedSubType && !isEmpty(prevSelectedSubType.appConfigFields)) {
              await this.clearAppConfigFields(prevSelectedSubType.appConfigFields);
            }
          }
          if (this.isAccountVisitRecord) {
            if (selectedActivityType.title === this.translate.instant("INSTORE")) {
              // check selected A/B Level Accounts
              if(this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_applyabaccountlevelfilter']){
                this.activityService.selectedActivity['accounts'].some(itemAcct => {
                  if (itemAcct.accountLevel !='548910000' && itemAcct.accountLevel !='548910001') {
                    this.notificationService.notify(this.translate.instant('NON_AB_LEVEL_ACCOUNT') , 'Meeting Details', 'top', ToastStyle.INFO);
                    this.selectedContacts.length=0;
                    this.activityService.selectedActivity['accounts'] =[];
                    this.activityService.selectedActivity['contacts'] = [];
                    currentActivity.location = ""
                    const nestedMeetings = this.activityService.getAccountVisitNestedMeetings(currentActivity.ID);
                    arrayActivityToUpdate.push(
                      ...nestedMeetings.map(a => {
                        return new AppointmentActivity({
                          _id: a._id ?? DB_KEY_PREFIXES.MEETING_ACTIVITY + a.ID,
                          _rev: a._rev ?? undefined,
                          activityid: a.ID,
                          offlineMeetingId: a.offlineMeetingId,
                          subject: a.subject,
                          scheduledstart: a.scheduledStart,
                          scheduledend: a.scheduledEnd,
                          indskr_parentcallid: a.indskr_parentcallid,
                          stateCode: 2,
                        });
                      })
                    );

                    return true
                  }
                })
              }
            }
            //Subject = Account Name - Activity - Format
            currentActivity['subject'] = (isEmpty(currentActivity.accountString)
              ? '' :
              (currentActivity.accountString + ' - ')) +
              this.translate.instant('ACCOUNT_VISIT') + ' - ' +
              selectedActivityType.title;
          } else {
            if (!this.isAccountVisitNestedMeeting && this.secondaryInfoService.isAppointmentSecInfoConfigured) {
              //Subject = HCP Name - Activity - Format - Rep Name
              if(this.secondaryInfoService.checkIfSchemaIsConfig('indskr_ActivityType', SecondaryInfoEntityName.Appointment))
                currentActivity['subject'] = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(this.activityService.selectedActivity, SecondaryInfoEntityName.Appointment);
            }
            else if (!this.isAccountVisitNestedMeeting && this.features.meetingAutoSubjectEnabled) {
              //Subject = HCP Name - Activity - Format - Rep Name
              currentActivity['subject'] =
                (isEmpty(currentActivity.contacts)
                  ? ''
                  : this.contactService.getFullNameForContactDisplaySequence(currentActivity.contacts[0]) + ' - ') +
                this.translate.instant('MEETING') +
                ' - ' +
                selectedActivityType.title +
                ' - ' +
                currentActivity.meetingOwnerName;
            }
            // When both MEETING_AUTO_SUBJECT and secondary info are disabled, subject should not update
            // when format changes (per OMNI-53187). No else branch needed - subject remains unchanged.
          }
          if (this.isInStoreMeeting || !isEmpty(this.activityService.selectedActivity['inStorePhotos'])) {
            await this.meetingDataService.updateInStorePhotos(this.activityService.selectedActivity['inStorePhotos'].map(photo => { return { photoAttachmentId: photo.indskr_photoattachmentid, deleted: true } }));
          }
          arrayActivityToUpdate.push(currentActivity);
          await this.displayLoader({ duration: 30000 });
          if (!this.device.isOffline) {
            if(this.isAccountVisitRecord) await this.meetingDataService.crudMeetingsOnlineWithOfflineUploadEndpoint(arrayActivityToUpdate);
            else {
              const payload = {
                indskr_activitytype: selectedActivityType.id,
                activityTypeName: selectedActivityType.title,
                indskr_activitysubtype: defaultActivitySubType ? defaultActivitySubType.indskr_activitysubtypeid : null,
                activitySubTypeName: defaultActivitySubType ? formattedDefaultActivitySubTypeName : null
              }
              if (!isEmpty(defaultActivitySubType?.appConfigFields))
                this.saveDefaultAppConfigFields(defaultActivitySubType);
              await this.meetingDataService.updateActivityTypeAndActivitySubType((this.activityService.selectedActivity as AppointmentActivity), payload, ActivityTypeCodeRaw.Appointment, "indskr_activitytype");
              if (this.secondaryInfoService.isAppointmentSecInfoConfigured || this.features.meetingAutoSubjectEnabled) {
                const payload = new UpdateMeetingPayload();
                payload.subject = this.activityService.selectedActivity.subject;
                await this.meetingDataService.updateMeeting(this.activityService.selectedActivity as AppointmentActivity, payload);
              }
            }
          } else {
            await this.activityService.upsertMeetingsOfflineData(currentActivity, false, true);
          }
          currentActivity.modified = new Date();
          await this.dismissLoader();
          if (expenseAction === 'confirmScrap') {
            const notScrapped = await this.meetingExpenseService.scrapDraftsForMeeting(currentActivity.ID)
              .catch((err) => {
                console.error('ActivitiesDetailsPane: format-change expense scrap failed', err);
                return 1;
              });
            if (notScrapped > 0) {
              this.notificationService.notify(this.translate.instant('MEETING_EXPENSE_SCRAP_FAILED'), 'Meeting Details', 'top', ToastStyle.DANGER);
            }
          }
          this.footerService.initButtons(FooterViews.Activities)
          this.isGpsEnabled = this.features.GPSCheckInEnabled && !this.activityService.isRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype)
          this.isLiveTimeFieldEnabledForF2FMeetings =this.authService.hasFeatureAction(FeatureActionsMap.HIDE_LIVETIME_FOR_F2F_MEETINGS) && !this.activityService.isRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype)
          this.isContentRequiredForRemoteChannelEnabled = this.features.meetingContentReasonEnabled && this.activityService.isContentRequiredForRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype)
          this.initPhotosSectionHeader();
          await this.initFormFields();
          this.initPhotosSectionHeader();
          // The call type just changed, which changes which Samples & Materials
          // tabs are visible for this format — reset to the first visible tab
          // under the NEW format rather than leaving whatever was selected
          // under the OLD one. _initSamplesMaterialsSectionHeader's own
          // re-validation only corrects a tab that's become INvisible, not one
          // that's still visible but no longer the correct default (e.g.
          // Request stays selected after switching to a format that now also
          // shows Materials, which should take priority) (OMNI-60544).
          this.activeSamplesMaterialsSubTab = resolveDefaultSubTab({
            dropsVisible: this.features.sampleDropEnabled && this.isSampleDropSectionVisible,
            materialsVisible: this.features.promoMaterialEnabled && this.isPromoMaterialSectionVisible,
            requestVisible: this.features.sampleDeliveryRequestEnabled && this.isSdrSectionVisible,
          });
          this._initSamplesMaterialsSectionHeader();
          this.displayConflictMsg = false;
        }
      } else {
        if(!this.activityTypeFormField.inputValue) this.activityTypeFormField.isEmptyRequiredField = true;
      }
    });
  }

  async meetingSubjectAutomateForAcino(formatTitle) {
    if (this.authService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT)) {
      let subject = this.activityService.selectedActivity.subject;
      let contactFormattedSubject = '';
      let formatContactFormattedSubject = '';
      if (this.activityService.selectedActivity['contacts'] && this.activityService.selectedActivity['contacts'].length) {
        contactFormattedSubject = `${this.translate.instant('VISIT')} - ${this.contactService.getFullNameForContactDisplaySequence(this.activityService.selectedActivity['contacts'][0])}`
      }
      if (this.activityService.selectedActivity.activityTypeName) {
        formatContactFormattedSubject = `${this.activityService.selectedActivity.activityTypeName} ${contactFormattedSubject ? contactFormattedSubject : this.translate.instant('VISIT')} `
      }
      if (lodashIsEqual(subject, this.translate.instant('VISIT')) || lodashIsEqual(subject, contactFormattedSubject.trim()) || lodashIsEqual(subject, formatContactFormattedSubject.trim())) {
        subject = `${formatTitle} ${contactFormattedSubject ? contactFormattedSubject : this.translate.instant('VISIT')}`;
        await this.meetingSubjectUpdate(subject);
      }
    }
  }

  private async selectMeetingType(event) {

    const activity: AppointmentActivity = <AppointmentActivity>this.activityService.selectedActivity;

    const prevSelectedValue = activity.indskr_meetingtype;

    let dropdownListDetail: IndDropdownListDetailModel = {
      id: 'meeting-type-select',
      data: this.activityService.meetingTypes.map(option => {
        let obj = {
          title: option.type,
          id: option.value.toString(),
          isSelected: false,
        };
        if (prevSelectedValue === option.value) {
          obj['isSelected'] = true;
        }
        return obj;
      }),
    };
    let popover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event
    })
    await popover.present();
    await popover.onDidDismiss().then(async (data: any) => {
      if (data && data.data && data.data.selectedItems && data.data.selectedItems.length == 1 && data.data.selectedItems[0].id != activity.indskr_meetingtype) {
        if (this.backgroundUploadInProgress) return;
        const seletectedMeetingType = parseInt(data.data.selectedItems[0].id);
        const payload = new UpdateMeetingPayload();
        payload.indskr_meetingtype = seletectedMeetingType;
        await this.displayLoader();
        if (!this.device.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
          try {
            await this.meetingDataService.updateMeeting(activity, payload, true);
          } catch (error) {
            console.error("Failed to update meeting type, resetting: error: ", error);
            const isSuccess = await this.activityService.upsertMeetingsOfflineData(activity, false, true);
            if (!isSuccess) {
              console.error("Failed to update meeting type, resetting")
              activity.indskr_meetingtype = prevSelectedValue;
              const errorMessage = error.errorId ? error.errorId : error.message;
              this.notificationService.notify(this.translate.instant('UPDATING_MEETING_TYPE_FAILED') + errorMessage, 'Meeting Details', 'top', ToastStyle.DANGER);
            }
          }
        }
        else {
          activity.indskr_meetingtype = seletectedMeetingType;
          const isSuccess = await this.activityService.upsertMeetingsOfflineData(activity);
          if (!isSuccess) {
            console.error("Failed to update meeting type in offline data, resetting")
            activity.indskr_meetingtype = prevSelectedValue;
          }
        }
        await this.dismissLoader();
      }
      this.isClickedMeetingTypes = true;
    });
  }

  private initActivitiesDetailsPageTitle(): void {
    let buttons = [];
    let reopenBtn = null;
    this.addAssignButton(buttons);
    this.addDictateButton(buttons);
    reopenBtn = this.addReopenButton(buttons);
    this.addActionButtons(buttons, reopenBtn, this.features.cancelMeetingWithReasonEnabled);

    this.activitiesDetailsPanePageTitle = {
      id: 'activities-details-page-title',
      title: this.initializeheaderTitle(),
      displayDefaultBackButton: this.navService.getCurrentPageName() === PageName.GoAppNotificationPageComponent ? this.device.isMobileDevice : true,
      controls: buttons,
      enableTooltipForTitle: this.secondaryInfoService.isAppointmentSecInfoConfigured
    };
  }

  private addAssignButton(buttons: any[]): void {
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ASSIGN_MEETING) && !this.isFromChat) {
      const notOwner = this.activityService.selectedActivity.ownerId !== this.authService.user.xSystemUserID;
      const notPrivilegedCovisitor = !(this.isCovisitor && this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS);
      const isDisabled = this.device.isOffline ||
        (this.activityService.selectedActivity as AppointmentActivity).state !== 0 ||
        (notOwner && notPrivilegedCovisitor) ||
        this.activityService.selectedActivity.status === 4;
      buttons.push({
        id: "assign-owner",
        imgSrc: 'assets/imgs/assign_owner_white.svg',
        name: this.translate.instant('ASSIGN'),
        isDisabled,
        align: "right",
      });
    }
  }

  private addDictateButton(buttons: any[]): void {
    if (!this.authService.hasFeatureAction(FeatureActionsMap.VOICE_NOTE_TAKER)) {
      return;
    }
    if (!(this.activityService.selectedActivity instanceof AppointmentActivity)) {
      return;
    }
    buttons.push({
      id: 'dictate',
      imgSrc: 'assets/imgs/action_button_mic.svg',
      name: this.translate.instant('DICTATE'),
      isDisabled: this.enableReadonlyViewForMeetings || this.backgroundUploadInProgress,
      align: 'right',
    });
  }

  /**
   * Dictate onto this meeting: capture the spoken account, let the rep review the
   * detected details, then merge them in. Additive only — the meeting's own
   * fields are left as the rep set them.
   */
  private async startDictate(): Promise<void> {
    const activity = this.activityService.selectedActivity;
    if (!(activity instanceof AppointmentActivity)) {
      return;
    }
    const [
      { VoiceNoteCaptureComponent },
      { VoiceNoteMeetingService },
      { VoiceNoteService },
      { VoiceNoteType },
    ] = await Promise.all([
      import('@omni/components/voice-notes/voice-note-capture/voice-note-capture'),
      import('@omni/services/voice-note/voice-note-meeting.service'),
      import('@omni/services/voice-note/voice-note.service'),
      import('@omni/classes/voice-note/voice-note.class'),
    ]);

    const capture = await this.modalCtrl.create({
      component: VoiceNoteCaptureComponent,
      componentProps: { type: VoiceNoteType.CallNote, primaryAction: 'update-meeting' },
      backdropDismiss: false,
      cssClass: VOICE_NOTE_CAPTURE_MODAL_CLASS_NAME,
    });
    await capture.present();
    const { data, role } = await capture.onDidDismiss();
    if (!data) {
      return;
    }
    if (role === 'save') {
      await this.injector.get(VoiceNoteService).saveCapture(data);
      this.notificationService.notify(
        this.translate.instant('DICTATE_SAVED_TO_MY_NOTES'),
        'Meeting Details',
        'top',
        ToastStyle.INFO,
      );
      return;
    }
    if (role !== 'update-meeting') {
      return;
    }
    if (data.detectionFailed) {
      this.notificationService.notify(
        this.translate.instant('DICTATE_DETECTION_FAILED_MERGE'),
        'Meeting Details',
        'top',
        ToastStyle.INFO,
      );
    }

    // Nothing reaches the meeting without the rep confirming it, so the review
    // opens whether or not the detector had a reading; without one it opens on
    // the dictation as spoken.
    const meetingService = this.injector.get(VoiceNoteMeetingService);
    const confirmed = await this.injector.get(DictationFlowService).reviewAndConfirm(
      detectionForReview(data.detected, { name: data.subject, transcript: data.transcript }),
      { targetMeeting: meetingService.describeMeeting(activity), transcript: data.transcript },
    );
    if (!confirmed) {
      // Dictated straight into the meeting, so nothing was ever saved as a note.
      await this.injector.get(DictationFlowService).offerToKeepCapture(data);
      return;
    }

    await this.displayLoader();
    try {
      const applied = await this.injector.get(VoiceNoteMeetingService).applyDictationToMeeting(activity, confirmed, data.transcript);
      this.preSavedNotes = activity.notes;
      // Each section swallows its own failure, so the counts are the only signal that the
      // write actually landed. Confirming nothing means the rep needs to know, not a tick.
      const addedAnything =
        applied.contacts + applied.accounts + applied.products + applied.keyMessages + applied.objectives > 0 ||
        applied.notesUpdated ||
        applied.locationSet;
      this.notificationService.notify(
        this.translate.instant(addedAnything ? 'DICTATE_ADDED_TO_MEETING' : 'DICTATE_NOTHING_ADDED'),
        'Meeting Details',
        'top',
        addedAnything ? ToastStyle.INFO : ToastStyle.DANGER,
      );
    } catch (error) {
      console.error('startDictate: applying dictation failed', error);
      this.notificationService.notify(
        this.translate.instant('SOMETHING_REALLY_BAD_HAPPENED'),
        'Meeting Details',
        'top',
        ToastStyle.DANGER,
      );
    } finally {
      await this.dismissLoader();
    }
  }

  private addReopenButton(buttons: any[]): any {
    if (this.authService.hasFeatureAction(FeatureActionsMap.MEETING_REOPEN)) {
      return {
        id: "reopen",
        imgSrc: 'assets/imgs/header_activity_reopen.svg',
        name: this.translate.instant('REOPEN'),
        isDisabled: !this.isSelectedActivityReopenable,
        align: "right"
      };
    }
    return null;
  }

  private addActionButtons(buttons: any[], reopenBtn: any, isCancelEnabled: boolean): void {
    const scrapButton = {
      id: "scrap",
      imgSrc: 'assets/imgs/header_cancel.svg',
      name: isCancelEnabled ? this.translate.instant('DELETE_OR_CANCEL_PROCEDURE_LOG_HEADER') : this.translate.instant('SCRAP'),
      isDisabled: !this.isScrapButtonEnabled || this.activityService.selectedActivity.status === 4,
      align: "right"
    };

    const completeButton = {
      id: "markComplete",
      imgSrc: 'assets/imgs/header_complete.svg',
      name: this.translate.instant('COMPLETE'),
      isDisabled: this.canNotComplete || this.activityService.selectedActivity.status === 4,
      align: "right"
    };

    if (this.uiService.showCancelDoneOnActivityDetails || this.activityService.selectedActivity.isFromXperiences) {
      if (reopenBtn) buttons.push(reopenBtn);
      buttons.push(scrapButton, completeButton);
    } else if (this.features.liveMeet) {
      buttons.push(scrapButton);
    } else {
      if (reopenBtn) buttons.push(reopenBtn);
      buttons.push(scrapButton);
      if (!(this.activityService.selectedActivity['isJointmeeting'] && (!this.activityService.isMeetingOwner && (this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS)))) {
        buttons.push(completeButton);
      }
    }
  }

  private get canNotComplete() {
    
    const activity = this.activityService.selectedActivity;
    if (!activity) return false;

    const isCompleted = activity.state === this.meetingState.Completed;
    const isReadonly = this.enableReadonlyViewForMeetings;
    const isUploading = this.backgroundUploadInProgress;
    const isOfflineNotSupported = this.device.isOffline && (this.isAccountVisitRecord || this.isAccountVisitNestedMeeting);
    const isNotOwner = !this.activityService.isMeetingOwner;
    const isNotPrivilegedCovisitor = !(this.isCovisitor && this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS);
    const hasNoEditRights = isNotOwner && isNotPrivilegedCovisitor;

    return hasNoEditRights || isCompleted || isReadonly || isUploading || isOfflineNotSupported;
  }

  private canNotAppeal() {
    let isDisabled = true;

    const isMeetingCompleted = this.activityService.selectedActivity
      && (!this.activityService.isMeetingOwner
        || this.activityService.selectedActivity.state == this.meetingState.Completed
        || this.activityService.selectedActivity.state == this.meetingState.Canceled
        || this.activityService.teamViewActive
        || this.backgroundUploadInProgress
        || (
          // Account visit meeting does not support offline yet
          this.device.isOffline
          && (
            this.isAccountVisitRecord
            || this.isAccountVisitNestedMeeting
          )
        )
      );

      if(isMeetingCompleted && !this.device.isOffline) {
        const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;

        if(currentMeeting.gpsCheckInDetails && !isEmpty(currentMeeting.gpsActivityPhotos)
        && (currentMeeting.gpsCheckInDetails.statuscode === GPSActivityApprovalStatus.DRAFT
          || !currentMeeting.gpsCheckInDetails.statuscode)
        && currentMeeting.gpsCheckInDetails.indskr_checkinstatus === GPS_STATUS.INVALID && currentMeeting.gpsCheckInDetails.indskr_checkoutstatus === GPS_STATUS.INVALID) {
          isDisabled = false;
        }

      }
      return isDisabled;
  }


  public onPageTitleControlClick(id: string) {
    switch (id) {
      case 'cancel':
      case 'close':
        if(this.isFromChat) this.modalCtrl.dismiss();
        else this.closepage();
        break;
      case 'done':
        this.markNewActivityOkay();
        break;
      case 'scrap':
        this.handleMeetingScrap();
        break;
      case 'dictate':
        this.startDictate();
        break;
      case 'markComplete':
        this.markComplete(true);
        break;
      case 'reopen':
        this.reopenMeeting();
        break;
      case 'assign-owner':
        this.openUsersList();
        break;
      default:
        break;
    }
  }

  private opportunitiesSectionHeader() {
    this.opportunitiesSectionTitle = {
      id: 'opportunities',
      title: this.translate.instant('OPPORTUNITIES'),
      controls: [
        {
          id: 'add-opportunities',
          text: this.translate.instant('ADD'),
          isDisabled: !(!this.activityService.selectedActivity.isCompleted && !this.isReadOnlyRecommendedMeeting && !this.enableReadonlyViewForMeetings  && this.features.opportunitySelectionEnabled) ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID
        }
      ]
    };
  }

  private initObjectivesSectionHeader() {
    this.objectiveSectionHeader = {
      id: 'objectives',
      title: this.translate.instant('OBJECTIVES'),
      controls: [
        {
          id: 'add-objectives',
          text: this.translate.instant('ADD'),
          isVisible: this.features.isMeetingObjectiveSelectionEnabled,
          isDisabled: this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.enableReadonlyViewForMeetings
        }
      ]
    };
  }

  private initGpsActivityPhotosSectionHeader() {
    this.gpsActivityPhotosSectionHeader = {
      id: 'gpsActivityPhotos',
      title: this.translate.instant('CHECK_IN_CHECK_OUT_PHOTOS_CAP'),
      controls: [
        {
          id: 'appeal',
          text: this.translate.instant('APPEAL'),
          isVisible: true,
          isDisabled: this.canNotAppeal()
        }
      ]
    };
  }

  private initEventsSectionHeader() {
    this.eventsSectionHeader = {
      id: 'meetingevents',
      title:  this.translate.instant('EVENTS'),
      controls: [
        {
          id: 'add-meetingevents',
          text: this.translate.instant('ADD'),
          isDisabled: !(!this.activityService.selectedActivity.isCompleted && !this.isReadOnlyRecommendedMeeting && !this.enableReadonlyViewForMeetings  && this.features.eventsEnabled) ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled
        }
      ]
    }
  }

  private initProceduresSectionHeader() {
    this.proceduresSectionHeader = {
      id: 'procedures',
      title: this.translate.instant('PROCEDURES'),
      controls: [
        {
          id: 'add-procedures',
          text: this.translate.instant('ADD'),
          isDisabled: this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.enableReadonlyViewForMeetings,
        }
      ]
    }
  }

  private initSupportingMaterialsSectionHeader() {
    this.supportingMaterialsSectionHeader = {
      id: 'supportingmaterials',
      title: this.translate.instant('SUPPORTING_MATERIALS'),
      controls: [
        {
          id: 'add-supportingmaterials',
          text: this.translate.instant('ADD'),
          isDisabled: this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.enableReadonlyViewForMeetings,
        }
      ]
    }
  }

  private initPhotosSectionHeader() {
    const activityTypeFieldText = this.activityService.selectedActivity.activityTypeName
      || this.meetingActivityTypes?.find(t => t.indskr_activitytypeid === this.activityService.selectedActivity.indskr_activitytype)?.indskr_name;
    this.isInStoreMeeting = this.isAccountVisitRecord && !this.isAccountVisitNestedMeeting && activityTypeFieldText === this.translate.instant("INSTORE");
    if (this.isInStoreMeeting) {
      this.photosSectionHeader = {
        id: 'photos',
        title: this.translate.instant('IN_STORE_PHOTOS'),
        controls: [
          {
            id: 'add-photos',
            text: this.translate.instant('ADD'),
            isDisabled: this.backgroundUploadInProgress
              || this.device.isOffline
              || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)
              || isEmpty(this.activityService.selectedActivity['accounts'])
              || this.activityService.selectedActivity['inStorePhotos']?.length >= 10
              || !this.activityService.isMeetingOwner || this.activityService.selectedActivity.isCompleted || this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.enableReadonlyViewForMeetings,
          }
        ]
      }
    }
  }

  private _handleAddOpportunities() {
    const accountIds = this.activityService.selectedActivity['accounts'].map(el => el.id)
    const contactIds = this.activityService.selectedActivity['contacts'].map(el => el.ID)
    let opportunitiesDataSet = this.opportunityService.opportunities.filter(item => item.opportunityName);
    let relatedOpportunitiesDataSet = opportunitiesDataSet.filter(item => accountIds.includes(item.accountID) || contactIds.includes(item.contactID) || this._checkIfOppHasTheseContacts(contactIds,item));
    const opportuntiesSelectionViewData: OpportunitySelectionViewDataModel = {
      isReadOnlyMode: this.activityService.selectedActivity.isCompleted ? true : false,
      opportunitiesDataSet: opportunitiesDataSet,
      relatedOpportunitiesData: relatedOpportunitiesDataSet,
      selectedOpportunities: this.applicableOpportunities,
      disableDoneButtonInOffline: false,
      isMultiSelection: true,
      callbackFromSelectionComponent: (event: string, newSelectedOpportunities: Array<Opportunity>, data: any) => this._handledOpportunitiesSelection(event, newSelectedOpportunities, data),
    };
    this.navService.pushWithPageTracking(PageName.OpportunitySelectionPage, PageName.OpportunitySelectionPage, { viewData: opportuntiesSelectionViewData }, PageName.OpportunitySelectionPage);
  }

  private _checkIfOppHasTheseContacts(contactIds:Array<string>,opp:Opportunity):boolean{
    let flag = false;
    for(let i=0;i<opp.stakeholders.length;i++){
      const stakeholder = opp.stakeholders[i];
      if(contactIds.includes(stakeholder.ID)){
        flag=true;
        break;
      }
    }
    return flag;
  }

  private _handleAddAssets() {
    const assets = this.applicableAssets.filter(asset => !asset.noaccess);
    const opportuntiesSelectionViewData: AssetSelectionViewDataModel = {
      viewMode: this.activityService.selectedActivity.isCompleted ? ComponentViewMode.READONLY : ComponentViewMode.SELECTION,
      selectedAssets: assets,
      callbackFromSelectionComponent: (event: string, selectedAssets: CustomerAsset[], data: any) => this._handledAssetsSelection(event, selectedAssets, data),
    };
    this.uiService.prevView = this.uiService.activeView;
    this.navService.pushWithPageTracking(PageName.FieldMaterialManagementPageComponent, PageName.FieldMaterialManagementPageComponent, { viewData: opportuntiesSelectionViewData }, PageName.FieldMaterialManagementPageComponent);
  }

  private async _handleAddAccountPlans(ev) {
    const accountIds = this.activityService.selectedActivity['accounts'].map(el => el.id)
    let accountPlanDataSet = [];
    if (accountIds.length) {
      this.accountManagementService.accountPlans.filter(ap => Number(ap.endDate) > this.activityService.selectedActivity.scheduledEnd.getTime() || !ap.endDate).forEach((e) => {
        if (accountIds.includes(e.accountId)) {
          accountPlanDataSet.push(e)
        }
      });
    } else {
      accountPlanDataSet = this.accountManagementService.accountPlans.filter(ap => Number(ap.endDate) > this.activityService.selectedActivity.scheduledEnd.getTime() || !ap.endDate);
    }
    if (accountPlanDataSet.length)
      accountPlanDataSet = this.sortListByFielName(uniqBy(accountPlanDataSet,'ID'), 'accountPlanName');
    const accountPlansSelectionViewData: AccountPlansSelectionPageModel = {
      isReadOnlyMode: this.activityService.selectedActivity.isCompleted,
      selectedAccPlans: this.applicableAccountPlans,
      selectableAccPlans: this.activityService.selectedActivity.isCompleted ? [] : accountPlanDataSet,
      disableDoneButtonInOffline: false,
      viewMode: this.activityService.selectedActivity.isCompleted ? ComponentViewMode.READONLY : ComponentViewMode.SELECTION,
      callbackFromSelectionComponent: (event: string, newSelectedAccountPlans: Array<AccountPlan>, data: any) => this.handleAccountPlanSelection(event, newSelectedAccountPlans, data),
    };
    this.navService.pushWithPageTracking(PageName.AccountManagementPageComponent, PageName.AccountManagementPageComponent, { viewData: accountPlansSelectionViewData }, PageName.AccountManagementPageComponent);
  }

  async handleAccountPlanSelection(event, newSelectedAccPlans: Array<AccountPlan>, data: any) {
    if (event && event == 'DONEBUTTONCLICK') {
      let accPlansPayload = [];
      newSelectedAccPlans.forEach(a => {
        accPlansPayload.push(a.ID);
      });
      const payload = accPlansPayload;
      this.applicableAccountPlans = [];
      accPlansPayload.forEach(item => {
        const foundAccountPlan = this.accountManagementService.getAccountPlanByPlanId(
          item
        );
        this.applicableAccountPlans.push(foundAccountPlan);
      });
      const origAccountPlans = (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans;
      if (this.applicableAccountPlans.length) {
        (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans = this.applicableAccountPlans.map(a => {
          return {
            accountPlanId: a.ID,
            accountPlanName: a.accountPlanName,
          }
        });
      } else {
        (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans = [];
      }
      await this.displayLoader();

      // Account visit
      if (
        this.isAccountVisitRecord
        || this.isAccountVisitNestedMeeting
      ) {
        let shouldRevert = false;
        try {
          const meeting: AppointmentActivity = this.activityService.getActivityByID(this.activityService.selectedActivity.ID) as AppointmentActivity;
          shouldRevert = !await this.meetingDataService.crudMeetingsOnlineWithOfflineUploadEndpoint(
            [meeting],
          );
          if (!shouldRevert) {
            this.activityService.selectedActivity = meeting;
          }
        } catch (error) {
          console.error('handleAccountPlanSelection: ', error);
          this.notificationService.notify(
            this.translate.instant('XPERIENCES_ERROR'),
            'Activity Detail',
            'top',
            ToastStyle.DANGER,
          );
          // Revert
          shouldRevert = true;
        }
        if (shouldRevert) {
          (this.activityService.selectedActivity as AppointmentActivity).associatedAccountPlans = origAccountPlans;
        }
        await this.dismissLoader();
        return;
      }

      await this.meetingDataService
        .addAccountPlansToMeeting(
          this.activityService.selectedActivity as AppointmentActivity,
          payload
        )
        .then(async (opportunities) => {
          await this.dismissLoader();
        });
    }
  }

  private _handleAddEvents() {
    this.activityService.prevSelectedActivity = this.activityService.selectedActivity;
    const eventsSelectionViewData: EventsSelectionViewDataModel = {
      isReadOnlyMode: this.activityService.selectedActivity.isCompleted,
      eventsDataSet: [],
      selectedEvents: this.applicableEvents,
      disableDoneButtonInOffline: false,
      viewMode: ComponentViewMode.ADDNEW,
      callbackFromSelectionComponent: (event: string, newSelectedEvents: Array<EventActivity>, data: any) => this._handledEventsSelection(event, newSelectedEvents, data),
    };
    this.navService.pushWithPageTracking(PageName.EventsToolPageComponent, PageName.EventsToolPageComponent, { viewData: eventsSelectionViewData }, PageName.EventsToolPageComponent);
  }

  private _handledOpportunitiesSelection(event, newSelectedOpportunities: Array<Opportunity>, data: any) {
    if (event && event == 'DONEBUTTONCLICK') {
      let opportuntiesPayload = [];
      newSelectedOpportunities.forEach(a => {
        opportuntiesPayload.push(a.ID);
      });
      const payload = opportuntiesPayload;
      this.applicableOpportunities = [];
      opportuntiesPayload.forEach(item => {
        let foundOpportunity = this.opportunityService.getOpportunityDetailsbyId(item);
        this.applicableOpportunities.push(foundOpportunity);
      });
      if (this.applicableOpportunities.length) {
        (this.activityService.selectedActivity as AppointmentActivity).associatedOpportunities = this.applicableOpportunities.map(a => {
          return {
            opportunityId: a.ID,
            opportunityName: a.opportunityName,
          }
        });
      } else {
        (this.activityService.selectedActivity as AppointmentActivity).associatedOpportunities = [];
      }
      this.displayLoader();
      this.meetingDataService.addOpportunitiesToMeeting(this.activityService.selectedActivity as AppointmentActivity, payload).then(async (opportunities) => {
        this.dismissLoader();
      });
    }
  }

  private async _handledAssetsSelection(event, selectedAssets: CustomerAsset[], data: any) {
    if (event && event == 'DONEBUTTONCLICK') {
      const assets = this.applicableAssets.filter(asset => !asset.noaccess);
      let newAssets = [];
      let removedAssets = [];
      if (isEmpty(assets) && !isEmpty(selectedAssets)) {
        newAssets = selectedAssets;
      } else if (!isEmpty(assets) && isEmpty(selectedAssets)) {
        removedAssets = selectedAssets;
      } else {
        removedAssets = intersectionBy(assets, selectedAssets, 'msdyn_customerassetid');
        newAssets = differenceBy(selectedAssets, removedAssets, 'msdyn_customerassetid');
      }
      this.displayLoader();
      await this.fieldMaterialManagementService.mapAssetsToMeeting(newAssets, removedAssets, this.activityService.selectedActivity?.ID).then(() => {
        this.dismissLoader();
        this.initMeetingAssets();
      }).catch(err=> {
        console.error("Error while mapping assets to meeting", err);
        this.dismissLoader();
      });
    }
  }

  private _handledEventsSelection(event, newSelectedEvents: Array<EventActivity>, data: any) {
    this.activityService.selectedActivity = this.activityService.prevSelectedActivity;
    if (event && event == 'DONEBUTTONCLICK') {
      let eventsPayload = [];
      newSelectedEvents.forEach(a => {
        eventsPayload.push(a.ID);
      });
      const payload = eventsPayload;
      this.applicableEvents = [];
      eventsPayload.forEach(item => {
        let foundEvent = this.eventsToolService.getEventDetailsbyId(item);
        this.applicableEvents.push(foundEvent);
      });
      if (this.applicableEvents.length) {
        (this.activityService.selectedActivity as AppointmentActivity).associatedEvents = this.applicableEvents.map(a => {
          return {
            eventId: a.ID,
            name: a.name,
          }
        });
      } else {
        (this.activityService.selectedActivity as AppointmentActivity).associatedEvents = [];
      }
      this.displayLoader();
      this.meetingDataService.addEventsToMeeting(this.activityService.selectedActivity as AppointmentActivity, payload).then(async (events) => {
        this.dismissLoader();
      });
    } else {
      this.activityService.prevSelectedActivity = undefined;
    }
    this._checkPageAndInitActivitiesFooterButtons()

  }


  private openTeamsMeeting() {
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      const activity = this.activityService.selectedActivity;
      const url = activity.indskr_teamslink;
      if (!url) return;
      this.websocket.removeSubscription(activity);
      this.activityDataService.updateTeamsMeetingSubject(activity.subject, activity.indskr_teams_meeting_id);
      if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
        if(this.device.deviceFlags.ios) {
          this.inAppBrowser.create(url, '_blank', { location: 'no', hideurlbar: 'yes', zoom: 'no' });
        }else {
          this.inAppBrowser.create(url, '_system', { location: 'yes', toolbar: 'yes', zoom: 'no' });
        }
      } else {
        if(this.device.deviceFlags.electron) {
          electronApi.openExternal(url);
        }else {
          window.open(url, "_system");
        }
      }
    }
  }

  /**
     * @description This method will save additional Config
     *
    */
  private pushAdditionalConfigOffline(payload) {
    if (this.activityService.selectedActivity.appConfigFields !== undefined) {
      let removeIndex = this.activityService.selectedActivity.appConfigFields.map(function (item) { return item.fieldName; }).indexOf(payload.fieldName);
      if (removeIndex > -1) {
        this.activityService.selectedActivity.appConfigFields.splice(removeIndex, 1);
      }
      this.activityService.selectedActivity.appConfigFields.push(payload);
    }
  }

  onFooterButtonClicked(buttonId: string) {
    // Prevent account visit offline request
    if (this.activityService.accountVisitOfflineCheck(
      {
        isAccountVisitEnabled: this.isAccountVisitEnabled,
        isAccountVisitRecord: this.isAccountVisitRecord,
        isAccountVisitNestedMeeting: this.isAccountVisitNestedMeeting,
      },
      true,
    )) {
      return;
    }

    switch (buttonId) {
      case 'message':
        this.sendMeetingURL(null);
        break;
      case 'meetingReopen':
        this.reopenMeeting();
        break;
      case 'teams_meeting':
        this.openTeamsMeeting();
        break;
      case 'meetingAssets':
        this._handleAddAssets();
        break;
      case 'checkin':
        this.checkInForMeeting();
        break;
      case 'checkout':
        this.checkOutMetting();
        break;
      case 'meetingassignOwner':
        this.openUsersList();
        break;
      case 'markcomplete':
        this.markComplete(true);
        break;
      default:
        break;
    }
  }

  get isSelectedActivityReopenable() {
    return (this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS) ?
    false : this.from == PageName.AccountPlanActivities ? false : this.activityService.selectedActivity.omnip_datecompleted ?
        !((!this.activityService.isMeetingOwner && (!this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS))
    || this.enableReadonlyViewForMeetings || !this.activityService.selectedActivity.isCompleted || this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)
    // "Completed Past Meeting Reopen Period" counts from the meeting's own scheduled end,
    // not from when it happened to be marked complete — otherwise a meeting scheduled long
    // ago but only just closed (e.g. an overdue Open meeting completed today) reads as
    // "completed 0 days ago" and stays reopenable indefinitely, regardless of how stale the
    // meeting itself is. Using scheduledEnd makes an already-overdue meeting immediately
    // non-reopenable the moment it's completed, same as one closed on time and left long enough.
    || this.dateTimeFormatsService.getDifferenceInDays(new Date(), new Date(this.activityService.selectedActivity.scheduledEnd)) >= this.authenticationOfflineService.user.pastMeetingReopenPeriod
    || this.backgroundUploadInProgress) : false;
  }

  refreshPlanToDO() {
    if (this.agendaFooterService.actSegment === 'agenda' && this.agendaFooterService.planTabSegment === 'planTabTodo') {
      this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
    }
  }

  checkConflictMsgDisplay(shouldForceCheck = false): boolean {
    const formatId = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_activitytype;
    if (this.meetingMandatoryConfig.shouldHideDateTimeFieldsForFormat(formatId)) {
      return false;
    }
    const flag = this.isNewlyCreatedActivity || this.shouldCheckConflict || shouldForceCheck;
    if (this.shouldCheckConflict && this.agendaFooterService.actSegment === 'week') {
      this.activityService.publishActivityEvent({ action: 'Update', activity: this.activityService.selectedActivity });
    }
    this.shouldCheckConflict = false;
    const activity = this.activityService.activities.find(a => a.ID === this.activityService.selectedActivity.ID);
    const hasConflict = (flag && activity?.conflictingActivityIds?.size > 0) ? true : false;
    const hasWarning = (this.authService.user.meetingProximityWarningPeriod > 0 && flag && activity?.closeByActivityIds?.size > 0) ? true : false;
    this.conflictMsg = hasWarning ? this.translate.instant('PROXIMITY_MEETING_WARNING') : this.translate.instant('ACTIVITY_CONFLICT_MSG');
    return hasConflict || hasWarning;
  }

  onTimeUpdated() {
    this.shouldCheckConflict = true;
  }

  private handleMandatoryFieldNotification(): boolean {
    const shouldDisplayMandatoryConfigFormFieldNotification: boolean = this.isCheckMandatoryFieldValidationIsFailed();
    const shouldDisplayCovisitorComplianceMandatoryFieldNotification: boolean = this.activityService.shouldShowCovisitorComplianceForm(this.activityService.selectedActivity)
      && this.requiredFields['covisitor-compliance']?.['isRequired'] === true
      && this.requiredFields['covisitor-compliance']?.['isAdded'] === false;

    let shouldReturn: boolean = shouldDisplayMandatoryConfigFormFieldNotification
      || shouldDisplayCovisitorComplianceMandatoryFieldNotification;

    let covisitorComplianceNotificationFn: () => void =
      shouldDisplayCovisitorComplianceMandatoryFieldNotification
      ? () => {
        this.notificationService.notify(
          this.translate.instant('MEETING_COMPLETE_FAIL_ALERT_COVISITOR_COMPLIANCE'),
          'Meeting Details',
          'top',
          ToastStyle.DANGER
        );
      }
      : null;

    if (shouldDisplayMandatoryConfigFormFieldNotification) {
      this.notificationService.notify(
        this.translate.instant('APP_CONFIG_FIELDS_MESSAGE_MEETING',
        { appConfigFieldName: this.configMandatoryField.toLowerCase() }),
        'Meeting Details',
        'top',
        ToastStyle.DANGER,
        3000,
        true,
        undefined,
        covisitorComplianceNotificationFn,
      );
    } else if (covisitorComplianceNotificationFn) {
      covisitorComplianceNotificationFn();
    }

    return shouldReturn;
  }

  private onCovisitorComplianceChange(event: CheckboxCustomEvent) {
    if (event && event.detail) {
      this.covisitorComplianceAck$.next(!!(event.detail.checked));
    }
  }
  private resetCovisitorComplianceAck() {
    if (
      this.activityService.selectedActivity instanceof AppointmentActivity
      && (this.activityService.selectedActivity as AppointmentActivity)?.covisitorComplianceAcked === true
      && (
        !this.activityService.selectedActivity.accompaniedUserList
        || (
          Array.isArray(this.activityService.selectedActivity.accompaniedUserList)
          && this.activityService.selectedActivity.accompaniedUserList.length === 0
        )
      )
    ) {
      this.covisitorComplianceAck$.next(false);
    }
  }

  /* To check foll.
    1.Feature Action is enabled
    2.Selected Contacts length is 1
    3.scheduledStart isAfter currentTimeStart
  */
    async calculateBestRecommendedTime() {

      /* To check foll.
        1.Feature Action is enabled
        2.Selected Contacts length is 1
        3.showBestTimeRecommendation is enabled for this user
        4.scheduledStart isAfter currentTimeStart
        5.Device should be online
      */
      if (this.isTimeRecommendationEnabled && this.selectedContacts.length === 1
        && this.authService.user.showBestTimeRecommendation && !this.device.isOffline) {

        const scheduledStart = new Date(this.activityService.selectedActivity.scheduledStart);
        const currentTimeStart: Date = new Date();


        if (this.dateTimeFormatsService.isAfterDate(scheduledStart, currentTimeStart)) {
          this.showTimeRecommendations = true;

          const contactId = this.selectedContacts[0]['ID'];

          this.getPicklistForRecommendedEngagementPeriod();
          await this.getRecommendedEngagementPeriodByContactId(contactId);
        }
        else {
          this.showTimeRecommendations = false;

          this.recommendedByCurrentTime = [];
        }
      }
      else {

        this.recommendedByCurrentTime = [];
      }
    }

    async closeRecommendedations(){
      this.showTimeRecommendations = false;
      this.authService.updateUserProps({ hideBestTimeRecommendationCount: this.authService.user.hideBestTimeRecommendationCount + 1 });

      if(this.authService.user.hideBestTimeRecommendationCount === this.authService.user.bestTimeRecommendationConfig){
        this.notificationService.notify(this.translate.instant('SETTINGS_RECOMMENDATIONS_BEST_TIME_MEETING_WARNING'), "Meeting Details", "top", ToastStyle.INFO, 3000);
        this.authService.updateUserProps({ showBestTimeRecommendation: false, hideBestTimeRecommendationCount: 0 });
      }

      await this.activityDataService.updateUserTimeRecommendation();
    }
    // update meeting date and upsert offline data
    private async updateMeetingDate(dateData, isUpdateStartDate: boolean = false) {
      const startTime = dateData.startTime;
      const endTime = dateData.endTime;
      const prevStartTime = dateData.prevStartTime;
      const prevEndTime = dateData.prevEndTime;

      let currentAppointmentActivity = this.activityService.selectedActivity;
      currentAppointmentActivity.scheduledStart = new Date(startTime);
      currentAppointmentActivity.scheduledEnd = new Date(endTime);
      const payload = new UpdateMeetingPayload();
      payload.scheduledStart = new Date(startTime);
      payload.scheduledEnd = new Date(endTime);
      try{
      const isUpdated = await this.meetingDataService.updateMeeting(this.activityService.selectedActivity as AppointmentActivity, payload, false, true, true, isUpdateStartDate)
        if (isUpdated && isUpdated != undefined) {
          const newDuration = this.dateTimeFormatsService.getDifferenceInMinutes(new Date(endTime), new Date(startTime));
          this.activityService.updateSelectedActivityProps({
            modified: new Date(),
            scheduledStart: new Date(startTime),
            scheduledEnd: new Date(endTime),
            durationInMinutes: newDuration,
          });
          this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledStart = new Date(startTime);
          this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledEnd = new Date(endTime);
          // upsert offline data
          await this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity);
          this.updateUIWithLatestTime();
        } else {
          // error handling
          if (this.meetingDataService.isErrorStartDateUpdateMeeting) {
            // Do not update the selected date in the case of error due to altering system date
            console.error('IndDatetimeFormComponent: onDismiss: error update meeting - start date');
            this.activityService.updateSelectedActivityProps({ scheduledStart: new Date(prevStartTime), scheduledEnd: new Date(prevEndTime) });
            this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledStart = new Date(prevStartTime);
            this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledEnd = new Date(prevEndTime);
            const dateTime = {startDateTime: this.activityService.selectedActivity.scheduledStart, endDateTime: this.activityService.selectedActivity.scheduledEnd};
            this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
          } else {
            this.activityService.updateSelectedActivityProps({ scheduledStart: new Date(startTime), scheduledEnd: new Date(endTime) });
            this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledStart = new Date(startTime);
            this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledEnd = new Date(endTime);
            const dateTime = {startDateTime: this.activityService.selectedActivity.scheduledStart, endDateTime: this.activityService.selectedActivity.scheduledEnd};
            this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
            // upsert offline data
            this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity);
          }
          if (this.activityService.selectedActivity instanceof AppointmentActivity && (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID))) {
            this.activityService.finalizeAgendaRefresh();
            this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
          }
          if (this.agendaFooterService.actSegment === 'week') {
            const displayActivity = this.activityService.displayActivities.find(a => a.ID === this.activityService.selectedActivity.ID);
            if (displayActivity) {
              displayActivity.scheduledStart = new Date(currentAppointmentActivity.scheduledStart);
              displayActivity.scheduledEnd = new Date(currentAppointmentActivity.scheduledEnd);
              this.activityService.publishActivityEvent({action: "Update", activity: this.activityService.selectedActivity});
            }
          } else {
            this.activityService.finalizeAgendaRefresh();
          }
          this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
          const dateTime = {startDateTime: this.activityService.selectedActivity.scheduledStart, endDateTime: this.activityService.selectedActivity.scheduledEnd};
          this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
        }
      }catch(error ) {
        console.error('IndDatetimeFormComponent: onDismiss: ', error);
        this.activityService.updateSelectedActivityProps({ scheduledStart: new Date(startTime), scheduledEnd: new Date(endTime) });
        this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledStart = new Date(startTime);
        this.activityService.getActivityByID(this.activityService.selectedActivity.ID).scheduledEnd = new Date(endTime);
        // upsert offline data
        this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity, false, true);
        const dateTime = {startDateTime: this.activityService.selectedActivity.scheduledStart, endDateTime: this.activityService.selectedActivity.scheduledEnd};
        this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
      };
    }

  private updateUIWithLatestTime() {
    const currentAppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    if (currentAppointmentActivity && (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID))) {
      this.activityService.finalizeAgendaRefresh();
      this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
    }
    if (this.agendaFooterService.actSegment === 'week' || this.activityService.newHomeView === 'calendarView') {
      // Date Time is updated on calendar view
      // After the update, calendar view needs to refresh the cell data from displayActivities array
      // Hence, we want to update the record in displayActivities array before publishing an update event
      // We can publish refreshAgenda event but try to update only the record in the array instead
      // because running refreshAgenda is expensive.
      const displayActivity = this.activityService.displayActivities.find(a => a.ID === this.activityService.selectedActivity.ID);
      if (displayActivity) {
        displayActivity.scheduledStart = new Date(currentAppointmentActivity.scheduledStart);
        displayActivity.scheduledEnd = new Date(currentAppointmentActivity.scheduledEnd);
        this.activityService.publishActivityEvent({ action: "Update", activity: this.activityService.selectedActivity });
      }
    } else {
      this.activityService.finalizeAgendaRefresh();
    }
    this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
    const dateTime = { startDateTime: this.activityService.selectedActivity.scheduledStart, endDateTime: this.activityService.selectedActivity.scheduledEnd };
    this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
  }

    public notesChanged(ev): void {
      if (this.backgroundUploadInProgress) return;
      if (ev && ev.target) {
        this.tempNoteText = ev.target.value;
        this.isSaveNotesEnabled = true;
      } else {
        this.tempNoteText = '';
        this.isSaveNotesEnabled = true;
      }
      this.initMeetingNotesSectionHeader();
    }

    get nonDeletedNotes() {
      const hasOffLabelAccess = this.authService.hasOffLabelNotesAccess();
      return this.activityService.selectedActivity.meetingNotes
        .filter(note => !note.isDeleted && (!this.autoSavedNote || note.noteId != this.autoSavedNote.noteId))
        .filter(note => !note.isOffLabel || hasOffLabelAccess);
    }

    public isNoteControlsEnabled(note: IONote): boolean {
      return (((this.isCovisitor && (this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS || this.features.coVisitorAccess === CovisitorAccess.MINIMUM_ACCESS)) || this.activityService.isMeetingOwner) && note.ownerId == this.authService.user.systemUserID && !this.activityService.selectedActivity?.isCompleted);
    }

    get isOffLabelNotesEnabled(): boolean {
      return this.authService.hasOffLabelNotesAccess();
    }

    // Off-label notes are only ever created on explicit Add click (see
    // createMeetingNoteOnAdd), never via auto-save-on-blur, so there is never an
    // in-flight/already-saved draft for this toggle to race against or need to
    // correct after the fact - it only needs to update the local flag here.
    public toggleNewNoteOffLabel(event: CustomEvent) {
      this.isNewNoteOffLabel = event.detail.checked;
      this.initMeetingNotesSectionHeader();
    }

    public onOffLabelNativeToggle(event: Event): void {
      const checked = (event.target as HTMLInputElement).checked;
      this.toggleNewNoteOffLabel({ detail: { checked } } as CustomEvent);
    }

    public async addMeetingNote() {
      if (!((this.tempNoteText && !isEmpty(this.tempNoteText)) || !isEmpty(this.base64str))) {
        return;
      }

      if (this.isOffLabelNotesEnabled) {
        // BU_APPOINTMENT_GA_OFFLABEL_NOTES is on: skip auto-save entirely and only
        // ever create the note here, on explicit Add click. Auto-saving on blur
        // would create the note before the toggle's own change is even knowable
        // (a checkbox's change event fires after blur), which is what caused notes
        // to flip between Normal/Off-label - creating only here, reading the
        // toggle fresh at this exact moment, removes that class of bug entirely.
        await this.createMeetingNoteOnAdd();
        return;
      }

      // Clicking Add blurs the textarea first, which kicks off the auto-save
      // create for this note under activityService.task. Wait for that to fully
      // finish (including the server round-trip that swaps the temp offline id
      // for the real one) before clearing autoSavedNote - otherwise
      // updateNoteIdFromResponse finds autoSavedNote already null, the note
      // keeps its temp id forever, and any later edit to it gets misread as a
      // brand new note and re-created on the server.
      await this.activityService.task.waitForCompletion();
      this.autoSavedNote = null;
      this.isSaveNotesEnabled = false;
      this.isNewNoteOffLabel = false;
      this.removeMeetingNoteAttachment(null);
      this.tempNoteText = '';
      this._sortMeetingNotes();
      this.initMeetingNotesSectionHeader();
    }

    private async createMeetingNoteOnAdd(): Promise<void> {
      // Snapshot the draft and clear it synchronously, before any await. A fast
      // double-click/double-tap on Add dispatches two separate click events; without
      // this, both would see tempNoteText/base64str still populated and each call
      // createMeetingNoteOnAdd(), creating two notes for one piece of text - the
      // same class of race this whole session has been about, just in a new spot.
      const noteText = this.tempNoteText;
      const attachmentBase64 = this.base64str;
      const attachmentFile = this.attachmentFile;
      const isOffLabel = this.isNewNoteOffLabel;
      this.isSaveNotesEnabled = false;
      this.isNewNoteOffLabel = false;
      this.tempNoteText = '';
      this.base64str = null;
      this.attachmentFile = null;

      this.trackingService.tracking('MeetingNotesUpdate', TrackingEventNames.ACTIVITY);
      const now = new Date().getTime().toString();
      const tempNote: any = {
        annotationid: 'offlinmeetingnote' + now,
        activityid: this.activityService.selectedActivity.ID,
        createdon: now,
        notetext: noteText,
        ownerName: this.authService.user.displayName,
        ownerid: this.authService.user.systemUserID,
        deleted: false,
        pendingPushForDynamics: true,
        isdocument: false,
        isOffLabel: isOffLabel
      };

      if (attachmentBase64) {
        tempNote.isdocument = true;
        tempNote.documentbody = attachmentBase64;
        tempNote.filename = attachmentFile.name;
        tempNote.filesize = attachmentFile.size;
        tempNote.mimetype = attachmentFile.type;
      } else {
        tempNote.hasDocument = false;
      }

      const currentNote = new IONote(tempNote);
      this.activityService.getActivityByID(this.activityService.selectedActivity.ID).meetingNotes = this.activityService.selectedActivity.meetingNotes;
      this.activityService.getDisplayctivityByID(this.activityService.selectedActivity.ID).meetingNotes = this.activityService.selectedActivity.meetingNotes;
      this.activityService.selectedActivity.meetingNotes.push(currentNote);

      await this.activityService.task.begin();
      try {
        await this.displayLoader();
        await this.activityService.updateMeetingNoteInOfflineDB(tempNote);
        if (!this.device.isOffline) {
          await this.meetingDataService.uploadMeetingNotesOnline().then(res => {
            if (res && Array.isArray(res) && res.length > 0 && res[0].noteid) {
              currentNote.noteId = res[0].noteid;
            }
          });
        } else if (this.activityService.selectedActivity.ID.includes('offline')) {
          this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity);
        } else {
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(this.activityService.selectedActivity as AppointmentActivity, true);
        }
      } catch (error) {
        console.error('createMeetingNoteOnAdd: ' + error);
      } finally {
        await this.activityService.task.complete();
        await this.dismissLoader();
      }

      this.removeMeetingNoteAttachment(null);
      this._sortMeetingNotes();
      this.initMeetingNotesSectionHeader();
    }

    public async updateNote(ev) {
      if (!ev || !ev.action) {
        return;
      }
      if (this.backgroundUploadInProgress) {
        return;
      }
      const noteIndex = this.activityService.selectedActivity.meetingNotes.findIndex(note => note.noteId === ev.noteId);
      if (noteIndex < 0) {
        console.error("Error : coundn't find note id --> ", ev.noteId);
        return;
      }
    
      const existingNote = this.activityService.selectedActivity.meetingNotes[noteIndex];
      const offlinePayload = this.createOfflinePayload(existingNote);
    
      await this.processNoteUpdate(ev, noteIndex, existingNote, offlinePayload);
    }
    
    private createOfflinePayload(existingNote: any): any {
      const payload: any = {
        annotationid: existingNote.noteId,
        activityid: this.activityService.selectedActivity.ID,
        createdon: existingNote.createdTime.getTime().toString(),
        notetext: existingNote.noteText,
        ownerName: existingNote.ownerName,
        ownerid: existingNote.ownerId,
        isdocument: existingNote.hasDocument,
        filename: existingNote.documentName,
        mimetype: existingNote.documentMimeType,
        filesize: existingNote.documentSize,
        pendingPushForDynamics: true,
        isOffLabel: existingNote.isOffLabel ?? false
      };
    
      this.addDocumentBodyIfNeeded(payload, existingNote);
      return payload;
    }
    
    private addDocumentBodyIfNeeded(payload: any, existingNote: any): void {
      const isOfflineNoteWithDocument = existingNote.noteId.includes("offlinmeetingnote") && 
                                       existingNote.hasDocument && 
                                       !isEmpty(existingNote.documentDataURL);
      
      if (isOfflineNoteWithDocument) {
        payload.documentbody = existingNote.documentDataURL;
      }
    }
    
    private async processNoteUpdate(ev: any, noteIndex: number, existingNote: any, offlinePayload: any): Promise<void> {
      if (ev.action === 'DELETE') {
        offlinePayload.deleted = true;
        this.handleNoteDeletion(ev, noteIndex);
      } else if (ev.action === 'SAVE') {
        this.handleNoteUpdate(ev, existingNote, offlinePayload);
      }

      await this.saveNoteChanges(offlinePayload, existingNote);
      this.updateChangeDetection();
    }
    
    private handleNoteDeletion(ev: any, noteIndex: number): void {
      this.activityService.selectedActivity.meetingNotes.splice(noteIndex, 1);
      
      if (!isEmpty(this.autoSavedNote) && this.autoSavedNote.noteId === ev.noteId) {
        this.autoSavedNote = null;
      }
    }
    
    private handleNoteUpdate(ev: any, existingNote: any, offlinePayload: any): void {
      this.updateNoteText(existingNote, offlinePayload, ev.updatedText);
      
      if (ev.attachmentFileUpdated) {
        [existingNote, offlinePayload] = this._updateAttachmentinNotes(existingNote, offlinePayload, ev);
      } else if (ev.isAttachmentRemoved) {
        [existingNote, offlinePayload] = this._resetDocumentDetailsOfNote(existingNote, offlinePayload);
      }
    }
    
    private updateNoteText(existingNote: any, offlinePayload: any, updatedText: string): void {
      const noteText = updatedText && !isEmpty(updatedText.trim()) ? updatedText : '';
      existingNote.noteText = offlinePayload.notetext = noteText;
    }
    
    private async saveNoteChanges(offlinePayload: any, existingNote: any): Promise<void> {
      try {
        await this.activityService.updateMeetingNoteInOfflineDB(offlinePayload);
        
        if (!this.device.isOffline) {
          await this.handleOnlineUploadIfValidResponse(existingNote);
        } else {
          await this.handleOfflineSave();
        }
      } catch (error) {
        console.error('updateMeetingNote: ' + error);
      }
    }
    
    private async handleOnlineUploadIfValidResponse(existingNote: any): Promise<void> {
      const response = await this.meetingDataService.uploadMeetingNotesOnline();
      
      if (this.isValidUploadResponse(response)) {
        existingNote.noteId = response[0].noteid;
      }
    }
    
    private isValidUploadResponse(response: any): boolean {
      return response && Array.isArray(response) && response.length > 0 && response[0].noteid;
    }
    
    private updateChangeDetection(): void {
      this.cdRef.markForCheck();
      this.cdRef.markForCheck();
    }

    private _resetDocumentDetailsOfNote(note: IONote, offlinePayload: any) {
      note.documentSize = offlinePayload['filesize'] = 0;
      note.documentName = offlinePayload['filename'] = '';
      note.documentMimeType = offlinePayload['mimetype'] = '';
      note.documentDataURL = offlinePayload['documentbody'] = '';
      note.hasDocument = offlinePayload['isdocument'] = false;
      offlinePayload['fileremoved'] = true;
      return [note, offlinePayload];
    }

    private _updateAttachmentinNotes(note: IONote, offlinePayload: any, ev: any) {
      note.hasDocument = offlinePayload['isdocument'] = true;
      note.documentSize = offlinePayload['filesize'] = ev.documentSize;
      note.documentName = offlinePayload['filename'] = ev.documentName;
      note.documentMimeType = offlinePayload['mimetype'] = ev.documentMimeType;
      note.documentDataURL = offlinePayload['documentbody'] = ev.attachmentFileDataUrl;
      offlinePayload['fileupdated'] = true;
      return [note, offlinePayload];
    }

    private _sortMeetingNotes(): void {
      if (this.activityService.selectedActivity.meetingNotes && this.activityService.selectedActivity.meetingNotes.length > 1) {
        this.activityService.selectedActivity.meetingNotes.sort((a, b) => {
          return (this.dateTimeFormatsService.isBeforeDate(a.createdTime, b.createdTime) ? 1 : -1)
        })
      }
    }

    private getApplicableAssetsHeirarchyModel() {
      const hashTable = Object.create(null)
      this.applicableAssets = orderBy(this.applicableAssets, obj => obj.msdyn_name);
      this.applicableAssets.forEach(aData => hashTable[aData.msdyn_customerassetid] = this.getMainCardDataModel(aData));
      const dataTree = []
      this.applicableAssets.forEach(aData => {
        if (aData.msdyn_parentasset && hashTable[aData.msdyn_parentasset]) {
          hashTable[aData.msdyn_parentasset].showIcon = true;
          hashTable[aData.msdyn_parentasset].noLeftMarginLabel = true;
          hashTable[aData.msdyn_parentasset].childItems.push((hashTable[aData.msdyn_customerassetid]));
          hashTable[aData.msdyn_parentasset].childItems = orderBy(hashTable[aData.msdyn_parentasset].childItems, obj => obj.primaryTextRight);
        } else {
          dataTree.push(hashTable[aData.msdyn_customerassetid]);
        }
      })
      this.applicableAssetsModel = dataTree;
    }

    private getMainCardDataModel(asset: CustomerAsset) {
      let viewData: MainCardViewDataModel;
      viewData = {
        id: asset.msdyn_customerassetid,
        fixedHeight: true,
        primaryTextLeft: '',
        primaryTextRight: asset.msdyn_name,
        secondaryTextRight: asset.indskr_serialnumber ? this.translate.instant("SERIAL_NUMBER") + " : " + asset.indskr_serialnumber : '',
        secondaryTextRightTwo: '',
        isMainToolTemplate: true,
        childItems: [],
        iconName: 'chevron-forward-outline',
        isExpanded: false,
        isNotAutoExpanded: true,
        parentAsset: asset.msdyn_parentasset,
        mainItemCssClass: 'asset selector-item',
        showMoreInfo: true,
        moreInfo: [{
          label: this.translate.instant("CATEGORY"),
          value: asset.categoryName
        }, {
          label: this.translate.instant("PRODUCT"),
          value: asset.productName
        }, {
          label: this.translate.instant("STATUS"),
          value: asset.indskr_assetstatus
        }],
        clickHandler: async (id: string, event, specificTarget, refData) => {
          event?.stopPropagation();
          if (specificTarget == 'startIcon') {
            let card = this.findInDepth(id, this.applicableAssetsModel);
            card.isExpanded = !card.isExpanded;
            card.iconName = card.isExpanded ? 'chevron-down-outline' : 'chevron-forward-outline';
          } else if (specificTarget == 'endIcon') {
            await this.alertService.showAlert({
              title: this.translate.instant('ASSET_REMOVE_TITLE'),
              message: this.translate.instant('ASSET_REMOVE_MSG')
            }, this.translate.instant('REMOVE')
            ).then(async res => {
              if (res.role === 'ok') {
                const found = this.applicableAssets.find(a => a.msdyn_customerassetid == id);
                if (found) {
                  let removedAssets = [];
                  removedAssets.push(found);
                  let card = this.findInDepth(id, this.applicableAssetsModel);
                  if (card.childItems) {
                    const childCards = this.flattenTree(card.childItems);
                    childCards.forEach(c => {
                      let childAsset = this.applicableAssets.find(a => a.msdyn_customerassetid == c.id);
                      if (childAsset) {
                        removedAssets.push(childAsset);
                      }
                    });
                  }
                  this.displayLoader();
                  await this.fieldMaterialManagementService.mapAssetsToMeeting([], removedAssets, this.activityService.selectedActivity?.ID).then(() => {
                    this.dismissLoader();
                    this.initMeetingAssets();
                  }).catch(err => {
                    console.error("Error while mapping assets to meeting", err);
                    this.dismissLoader();
                  });
                }
              }
            });
          }
        },
      };
      if (!this.isReadOnlyMeeting && !this.device.isOffline) {
        viewData.showEndIcon = true;
        viewData.endIconType = 'indegene-selectors-remove-icon';
        viewData.endIconCssClass = 'remove-icon';
      }
      return viewData;
    }

  private findInDepth(id: string, array: any[]) {
    let result;
    array.some(o => o.id === id && (result = o) || (result = this.findInDepth(id, o.childItems || [])));
    return result;
  }


  async checkInForMeeting() {
    const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;
    const isMeetingValidDay = this.dateTimeFormatsService.isAfterDate(new Date(), new Date(currentMeeting.scheduledStart)) && this.dateTimeFormatsService.isBeforeDate(new Date(), new Date(currentMeeting.scheduledEnd)) || this.dateTimeFormatsService.getDifferenceInCalendarDays(new Date(currentMeeting.scheduledStart), new Date()) == 0
    let distance;
    let gpsCheckInStatus;

    if(this.device.isOffline){
      this.notificationService.notify(this.translate.instant('NETOWRK_UNAVAILABLE_CHECKIN'), 'Check In', 'top', ToastStyle.DANGER, 3000);
      return;
    }

    if(this.checkinProcess) return;
    this.checkinProcess = true;

    if (!isMeetingValidDay) {
      this.notificationService.notify(this.translate.instant('CHECKIN_DIFFERENT_DAY'), 'Check In', 'top', ToastStyle.DANGER, 3000);
      this.checkinProcess = false;
      return;
    }

    await this.displayLoader({duration : 30000});
    const currentCoordinates: any = await this.geolocationService.getCurrentPosition();

    this.isManualCheckinProcess = false;

    if (currentCoordinates.latitude <= 0) {
      this.notificationService.notify(this.translate.instant('UNABLE_TO_GET_LOCATION'), 'Check In', 'top', ToastStyle.DANGER, 3000);
      await this.dismissLoader();
      this.checkinProcess = false;

      // if manualGPSCheckinEnabled is ON then force user to do manual checkin incase of UNABLE_TO_GET_LOCATION
      if (this.features.manualGPSCheckinEnabled && await firstValueFrom(this.geolocationService.isEnabled$)) {
        let confirmedManualCheckIn = await this.showManualGPSConfirmAlert('AUTO_CHECK_IN_FAILED', this.translate.instant('MANUAL_CHECKIN_DISTANCE_WARNING'),'MANUAL_CHECKIN');
        if (!confirmedManualCheckIn) {
          this.checkinProcess = false;
          return;
        };
        this.isManualCheckinProcess = true;
        gpsCheckInStatus = GPS_STATUS.INVALID;
      }
      else
        return;
    };

    // if meeting doesn't have latitude and logitude
    if (!currentMeeting.indskr_meetinglocationlatitude && !currentMeeting.indskr_meetinglocationlongitude) {
      const selectedAddress = await this.accountService.getPrimaryAddressOfAccount(this.activityService.selectedActivity['accounts'][0].id);
      if (selectedAddress && selectedAddress.longitude && selectedAddress.latitude) {
        currentMeeting.location = selectedAddress.compositeAdd;
        currentMeeting.indskr_meetinglocationlongitude = selectedAddress.longitude;
        currentMeeting.indskr_meetinglocationlatitude = selectedAddress.latitude;
      } else {
        const coordinatesFromAddress = await convertAddressToCoords(currentMeeting.location);
        if (coordinatesFromAddress) {
          currentMeeting.indskr_meetinglocationlongitude = coordinatesFromAddress.longitude;
          currentMeeting.indskr_meetinglocationlatitude = coordinatesFromAddress.latitude;
        } else if(this.features.manualGPSCheckinEnabled) {
          await this.dismissLoader();
          // if manualGPSCheckinEnabled is ON then force user to do manual checkin incase of INVALID_ADDRESS
          let confirmedManualCheckIn = await this.showManualGPSConfirmAlert('AUTO_CHECK_IN_FAILED', this.translate.instant('MANUAL_CHECKIN_DISTANCE_WARNING'),'MANUAL_CHECKIN');
          if (!confirmedManualCheckIn) {
            this.checkinProcess = false;
            return;
          };
          this.isManualCheckinProcess = true;
          gpsCheckInStatus = GPS_STATUS.INVALID;
        }
        else {
          this.notificationService.notify(this.translate.instant('INVALID_ADDRESS'), 'Check Out', 'top', ToastStyle.DANGER, 3000);
          await this.dismissLoader();
          this.checkinProcess = false;
          return;
        }
      }
      await this.meetingDataService.updateMeetingLocation(currentMeeting);
      distance = calculateDistance(
        { latitude: currentCoordinates.latitude, longitude: currentCoordinates.longitude },
        { latitude: currentMeeting.indskr_meetinglocationlatitude, longitude: currentMeeting.indskr_meetinglocationlongitude },
        'M'
      );
    } else {
      distance = calculateDistance(
        { latitude: currentCoordinates.latitude, longitude: currentCoordinates.longitude },
        { latitude: currentMeeting.indskr_meetinglocationlatitude, longitude: currentMeeting.indskr_meetinglocationlongitude },
        'M'
      );
    }
    await this.dismissLoader();

    if(!this.isManualCheckinProcess) {
      if (distance > this.authService.user.validCallDistance) {

        if (this.features.manualGPSCheckinEnabled) {
          const fixedDistance = (distance / 1000).toFixed(2);
          const alertMsg = this.translate.instant(this.isAccountVisitRecord ? 'MANUAL_CHECKIN_WITH_DISTANCE_WARNING_AC' :'MANUAL_CHECKIN_WITH_DISTANCE_WARNING', { distance: fixedDistance });
          let confirmedManualCheckIn = await this.showManualGPSConfirmAlert('AUTO_CHECK_IN_FAILED', alertMsg,'MANUAL_CHECKIN');
          if (!confirmedManualCheckIn) {
            this.checkinProcess = false;
            return;
          };
          this.isManualCheckinProcess = true;
          gpsCheckInStatus = GPS_STATUS.INVALID;
        } else {
          let confirmedCheckIn = await this.showCheckInDistanceAlert((distance / 1000).toFixed(2));
          if (!confirmedCheckIn) {
            this.checkinProcess = false;
            return;
          };
          gpsCheckInStatus = GPS_STATUS.INVALID;
        }

      } else {
        let confirmedCheckIn = await this.showCheckInConfirmAlert();
        if (!confirmedCheckIn) {
          this.checkinProcess = false;
          return;
        };
        gpsCheckInStatus = GPS_STATUS.VALID;
      }
    }

    let payload: any = {
      indskr_checkinlongitude: currentCoordinates.longitude,
      indskr_checkinlatitude: currentCoordinates.latitude,
      indskr_checkindatetime: new Date(),
      indskr_checkindistance: distance,
      indskr_checkinstatus: gpsCheckInStatus
    }

    if(this.features.manualGPSCheckinEnabled && this.isManualCheckinProcess) {
      this.openPhotoCaptureViewerForGPSActivity(GPSActivity.CHECKIN,payload)
    } else {
      await this.displayLoader();

      const response: any = await this.meetingDataService.updateMeetingCheckInCheckout(currentMeeting, payload);
      if (!response) {
        await this.dismissLoader();
        this.checkinProcess = false;
        return;
      }

      currentMeeting.gpsCheckInDetails['indskr_checkinstatus'] = response.indskr_checkinstatus ?? gpsCheckInStatus;
      currentMeeting.gpsCheckInDetails['indskr_checkindatetime'] = response.indskr_checkindatetime ?? payload.indskr_checkindatetime;
      currentMeeting.gpsCheckInDetails['indskr_gpscheckindetailsid'] = response.indskr_gpscheckindetailsid;
      await this.disk.updateOrInsertActivityToActivityDetailRawDocument(this.activityService.selectedActivity as AppointmentActivity, true);
      await this.dismissLoader();
      this._checkPageAndInitActivitiesFooterButtons()
      await this.initFormFields();
      this.checkinProcess = false;
      this.notificationService.notify(this.translate.instant('GPS_CHECKIN_SUCESS'), 'Check In', 'top', ToastStyle.INFO, 3000);
    }
  }

  async checkOutMetting() {
    const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;
    const isMeetingToday = this.dateTimeFormatsService.getDifferenceInCalendarDays(new Date(currentMeeting.scheduledStart), new Date()) == 0;
    let gpsCheckOutStatus;
    let distance;

    const checkoutDateTime = new Date();
    // GPS check out min duration reminder
    if (currentMeeting.gpsCheckInDetails?.indskr_checkindatetime) {
      const { durationLimitInMin, actualDurationInMin, shouldAlert } = this.activityService.validateGpsCheckOutMinDurationViolation(
        new Date(currentMeeting.gpsCheckInDetails?.indskr_checkindatetime),
        checkoutDateTime,
      );

      if (shouldAlert) {
        if (!await this.activityService.showGPSCheckOutMinDurationReminder(durationLimitInMin, actualDurationInMin)) {
          return;
        }
      }
    }

    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant('NETOWRK_UNAVAILABLE_CHECKOUT'), 'Check Out', 'top', ToastStyle.DANGER, 3000);
      return;
    }
    // check GPS check-in duration
    if (this.isInStoreMeeting && this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT_FORMAT_INSTORE_MR)) {
      let minutesDifference = this.dateTimeFormatsService.getDifferenceInMinutes(new Date(),new Date(currentMeeting.gpsCheckInDetails.indskr_checkindatetime));
      if(minutesDifference < 15 ){
        let userclicked = await this.alertService.showAlert({
          header: '',
          message: this.translate.instant('FA_INSTORE_CHECK_GPS_DURATION',{N:15})
        }, this.translate.instant('CONTINUE'),  this.translate.instant('CANCEL')
        ).then(async res => {
          if (res.role === 'ok') {
          }else{
            return 'userClickedCancel';
          }
        }).catch((err) => console.error('catch event ! ' + err));
        if(userclicked == 'userClickedCancel') return;
      }
    }
    if (this.isInStoreMeeting && this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT_FORMAT_INSTORE_OSS)) {
      let minutesDifference = this.dateTimeFormatsService.getDifferenceInMinutes(new Date(),new Date(currentMeeting.gpsCheckInDetails.indskr_checkindatetime));
      if(minutesDifference < 30 ){
        let userclicked = await this.alertService.showAlert({
          header: '',
          message: this.translate.instant('FA_INSTORE_CHECK_GPS_DURATION',{N:30})
        }, this.translate.instant('CONTINUE'),  this.translate.instant('CANCEL')
        ).then(async res => {
          if (res.role === 'ok') {
          }else{
            return 'userClickedCancel';
          }
        }).catch((err) => console.error('catch event ! ' + err));
        if(userclicked == 'userClickedCancel') return;
      }
    }
    if (this.checkinProcess) return;
    this.checkinProcess = true;

    if (!isMeetingToday) {
      this.notificationService.notify(this.translate.instant('CHECKIN_DIFFERENT_DAY'), 'Check Out', 'top', ToastStyle.DANGER, 3000);
      this.checkinProcess = false;
      return;
    }
    await this.displayLoader({ duration: 30000 });
    const currentCoordinates = await this.geolocationService.getCurrentPosition();

    let confirmedCheckOut;
    this.isManualCheckinProcess = false;

    if (currentCoordinates.latitude <= 0) {
      this.notificationService.notify(this.translate.instant('UNABLE_TO_GET_LOCATION'), 'Check Out', 'top', ToastStyle.DANGER, 3000);
      await this.dismissLoader();
      this.checkinProcess = false;

      // if manualGPSCheckinEnabled is ON then force user to do manual checkout incase of UNABLE_TO_GET_LOCATION
      if (this.features.manualGPSCheckinEnabled && await firstValueFrom(this.geolocationService.isEnabled$)) {
        let confirmedManualCheckOut = await this.showManualGPSConfirmAlert('AUTO_CHECK_OUT_FAILED', this.translate.instant('MANUAL_CHECKOUT_DISTANCE_WARNING'),'MANUAL_CHECKOUT');
        if (!confirmedManualCheckOut) {
          this.checkinProcess = false;
          return;
        };
        confirmedCheckOut = CHECKOUT_OPTIONS.CHECKOUT;
        this.isManualCheckinProcess = true;
        gpsCheckOutStatus = GPS_STATUS.INVALID;
      }
      else
        return;
    };

    // if meeting doesn't have latitude and logitude
    if (!currentMeeting.indskr_meetinglocationlatitude && !currentMeeting.indskr_meetinglocationlongitude) {
      const selectedAddress = await this.accountService.getPrimaryAddressOfAccount(this.activityService.selectedActivity['accounts'][0].id);
      if (selectedAddress) {
        currentMeeting.location = selectedAddress.compositeAdd;
        currentMeeting.indskr_meetinglocationlongitude = selectedAddress.longitude ? selectedAddress.longitude : null;
        currentMeeting.indskr_meetinglocationlatitude = selectedAddress.latitude ? selectedAddress.latitude : null;
      } else {
        const coordinatesFromAddress = await convertAddressToCoords(currentMeeting.location);
        if (coordinatesFromAddress) {
          currentMeeting.indskr_meetinglocationlongitude = coordinatesFromAddress.longitude;
          currentMeeting.indskr_meetinglocationlatitude = coordinatesFromAddress.latitude;
        } if(this.features.manualGPSCheckinEnabled) {
          // if manualGPSCheckinEnabled is ON then force user to do manual checkin incase of INVALID_ADDRESS
          await this.dismissLoader();
          let confirmedManualCheckOut = await this.showManualGPSConfirmAlert('AUTO_CHECK_OUT_FAILED', this.translate.instant('MANUAL_CHECKOUT_DISTANCE_WARNING'),'MANUAL_CHECKOUT');
          if (!confirmedManualCheckOut) {
            this.checkinProcess = false;
            return;
          };
          confirmedCheckOut = CHECKOUT_OPTIONS.CHECKOUT;
          this.isManualCheckinProcess = true;
          gpsCheckOutStatus = GPS_STATUS.INVALID;
        } else {
          this.notificationService.notify(this.translate.instant('INVALID_ADDRESS'), 'Check Out', 'top', ToastStyle.DANGER, 3000);
          await this.dismissLoader();
          this.checkinProcess = false;
          return;
        }
      }
      await this.meetingDataService.updateMeetingLocation(currentMeeting);
      distance = calculateDistance(
        { latitude: currentCoordinates.latitude, longitude: currentCoordinates.longitude },
        { latitude: currentMeeting.indskr_meetinglocationlatitude, longitude: currentMeeting.indskr_meetinglocationlongitude },
        'M'
      );
    } else {
      distance = calculateDistance(
        { latitude: currentCoordinates.latitude, longitude: currentCoordinates.longitude },
        { latitude: currentMeeting.indskr_meetinglocationlatitude, longitude: currentMeeting.indskr_meetinglocationlongitude },
        'M'
      );
    }

    await this.dismissLoader();

    if(!this.isManualCheckinProcess) {
      if (distance > this.authService.user.validCallDistance) {

        if (this.features.manualGPSCheckinEnabled) {
          const fixedDistance = (distance / 1000).toFixed(2);
          const alertMsg = this.translate.instant(this.isAccountVisitRecord ? 'MANUAL_CHECKOUT_WITH_DISTANCE_WARNING_AC' : 'MANUAL_CHECKOUT_WITH_DISTANCE_WARNING', { distance: fixedDistance });
          let confirmedManualCheckOut = await this.showManualGPSConfirmAlert('AUTO_CHECK_OUT_FAILED', alertMsg,'MANUAL_CHECKOUT');
          if (!confirmedManualCheckOut) {
            this.checkinProcess = false;
            return;
          };
          confirmedCheckOut = CHECKOUT_OPTIONS.CHECKOUT;
          this.isManualCheckinProcess = true;
          gpsCheckOutStatus = GPS_STATUS.INVALID;
        } else {
          confirmedCheckOut = await this.showCheckOutConfirmAlert('CHECKOUT_DISTANCE_WARNING', (distance / 1000).toFixed(2));
          if (!confirmedCheckOut) {
            this.checkinProcess = false;
            return;
          };
          gpsCheckOutStatus =  GPS_STATUS.INVALID;
        }

      } else {
        confirmedCheckOut = await this.showCheckOutConfirmAlert(this.isAccountVisitRecord ? 'CHECKOUT_POSITIVE_AC' : 'CHECKOUT_POSITIVE');
        if (!confirmedCheckOut) {
          this.checkinProcess = false;
          return;
        };
        gpsCheckOutStatus =  GPS_STATUS.VALID;
      }
    }

    let payload: any = {
      indskr_checkoutlongitude: currentCoordinates.longitude,
      indskr_checkoutlatitude: currentCoordinates.latitude,
      indskr_checkoutdatetime: new Date(),
      indskr_checkoutdistance: distance,
      indskr_checkoutstatus: gpsCheckOutStatus,
      indskr_gpscheckindetailsid: currentMeeting.gpsCheckInDetails["indskr_gpscheckindetailsid"]
    }

    if (confirmedCheckOut === CHECKOUT_OPTIONS.CHECKOUT_COMPLETE) {
      await this.displayLoader();
      const response: any = await this.meetingDataService.updateMeetingCheckInCheckout(currentMeeting, payload);
      if (!response) {
        await this.dismissLoader();
        this.checkinProcess = false;
        return;
      };

      this.setCheckinCheckoutStatus(currentMeeting, payload);

      const markedComplete = await this.markComplete(true);
      if (!markedComplete) {
        await this.dismissLoader();
        return;
      };

      await this.activityService.upsertMeetingsOfflineData(currentMeeting);
      this._checkPageAndInitActivitiesFooterButtons()
      await this.dismissLoader();
      this.initFormFields();
      this.notificationService.notify(this.translate.instant('GPS_CHECKOUT_COMPLETE_SUCESS'), 'Check Out', 'top', ToastStyle.INFO, 3000);
    } else if (confirmedCheckOut === CHECKOUT_OPTIONS.CHECKOUT) {
      if(this.features.manualGPSCheckinEnabled && this.isManualCheckinProcess) {
        this.openPhotoCaptureViewerForGPSActivity(GPSActivity.CHECKOUT, payload)
      }
      else {
        await this.displayLoader();
        const response: any = await this.meetingDataService.updateMeetingCheckInCheckout(currentMeeting, payload);
        await this.dismissLoader();
        if (!response) {
          this.checkinProcess = false;
          return;
        };
        this.setCheckinCheckoutStatus(currentMeeting, payload);
        this.notificationService.notify(this.translate.instant('GPS_CHECKOUT_SUCESS'), 'Check Out', 'top', ToastStyle.INFO, 3000);
      }
    }
  }

  private async setCheckinCheckoutStatus(currentMeeting,payload ){
    currentMeeting.gpsCheckInDetails['indskr_checkoutstatus'] = payload.indskr_checkoutstatus;
    currentMeeting.gpsCheckInDetails['indskr_checkoutdatetime'] = payload.indskr_checkoutdatetime;
    await this.disk.updateOrInsertActivityToActivityDetailRawDocument(this.activityService.selectedActivity as AppointmentActivity, true);
    this.footerService.hideButton('checkout');
    this._checkPageAndInitActivitiesFooterButtons()
    this.initFormFields();
    this.checkinProcess = false;
  }

  async showCheckInConfirmAlert(): Promise<boolean> {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('CONFIRM_CHECKIN'),
      message :this.translate.instant('CHECKIN_CONFIRM_MESSAGE'),
      buttons: [{
        text: this.translate.instant('CANCEL'),
        role: 'cancel',
        handler: () => {
          return  false;
        },
      },{
        text: this.translate.instant('CHECK_IN_FOOTBAR'),
        role: 'confirm',
        handler: () => {
          return  true;
        },
      }],
    });
    await alert.present();

    return await alert.onDidDismiss().then((data) => {
      return data.role == "confirm";
    });

  }

  async showCheckInDistanceAlert(distance): Promise<any> {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('CONFIRM_CHECKIN'),
      message : this.translate.instant(this.isAccountVisitRecord ? 'CHECKIN_DISTANCE_WARNING_AC' : 'CHECKIN_DISTANCE_WARNING', { distance }),
      buttons: [{
        text: this.translate.instant('CHECKIN_ANYWAY'),
        role: 'confirm',
        handler: () => {
          return true
        },
      },{
        text: this.translate.instant('CANCEL'),
        role: 'cancel',
        handler: () => {
          return  false;
        },
      }],
    });
    await alert.present();

    return await alert.onDidDismiss().then((data) => {
      return data.role == "confirm" ;
    });
  }

  public async _handleLocationComponentCallback(selectedAddress) {
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      let meeting = this.activityService.selectedActivity;
      if (selectedAddress == null) {
        meeting.location = "";
        meeting.indskr_meetinglocationlongitude = null;
        meeting.indskr_meetinglocationlatitude = null;
      } else if (typeof selectedAddress === 'object') {
        meeting.location = selectedAddress.compositeAdd;
        if (selectedAddress.longitude && selectedAddress.latitude) {
          meeting.indskr_meetinglocationlongitude = selectedAddress.longitude;
          meeting.indskr_meetinglocationlatitude = selectedAddress.latitude;
        }
      } else {
        meeting.location = selectedAddress;
        const coordinatesFromAddress = await convertAddressToCoords(selectedAddress);
        if (coordinatesFromAddress) {
          meeting.indskr_meetinglocationlongitude = coordinatesFromAddress.longitude;
          meeting.indskr_meetinglocationlatitude = coordinatesFromAddress.latitude;
        } else {
          meeting.indskr_meetinglocationlongitude = null;
          meeting.indskr_meetinglocationlatitude = null;
        }
      }
      await this.meetingDataService.updateMeetingLocation(meeting);
      // Trigger GPS capture when location is changed via location screen
      await this.meetingLocationCaptureService.captureContactLocationDistance(meeting);
      this._checkPageAndInitActivitiesFooterButtons()
    }
  }

  async showCheckOutConfirmAlert(message, distance?) : Promise<any> {
    if (distance) {
      message = this.translate.instant(message, { distance });
    } else {
      message = this.translate.instant(message, {})
    }

    const alert = await this.alertCtrl.create({
      header: this.translate.instant('CONFIRM_CHECKOUT'),
      message,
      buttons: [{
        text: this.translate.instant(distance ? 'CHECKOUT_ANYWAY_AND_COMPLETE'  : 'CHECKOUT_COMPLETE'),
        role: 'confirm',
        handler: () => {
          return ({ values : CHECKOUT_OPTIONS.CHECKOUT_COMPLETE })
        },
      },{
        text: this.translate.instant('CHECK_OUT_ONLY'),
        role: 'confirm',
        handler: () => {
          return ({ values : CHECKOUT_OPTIONS.CHECKOUT })
        },
      },{
        text: this.translate.instant('CANCEL'),
        role: 'cancel',
        handler: () => {
          return ({ values : CHECKOUT_OPTIONS.CANCEL })
        },
      }],
    });
    await alert.present();

    return await alert.onDidDismiss().then(({data}) => {
      if(this.device.isOffline) {
        this.notificationService.notify(this.translate.instant('SOMETHING_REALLY_BAD_HAPPENED'), 'Check Out', 'top', ToastStyle.DANGER, 3000);
        return false;
      }
      return data ? data.values : false;
    });

  }

  async showManualGPSConfirmAlert(header,message, button) : Promise<any> {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant(header),
      message: message,
      buttons: [{
        text: this.translate.instant(button),
        role: 'confirm',
        handler: () => {
          return  true;
        },
      },{
        text: this.translate.instant('CANCEL'),
        role: 'cancel',
        handler: () => {
          return  false;
        }
      }],
    });
    await alert.present();

    return await alert.onDidDismiss().then((data) => {
      return data.role == "confirm";
    });
  }

  private openPhotoCaptureViewerForGPSActivity(activityType :number, gpsPayload) {
    if (!this.device.isNativeApp) {
      this.notificationService.notify(this.translate.instant('GPS_PHOTOS_WEB_WARNING'), 'Meeting Details', 'top', ToastStyle.DANGER);
      return;
    }
    let header;// = activityType === GPSActivity.CHECKIN ? 'MANUAL_CHECKIN': 'MANUAL_CHECKOUT';
    let activityPhotos: GPSActivityPhoto;
    const activity = (this.activityService.selectedActivity) as AppointmentActivity;
    if (activityType === GPSActivity.CHECKIN) {
      header = 'MANUAL_CHECKIN';
      if (!isEmpty(activity.gpsActivityPhotos)) {
        activityPhotos = activity.gpsActivityPhotos.find(gpsActivityPhoto => gpsActivityPhoto.indskr_type === 548910000);
      }
    } else {
      header = 'MANUAL_CHECKOUT';
      if (!isEmpty(activity.gpsActivityPhotos)) {
        activityPhotos = activity.gpsActivityPhotos.find(gpsActivityPhoto => gpsActivityPhoto.indskr_type === 548910001);
      }
    }
    let accountName = '';
    let etmsCode = '';
    if (!isEmpty(activity.accounts)) {
      accountName = activity.accountString;
      const account = this.accountService.getAccountById(activity.accounts[0].id);
      if (account?.extendedDetails['externalId']) {
        etmsCode = account.extendedDetails['externalId']
      }
    }
    const photoModel: IndPhotoCaptureViewerDataModel = {
      pageTitle: this.translate.instant(header),
      photosLimit: activityPhotos ? (10 - activityPhotos.photoAttachments.length) : 10,
      photoNameFormat: `${this.authService.user.displayName} ${accountName} ${etmsCode} {currentTimestamp} ${this.translate.instant(header)}.PNG`,
      photoOrigin: PhotoOrigin.GPS_CHECKIN,
      accountId: isEmpty(activity.accounts) ? '' : activity.accounts[0].id,
      errorMessage: this.translate.instant('MAX_PHOTO_NOTIFICATION', { limit: 10 }),
      callbackEvent: (data: []) => this._handlePhotoCaptureComponentCallbackForGPSActivity(data, activityType, gpsPayload)
    };
    this.navService.pushWithPageTracking(PageName.IndPhotoCaptureViewerComponent, PageName.IndPhotoCaptureViewerComponent, { photoModel: photoModel }, PageName.IndPhotoCaptureViewerComponent);
  }

  private async _handlePhotoCaptureComponentCallbackForGPSActivity(data: Photo[], activityType: number, gpsPayload) {
    if(!isEmpty(data))
    {
      const currentMeeting = (this.activityService.selectedActivity) as AppointmentActivity;
      let gpsActivitiyPayload = [{
        'indskr_type': activityType,
        'indskr_gpscheckindetailsid': currentMeeting.gpsCheckInDetails['indskr_gpscheckindetailsid'],
        'photoAttachmentIds': []
      }];

      await this.displayLoader({ duration: 30000 });
      if(activityType === GPSActivity.CHECKIN) {
        const response: any = await this.meetingDataService.updateMeetingCheckInCheckout(currentMeeting, gpsPayload, data, gpsActivitiyPayload);
        if (!response) {
          await this.dismissLoader();
          this.checkinProcess = false;
          return;
        }

        currentMeeting.gpsCheckInDetails['indskr_checkinstatus'] = response.indskr_checkinstatus ?? GPS_STATUS.INVALID;
        currentMeeting.gpsCheckInDetails['indskr_checkindatetime'] = response.indskr_checkindatetime ?? gpsPayload.indskr_checkindatetime;
        currentMeeting.gpsCheckInDetails['indskr_gpscheckindetailsid'] = response.indskr_gpscheckindetailsid;
        await this.disk.updateOrInsertActivityToActivityDetailRawDocument(this.activityService.selectedActivity as AppointmentActivity, true);
        this._checkPageAndInitActivitiesFooterButtons()
        this.initFormFields();
        this.checkinProcess = false;
      } else {
        const response: any = await this.meetingDataService.updateMeetingCheckInCheckout(currentMeeting, gpsPayload, data, gpsActivitiyPayload);
        if (!response) {
          this.checkinProcess = false;
          return;
        };
        await this.setCheckinCheckoutStatus(currentMeeting, gpsPayload);
      }

      await this.initGpsActivityPhotos();
      await this.dismissLoader();
      this.notificationService.notify(activityType === GPSActivity.CHECKIN?this.translate.instant('GPS_CHECKIN_SUCESS'):this.translate.instant('GPS_CHECKOUT_SUCESS'), 'Check In', 'top', ToastStyle.INFO, 3000);
    }
    else {
      let meeting = this.activityService.selectedActivity as AppointmentActivity;
      this.checkinProcess = false;

      if(activityType === GPSActivity.CHECKIN) {
        this.checkInField = {
          isDateField: true,
          label: this.translate.instant('CHECK_IN_STATUS'),
          inputText:  '',
          customPlaceholderLabel: meeting.gpsCheckInDetails && !meeting.gpsCheckInDetails.indskr_checkindatetime ? this.translate.instant('START_CHECK_IN') : '',
          id: 'check-in-field',
          isReadOnly: true,
          isRequired : this.features.gpsFunctionalityEnabled && meeting.state != MeetingActivityState.Completed,
          errorMessage: this.activityService.getErrorMessageRequiredField(),
          isEmptyRequiredField : this.checkinFieldsEmpty && this.features.gpsFunctionalityEnabled && meeting.gpsCheckInDetails.indskr_checkinstatus == null,
          isHidden :  !this.features.GPSCheckInEnabled ||this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype),
          eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
        }
      } else {
        this.checkOutField = {
          isDateField: true,
          label: this.translate.instant('CHECK_OUT_STATUS'),
          inputText: '',
          customPlaceholderLabel: meeting.gpsCheckInDetails && !meeting.gpsCheckInDetails.indskr_checkoutdatetime ?  this.translate.instant('START_CHECK_OUT') : '',
          id: 'check-out-field',
          isReadOnly: true,
          isHidden : !this.features.GPSCheckInEnabled ||this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype),
          eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
        }
      }

      this.detectChangesOnActivityDetails(true);
    }
  }

  public openPhotoViewerForGPSActivity(photoAttachment: PhotoAttachmentDto, activityType :number) {
    const header = activityType === GPSActivity.CHECKIN? 'MANUAL_CHECKIN': 'MANUAL_CHECKOUT';

    const photoModel: IndPhotoViewerDataModel = {
      pageTitle: this.translate.instant(header),
      masterPhotos: photoAttachment.photos,
      readOnly: true,
      callbackEvent: (data: []) => this._handlePhotoViewerCallback(data, photoAttachment)
    };
    this.navService.pushWithPageTracking(PageName.IndPhotoViewerComponent, PageName.IndPhotoViewerComponent, { photoModel: photoModel }, PageName.IndPhotoViewerComponent);
  }

  private async _handlePhotoViewerCallback(removedItems: PhotoResponse[], photoAttachment: PhotoAttachmentDto) {
    if (removedItems.length) {
      const removedAttachmentIds = removedItems.map((item) => item.indskr_photoattachmentid);
      const photos:PhotoResponse[] = lodashFilter(photoAttachment.photos, (photo) =>
        includes(removedAttachmentIds, photo.indskr_photoattachmentid)
      );
      const payload = photos.map(photo => ({ photoAttachmentId: photo.indskr_photoattachmentid, deleted: true }));
      await this.displayLoader();

      this.initGpsActivityPhotos();
      await this.dismissLoader();
    }
  }

  public async initGpsActivityPhotos() {
    if(this.features.manualGPSCheckinEnabled) {
      const activity = this.activityService.selectedActivity as AppointmentActivity;
      this.initAppealStatusFormField(activity);

      this.checkInPhotoAttachments = [];
      this.checkOutPhotoAttachments = [];
      const gpsActivityPhotos = activity.gpsActivityPhotos ?? [];
      gpsActivityPhotos.map(at => {
        if(at['indskr_type'] == GPSActivity.CHECKIN) {
          this.checkInPhotoAttachments.push({photos: at['photoAttachments'] });
        } else {
          this.checkOutPhotoAttachments.push({photos: at['photoAttachments'] });
        }
      });
    }
  }

  private initAppealStatusFormField(activity) {
    if(activity.gpsCheckInDetails && !isEmpty(activity.gpsActivityPhotos)
      && activity.gpsCheckInDetails.statuscode !== null && activity.gpsCheckInDetails.statuscode !== undefined
      && activity.gpsCheckInDetails.statuscode !== 1) {
      this.appealStatusFormField = {
        label: this.translate.instant('APPEAL_STATUS'),
        inputText: this.appealService.getAppealStatusFormattedValue(activity.gpsCheckInDetails['statuscode']),
        id: 'appeal-status',
        isReadOnly: true,
        isDisabled: true,
        showArrow: false,
      }
    }
  }

  async showMeetingCompleteAlert(){
    return this.uiService.displayAlertConfirmation({
      title: this.translate.instant('MARK_COMPLETE'),
      message: this.translate.instant('COMPLETE_WITHOUT_CHECKIN')+'?', // need to change the text
      cancelButtonText: this.translate.instant('NO'),
      confirmButtonText: this.translate.instant('YES')
    }).then((confirm) => {
      return confirm
    }).catch(err => {
      return false;
    });
  }

  async onContactsUpdated(data) {
    if (this.from === PageName.GoAppHomeComponent) {
      this.navCtrl.pop({ progressAnimation: false }).then(() => { 
        const modalElement = document.querySelector('ion-modal');
        if (modalElement?.classList.contains('fullStretchView')) {
          modalElement.classList.remove('fullStretchView');
        }
      });
      // Trigger GPS capture when contacts are updated (location may have been updated via contact selection)
      if (this.activityService.selectedActivity instanceof AppointmentActivity) {
        await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityService.selectedActivity);
      }
      return;
    }
    if (this.authService.user.meetingProximityWarningPeriod > 0) {
      this.shouldCheckConflict = true;
      if (this.uiService.toolsActivityActive) {
        this.activityService.signalActivityConflictCheck$.next(this.activityService.selectedActivity);
      } else {
        this.events.publish("refreshAgenda");
      }
    }
    // Trigger GPS capture when contacts are updated (location may have been updated via contact selection)
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityService.selectedActivity);
    }
  }

  private flattenTree(childItems) {
    return childItems.flatMap(child => isEmpty(child.childItems) ? child : [child, ...this.flattenTree(child.childItems)]);
  }

  private get isReadOnlyMeeting() {
    return this.enableReadonlyViewForMeetings || this.activityService.selectedActivity.isCompleted || this.isReadOnlyJointMeeting || this.backgroundUploadInProgress;
  }

  public get nativeShareAvailable() {
    if (this.device.isNativeApp && this.device.deviceFlags.electron) {
      return false;
    }
    if (!this.device.isNativeApp && (window as any).plugins?.socialsharing?.shareW3C === navigator.share) {
      return false;
    }
    if (this.device.isNativeApp && this.device.deviceFlags.ios) return !!(navigator.share);
    return !!(navigator.share && (!(navigator as any).canShare || (navigator as any).canShare({ url: location.href })));
  }

   // --------------------------------No Detailing in a Meeting-------------------------------- //
   private fetchMeetingContentReasons() {
    const meetingContentReasons = this.activityService.meetingContentReasons;
    if (isEmpty(meetingContentReasons)) {
      return []
    }
    return meetingContentReasons.map(res => {
      return {
        type: 'radio',
        name: res.indskr_name,
        label: res.indskr_name,
        value: res.indskr_meetingcontentreasonsid
      }
    })
  }

  public isCurrentContentNotPlayedByUser() {
    let isNotPlayed = true;

    let tempActivityResources = this.activityService.selectedActivity['activityResources'].map(a => ({...a}));
    tempActivityResources.forEach(function (element) {
      element['name'] = element['indskr_ckmtitle'];
    });

    const intersection_Presentations = intersectionBy(
      this.activityService.selectedActivity['presentations'],
      this.activityService.selectedActivity['activityPresentations'],
      'name'
    );


    const intersection_Resources = intersectionBy(
      this.activityService.selectedActivity['presentations'],
      tempActivityResources,
      'name'
    );


    if(!isEmpty(intersection_Presentations) || !isEmpty(intersection_Resources))
      isNotPlayed = false;

    return isNotPlayed;
  }

  public async onDiseaseAreasSave(event){
    if (!this.device.isOffline && !(this.activityService.selectedActivity as AppointmentActivity).ID.includes('offline')  && this.activityService.selectedActivity instanceof AppointmentActivity && event && Array.isArray(event)) {
      this.activityService.selectedActivity.activityDiseaseAreas = event.filter(item => item.isSelected || item.isAutoSelected).map((obj,idx)=> {
        return {
            "indskr_diseaseareaid": obj.id,
            "indskr_sequence": idx+1,
            "indskr_automaticallyselected": obj.isAutoSelected,
            "indskr_name": obj.label,
            "isSelected" : true,
        };
      });
      this.displayLoader();
      await this.meetingDataService.updateMeetingProductKeyMessages(this.activityService.selectedActivity,{products:false,indications:false,diseaseAreas:true}).then(response => {
        this.initDieseaseAreaSectionData();
      }).catch(err => {
        console.error(err);
        this.notificationService.notify(this.translate.instant('UPDATING_DISEASE_AREA_FAILED'), 'Meeting Details', 'top', ToastStyle.DANGER);
      })
      this.dismissLoader();
    }
  }

  public async onProductIndicationsSave(event){
    if (!this.device.isOffline && !(this.activityService.selectedActivity as AppointmentActivity).ID.includes('offline')  && this.activityService.selectedActivity instanceof AppointmentActivity && event && Array.isArray(event)) {
      this.activityService.selectedActivity.activityProductIndications = event.filter(item => item.isSelected || item.isAutoSelected).map((obj,idx)=> {
        return {
            "productIndicationId": obj.id,
            "indskr_sequence": idx+1,
            "indskr_automaticallyselected": obj.isAutoSelected,
            "indskr_name": obj.label,
            "isSelected" : true,
            activityProductIndicationKeyMessages: obj.childItems ? obj.childItems.filter(ci=> ci.isSelected || ci.isAutoSelected).map((obj2,idx2)=> {
              return {
                "indskr_keymessageid": obj2.id,
                "indskr_automaticallyselected": obj2.isAutoSelected,
                "indskr_name": obj2.label,
                "isSelected": true,
              };
            }) : [],
        };
      });
      this.displayLoader();
      await this.meetingDataService.updateMeetingProductKeyMessages(this.activityService.selectedActivity,{products:false,indications:true,diseaseAreas:false}).then(response => {
        this.initProductIndicationsSectionData();
      }).catch(err => {
        console.error(err);
        this.notificationService.notify(this.translate.instant('UPDATING_PRODUCT_INDICATION_FAILED'), 'Meeting Details', 'top', ToastStyle.DANGER);
      })
      this.dismissLoader();
    }
  }

  private async initDieseaseAreaSectionData(){
    if(!this.features.diseaseAreaEnabled){
      return;
    }
    let diseaseAreasList = [];
    this.selectedDiseaseAreas = [];
    if(this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings){
      if((this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas){
        (this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas.forEach(item => {
          this.selectedDiseaseAreas.push(item.indskr_diseaseareaid);
          if(item['indskr_diseaseareaid'] && item['indskr_name']){
            diseaseAreasList.push({
              id: item['indskr_diseaseareaid'],
              title: item['indskr_name'],
            })
          }
        });
      }
    }else{
      if((this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas){
        (this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas.forEach(item => {
          this.selectedDiseaseAreas.push(item.indskr_diseaseareaid);
        });
      }
      let offlineData = await this.disk.retrieve(DB_KEY_PREFIXES.CONTACT_DISEASE_AREAS);
      let usersPositionGroups = this.authenticationOfflineService.user.positionGroups ? this.authenticationOfflineService.user.positionGroups.map(a=> a.positionGroupId) : [];
      if(offlineData && offlineData.raw && Array.isArray(offlineData.raw)){
        offlineData.raw.forEach(item => {
          if(item['indskr_diseaseareaid'] && item['indskr_name'] && item['positionGroups'] && intersection(usersPositionGroups,item['positionGroups']).length > 0){
            diseaseAreasList.push({
              id: item['indskr_diseaseareaid'],
              title: item['indskr_name'],
            })
          }
        });
        if((this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas && (this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas.length > 0){
          (this.activityService.selectedActivity as AppointmentActivity).activityDiseaseAreas.forEach((acpi,idx) => {
            let selacpiidx = diseaseAreasList.findIndex(a=> a.id == acpi.indskr_diseaseareaid);
            if(selacpiidx >= 0){
              let element = diseaseAreasList[selacpiidx];
              diseaseAreasList.splice(selacpiidx, 1);
              diseaseAreasList.splice(idx, 0, element);
            }
          })
        }
      }
    }

    this.diseaseAreaSectionViewData= {
      id: 'meeting-disease-area',
      sectionHeaderViewData: {
        id: 'meetingdiseasearea',
        title: this.translate.instant('DISEASE_AREA'),
        controls: [
          {
            id: 'ri-header-save',
            text: this.translate.instant('SAVE'),
            isDisabled: true,
          }
        ]
      },
      isDisabled: this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.backgroundUploadInProgress || this.enableReadonlyViewForMeetings || this.device.isOffline || (this.activityService.selectedActivity as AppointmentActivity).ID.includes('offline') ,
      items: diseaseAreasList.map(a=> {
        return {
          id: a.id,
          label: a.title,
          value: a.id,
          isSelected: this.selectedDiseaseAreas.some(b=> b == a.id),
          isAutoSelected: false,
        }
      })
    }
  }

  private async initProductIndicationsSectionData(){
    if(!this.features.productIndicationEnabled) {
      return;
    }
    let productIndicationsList = [];
    this.selectedProductIndications= [];
    if(this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings){
      if((this.activityService.selectedActivity as AppointmentActivity).activityProductIndications){
        (this.activityService.selectedActivity as AppointmentActivity).activityProductIndications.forEach(item => {
          this.selectedProductIndications.push(item.productIndicationId);
          if(item['productIndicationId'] && item['indskr_name']){
            let obj = {
              id: item['productIndicationId'],
              title: item['indskr_name'],
              keyMessages: [],
            };
            if(item.activityProductIndicationKeyMessages){
              item.activityProductIndicationKeyMessages.forEach(keyMsg=> {
                this.selectedProductIndications.push(item.productIndicationId+keyMsg.indskr_keymessageid);
                obj.keyMessages.push({
                  id: keyMsg.indskr_keymessageid,
                  title: keyMsg.indskr_name,
                })
              })
            }
            productIndicationsList.push(obj);
          }
        });
      }
    }else{
      if((this.activityService.selectedActivity as AppointmentActivity).activityProductIndications){
        (this.activityService.selectedActivity as AppointmentActivity).activityProductIndications.forEach(item => {
          this.selectedProductIndications.push(item.productIndicationId);
        });
      }
      if(this.brandService.productIndications && Array.isArray(this.brandService.productIndications)){
        this.brandService.productIndications.forEach(item => {
          if(item['productid'] && (this.activityService.selectedActivity as AppointmentActivity).products && (this.activityService.selectedActivity as AppointmentActivity).products.some(p=> (p.isSelected || p.isAutoSelected) && p.ID == item['productid'])){
            if(item['productIndications']){
              item['productIndications'].forEach(indication=> {
                let selActProInd = (this.activityService.selectedActivity as AppointmentActivity).activityProductIndications.find(a=> a.productIndicationId == indication['indskr_productindicationid']);
                let obj = {
                    id: indication['indskr_productindicationid'],
                    title: indication['indskr_name'],
                    isSelected: selActProInd && selActProInd.isSelected,
                    isAutoSelected: selActProInd && selActProInd.indskr_automaticallyselected,
                    keyMessages: [],
                }
                if(indication['productIndicationsKeyMessages']){
                  indication['productIndicationsKeyMessages'].forEach(keyMsg=> {
                    if(this.authService.user.indskr_mapkeymessagestopositiongroup){
                      if(!this.brandService.keyMessagesByPositionGroups.some(a=> a.indskr_keymessageid == keyMsg['indskr_keymessageid'])){
                        return;
                      }
                    }
                    let selActProIndKeyMsg;
                    if(selActProInd){
                      selActProIndKeyMsg = selActProInd.activityProductIndicationKeyMessages.find(a=> a.indskr_keymessageid == keyMsg['indskr_keymessageid']);
                    }
                   obj.keyMessages.push({
                        id: keyMsg['indskr_keymessageid'],
                        title: keyMsg['indskr_name'],
                        isSelected: selActProIndKeyMsg && selActProIndKeyMsg.isSelected,
                        isAutoSelected: selActProIndKeyMsg && selActProIndKeyMsg.indskr_automaticallyselected,
                    });
                    this.selectedProductIndications.push(indication.indskr_productindicationid+keyMsg.indskr_keymessageid);
                 });
                }
                productIndicationsList.push(obj);
              });

            }
          }
        });
        if(productIndicationsList.length > 0){
          productIndicationsList = sortBy(productIndicationsList, [function (o) { return o.title; }]);
          productIndicationsList = sortBy(productIndicationsList, [function(o) { return o.isSelected || o.isAutoSelected}]);
        }
      }
    }

    this.productIndicationSectionViewData= {
      id: 'meeting-product-indication',
      sectionHeaderViewData: {
        id: 'meetingproductindication',
        title: this.translate.instant('PRODUCT_INDICATION'),
        controls: [
          {
            id: 'ri-header-save',
            text: this.translate.instant('SAVE'),
            isDisabled: true,
          }
        ]
      },
      isDisabled: this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.state == MeetingActivityState.Canceled || this.backgroundUploadInProgress || this.enableReadonlyViewForMeetings || this.device.isOffline || (this.activityService.selectedActivity as AppointmentActivity).ID.includes('offline') ,
      items: productIndicationsList.map(a=> {
        return {
          id: a.id,
          label: a.title,
          value: a.id,
          isSelected: this.selectedProductIndications.some(b=> b == a.id),
          isAutoSelected: a.isAutoSelected,
          childItems: a.keyMessages.map(b=> {
            return {
              id: b.id,
              label: b.title,
              value: b.id,
              isSelected: b.isSelected,
              isAutoSelected: b.isAutoSelected,
            }
          }),

        }
      })
    }
  }

  public openKeyMessageSentimentPage(ev) {
    if (!this.contactService.loadedContacts) return;
    if (this.enableReadonlyViewForMeetings || this.activityService.selectedActivity.isFromXperiences || ((this.activityService.selectedActivity.isCompleted
      || this.activityService.selectedActivity['indskr_suggest'] || this.activityService.selectedActivityJointMeetingStatus)
      && this.activityService.selectedActivity['contacts'].length > 0) || (this.device.isBackgroundUploadInProgress && this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID))) {
      if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent) {
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.activeView = '';
      }
      this.contactService.accessedContactListFrom = PageName.ActivitiesDetailsPaneComponent;
      this.uiService.showNewActivity = false;
      this.contactService.contactPageMode = ComponentViewMode.READONLY;
      this.navService.pushWithPageTracking(PageName.ContactPageComponent, PageName.ContactPageComponent, null, PageName.ContactPageComponent);
    } else {
      if (this.navService.getCurrentPageName() == PageName.AccountPageComponent) {
        this.uiService.prevView = '';
        this.uiService.activeView = '';
      } else if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent) {
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.activeView = '';
      }
      this.uiService.showNewActivity = false;
      this.contactService.contactPageMode = ComponentViewMode.ADDNEW;
      if (this.navService.getCurrentPageName() == PageName.ContactPageComponent) {
        this.contactService.accessedContactListFrom = PageName.ActivitiesDetailsPaneComponent;
      } else if (this.navService.getCurrentPageName() == PageName.GoAppActivitiesPageComponent) {
        this.contactService.accessedContactListFrom = PageName.ActivitiesDetailsPaneComponent;
      }
      if (this.uiService.activitiesPagePlanTabSelectedPlan == 'callPlans' || this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent) {
        this.contactService.contactInformation = undefined;
        this.uiService.contactDetailsSegment = undefined;
      }
      this.navService.pushWithPageTracking(PageName.ContactPageComponent, PageName.ContactPageComponent);
    }
  }
  // --------------------------------No Detailing in a Meeting-------------------------------- //

  async generateMeetingUrl(meetingId){
   let response:any = await this.meetingDataService.generateMeetingUrl(meetingId);
   (this.activityService.selectedActivity as AppointmentActivity).meetingURL = response.meetingUrl;
   this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity);
  }

  async handleMeetingOutcomeField(myEvent) {
    if (isArray(this.activityOutcomeOptions) && !isEmpty(this.activityOutcomeOptions)) {
      let activity: AppointmentActivity = <AppointmentActivity>this.activityService.selectedActivity;
      const prevSelectedValue = activity.meetingOutcomeId;
      let dropdownListDetail: IndDropdownListDetailModel = {
        id: 'activity_outcome_type',
        isMultipleSelectionEnabled: false,
        data: this.activityOutcomeOptions.map(type => {
          return {
            title: type.indskr_name,
            id: type.indskr_activityoutcomeid,
            isSelected: type.indskr_activityoutcomeid == (this.activityService.selectedActivity as AppointmentActivity).meetingOutcomeId,
          }
        }),
      };

      this.activityOutcomePopover = await this.popoverCtrl.create({ component: IndDropdownListComponent, componentProps: { viewData: dropdownListDetail }, cssClass: 'account-plan-select', event: myEvent });

      await this.activityOutcomePopover.present();

      await this.activityOutcomePopover.onDidDismiss().then(async (data) => {
        if (this.backgroundUploadInProgress) return;
        if (data && data.data && data.data.selectedItems && data.data.selectedItems.length == 1 && data.data.selectedItems[0].id != activity.meetingOutcomeId) {
          if (this.backgroundUploadInProgress) return;
          const seletectedMeetingOutcome = data.data.selectedItems[0].id;
          const payload = new UpdateMeetingPayload();
          payload.meetingOutcomeId = seletectedMeetingOutcome;
          payload.meetingOutcomeString = data.data.selectedItems[0].title;
          if (!this.device.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
            await this.displayLoader();
            try {
              await this.meetingDataService.updateMeeting(activity, payload, true);
            } catch (error) {
              console.error("Failed to update meeting type, resetting: error: ", error);
              const isSuccess = await this.activityService.upsertMeetingsOfflineData(activity, false, true);
              if (!isSuccess) {
                console.error("Failed to update meeting type, resetting")
                activity.meetingOutcomeId = prevSelectedValue;
                const errorMessage = error.errorId ? error.errorId : error.message;
                this.notificationService.notify(this.translate.instant('UPDATING_MEETING_OUTCOME_FAILED') + errorMessage, 'Meeting Details', 'top', ToastStyle.DANGER);
              }else{
                activity.meetingOutcomeId = seletectedMeetingOutcome;
                activity.meetingOutcomeString = data.data.selectedItems[0].title;
              }
            }
            await this.dismissLoader();
          }
          else {
            activity.meetingOutcomeId = seletectedMeetingOutcome;
            activity.meetingOutcomeString = data.data.selectedItems[0].title;
            const isSuccess = await this.activityService.upsertMeetingsOfflineData(activity);
            if (!isSuccess) {
              console.error("Failed to update meeting type in offline data, resetting")
              activity.meetingOutcomeId = prevSelectedValue;
            }
          }
        }
        this.activityOutcomePopover = undefined;
      });
    }
  }

  private async openUsersList() {
    let data = [];
    if (this.procedureTrackerDataService.users.length) {
      data = this.procedureTrackerDataService.users.filter((user) => user.userId != this.authService.user.xSystemUserID && user.userType && user.userType.includes(UserTypes.SALES_REP) && user.primaryPosition).map(user => {
        return {
          id: user.userId,
          title: user.userFullName,
        }
      })
    }

    data = orderBy(data, 'title');

    const productManagerModal = await this.modalCtrl.create({
      component: SelectListComponent,
      componentProps: {
        viewData: {
          data: data,
          isMultipleSelectionEnabled: false,
          title: this.translate.instant('USERS'),
          dividerTitle: this.translate.instant('ALL_USERS'),
          isSearchEnabled: true,
          confirmationCheckRequired: true,
          confirmationAlertData: {
            title: this.translate.instant('ARE_YOU_SURE'),
            message:this.translate.instant('ASSIGN_OWNER_WARNING'),
            confirmButtonText: this.translate.instant('ASSIGN'),
            cancelButtonText: this.translate.instant('CANCEL')
          },
          needcustomMessage: true
        }
      },
      backdropDismiss: false
    });
    productManagerModal.present();
    productManagerModal.onDidDismiss().then(async (obj) => {
      if (obj && obj.data && obj.data.isDone) {
        const data = obj.data;
        if (isEmpty(data.selectedItems)) return;

        let newOwner =  this.procedureTrackerDataService.users.find((user) => user.userId === data.selectedItems[0].id);
        let payload = {
          ownerid: newOwner.userId,
          indskr_positionid: newOwner.primaryPosition
        }

        const isAssignedOwner = await this.meetingDataService.assignOwner(payload, this.activityService.selectedActivity.ID);
        if (!isAssignedOwner) return;

        let activity = (this.activityService.selectedActivity as AppointmentActivity);
        let subject = activity.subject;
        let updatedSubject = false;
        this.meetingDataService.setMeetingSubjectFromContact(activity, activity.meetingOwnerName)
        if(subject != (this.activityService.selectedActivity as AppointmentActivity).subject){
          updatedSubject = true;
        }
        if (this.activityService.selectedActivity instanceof AppointmentActivity) {
          this.activityService.updateSelectedActivityProps({
            ownerId: newOwner.userId,
            positionId: newOwner.primaryPosition,
            meetingOwnerId: newOwner.userId,
            meetingOwner: newOwner.userFullName,
            meetingOwnerName: data.selectedItems[0].title,
          });
          // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
          
          if(this.secondaryInfoService.isAppointmentSecInfoConfigured && this.secondaryInfoService.checkIfSchemaIsConfig('OwnerId', SecondaryInfoEntityName.Appointment) ) {
            subject = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(this.activityService.selectedActivity, SecondaryInfoEntityName.Appointment);
            updatedSubject= true;
          }

          if (updatedSubject) {
            this.activityService.updateSelectedActivityProps({ subject });
            const meetingPayload = new UpdateMeetingPayload();
            meetingPayload.subject = this.activityService.selectedActivity.subject;
            if (!this.device.isOffline) {
              await this.meetingDataService.updateMeeting(activity, meetingPayload);
            }
          }

          this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity);
          this.initFormFields();

          let currentUserIsCovisitor = this.isUserCovisitor(this.authService.user.xSystemUserID, this.activityService.selectedActivity);
          if (currentUserIsCovisitor) {
            this._checkPageAndInitActivitiesFooterButtons()
            this. initActivitiesDetailsPageTitle();
            return
          };

          let currentUserPositions = this.authService.user.positions.map((position) => position.ID);
          if (currentUserPositions.includes(newOwner.primaryPosition)) {
            this._checkPageAndInitActivitiesFooterButtons()
            this. initActivitiesDetailsPageTitle();
            return;
          };
        }

        if (this.navService.getCurrentPageName() === PageName.ActivitiesDetailsPaneComponent && this.device.isMobileDevice) {
          this.navService.popWithPageTracking();
        } else if (this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent) {
          this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView);
          if (this.footerService.isActivitiesButton && this.uiService.showRightPane) this.uiService.showRightPane = false;
        } else {
          this.navService.popChildNavPageWithPageTracking();
        }

        this.activityService.removeActivity(this.activityService.selectedActivity, true);
        if (!this.uiService.toolsActivityActive) { this.events.publish('refreshAgenda'); }
        else this.uiService.agendaRefreshRequired = true;
        if (this.uiService.activitiesPageTab === 'day') {
          this.events.publish('activityDeleted');
        }
        if(this.activityService.multiOptionActivityFilter && this.activityService.multiOptionActivityFilter.some(a=> a.categoryPath == "Users" && (a.value == this.activityService.selectedActivity.ownerId || this.isUserCovisitor(a.value, this.activityService.selectedActivity as AppointmentActivity)))){
          // Dont remove the activity from calendar
        }else{
          this.activityService.publishActivityEvent({ action: "Delete", activity: this.activityService.selectedActivity });
        }
      }
    })
  }

  isUserCovisitor(userId : string, meeting : AppointmentActivity){
    return meeting.accompaniedUserList.length > 0 &&  meeting.accompaniedUserList.some((user) => user.id === userId);
  }

  private async openMarketingPlans() {
    const currentMeeting = this.activityService.selectedActivity as AppointmentActivity;
    if(currentMeeting.state ==MeetingActivityState.Completed && !currentMeeting.marketingBusinessPlanId) return;
    let marketingPlans = this.marketingPlansManagementOfflineService.filterMarketingBusinessPlanByTime(this.marketingPlansManagementOfflineService.marketingPlans);

    const selectedMarketingPlan: any = {
      indskr_brandplanid: currentMeeting.marketingBusinessPlanId,
      indskr_name: currentMeeting.marketingBusinessPlanName
    }

    if (!isEmpty(marketingPlans)) {
      const marketingPlansSelectionViewData: MarketingPlanSelectionViewDataModel = {
        isReadOnlyMode: false,
        selectedMarketingPlans: currentMeeting.marketingBusinessPlanId ? [new MarketingPlan(selectedMarketingPlan)] : [],
        disableDoneButtonInOffline: false,
        positionfilter: true,
        viewMode: false ? ComponentViewMode.READONLY : ComponentViewMode.SELECTION,
        callbackFromSelectionComponent: (event: string, newSelectedMarketingPlans: MarketingPlan[], data: any) => this._handledMarketingPlansSelection(event, newSelectedMarketingPlans, data),
      };
      this.navService.pushWithPageTracking(PageName.MarketingPlanManagementPageComponent, PageName.MarketingPlanManagementPageComponent, { viewData: marketingPlansSelectionViewData, from: PageName.GoAppActivitiesPageComponent }, PageName.MarketingPlanManagementPageComponent);
    }
  }

    private openKitBooking() {
    const isReadOnlyMode = (this.enableReadonlyViewForMeetings || (this.activityService.selectedActivity.isCompleted) || this.isEffectiveDiffPosition) || (this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID && (this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS));
    const selectedKitBooking = this.activityService.getActivityByID(this.activityService.selectedActivity['indskr_kitbooking']);
    if (isReadOnlyMode) return;
    const listDetail: MainToolTemplateDetail = {
      title: this.translate.instant('KIT_BOOKINGS'),
      dividerTitle: this.translate.instant('KIT_BOOKINGS'),
      isSearchEnabled: !isReadOnlyMode,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: !isReadOnlyMode,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'secondaryTextLeft',
      hideAllItemsList: false,
      isListSelectionEnabled: !isReadOnlyMode || !this.device.isOffline,
      listSelectionType: MainToolTemplateListSelectionType.SINGLESELECTION,
      navOptions: { animate: false },
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail) => this._handleKitBookingComponentEvent(data, eventTarget, refData),
      data: this.getKitBookingSelectionData(isReadOnlyMode, selectedKitBooking),
    };
    this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, { viewData: listDetail, disableSorting: true }, PageName.MainToolTemplateComponent);
  }

    private getKitBookingSelectionData(isReadOnlyMode, selectedKitBooking) {
      let setBookingActivities = cloneDeep(this.activityService.activities.filter(o => o.type == ActivityType.SetBooking) as SetBookingActivity[]);
      setBookingActivities = setBookingActivities.filter(setbooking => (setbooking.indskr_status!= SetBookingStatus.CANCELLED && setbooking.indskr_status!= SetBookingStatus.CANCELERROR && setbooking.indskr_status!= SetBookingStatus.PENDINGCANCEL) || setbooking.ID==selectedKitBooking?.ID )
      setBookingActivities = setBookingActivities.sort((a, b): number => {
        if (a.scheduledStart > b.scheduledStart) return 1;
        if (a.scheduledStart < b.scheduledStart) return -1;
        return 0;
      });
      const data: Array<MainCardViewDataModel> = setBookingActivities.map(item => {
      let isSelected = !isEmpty(selectedKitBooking) ? item.ID == selectedKitBooking?.ID : false;
      return {
        id: item.ID,
        primaryTextLeft: item.statusString ? `${this.translate.instant('STATUS')} - ${item.statusString}` : '',
        secondaryTextLeft: item.scheduledStart ? `${this.dateTimeFormatsService.formatDate(new Date(item.scheduledStart), this.dateTimeFormatsService.dateToUpper)}` : '',
        showEndIcon: !isReadOnlyMode,
        mainItemCssClass: 'selector-item',
        isItemSelectedForSelectionView: isSelected,
        endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
        endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
        primaryTextRight: item.subject ? item.subject : this.translate.instant('KIT_BOOKING'),
        showArrow: false,
        isSelected: false,
        eventOwnerId: (this.activityService.selectedActivity as AppointmentActivity).ownerId
      };
    });
    return data;
  }

  private async _handleKitBookingComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
      let appointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
      let payload = [];
      if (isEmpty(data.selectedItems)) {
        appointmentActivity.indskr_kitbooking = '';
      } else {
        appointmentActivity.indskr_kitbooking = data.selectedItems[0].id;
        payload.push({
          'indskr_kitbooking': data.selectedItems[0].id
        })
      }
      if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)){
        await this.activityService.upsertMeetingsOfflineData(appointmentActivity);
      } else{
        try {
          await this.meetingDataService.updateKitBookings(appointmentActivity, payload);
        } catch (error) {
          console.error('Adding Set Booking to Meeting: ', error);
          this.activityService.upsertMeetingsOfflineData(appointmentActivity, false, true);
        }
      }
      this.initFormFields();
    } else if (eventTarget && eventTarget === 'LeftHeaderButtonClick') {
      await this.navService.popWithPageTracking();
    } else if (eventTarget && eventTarget === 'MainItemEvents-mainItem') {
      if(data && data.id) {
        let linkedKitBooking = this.activityService.getActivityByID(data.id);
        if(linkedKitBooking) {
          this.navService.pushChildNavPageWithPageTracking(PageName.SetBookingActivityDetailsComponent, PageName.SetBookingActivityDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: 'Meeting', activity: linkedKitBooking });
          this.navService.setChildNavRightPaneView(true);
          this.uiService.showRightPane = true;
        } else {
          this.notificationService.notify(this.translate.instant("SOMETHING_REALLY_BAD_HAPPENED"), 'Meeting Details', 'top', ToastStyle.DANGER);
          return;
        }
      }
    }
  }

  async _handledMarketingPlansSelection(event, newSelectedMarketingPlans, data) {
    let currentMeeting = this.activityService.selectedActivity as AppointmentActivity;

    if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
      this.meetingDataService.updateMeetingMarketingBusinessPlanOffline(this.activityService.selectedActivity.ID, newSelectedMarketingPlans[0]);
      this.updateMarketBusinessPlanInMeeting(newSelectedMarketingPlans[0], currentMeeting);
      return;
    }

    this.displayLoader();
    const mode = newSelectedMarketingPlans.length > 0 ? 'Update' : 'Delete';
    const payloadMarketingPlanID = newSelectedMarketingPlans.length > 0 ? newSelectedMarketingPlans[0].ID : currentMeeting.marketingBusinessPlanId;

    const response = await this.meetingDataService.updateMeetingMarketingBusinessPlanOnline(mode, { indskr_marketingbusinessplan: payloadMarketingPlanID }, this.activityService.selectedActivity.ID);
    if (!response) return;
    this.updateMarketBusinessPlanInMeeting(newSelectedMarketingPlans[0], currentMeeting);

    this.activityService.publishActivityEvent({ action: 'Update', activity: this.activityService.selectedActivity });
    this.activityService.upsertMeetingsOfflineData(currentMeeting);
    this.dismissLoader();
    this.initFormFields();
  }

  private async _handledCoachingPlanSelection(event, selected, data) {
    if (this.activityService.selectedActivity.isCompleted || this.backgroundUploadInProgress) {
      return;
    }

    const currentMeeting = this.activityService.selectedActivity as AppointmentActivity;
    const selectedPlan = selected.selectedItems[0];
    const isOfflineMode = this.device.isOffline || this.activityService.hasOfflineMeetingData(currentMeeting.ID);

    try {
      if (isOfflineMode) {
        await this.handleCoachingPlanOfflineUpdate(currentMeeting, selectedPlan);
      } else {
        await this.handleCoachingPlanOnlineUpdate(currentMeeting, selectedPlan);
      }
      this.initFormFields();
    } catch (error) {
      console.error('Error updating coaching plan:', error);
    }
  }

  private async handleCoachingPlanOfflineUpdate(meeting: AppointmentActivity, selectedPlan: any) {
    await this.meetingDataService.updateMeetingCoachingPlanOffline(meeting.ID, selectedPlan);
    this.updateCoachingPlanInMeeting(selectedPlan, meeting);
  }

  private async handleCoachingPlanOnlineUpdate(meeting: AppointmentActivity, selectedPlan: any) {
    this.displayLoader();
    try {
      const selectedCoachingId = selectedPlan?.id || '';
      const payload = { indskr_coachingplan: selectedCoachingId };
      
      const response = await this.meetingDataService.updateMeetingCoachingPlanOnline(payload, meeting.ID);

      if (!response) {
        return;
      }

      this.updateCoachingPlanInMeeting(selectedPlan, meeting);
      this.activityService.publishActivityEvent({ action: 'Update', activity: meeting });
      await this.activityService.upsertMeetingsOfflineData(meeting);
    } finally {
      this.dismissLoader();
    }
  }

  updateMarketBusinessPlanInMeeting(marketingBusinessPlan, meeting) {
    meeting.marketingBusinessPlanId = marketingBusinessPlan && marketingBusinessPlan.ID ? marketingBusinessPlan.ID : "";
    meeting.marketingBusinessPlanName = marketingBusinessPlan && marketingBusinessPlan.brandPlanName ? marketingBusinessPlan.brandPlanName : "";
  }

  updateCoachingPlanInMeeting(coachingPlan, meeting) {
    meeting.indskr_coachingplan = coachingPlan && coachingPlan.id ? coachingPlan.id : "";
    meeting.indskr_coachingplanname = coachingPlan && coachingPlan.primaryTextRight ? coachingPlan.primaryTextRight : "";
  }

  private get _currentCompetitorProductsString(): string {
    let str = '';
    let currentCompetitorProducts = (this.activityService.selectedActivity as AppointmentActivity).competitorProducts;
    if (currentCompetitorProducts) {
        if (currentCompetitorProducts.length === 1) {
            str = `${currentCompetitorProducts[0].productName}`;
        } else if (currentCompetitorProducts.length >= 2) {
          currentCompetitorProducts.sort((a, b): number => {
                if (a.productName > b.productName) return 1;
                if (a.productName < b.productName) return -1;
                return 0;
            });
            str = `${currentCompetitorProducts[0].productName} +${currentCompetitorProducts.length - 1}`;
        }
    }
    return str;
  }

  private handleCompetitorProductSelect(): void {
      const isReadOnlyMode = this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings;
      const listDetail: MainToolTemplateDetail = {
        title: this.translate.instant('COMPETITOR_PRODUCTS'),
        dividerTitle:this.translate.instant('ALL_COMPETITOR_PRODUCTS'),
        isSearchEnabled: !isReadOnlyMode,
        showLeftHeaderButton: true,
        leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
        leftHeaderBtnText: this.translate.instant('CANCEL'),
        showRightHeaderButton: !isReadOnlyMode,
        rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
        rightHeaderBtnText: this.translate.instant('DONE'),
        orderByPropertyName: 'primaryTextRight',
        searchTitle: '',
        hideAllItemsList: false,
        isListSelectionEnabled: !isReadOnlyMode,
        listSelectionType: MainToolTemplateListSelectionType.MULTIPLESELECTION,
        navOptions: { animate: false },
        eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail)=> this._handleCompetitorProductComponentEvent(data,eventTarget,refData),
        searchHandler:(text: string) => this._handleCompetitorProductsComponentSearch(text),
        data: this.allCompetitorProducts.map(c => {
          let isSelected = false;
          if((this.activityService.selectedActivity as AppointmentActivity) && (this.activityService.selectedActivity as AppointmentActivity).competitorProducts && (this.activityService.selectedActivity as AppointmentActivity).competitorProducts.some(oco => (oco.indskr_productid === c.ID))){
            isSelected = true;
          }
          return {
            id: c.ID,
            primaryTextLeft: '',
            secondaryTextLeft: '',
            showEndIcon: !isReadOnlyMode,
            mainItemCssClass: 'selector-item',
            isItemSelectedForSelectionView: isSelected,
            endIconType: isSelected?'indegene-selectors-checkmark-icon':'indegene-selectors-add-icon',
            endIconCssClass: isSelected?'checkmark-icon':'add-icon',
            primaryTextRight: c.name,
            showArrow: false,
            arrowType: '',
            eventOwnerId: (this.activityService.selectedActivity as AppointmentActivity).ownerId
          };
        }),
      };
      this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent,PageName.NothingSelectedView,{viewData:listDetail},PageName.MainToolTemplateComponent);
  }

  private async _handleCompetitorProductComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
      let appointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
      if (isEmpty(data.selectedItems)) {
        appointmentActivity.competitorProducts = [];
      } else {
        const alreadySelComProds = appointmentActivity.competitorProducts;
        appointmentActivity.competitorProducts = [];
        data.selectedItems.forEach((item,idx) => {
          const alreadySelComProd = alreadySelComProds.find(a=> a.indskr_productid == item.id);
          if(alreadySelComProd){
            appointmentActivity.competitorProducts.push(alreadySelComProd)
          }else{
            const foundCompProduct = this.allCompetitorProducts.find(a=> a.ID == item.id);
            if(foundCompProduct){
              appointmentActivity.competitorProducts.push({
                indskr_activityproductid:'',
                indskr_isautomaticallyselected:false,
                indskr_productid: foundCompProduct.ID,
                indskr_sequence: idx+1,
                productName: foundCompProduct.name,
                productStructure: foundCompProduct.productStructure,
                isCompetitor: true,
              })
            }
          }
        });
      }

      if (this.device.isOffline || this.activityService.hasOfflineMeetingData(appointmentActivity.ID)) {
        try{ // I/O operations needs to be wrap in a try and catch block
          this.activityService.upsertMeetingsOfflineData(appointmentActivity); // offline saving
        }catch(e){
          console.error(e);
        }
      }else{
        this.displayLoader();
        await this.meetingDataService.updateMeetingProductKeyMessages((this.activityService.selectedActivity as AppointmentActivity),{products:true,indications:false,diseaseAreas:false}).then(response => {
        }).catch(err => {
          console.error(err);
          this.notificationService.notify(this.translate.instant('UPDATING_COMPETITOR_PRODUCT_FAILED'), 'Meeting Details', 'top', ToastStyle.DANGER);
        })
        this.dismissLoader();
      }

    }
  }

  private async _handleCoachingPlanComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
      this._handledCoachingPlanSelection(eventTarget, data, refData)
    }
  }

  private openCoachingPlans() {
    const isReadOnlyMode = this.activityService.selectedActivity.isCompleted || this.activityService.teamViewActive;
    const listDetail: MainToolTemplateDetail = {
      title: this.translate.instant('COACHING_PLANS'),
      dividerTitle:this.translate.instant('ALL_COACHING_PLANS'),
      isSearchEnabled: !isReadOnlyMode,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: !isReadOnlyMode,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'primaryTextRight',
      searchTitle: '',
      hideAllItemsList: false,
      isListSelectionEnabled: !isReadOnlyMode,
      listSelectionType: MainToolTemplateListSelectionType.SINGLESELECTION,
      navOptions: { animate: false },
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail)=> this._handleCoachingPlanComponentEvent(data,eventTarget,refData),
      searchHandler:(text: string) => this._handleCoachingPlanComponentSearch(text),
      data: this.allCoachingPlans.map(c => {
        let isSelected = false;
        if((this.activityService.selectedActivity as AppointmentActivity) && (this.activityService.selectedActivity as AppointmentActivity).indskr_coachingplan && (this.activityService.selectedActivity as AppointmentActivity).indskr_coachingplan == c.indskr_coachingplanid){
          isSelected = true;
        }
        return {
          id: c.indskr_coachingplanid,
          primaryTextLeft: '',
          secondaryTextLeft: '',
          showEndIcon: !isReadOnlyMode,
          mainItemCssClass: 'selector-item',
          isItemSelectedForSelectionView: isSelected,
          endIconType: isSelected?'indegene-selectors-checkmark-icon':'indegene-selectors-add-icon',
          endIconCssClass: isSelected?'checkmark-icon':'add-icon',
          primaryTextRight: c.indskr_name,
          showArrow: false,
          arrowType: '',
          eventOwnerId: (this.activityService.selectedActivity as AppointmentActivity).ownerId
        };
      }),
    };
    this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent,PageName.NothingSelectedView,{viewData:listDetail},PageName.MainToolTemplateComponent);
  }

  private _handleCompetitorProductsComponentSearch(text: string): string[] {
    let ids: Array<string> = [];
    if (text.length >= 1) {
      ids = this.allCompetitorProducts && this.allCompetitorProducts.filter(pro => {
          return pro.name.trim().toLowerCase().includes(text.trim().toLowerCase());
      }).map(pro => pro.ID);
    } else {
        ids = this.allCompetitorProducts && this.allCompetitorProducts.map(pro => pro.ID);
    }
    return ids;
  }

  // Only introduced to handle specific sccenario of making appointment editable in calendar view
  // isDiffPosition is true for any non-owner. FULL_ACCESS co-visitors are explicitly
  // granted edit rights by the meeting owner, so they must not be blocked by it.
  get isEffectiveDiffPosition(): boolean {
    return !!this.activityService.selectedActivity?.isDiffPosition
      && !(this.isCovisitor && this.features.coVisitorAccess === CovisitorAccess.FULL_ACCESS);
  }

  get enableReadonlyViewForMeetings():boolean {
    let flag = this.activityService.teamViewActive;
    if(this.activityService.isMyUserSelectedInTeamView && this.agendaFooterService.actSegment == 'week' && this.activityService.selectedActivity && this.activityService.selectedActivity instanceof AppointmentActivity && this.activityService.activities.some(a=> a.ID == this.activityService.selectedActivity.ID)){
      flag = false;
    }

    if ((!this.activityService.isMeetingOwner &&
      (this.isCovisitor && this.features.coVisitorAccess !== CovisitorAccess.FULL_ACCESS))) {
      flag = true;
    }
    if (this.isFromChat) {
      flag = true;
    }
    if (this.isEffectiveDiffPosition) {
      flag = true;
    }

    return flag;
  }
  private _handleCoachingPlanComponentSearch(text: string): string[] {
    let ids: Array<string> = [];
    if (text.length >= 1) {
      ids = this.allCoachingPlans && this.allCoachingPlans.filter(pro => {
          return pro.indskr_name.trim().toLowerCase().includes(text.trim().toLowerCase());
      }).map(pro => pro.indskr_coachingplanid);
    } else {
        ids = this.allCoachingPlans && this.allCoachingPlans.map(pro => pro.indskr_coachingplanid);
    }
    return ids;
  }

  // # # # View Contacts in sequence the way they were selected during meeting creation # # # //
  public getMeetingContactsSequenceString(){
    let contactString:string = `${this.features.liveMeet ? 'Participants' : Utility.globalCustomersText}`;

    if(this.contactService.isMeetingContactSequenceEnabled) {
      this.selectedContacts.sort((contactA, contactB) => {
        return contactA.indskr_sequence - contactB.indskr_sequence;
      });
    }

    //Only one contact, return his name
    if (this.selectedContacts.length === 1) {
        contactString = `${this.selectedContacts[0].fullName}`;
        if(!this.selectedContacts[0].isActive && String(this.selectedContacts[0].fullName).trim() != ''){
            contactString += ' (Inactive)';
        }
    } else if (this.selectedContacts.length >= 2) {
        contactString =  `${this.selectedContacts[0].fullName}`;
        if(!this.selectedContacts[0].isActive){
            contactString += ` (Inactive) +${this.selectedContacts.length-1}`;
        }else if(this.selectedContacts.some((con,index) =>{
            if(index == 0) return false;
            return (!con.isActive);
        })){
            contactString =  `${this.selectedContacts[0].fullName} +${this.selectedContacts.length-1} (Inactive)`;
        }else{
            contactString =  `${this.selectedContacts[0].fullName} +${this.selectedContacts.length-1}`;
        }
    }

    if(!contactString || contactString == undefined || contactString == 'undefined ') {
        return "";
    }
    else
    return contactString;
  }

  private async initConfigFieldsLookupData(){
    let lookupFields = [];
    if(this.appointmentConfigFields && this.appointmentConfigFields.length > 0){
      lookupFields = this.appointmentConfigFields.filter(a => a.datatype == 'Lookup' || a.fieldType == 'Lookup');
    }
    if(lookupFields && lookupFields.length > 0){
      await this.disk.retrieve(DB_KEY_PREFIXES.IO_CONFIG_ALL_LOOKUP_FIELDS, true).then((doc)=>{
        if(doc && doc.raw){
          this.lookupConfigFieldsData = doc.raw['appointment']
        }
      })
    }
  }
  public selctedOpport(selected){
    if(this.activityService.selectedActivity.ownerId != this.authService.user.systemUserID) return;
    const accountIds = this.activityService.selectedActivity['accounts'].map(el => el.id)
    const contactIds = this.activityService.selectedActivity['contacts'].map(el => el.ID)
    let opportunitiesDataSet = this.opportunityService.opportunities.filter(item => item.opportunityName);
    let relatedOpportunitiesDataSet = opportunitiesDataSet.filter(item => accountIds.includes(item.accountID) || contactIds.includes(item.contactID) || this._checkIfOppHasTheseContacts(contactIds,item));
    let opportunityReadOnly = this.activityService.selectedActivity.isCompleted ||  this.activityService.selectedActivity.createdby != this.authService.user.systemUserID
    const opportuntiesSelectionViewData: OpportunitySelectionViewDataModel = {
      isReadOnlyMode: opportunityReadOnly ? true : false,
      opportunitiesDataSet: opportunitiesDataSet,
      relatedOpportunitiesData: relatedOpportunitiesDataSet,
      selectedOpportunities: this.applicableOpportunities,
      disableDoneButtonInOffline: false,
      isMultiSelection: true,
      callbackFromSelectionComponent: (event: string, newSelectedOpportunities: Array<Opportunity>, data: any) => this._handledOpportunitiesSelection(event, newSelectedOpportunities, data),
    };
    let clickedOpp = selected;
    this.navService.pushWithPageTracking(PageName.OpportunitySelectionPage, PageName.OpportunitySelectionPage, { viewData: opportuntiesSelectionViewData , clickedOpportunity:clickedOpp }, PageName.OpportunitySelectionPage);

  }

  onMeetingNotesFocusIn() {
  }

async onMeetingNotesFocusOut() {

  if (this.isOffLabelNotesEnabled) {
    // BU_APPOINTMENT_GA_OFFLABEL_NOTES is on: off-label notes are only ever
    // created on explicit Add click (see createMeetingNoteOnAdd). Skipping
    // auto-save entirely here means there's never a note in flight for the
    // off-label toggle to race against.
    return;
  }

  if (!this.shouldSaveNotes()) {
    return;
  }

  if (this.autoSavedNote) {
    await this.activityService.task.begin();
    try {
      await this.handleExistingNoteUpdate();
    } catch (error) {
      console.error('note outfocus event: ' + error);
    } finally {
      await this.activityService.task.complete();
    }
    return;
  }

  // Claim the draft note synchronously, with no await before this point.
  // onMeetingNotesFocusOut can fire more than once for what looks like a
  // single user action - if the create decision were made after an await,
  // both calls could still see autoSavedNote as null and each create their
  // own note, producing two duplicate notes for one piece of text. Setting
  // autoSavedNote here, before any async gap, guarantees any later call
  // sees it already set and updates it instead.
  this.trackingService.tracking('MeetingNotesUpdate', TrackingEventNames.ACTIVITY);
  const selectedActivity = cloneDeep(this.activityService.selectedActivity);
  const tempNote = this.createTempNote(selectedActivity);
  this.autoSavedNote = new IONote(tempNote);
  this.updateActivityNotes(selectedActivity);

  await this.activityService.task.begin();
  try {
    await this.saveNoteToDatabase(tempNote, selectedActivity);
    this.finalizeNoteCreation(selectedActivity);
  } catch (error) {
    console.error('note outfocus event: ' + error);
  } finally {
    await this.activityService.task.complete();
  }
}

private shouldSaveNotes(): boolean {
  return this.isSaveNotesEnabled && this.hasNoteContent();
}

private hasNoteContent(): boolean {
  const hasTextContent = this.tempNoteText && !isEmpty(this.tempNoteText.trim());
  const hasAttachment = !isEmpty(this.base64str);
  const hasAutoSavedNote = this.hasAutoSavedNoteContent();
  return hasTextContent || hasAttachment || hasAutoSavedNote;
}

private hasAutoSavedNoteContent(): boolean {
  if (!this.autoSavedNote || !this.autoSavedNote.noteText) {
    return false;
  }
  // Check if tempNoteText is empty or null/undefined
  const isTempNoteEmpty = !this.tempNoteText || isEmpty(this.tempNoteText.trim());
  return isTempNoteEmpty;
}

private async handleExistingNoteUpdate(): Promise<void> {
  const event = this.createNoteUpdateEvent();
  
  if (this.shouldUpdateNote(event)) {
    await this.updateNote(event);
    await this.activityService.task.complete();
  }
  
  this.initNotesSectionHeader();
}

private createNoteUpdateEvent(): any {
  const actionType = this.determineActionType();
  const event: any = {
    action: actionType,
    noteId: this.autoSavedNote.noteId,
    updatedText: this.tempNoteText,
  };

  if (this.hasAttachmentUpdate()) {
    this.addAttachmentDataToEvent(event);
  }

  return event;
}

private determineActionType(): string {
  const hasNoAttachment = isEmpty(this.base64str);
  const hasNoText = isEmpty(this.tempNoteText) || !this.tempNoteText.trim();
  
  return hasNoAttachment && hasNoText ? 'DELETE' : 'SAVE';
}

private hasAttachmentUpdate(): boolean {
  return this.base64str && 
         this.attachmentFile && 
         this.base64str !== this.autoSavedNote.documentDataURL;
}

private addAttachmentDataToEvent(event: any): void {
  event['attachmentFileUpdated'] = true;
  event['documentSize'] = this.attachmentFile.size;
  event['documentName'] = this.attachmentFile.name;
  event['documentMimeType'] = this.attachmentFile.type;
  event['attachmentFileDataUrl'] = this.base64str;
}

private shouldUpdateNote(event: any): boolean {
  const textChanged = this.autoSavedNote.noteText !== this.tempNoteText && 
                     (!this.tempNoteText || !isEmpty(this.tempNoteText.trim()));
  const attachmentUpdated = event['attachmentFileUpdated'];  
  return textChanged || attachmentUpdated;
}

private createTempNote(selectedActivity: any): any {
  const now = new Date().getTime().toString();
  const tempNote: any = {
    annotationid: 'offlinmeetingnote' + now,
    activityid: selectedActivity.ID,
    createdon: now,
    notetext: this.getNoteText(),
    ownerName: this.authService.user.displayName,
    ownerid: this.authService.user.systemUserID,
    deleted: false,
    pendingPushForDynamics: true,
    isdocument: false,
    isOffLabel: this.isNewNoteOffLabel
  };

  if (this.base64str) {
    this.addAttachmentToNote(tempNote);
  } else {
    tempNote.hasDocument = false;
  }

  return tempNote;
}

private getNoteText(): string {
  return this.tempNoteText && !isEmpty(this.tempNoteText.trim()) ? this.tempNoteText : '';
}

private addAttachmentToNote(tempNote: any): void {
  tempNote['isdocument'] = true;
  tempNote['documentbody'] = this.base64str;
  tempNote['filename'] = this.attachmentFile.name;
  tempNote['filesize'] = this.attachmentFile.size;
  tempNote['mimetype'] = this.attachmentFile.type;
}

private updateActivityNotes(selectedActivity: any): void {
  this.activityService.getActivityByID(selectedActivity.ID).meetingNotes = selectedActivity.meetingNotes;
  
  const displayActivity = this.activityService.getDisplayctivityByID(selectedActivity.ID);
  if (displayActivity) {
    displayActivity.meetingNotes = selectedActivity.meetingNotes;
  }
  
  selectedActivity.meetingNotes.push(this.autoSavedNote);
}

private async saveNoteToDatabase(tempNote: any, selectedActivity: any): Promise<void> {
  try {
    await this.activityService.updateMeetingNoteInOfflineDB(tempNote);
    
    if (!this.device.isOffline) {
      await this.handleOnlineUpload(selectedActivity);
    } else {
      await this.handleOfflineSave(selectedActivity);
    }
  } catch (error) {
    console.error('createMeetingNote: ' + error);
    await this.activityService.task.complete();
  }
}

private async handleOnlineUpload(selectedActivity: any): Promise<void> {
  const response = await this.meetingDataService.uploadMeetingNotesOnline();
  
  if (response && Array.isArray(response) && response.length > 0) {
    this.updateNoteIdFromResponse(response, selectedActivity.ID);
  }
}

private updateNoteIdFromResponse(response: any[], activityId: string): void {
  response.forEach(res => {
    if (res['activityid'] === activityId && this.autoSavedNote) {
      this.autoSavedNote.noteId = res.annotationid ? res.annotationid : res.noteid;
    }
  });
}

private async handleOfflineSave(selectedActivity?: any): Promise<void> {
  const activity = selectedActivity || this.activityService.selectedActivity;
  if (selectedActivity.ID.includes('offline')) {
    this.activityService.upsertMeetingsOfflineData(activity as AppointmentActivity);
  } else {
    await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
  }
}

private finalizeNoteCreation(selectedActivity: any): void {
  if (selectedActivity.ID === this.activityService.selectedActivity.ID) {
    this.activityService.updateSelectedActivityProps({ meetingNotes: selectedActivity.meetingNotes });
  }

  this.isSaveNotesEnabled = false;
  this.initNotesSectionHeader();
  this.activityService.task.complete();
}

  // # # # View Contacts in sequence the way they were selected during meeting creation # # # //

  //======= new account contact ui ==============//

  async setAccountsSourceData(meeting: AppointmentActivity, selectedAccounts: any) {
    const hideAccountField = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_APPOINTMENT_GA_HIDE_ACCOUNT_FIELD) as boolean;
    if (hideAccountField) {
      this.accountSourceData = [];
      return;
    }

    const affiliatedAccounts = meeting.contacts.length > 0
      ? await this.accountService.getAffiliatedAccountsFromSelectedContactsForMeeting(this.selectedContacts)
      : [];

    this.accountSourceData = this.getAvailableAccounts(selectedAccounts, affiliatedAccounts);
  }

  async setAccountFormField() {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const selectedAccounts = this.getSelectedAccounts();
    const hideAccountField = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_APPOINTMENT_GA_HIDE_ACCOUNT_FIELD) as boolean;
    const endIcons = [{
      iconName: 'searchblue', overRideDisabledProperty: false
    },
    { iconName: 'expandblue', overRideDisabledProperty: true }];

    const isAccountRequired = this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CONTACT_MANDATORY) || this.isAccountVisitRecord;
    if (!hideAccountField) {
      await this.setAccountsSourceData(meeting, selectedAccounts);
    } else {
      this.accountSourceData = [];
    }

    const isAccountFormDisabled = !(
      this.activityService.selectedActivity
      && !this.isReadOnlyJointMeeting
      && !this.enableReadonlyViewForMeetings
      && (this.activityService.selectedActivity.state != MeetingActivityState.Completed)) || this.isAccountVisitNestedMeeting || this.from === PageName.AccountPlanActivities;

    this.accountFormField = {
      label: this.translate.instant('ACCOUNTS'),
      inputText: '',
      id: 'account-field',
      formFieldType: FormFieldType.LIST,
      isReadOnly: true,
      showArrow: true,
      isHidden: hideAccountField,
      isRequired: ![MeetingActivityState.Completed, MeetingActivityState.Canceled].includes(meeting.state) && (this.isGpsEnabled || isAccountRequired),
      isEmptyRequiredField: this.isAccountClicked && !this.requiredFields['account-field']['isAdded'],
      isDisabled: isAccountFormDisabled || this.activityService.selectedActivity.state == MeetingActivityState.Canceled,
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      modalConfiguration: {
        searchTitle: this.translate.instant('SEARCH_ACCOUNTS'),
        selectedTitle: this.translate.instant('SELECTED_CONTACTS'),
        titleEndIcon: 'expandblue',
        searchInputConfig: {
          label: this.translate.instant('ACCOUNTS'),
          placeholder: this.translate.instant('TYPE') + '...'
        },
        showSearch: true,
      },
      filterMethod: this.filterAccountData.bind(this),
      endIcons,
      sections: await this.generateAccountSections(),
      selectedData: selectedAccounts,
      customPlaceholderLabel: ((this.activityService.selectedActivity && !this.isReadOnlyJointMeeting && !this.enableReadonlyViewForMeetings && this.activityService.selectedActivity.state != MeetingActivityState.Completed)) ? this.translate.instant('SELECT_ACCOUNTS') : this.translate.instant('NO_ACCOUNT'),
      eventHandler: (id: string, event, eventName, data) => {
        if (data && eventName == 'item-click') {
          const isAlreadyExist = meeting.accounts.some((account) => account.id === data.id);
          if (!isAlreadyExist) {
            this.addAccount(data);
          }
        } else if (eventName === 'closebutton') {
          this.removeAccount(data);
        }
      },
    };

    this.cdRef.markForCheck();
  }

  private getSelectedAccounts() {
    return this.activityService.selectedActivity.accounts.sort((accountA, accountB) => {
      if (accountA.accountName > accountB.accountName) return 1;
      if (accountA.accountName < accountB.accountName) return -1;
      return 0;
    }).map((account) => {
      let name = account.accountName;
      if (account.status === 2 || account.status == 548910003 || account.status == 548910010 || account.status == 548910011 || account.status == 548910012 || account.status == 548910013) {
        name += ' (Inactive)';
      }

      let mappedAccount = {
        id: account.id,
        title: name,
        image: '',
        refObject: account,
        endIcon: 'closebutton',
        endIconClickEnabled: true
      }

      return mappedAccount;
    });
  }

  private getAvailableAccounts(selectedAccounts: any[], affiliatedAccounts: any[]) {
    return this.accountService.accounts
      .map(account => ({
        id: account.id,
        title: account.accountName,
        image: '',
        refObject: account,
        endIcon: affiliatedAccounts.some(ac => ac.id === account.id) ? 'affiliation' : undefined,
      }))
      .filter(account => !selectedAccounts.some(acc => acc.id === account.id))
      .sort(this.sortList);
  }

  private sortList(a: any, b: any) {
    if (a.endIcon && !b.endIcon) return -1;
    if (!a.endIcon && b.endIcon) return 1;
    return a.title.localeCompare(b.title);
  }

  async addAccount(data) {
    await this.meetingDataService.updateMeetingWithAccounts('add', data.refObject);
    // Trigger GPS capture when account is added (may update location)
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityService.selectedActivity);
    }
    this.initFormFields();
  }

  async removeAccount(data) {
    await this.meetingDataService.updateMeetingWithAccounts('remove', data.refObject);
    // Trigger GPS capture when account is removed (may update location)
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityService.selectedActivity);
    }
    this.initFormFields();
  }

  async setContactSourceData(meeting: AppointmentActivity, selectedContacts: any) {
    const affiliatedContacts = meeting.accounts.length > 0
      ? await this.contactService.getAffiliatedContactsFromAccountsForMeeting(meeting.accounts)
      : [];

    this.contactSourceData = this.getAvailableContacts(selectedContacts, affiliatedContacts);
  }

  async setContactFormField() {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const selectedContacts = this.getSelectedContacts();
    const endIcons = [{
      iconName: 'searchblue', overRideDisabledProperty: false
    },
    { iconName: 'expandblue', overRideDisabledProperty: true }];

    this.setContactSourceData(meeting, selectedContacts)

    const isContactFormDisabled = (this.enableReadonlyViewForMeetings || this.isReadOnlyJointMeeting ||
      ((this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0 &&
        meeting.state === MeetingActivityState.Completed) || meeting.state === MeetingActivityState.Completed
      || (this.isAccountVisitRecord && (this.activityService.selectedActivity as AppointmentActivity).accounts.length === 0) ||
      this.from === PageName.AccountPlanActivities || this.isFromChat);

    const isSignatureRequiredFormat = this.isSignatureRequiredFormat();
    const isCapturedSignatureMeeting = this.activityService.selectedActivity?.hasCapturedSignature || false;

    this.contactFormField = {
      label: (this.features.liveMeet) ? this.translate.instant('ACTIVITY_DETAILS_PARTICIPANTS') : this.utilityService.globalCustomersText,
      inputText: '',
      id: 'contact-field',
      formFieldType: FormFieldType.LIST,
      isReadOnly: true,
      showArrow: true,
      isHidden: false,
      isRequired: !this.enableReadonlyViewForMeetings && this.activityService.selectedActivity.state != MeetingActivityState.Completed && this.activityService.selectedActivity.state != MeetingActivityState.Canceled && !this.isEffectiveDiffPosition && this.requiredFields?.['contact-field']['isRequired'],
      isEmptyRequiredField: this.isClickedContacts && this.requiredFields?.['contact-field']['isRequired'] && !this.requiredFields['contact-field']['isAdded'],
      isDisabled: (isSignatureRequiredFormat && isCapturedSignatureMeeting) || isContactFormDisabled || this.activityService.selectedActivity.state == MeetingActivityState.Canceled,
      errorMessage: this.activityService.getErrorMessageRequiredField(),
      customPlaceholderLabel: (this.activityService.selectedActivity && (this.activityService.selectedActivity as AppointmentActivity).contacts.length == 0) ? (this.activityService.selectedActivity.isCompleted || this.enableReadonlyViewForMeetings || this.activityService.selectedActivity.isFromXperiences) ? this.translate.instant('No ' + this.utilityService.globalCustomerText) : this.translate.instant('SELECT_WITH_GLOBALCUSTOMER', { globalCustomerText: this.utilityService.globalCustomersText }) : '',
      modalConfiguration: {
        searchTitle: this.translate.instant('SEARCH_CONTACTS'),
        selectedTitle: this.translate.instant('SELECTED_CONTACTS'),
        titleEndIcon: 'expandblue',
        searchInputConfig: {
          label: this.translate.instant('CONTACTS'),
          placeholder: this.translate.instant('TYPE') + '...'
        },
        showSearch: true,
      },
      filterMethod: this.filterContactData.bind(this),
      endIcons,
      sections: await this.generateContactSections(),
      selectedData: selectedContacts,
      eventHandler: (id: string, event, eventName, data) => {
        if (data && eventName == 'item-click') {
          const isAlreadyExist = meeting.contacts.some((contact) => contact.ID === data.id);
          if (!isAlreadyExist) {
            this.addContact(data);
          }
        } else if (eventName === 'closebutton') {
          this.removeContact(data);
        }
      },
    };

    this.cdRef.markForCheck();
  }

  private getSelectedContacts() {
    if ((this.activityService.selectedActivity as AppointmentActivity).contacts.length === 0) return [];

    if (this.contactService.isMeetingContactSequenceEnabled) {
      this.selectedContacts.sort((contactA, contactB) => {
        return contactA.indskr_sequence - contactB.indskr_sequence;
      });
    }

    return (this.activityService.selectedActivity as AppointmentActivity).contacts.sort((contactA, contactB): number => {
      let contactAFullName =  contactA.fullname ? contactA.fullname :(contactA.firstName.length > 0) ? contactA.firstName + " " + contactA.lastName : contactA.lastName;
      let contactBFullName = contactB.fullname ? contactB.fullname  : (contactB.firstName.length > 0) ? contactB.firstName + " " + contactB.lastName : contactB.lastName;
      if (contactAFullName.toLowerCase() > contactBFullName.toLowerCase()) return 1;
      if (contactAFullName.toLowerCase() < contactBFullName.toLowerCase()) return -1;
      return 0;
    }).map(contact => ({
      id: contact.ID,
      title: contact.fullname.trim() + (!contact.isActive ? ' (Inactive)' : '') ? contact.fullname.trim() + (!contact.isActive ? ' (Inactive)' : '') : contact.fullName.trim() + (!contact.isActive ? ' (Inactive)' : ''),
      image: '',
      refObject: contact,
      endIcon: 'closebutton'
    }));
  }

  private getAvailableContacts(selectedContacts: any[], affiliatedContacts: any[]) {
    return this.contactService.contacts.filter(item => item.isguest === false && item.isActive && item.indskr_iseventparticipant != true)
      .map(contact => ({
        id: contact.ID,
        title: contact.fullName,
        image: '',
        refObject: contact,
        endIcon: affiliatedContacts.some(con => con.ID === contact.ID) ? 'affiliation' : undefined,
      }))
      .filter(contact => !selectedContacts.some(con => con.ID === contact.id))
      .sort(this.sortList);
  }

  async addContact(data) {
    await this.meetingDataService.updateMeetingWithContacts('add', data.refObject);
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      // Same content matching step as the full contact picker (ContactsSelected handler).
      await this.meetingStructureService.addFilteredContentToMeeting();
      this.events.publish('contentIsAdded', this.activityService.selectedActivity.presentations);
      // Trigger GPS capture when contact is added (may update location)
      await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityService.selectedActivity);
    }
    await this.initFormFields();
    this._checkPageAndInitActivitiesFooterButtons()
  }

  async removeContact(data) {
    if (this._blockIfRemovingIaoLinkedCustomer(data.refObject)) return;
    if (this._blockIfRemovingSdrLinkedCustomer(data.refObject)) return;
    await this.meetingDataService.updateMeetingWithContacts('remove', data.refObject);
    // Trigger GPS capture when contact is removed (may update location)
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityService.selectedActivity);
    }
    await this.initFormFields();
    this._checkPageAndInitActivitiesFooterButtons()
  }

  async generateAccountSections(): Promise<Section[]> {
    const selectedAccounts = this.getSelectedAccounts();
    const showLessThanResultButton = !this.device.isOffline && this.features.showLessThanResultButtonForAccount;
    return this.createSections(selectedAccounts, 'SELECTED', 'AL_RESULTS', this.translate.instant('SEARCH_OTHER_WITH_TEXT', { text: this.translate.instant("ACCOUNT") }), showLessThanResultButton);
  }

  async generateContactSections(): Promise<Section[]> {
    const selectedContacts = this.getSelectedContacts();
    let globalCustomerText;
    switch (this.utilityService.globalCustomerText) {
      case 'Customer':
        globalCustomerText = this.translate.instant('CUSTOMER');
        break;
      case 'Stakeholder':
        globalCustomerText = this.translate.instant('STAKEHOLDER');
        break;
      default:
        if (this.utilityService.globalCustomersText) {
          globalCustomerText = this.utilityService.globalCustomerText;
        }
        break;
    }    // const showLessThanResultButton = false;

    const showLessThanResultButton = !this.device.isOffline && this.features.showLessThanResultButtonForContact;  
    return this.createSections(selectedContacts, 'SELECTED', 'AL_RESULTS', this.translate.instant('SEARCH_OTHER_WITH_TEXT', { text: globalCustomerText }), showLessThanResultButton);
  }

  private createSections(
    selectedData: any[],
    selectedTitleKey: string,
    resultsTitleKey: string,
    lessThanResultButtonKey: string,
    showLessThanResultButton: boolean = true
  ): Section[] {
    return [
      {
        id: 'selected',
        title: this.translate.instant(selectedTitleKey),
        showCountOnTitle: true,
        maxResultsView: 5,
        bottomButtonShow: true,
        expand: false,
        showBottomButton: true,
        bottomButtonConfig: {
          exceedMaxResultButton: {
            id: 'view-all',
            label: this.translate.instant('VIEW_MORE'),
          },
        },
        data: selectedData,
      },
      {
        id: 'results',
        title: this.translate.instant(resultsTitleKey),
        showFilteredData: true,
        showCountOnTitle: true,
        maxResultsView: 5,
        bottomButtonShow: true,
        expand: true,
        showBottomButton: true,
        bottomButtonConfig: {
          exceedMaxResultButton: {
            id: 'view-all',
            label: this.translate.instant('VIEW_MORE'),
          },
          lessThanResultButton: showLessThanResultButton ? {
            id: 'show-other',
            label: this.translate.instant(lessThanResultButtonKey),
          } : undefined,
        },
        data: [],
      },
    ];
  }

 

  filterAccountData(query: string): any[] {
    const meeting = this.activityService.selectedActivity;
    const queryWords = query.toLowerCase().split(' ').filter(word => word.trim() !== '');

    return this.accountSourceData
      .filter((h: any) => {
        const title = h.title.toLowerCase();
        return queryWords.every(word => title.includes(word));
      })
      .filter((h: any) => !meeting.accounts?.some((a: any) => a.id === h.id));
  }

  filterContactData(query: string): any[] {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const queryWords = query.toLowerCase().split(' ').filter(word => word.trim() !== '');

    return this.contactSourceData
      .filter((h: any) => {
        const title = h.title.toLowerCase();
        return queryWords.every(word => title.includes(word));
      })
      .filter((h: any) => !meeting.contacts?.some((a: any) => a.ID === h.id));
  }

  private async displayLoader(options: any = {}) {
    await this.uiService.displayLoader(options);
  }

  private async dismissLoader() {
    await this.uiService.dismissLoader();
  }

  // TrackBy functions for performance optimization
  trackByFormField(index: number, item: any): any {
    return item?.id || index;
  }

  trackByTimeSlot(index: number, item: any): any {
    return item?.[0] || index;
  }

  trackByTimeSlotItem(index: number, item: any): any {
    return item?.timeSlot || index;
  }

  trackByAppConfigField(index: number, item: any): any {
    return item?.id || index;
  }

  trackByPhoto(index: number, item: any): any {
    return item?.indskr_photoattachmentid || index;
  }

  trackByPhotoAttachment(index: number, item: any): any {
    return item?.id || index;
  }

  trackByObjective(index: number, item: any): any {
    return item?.indskr_name || index;
  }

  trackByProcedure(index: number, item: any): any {
    return item?.name || index;
  }

  trackByMaterial(index: number, item: any): any {
    return item?.name || index;
  }

  trackByEvent(index: number, item: any): any {
    return item?.name || index;
  }

  trackByOpportunity(index: number, item: any): any {
    return item?.opportunityName || index;
  }

  trackByAsset(index: number, item: any): any {
    return item?.id || index;
  }

  trackByNote(index: number, item: any): any {
    return item?.id || index;
  }

  trackByCoachingReport(index: number, item: any): any {
    return item?.id || index;
  }

  // Helper methods for cleaner template conditions
  isActivityTypeSupported(): boolean {
    return this.activityService.selectedActivity && 
           (this.activityService.selectedActivity.type === 'Appointment' || 
            this.activityService.selectedActivity.type === 'LiveMeet' || 
            this.activityService.selectedActivity.type === 'Joint Meeting');
  }

  shouldShowMeetingTypeField(): boolean {
    return !this.features.liveMeet && 
           this.features.isMeetingTypeFAEnabled && 
           !this.isAccountVisitRecord && 
           !this.isAccountVisitNestedMeeting && 
           !!this.meetingTypeFormField;
  }

  shouldShowMeetingURL(): boolean {
    return !this.teamsLink && 
           this.isRemoteEnabled && 
           !this.isGpsEnabled && 
           !this.isLiveTimeFieldEnabledForF2FMeetings;
  }

  shouldShowGPSCheckin(): boolean {
    return this.features.manualGPSCheckinEnabled && 
           !this.isAccountVisitNestedMeeting && 
           !this.disableGPSCheckInFlowForHCPMeeting;
  }

  isNotesReadOnly(): boolean {
    return this.activityService.selectedActivity?.isCompleted || 
           this.activityService.teamViewActive || 
           this.isEffectiveDiffPosition;
  }

  isNotesDisabled(): boolean {
    return this.isReadOnlyJointMeeting || 
           this.backgroundUploadInProgress || 
           this.activityService.selectedActivity.state === 2 || 
           !this.activityService.isMeetingOwner;
  }

  isSignatureRequiredFormat(): boolean {
    const currentActivityTypeId = this.activityService.selectedActivity?.indskr_activitytype;
    const matchedType = this.meetingActivityTypes?.find(
      type => type.indskr_activitytypeid === currentActivityTypeId
    );
  
    return matchedType?.indskr_capturesignature ?? false;
  }

  initMeetingFormatField() {
    if (!isEmpty(this.meetingActivityTypes) || !isEmpty(this.activityService.selectedActivity.indskr_activitytype)) {
      const activityTypeFieldText = this.activityService.selectedActivity.activityTypeName
        || this.meetingActivityTypes?.find(t => t.indskr_activitytypeid === this.activityService.selectedActivity.indskr_activitytype)?.indskr_name;
      if (isEmpty(this.activityService.selectedActivity.activitySubTypeName)){
        this.activityService.selectedActivity.activitySubTypeName =  this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, this.activityService.selectedActivity.indskr_activitytype)?.find(ast => ast.indskr_default)?.indskr_name ;
      }

      const isSignatureRequiredFormat = this.isSignatureRequiredFormat();
      const isContactElgibile = (this.activityService.selectedActivity as AppointmentActivity)?.contacts?.length > 0 ? true : false;
      const isCapturedSignatureMeeting = this.activityService.selectedActivity?.hasCapturedSignature || false;
      const isAccountVisitOrNestedMeeting = this.isAccountVisitRecord || this.isAccountVisitNestedMeeting;
      const isMeetingCompleted = this.activityService.selectedActivity.state === MeetingActivityState.Completed;
      const isMeetingCanceled = this.activityService.selectedActivity.state === MeetingActivityState.Canceled;
      const isMeetingOwner = this.activityService.isMeetingOwner;
      
      let additionalcontrols = [];

      if (isSignatureRequiredFormat 
        && activityTypeFieldText 
        && isContactElgibile
        && !isAccountVisitOrNestedMeeting 
        && (!isMeetingCompleted || isCapturedSignatureMeeting)
        && (!isMeetingCanceled || isCapturedSignatureMeeting)
        ) {
        
        const captureStatus = isCapturedSignatureMeeting ? "captured" : "pending";
        // OMNI-61539: a signature captured offline keeps its base64 locally until it
        // syncs to Dynamics — while present it can be viewed offline. Once synced the
        // local copy is gone and viewing needs a Dynamics fetch (online only).
        const hasLocalCapturedSignature = !!(this.activityService.selectedActivity as AppointmentActivity)?.indskr_signature;
        const isSignatureSyncedNotViewableOffline = this.device.isOffline && isCapturedSignatureMeeting && !hasLocalCapturedSignature;
        // Capture is allowed offline (owner, not yet captured); an unsynced signature
        // can be viewed offline. Only truly non-actionable cases are disabled — a
        // synced-offline signature stays tappable so we can inform the user via a toast.
        const isSignatureControlDisabled = (!isCapturedSignatureMeeting && !isMeetingOwner);
        // Blue (online) icon whenever the control is actionable offline (capture or
        // view unsynced); grey (offline) icon when disabled or synced-not-viewable.
        const iconMode = (isSignatureControlDisabled || isSignatureSyncedNotViewableOffline) ? "offline" : "online";
        const selectedIcon = `assets/imgs/signature_${captureStatus}_${iconMode}.svg`;

        additionalcontrols.push({
          id: 'meeting-capture-signature',
          src: selectedIcon,
          disabled: isSignatureControlDisabled
        });
      }

      this.activityTypeFormField = {
        label: this.translate.instant('FORMAT'),
        inputText: this.localisationService.getTranslatedString(activityTypeFieldText, EntityNameForTranslation.ActivityType),
        inputValue: this.localisationService.getTranslatedString(activityTypeFieldText, EntityNameForTranslation.ActivityType),
        customPlaceholderLabel: this.isNotReadOnly ? this.translate.instant('SELECT_FORMAT') : this.translate.instant('NO_FORMAT'),
        id: 'meeting-activityType-field',
        isReadOnly: true,
        isDisabled: (isSignatureRequiredFormat && isCapturedSignatureMeeting) || this.isAccountVisitNestedMeeting || this.isReadOnlyRecommendedMeeting || !this.isNotReadOnly || (this.isGpsEnabled && (this.activityService.selectedActivity as AppointmentActivity).gpsCheckInDetails?.indskr_checkinstatus != null),
        showArrow: (this.isNotReadOnly && !isEmpty(this.meetingActivityTypes)) && (!isSignatureRequiredFormat || (isSignatureRequiredFormat && !isCapturedSignatureMeeting)),
        formFieldType: FormFieldType.POPOVER_SELECT,
        isRequired: this.isNotReadOnly && !isEmpty(this.meetingActivityTypes) && this.requiredFields['meeting-activityType-field']['isRequired'],
        errorMessage: this.activityService.getErrorMessageRequiredField(),
        isEmptyRequiredField: (this.isNotReadOnly && !isEmpty(this.meetingActivityTypes) && this.requiredFields['meeting-activityType-field']['isRequired']) && this.isClickedFormat && isEmpty(this.activityService.selectedActivity.activityTypeName),
        additionalcontrols,
        customStyleForAdditionalControls: additionalcontrols.length > 0 ? true : false,
        eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
      };
    }
  }

  public async openCaptureSignature(ev?:any) {
    if (!ev) return;

    if (ev == 'meeting-capture-signature') {
      const isCapturedSignatureMeeting = this.activityService.selectedActivity?.hasCapturedSignature || false;
      const isMeetingOwner = this.activityService.isMeetingOwner;
      if (!isCapturedSignatureMeeting && !isMeetingOwner) {
        return;
      }

      let capturedSignature = '';
      let signatureTerms = '';
      const meetingId = this.activityService.selectedActivity.ID;

      // OMNI-61539: offline viewing of an already-captured signature.
      if (this.device.isOffline && isCapturedSignatureMeeting) {
        const localSignature = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_signature;
        if (localSignature) {
          // Captured offline and not yet synced — the base64 is still local, so show it.
          capturedSignature = localSignature;
          signatureTerms = (this.activityService.selectedActivity as AppointmentActivity)?.indskr_signatureterms || '';
        } else {
          // Already synced to Dynamics — the signature can't be fetched offline. Inform the user.
          this.notificationService.notify(
            this.translate.instant('MEETING_SIGNATURE_SYNCED_OFFLINE_MESSAGE'),
            'Meeting Details', 'top', ToastStyle.INFO
          );
          return;
        }
      }

      // Only fetch the previously captured signature when online (view mode).
      if (!this.device.isOffline && meetingId) {
        try {
          const response = await this.meetingDataService.fetchMeetingCaptureSignatureOnline(meetingId);
          if (response && response.length > 0) {
            if (response[0]['indskr_signature'] && response[0]['indskr_signature'] !== '') {
              capturedSignature = response[0]['indskr_signature'];
            }

            const isCapturedSignatureMeeting = this.activityService.selectedActivity?.hasCapturedSignature || false;

            if (!isCapturedSignatureMeeting && response[0]['indskr_signaturedate'] && response[0]['indskr_signaturedate'] !== '') {
              let capturedSignatureDate: Date = new Date();
              if (this.dateTimeFormatsService.isValidDate(new Date(response[0]['indskr_signaturedate']))){
                capturedSignatureDate = new Date(response[0]['indskr_signaturedate']);
              } else {
                capturedSignatureDate = new Date(parseFloat(response[0]['indskr_signaturedate']));
              }
              if (this.dateTimeFormatsService.isValidDate(capturedSignatureDate)) {
                const signatureTimestamp = capturedSignatureDate.getTime();
                this.activityService.updateSelectedActivityProps({ hasCapturedSignature: true });
                await this.meetingDataService.updateMeetingWithSignatureDate(signatureTimestamp);
              }
            }

            if (response[0]['indskr_signatureterms'] && response[0]['indskr_signatureterms'] !== '') {
              signatureTerms = response[0]['indskr_signatureterms'];
            }
          }
        } catch(error) {
          console.error("fetchMeetingCaptureSignatureOnline ", error);
        }
      }
      this.navService.pushWithPageTracking(
        PageName.CaptureSignatureMeetingComponent,
        PageName.CaptureSignatureMeetingComponent, 
        {
          captureSignatureMeetingEventHandler:(signatureData) => this._handleCaptureSignatureCompletion(signatureData),
          capturedSignatureFromActivity: capturedSignature,
          signatureTermsFromActivity: signatureTerms
        }
      );
      this.footerService.initButtons(FooterViews.CAPTURE_SIGNATURE_MEETING);
    }
  }

  private async _handleCaptureSignatureCompletion(signatureData: any) {
    const capturedSignatureDate = new Date();
    const signatureTimestamp: number = capturedSignatureDate.getTime();
    const configuredSignatureTerms = this.authenticationOfflineService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.MEETING_ENABLE_SIGNATURE_TERMS) as string || '';

    // OMNI-61539: when offline, persist the captured signature (base64) on the
    // meeting and save it to PouchDB. It uploads via the meeting's DTO when
    // connectivity returns. Viewing a captured signature stays online-only.
    if (this.device.isOffline) {
      const offlineLoader = await this.loadingController.create({});
      offlineLoader.present();
      try {
        this.activityService.updateSelectedActivityProps({
          indskr_signature: signatureData,
          indskr_signaturedate: signatureTimestamp,
          indskr_signatureterms: configuredSignatureTerms,
          hasCapturedSignature: true,
        });
        await this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity, true);
      } catch (error) {
        console.error('offline meeting signature save failed', error);
        this.events.publish("meetingCaptureSignatureSaveFailed");
        this.notificationService.notify(this.translate.instant('MEETING_SIGNATURE_NOT_SAVED_MESSAGE'), 'Meeting Details', 'top', ToastStyle.DANGER);
      } finally {
        offlineLoader.dismiss();
      }
      return;
    }

    const payload = {
      indskr_signaturedate: signatureTimestamp,
      indskr_signature: signatureData,
      indskr_signatureterms: configuredSignatureTerms,
    }
    const activityId = this.activityService.selectedActivity.ID;
    const loader = await this.loadingController.create({});
    
    loader.present();

    const response = await this.meetingDataService.updateMeetingCaptureSignatureOnline(payload, activityId);

    if (response) {
      this.activityService.updateSelectedActivityProps({ hasCapturedSignature: true });
      await this.meetingDataService.updateMeetingWithSignatureDate(signatureTimestamp);
      loader.dismiss();
    } else {
      this.events.publish("meetingCaptureSignatureSaveFailed");
      this.notificationService.notify(this.translate.instant('MEETING_SIGNATURE_NOT_SAVED_MESSAGE'), 'Meeting Details', 'top', ToastStyle.DANGER);
      loader.dismiss();
    }
  }

  private _checkPageAndInitActivitiesFooterButtons() {
    const currentPageName = this.navService.getCurrentPageName();
    const skipPageList = [PageName.CaptureSignatureMeetingComponent];
    if (currentPageName && !skipPageList.includes(currentPageName)) {
      this.footerService.initButtons(FooterViews.Activities);
    }
  }
}

export interface BottomButtonConfig {
  exceedMaxResultButton?: {
    id: string;
    label: string;
  };
  lessThanResultButton?: {
    id: string;
    label: string;
  };
}

export interface Section {
  id: string;
  title: string;
  showCountOnTitle?: boolean;
  maxResultsView?: number;
  bottomButtonShow?: boolean;
  expand?: boolean;
  showBottomButton?: boolean;
  bottomButtonConfig?: BottomButtonConfig;
  showFilteredData?: boolean;
  data: any[];
  image?: string; // Added property for image
  refObject?: any; // Added property for reference object
  endIcon?: string; // Added property for end icon
  endIconClickEnabled?: boolean; // Added property for enabling/disabling end icon clicks
  hideAvatarOrInitial?: boolean;
}




